import React, {
  useEffect,
  useMemo,
  forwardRef,
  useLayoutEffect,
  useImperativeHandle,
  useContext,
  useState,
  useCallback,
  useRef,
  memo,
} from "react";
import { createPortal } from "react-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link } from "react-router-dom";
import { AppSettings } from "./../../config/app-settings.js";
import { Modal, Button } from "bootstrap";
import { Icon } from "@iconify/react";
import Swal from "sweetalert2";
import Select from "react-select";
import { Circles } from "react-loader-spinner";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import {
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  LineChart,
  Line,
  ResponsiveContainer,
} from "recharts";
import autoTable from "jspdf-autotable";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import SignaturePad from "signature_pad";
import { jsPDF } from "jspdf";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import * as pdfjsLib from "pdfjs-dist/build/pdf";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";

import { Document, Page, pdfjs } from "react-pdf";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

const PDF_DOCUMENT_OPTIONS = {
  disableRange: true,
  disableStream: true,
  disableAutoFetch: true,
};

const normalizarPdfBase64 = (value = "") => {
  const raw = String(value || "").trim();
  if (!raw) return "";

  return raw
    .replace(/^data:application\/pdf(?:;[^,]*)?;base64,/i, "")
    .replace(/\s+/g, "");
};

const crearPdfDesdeBase64 = (base64Value, nombre = "Cotizacion_Procotiza.pdf") => {
  const base64 = normalizarPdfBase64(base64Value);
  if (!base64) return null;

  try {
    const binary = window.atob(base64);
    const bytes = new Uint8Array(binary.length);

    for (let index = 0; index < binary.length; index += 1) {
      bytes[index] = binary.charCodeAt(index);
    }

    const blob = new Blob([bytes], { type: "application/pdf" });
    const file = new File([blob], nombre, { type: "application/pdf" });
    const url = URL.createObjectURL(blob);

    return { url, file, nombre, esAdjunto: false, esProcotiza: true };
  } catch (error) {
    console.error("No se pudo convertir procotiza_pdf_base64 a PDF:", error);
    return null;
  }
};

const getPdfRenderQualityMultiplier = (pageWidth = 800) => {
  if (typeof window === "undefined") return 3;

  const isIOS =
    /iPad|iPhone|iPod/.test(window.navigator.userAgent) ||
    (window.navigator.platform === "MacIntel" &&
      window.navigator.maxTouchPoints > 1);

  // El zoom libre agranda un canvas. Para que no se vea borroso,
  // renderizamos el canvas más grande y lo mostramos reducido por CSS.
  // Desktop aguanta más resolución; iPad/Safari necesita un límite menor.
  const preferredMultiplier = isIOS ? 2.5 : 4;
  const estimatedHeight = pageWidth * 1.42;
  const maxCanvasPixels = isIOS ? 12000000 : 32000000;
  const maxByPixels = Math.sqrt(
    maxCanvasPixels / Math.max(pageWidth * estimatedHeight, 1),
  );

  return Math.max(2, Math.min(preferredMultiplier, maxByPixels));
};

const isPdfWorkerAbortError = (error) => {
  const message = String(
    error?.message ||
      error?.reason?.message ||
      error?.reason ||
      error?.target?.message ||
      error ||
      "",
  ).toLowerCase();

  return (
    message.includes("worker was terminated") ||
    message.includes("terminated") ||
    message.includes("destroyed") ||
    message.includes("cancelled") ||
    message.includes("canceled") ||
    message.includes("loading aborted")
  );
};

// Cierra TODOS los modales de Bootstrap que estén abiertos,
// limpia backdrop y quita la clase modal-open del <body>
// Cierra TODOS los modales de forma robusta (con fallback y doble pasada)
// Utilidad segura para cerrar TODOS los modales, con/ sin Bootstrap global
async function forceCloseAllModals(
  options = { dispose: true, timeoutMs: 200, removeReactBackdrops: false },
) {
  const {
    dispose = true,
    timeoutMs = 200,
    removeReactBackdrops = false,
  } = options || {};

  const hasBs = !!(window.bootstrap && window.bootstrap.Modal);

  const waitFrame = () =>
    new Promise((resolve) => requestAnimationFrame(resolve));

  const getReactRoot = () =>
    document.getElementById("root") ||
    document.getElementById("app") ||
    document.querySelector("[data-reactroot]");

  const isFichaTecnicaModal = (el) =>
    el?.classList?.contains("ficha-tecnica-modal") ||
    el?.classList?.contains("ficha-tecnica-backdrop") ||
    el?.getAttribute?.("data-react-managed-modal") === "true" ||
    el?.getAttribute?.("data-react-managed-modal-backdrop") === "true";

  const isReactManagedNode = (el) => {
    const root = getReactRoot();

    if (!el) return false;
    if (isFichaTecnicaModal(el)) return true;

    // Los nodos dentro del root pertenecen a React. No hay que removerlos
    // manualmente, porque después React intenta desmontarlos y dispara:
    // Failed to execute 'removeChild' on 'Node'.
    return Boolean(root && root.contains(el));
  };

  const safeRemoveBackdrop = (backdrop) => {
    if (!backdrop?.parentNode) return;

    if (!removeReactBackdrops && isReactManagedNode(backdrop)) {
      return;
    }

    try {
      backdrop.parentNode.removeChild(backdrop);
    } catch {}
  };

  const hardClose = () => {
    // Oculta sólo modales de Bootstrap externos. Los modales controlados por
    // React se cierran con setState y React debe desmontarlos por su cuenta.
    document.querySelectorAll(".modal").forEach((el) => {
      if (isFichaTecnicaModal(el)) return;

      try {
        el.classList.remove("show");
        el.setAttribute("aria-hidden", "true");
        el.style.display = "none";
        el.removeAttribute("aria-modal");
      } catch {}
    });

    // Borra sólo backdrops que no pertenezcan al árbol de React.
    // El backdrop del visor de ficha técnica es renderizado por React.
    document
      .querySelectorAll(".modal-backdrop")
      .forEach((backdrop) => safeRemoveBackdrop(backdrop));

    document.body.classList.remove("modal-open");
    document.body.style.removeProperty("padding-right");
    document.body.style.removeProperty("overflow");
  };

  if (!hasBs) {
    hardClose();
    await waitFrame();
    hardClose();
    return;
  }

  try {
    const modals = Array.from(document.querySelectorAll(".modal.show")).filter(
      (el) => !isFichaTecnicaModal(el),
    );

    if (modals.length) {
      await Promise.all(
        modals.map(
          (el) =>
            new Promise((resolve) => {
              try {
                const inst = window.bootstrap.Modal.getOrCreateInstance(el);
                const onHidden = () => {
                  el.removeEventListener("hidden.bs.modal", onHidden);
                  resolve();
                };

                el.addEventListener("hidden.bs.modal", onHidden, {
                  once: true,
                });

                inst.hide();

                setTimeout(() => {
                  try {
                    el.removeEventListener("hidden.bs.modal", onHidden);
                  } catch {}
                  resolve();
                }, timeoutMs);
              } catch {
                resolve();
              }
            }),
        ),
      );
    }
  } catch {}

  hardClose();

  if (dispose && hasBs) {
    try {
      document.querySelectorAll(".modal").forEach((el) => {
        if (isFichaTecnicaModal(el)) return;

        const inst = window.bootstrap.Modal.getInstance(el);
        if (inst?.dispose) inst.dispose();
      });
    } catch {}
  }

  await waitFrame();
  hardClose();
}

const PDFAllPages = ({ url }) => {
  const wrapRef = useRef(null);
  const [width, setWidth] = useState(0);
  const [numPages, setNumPages] = useState(0);

  useEffect(() => {
    const ro = new ResizeObserver((entries) => {
      if (entries[0]) setWidth(entries[0].contentRect.width);
    });
    if (wrapRef.current) ro.observe(wrapRef.current);
    return () => ro.disconnect();
  }, []);

  return (
    <div ref={wrapRef} style={{ width: "min(100%, 1200px)", margin: "0 auto" }}>
      <Document
        file={url}
        options={PDF_DOCUMENT_OPTIONS}
        onLoadSuccess={({ numPages }) => setNumPages(numPages)}
      >
        {Array.from({ length: numPages }, (_, i) => (
          <Page
            key={i}
            pageNumber={i + 1}
            width={Math.max(320, Math.min(1200, width || 800))}
          />
        ))}
      </Document>
    </div>
  );
};

const normalizePdfSectionText = (value = "") =>
  String(value || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ")
    .trim();

const PDF_SECTION_RULES = [
  {
    key: "especificaciones",
    label: "Especificaciones",
    patterns: [
      /^especificaciones(\s|$)/i,
      /^especificaciones tecnicas(\s|$)/i,
      /^ficha tecnica(\s|$)/i,
    ],
  },
  {
    key: "versiones",
    label: "Versiones",
    patterns: [/^versiones(\s|$)/i, /^version(\s|$)/i],
  },
  {
    key: "equipamiento",
    label: "Equipamiento",
    patterns: [
      /^equipamiento(\s|$)/i,
      /^equipamientos(\s|$)/i,
      /^equipamiento y seguridad(\s|$)/i,
      /^equipamiento exterior(\s|$)/i,
      /^equipamiento interior(\s|$)/i,
    ],
  },
  {
    key: "seguridad",
    label: "Seguridad",
    patterns: [/^seguridad(\s|$)/i, /^nissan safety shield(\s|$)/i],
  },
  {
    key: "tecnologia",
    label: "Tecnología",
    patterns: [
      /^tecnologia(\s|$)/i,
      /^tecnologias(\s|$)/i,
      /^multimedia(\s|$)/i,
      /^conectividad(\s|$)/i,
      /^nissanconnect(\s|$)/i,
    ],
  },
  {
    key: "motor",
    label: "Motor",
    patterns: [/^motor(\s|$)/i, /^motorizacion(\s|$)/i, /^desempeno(\s|$)/i],
  },
  {
    key: "dimensiones",
    label: "Dimensiones",
    patterns: [/^dimensiones(\s|$)/i, /^capacidades(\s|$)/i],
  },
  {
    key: "interiores",
    label: "Interiores",
    patterns: [/^interiores(\s|$)/i, /^interior(\s|$)/i, /^confort(\s|$)/i],
  },
  {
    key: "exteriores",
    label: "Exteriores",
    patterns: [/^exteriores(\s|$)/i, /^exterior(\s|$)/i, /^diseno(\s|$)/i],
  },
  {
    key: "rines",
    label: "Rines",
    patterns: [/^rines?(\s|$)/i, /^rin(es)?(\s|$)/i],
  },
  {
    key: "colores",
    label: "Colores",
    patterns: [/^colores(\s|$)/i, /^gama de colores(\s|$)/i],
  },
  {
    key: "accesorios",
    label: "Accesorios",
    patterns: [/^accesorios(\s|$)/i],
  },
];

const groupPdfTextIntoLines = (items, yTolerance = 2.5) => {
  const lines = [];

  for (const item of items) {
    const y = item.y;
    let line = lines.find((current) => Math.abs(current.y - y) <= yTolerance);

    if (!line) {
      line = { y, parts: [] };
      lines.push(line);
    }

    line.parts.push(item);
  }

  lines.sort((a, b) => b.y - a.y);

  return lines.map((line) => {
    line.parts.sort((a, b) => a.x - b.x);

    const text = line.parts.map((part) => part.str).join(" ");
    const maxFont = Math.max(...line.parts.map((part) => part.fontH || 0));

    return {
      text,
      ntext: normalizePdfSectionText(text),
      maxFont,
      y: line.y,
    };
  });
};

const detectPdfSectionsFromDocument = async (pdf, totalPages = 0) => {
  if (!pdf || !totalPages) return {};

  const scores = {};
  PDF_SECTION_RULES.forEach((rule) => {
    scores[rule.key] = new Map();
  });

  const testRule = (patterns, text) =>
    patterns.some((rx) => {
      const rxNorm = new RegExp(
        rx.source
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, ""),
        rx.flags,
      );

      return rxNorm.test(text);
    });

  for (let pageIndex = 0; pageIndex < totalPages; pageIndex += 1) {
    const page = await pdf.getPage(pageIndex + 1);
    const viewport = page.getViewport({ scale: 1 });
    const content = await page.getTextContent({
      normalizeWhitespace: true,
      disableCombineTextItems: false,
    });

    const items = content.items
      .map((item) => {
        const str = String(item.str || "").trim();
        if (!str) return null;

        return {
          str,
          x: item.transform?.[4] ?? 0,
          y: item.transform?.[5] ?? 0,
          fontH: Math.abs(item.transform?.[3] ?? 0),
        };
      })
      .filter(Boolean);

    if (!items.length) continue;

    const fullText = normalizePdfSectionText(
      items.map((item) => item.str).join(" "),
    );
    const topThreshold = viewport.height * 0.58;
    const headerItems = items.filter((item) => item.y >= topThreshold);

    const fontHeights = items
      .map((item) => item.fontH)
      .filter(Boolean)
      .sort((a, b) => a - b);

    const q85 = fontHeights[Math.floor(fontHeights.length * 0.85)] || 0;
    const bigFontItems = items.filter(
      (item) => item.fontH >= q85 && item.fontH > 0,
    );
    const candidateItems = [...headerItems, ...bigFontItems];
    const topLines = groupPdfTextIntoLines(candidateItems).slice(0, 12);

    for (const rule of PDF_SECTION_RULES) {
      let bestScoreOnPage = scores[rule.key].get(pageIndex) || 0;

      for (const line of topLines) {
        if (!testRule(rule.patterns, line.ntext)) continue;

        let score = 10;

        if (line.y >= viewport.height * 0.85) score += 4;
        else score += 2;

        if (line.maxFont >= q85) score += 3;

        if (score > bestScoreOnPage) {
          bestScoreOnPage = score;
          scores[rule.key].set(pageIndex, score);
        }
      }

      if (bestScoreOnPage === 0 && testRule(rule.patterns, fullText)) {
        scores[rule.key].set(pageIndex, 5);
      }
    }
  }

  const resultado = {};

  for (const rule of PDF_SECTION_RULES) {
    const pages = [...scores[rule.key].entries()]
      .filter(([, score]) => score >= 6)
      .sort((a, b) => a[0] - b[0])
      .map(([pageIndex]) => pageIndex);

    if (pages.length) {
      resultado[rule.label] = [...new Set(pages)];
    }
  }

  if (!Object.keys(resultado).length) {
    resultado.Páginas = Array.from({ length: totalPages }, (_, index) => index);
  }

  return resultado;
};

function VisorFichaTecnica({
  url,
  onClose,
  selectedMailData,
  showFotosButton = false,
  onOpenFotos,
  loadingFotos = false,
}) {
  const [numPages, setNumPages] = useState(null);
  const [paginaActual, setPaginaActual] = useState(1);
  const [secciones, setSecciones] = useState({});
  const [seccionActiva, setSeccionActiva] = useState(null);
  const [expandido, setExpandido] = useState({});
  const [viewerWidth, setViewerWidth] = useState(0);
  const [cargando, setCargando] = useState(true);
  const [pageLoading, setPageLoading] = useState(false);
  const [pdfError, setPdfError] = useState("");
  const [reloadKey, setReloadKey] = useState(0);

  const contenedorRef = useRef(null);
  const botonesRef = useRef(null);
  const transformRef = useRef(null);
  const mountedRef = useRef(false);
  const sectionRunIdRef = useRef(0);
  const pageLoadingTimerRef = useRef(null);
  const loadedDocumentKeyRef = useRef("");

  const documentKey = useMemo(
    () => `${url || "sin-url"}-${reloadKey}`,
    [url, reloadKey],
  );

  const puedeVerFotosSeminuevo = Boolean(showFotosButton && onOpenFotos);

  const pageWidth = useMemo(() => {
    const available = Number(viewerWidth || 0) - 78;
    if (!Number.isFinite(available) || available <= 0) return 800;
    return Math.max(320, Math.min(1120, available));
  }, [viewerWidth]);

  const pdfRenderQuality = useMemo(() => {
    return getPdfRenderQualityMultiplier(pageWidth);
  }, [pageWidth]);

  const pdfRenderWidth = useMemo(() => {
    return Math.round(pageWidth * pdfRenderQuality);
  }, [pageWidth, pdfRenderQuality]);

  const clearPageLoadingTimer = useCallback(() => {
    if (pageLoadingTimerRef.current) {
      clearTimeout(pageLoadingTimerRef.current);
      pageLoadingTimerRef.current = null;
    }
  }, []);

  const finishPageLoading = useCallback(() => {
    if (!mountedRef.current) return;
    clearPageLoadingTimer();
    setPageLoading(false);
  }, [clearPageLoadingTimer]);

  const startPageLoading = useCallback(() => {
    if (!mountedRef.current) return;

    clearPageLoadingTimer();
    setPageLoading(true);

    // Fallback: algunas páginas ya vienen cacheadas y react-pdf a veces no
    // dispara onRenderSuccess. Esto evita que el loader se quede pegado.
    pageLoadingTimerRef.current = setTimeout(() => {
      if (mountedRef.current) {
        setPageLoading(false);
      }
      pageLoadingTimerRef.current = null;
    }, 1600);
  }, [clearPageLoadingTimer]);

  const resetFreeZoom = useCallback((delayMs = 0) => {
    const runReset = () => {
      try {
        transformRef.current?.resetTransform?.();
      } catch {}
    };

    if (delayMs > 0) {
      setTimeout(runReset, delayMs);
    } else {
      requestAnimationFrame(runReset);
    }
  }, []);

  useEffect(() => {
    mountedRef.current = true;

    return () => {
      mountedRef.current = false;
      sectionRunIdRef.current += 1;
      clearPageLoadingTimer();
    };
  }, [clearPageLoadingTimer]);

  useEffect(() => {
    sectionRunIdRef.current += 1;
    loadedDocumentKeyRef.current = "";
    setNumPages(null);
    setPaginaActual(1);
    setSecciones({});
    setSeccionActiva(null);
    setExpandido({});
    setPdfError("");
    setCargando(Boolean(url));
    setPageLoading(false);
    resetFreeZoom(80);
  }, [url, resetFreeZoom]);

  useEffect(() => {
    if (!contenedorRef.current) return;

    const resizeObserver = new ResizeObserver((entries) => {
      const entry = entries?.[0];
      if (!entry) return;
      const width = entry.contentRect?.width || 0;
      setViewerWidth(width);
    });

    resizeObserver.observe(contenedorRef.current);

    return () => resizeObserver.disconnect();
  }, []);

  useEffect(() => {
    if (!pageLoading) return undefined;

    const fallbackTimer = setTimeout(() => {
      if (mountedRef.current) {
        setPageLoading(false);
      }
    }, 1800);

    return () => clearTimeout(fallbackTimer);
  }, [pageLoading, paginaActual, documentKey]);

  useEffect(() => {
    const timer = setTimeout(() => {
      const btnClose = document.querySelector(
        ".ficha-tecnica-modal .btn-close",
      );
      const preocupacion = Number(selectedMailData?.preocupacion_robo || 0);

      if (btnClose) {
        const esValido = preocupacion >= 4;
        btnClose.disabled = !esValido;
        btnClose.style.opacity = esValido ? "1" : "0.3";
        btnClose.style.cursor = esValido ? "pointer" : "not-allowed";
        btnClose.style.pointerEvents = "auto";
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [selectedMailData?.preocupacion_robo, pdfError]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (botonesRef.current && !botonesRef.current.contains(event.target)) {
        setExpandido({});
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDocumentLoadSuccess = useCallback(
    (pdf) => {
      if (!mountedRef.current) return;

      const totalPages = Number(pdf?.numPages || 0);
      const isFirstLoadForDocument =
        loadedDocumentKeyRef.current !== documentKey;
      loadedDocumentKeyRef.current = documentKey;
      const runId = ++sectionRunIdRef.current;

      setNumPages(totalPages);

      if (isFirstLoadForDocument) {
        setPaginaActual(1);
        resetFreeZoom(80);
      }

      setCargando(false);
      setPageLoading(false);
      setPdfError("");
      setSecciones((prev) =>
        Object.keys(prev || {}).length
          ? prev
          : {
              Páginas: Array.from({ length: totalPages }, (_, index) => index),
            },
      );

      (async () => {
        try {
          const detectedSections = await detectPdfSectionsFromDocument(
            pdf,
            totalPages,
          );

          if (!mountedRef.current || sectionRunIdRef.current !== runId) return;

          setSecciones(detectedSections);
        } catch (error) {
          if (isPdfWorkerAbortError(error)) return;
          console.warn("No se pudieron detectar secciones del PDF:", error);
        }
      })();
    },
    [documentKey, resetFreeZoom],
  );

  const handleDocumentLoadError = useCallback(
    (error) => {
      if (!mountedRef.current) return;

      if (isPdfWorkerAbortError(error)) {
        finishPageLoading();
        return;
      }

      console.error("Error cargando ficha técnica:", error);
      setCargando(false);
      setPageLoading(false);
      setPdfError(
        "No se pudo cargar la ficha técnica. Intenta abrirla nuevamente o revisa que el PDF exista.",
      );
    },
    [finishPageLoading],
  );

  const handlePageLoadSuccess = useCallback(() => {
    finishPageLoading();
  }, [finishPageLoading]);

  const handlePageRenderSuccess = useCallback(() => {
    finishPageLoading();
  }, [finishPageLoading]);

  const handlePageLoadError = useCallback(
    (error) => {
      if (isPdfWorkerAbortError(error)) {
        finishPageLoading();
        return;
      }
      handleDocumentLoadError(error);
    },
    [finishPageLoading, handleDocumentLoadError],
  );

  const handleClose = useCallback(
    (event) => {
      event?.preventDefault?.();
      event?.stopPropagation?.();
      mountedRef.current = false;
      sectionRunIdRef.current += 1;
      clearPageLoadingTimer();
      onClose?.();
    },
    [clearPageLoadingTimer, onClose],
  );

  const retryLoadPdf = () => {
    mountedRef.current = true;
    sectionRunIdRef.current += 1;
    loadedDocumentKeyRef.current = "";
    clearPageLoadingTimer();
    setPdfError("");
    setCargando(true);
    setPageLoading(false);
    setNumPages(null);
    setPaginaActual(1);
    setReloadKey((prev) => prev + 1);
  };

  const irAPaginaDirecta = useCallback(
    (pagina) => {
      const nextPage = Math.min(Math.max(Number(pagina), 1), numPages || 1);

      if (nextPage === paginaActual) {
        finishPageLoading();
        resetFreeZoom();
        return;
      }

      startPageLoading();
      setPaginaActual(nextPage);
      resetFreeZoom(80);
    },
    [
      finishPageLoading,
      numPages,
      paginaActual,
      resetFreeZoom,
      startPageLoading,
    ],
  );

  const irAPagina = useCallback(
    (pagina) => {
      irAPaginaDirecta(Number(pagina) + 1);
    },
    [irAPaginaDirecta],
  );

  const toggleExpandido = (seccion) => {
    setExpandido((prev) => {
      const nuevoEstado = {};

      Object.keys(prev).forEach((key) => {
        nuevoEstado[key] = false;
      });

      nuevoEstado[seccion] = !prev[seccion];

      return nuevoEstado;
    });
  };

  return (
    <>
      <style>{`
        .ficha-tecnica-modal .pdf-page-hd-wrap {
          max-width: 100% !important;
        }

        .ficha-tecnica-modal .pdf-page-hd-wrap .react-pdf__Page {
          width: 100% !important;
          max-width: 100% !important;
          background: transparent !important;
        }

        .ficha-tecnica-modal .pdf-page-hd-wrap .react-pdf__Page__canvas {
          width: 100% !important;
          height: auto !important;
          max-width: 100% !important;
          display: block !important;
          image-rendering: auto !important;
          transform: translateZ(0);
        }

        .ficha-tecnica-modal .react-pdf__Page {
          background: transparent !important;
        }
      `}</style>

      <div
        className="modal-backdrop fade show ficha-tecnica-backdrop"
        data-react-managed-modal-backdrop="true"
        style={{ zIndex: 1040 }}
      />

      <div
        className="modal fade show d-block ficha-tecnica-modal"
        data-react-managed-modal="true"
        tabIndex="-1"
        style={{ zIndex: 1050 }}
      >
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div
              className="modal-header position-relative d-flex align-items-center justify-content-between flex-wrap gap-2"
              style={{ minHeight: 58 }}
            >
              <div
                className="d-flex align-items-center gap-2 flex-wrap"
                style={{ minWidth: 0, zIndex: 2 }}
              >
                <h4 className="modal-title mb-0">Ficha Técnica</h4>

                {puedeVerFotosSeminuevo && (
                  <button
                    type="button"
                    className="btn btn-sm btn-dark d-flex align-items-center gap-1 shadow-sm"
                    onClick={onOpenFotos}
                    disabled={loadingFotos}
                    title="Ver fotos del seminuevo"
                    style={{
                      whiteSpace: "nowrap",
                      fontSize: 12,
                      padding: "4px 10px",
                      lineHeight: 1.2,
                    }}
                  >
                    <span>
                      {loadingFotos ? "Cargando fotos..." : "Ver fotos"}
                    </span>
                  </button>
                )}
              </div>

              {!pdfError && (
                <div
                  className="d-flex gap-2 flex-wrap ms-auto"
                  ref={botonesRef}
                  style={{ zIndex: 2 }}
                >
                  {Object.entries(secciones).map(([seccion, paginas]) => (
                    <div key={seccion} style={{ position: "relative" }}>
                      <button
                        type="button"
                        className={`tab-button btn btn-sm btn-ficha ${
                          seccionActiva === seccion
                            ? "active"
                            : "btn-outline-primary"
                        }`}
                        onClick={() => {
                          toggleExpandido(seccion);
                          setSeccionActiva(seccion);
                        }}
                      >
                        {seccion}
                      </button>

                      {expandido[seccion] && (
                        <div className="secction-ext">
                          {paginas.map((pagina) => (
                            <button
                              key={`${seccion}-${pagina}`}
                              type="button"
                              className="btn btn-pg btn-outline-secondary btn-sm"
                              onClick={() => {
                                irAPagina(pagina);
                                setExpandido((prev) => ({
                                  ...prev,
                                  [seccion]: false,
                                }));
                              }}
                            >
                              {`pág. ${pagina + 1}`}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}

              <button
                type="button"
                className="btn-close"
                onClick={handleClose}
                disabled={
                  !(Number(selectedMailData?.preocupacion_robo || 0) >= 4)
                }
                style={{ pointerEvents: "auto", zIndex: 5 }}
              />
            </div>

            <div className="flex-grow-1 d-flex" style={{ minHeight: 0 }}>
              <div className="flex-grow-1 d-flex" style={{ minWidth: 0 }}>
                <div
                  ref={contenedorRef}
                  style={{
                    position: "relative",
                    width: "100%",
                    height: "100%",
                    overflow: "hidden",
                    background: "#f8f9fa",
                    touchAction: "none",
                  }}
                >
                  {(cargando || pageLoading) && !pdfError && (
                    <div
                      style={{
                        position: "fixed",
                        inset: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "rgba(255,255,255,.65)",
                        zIndex: 1065,
                        pointerEvents: "none",
                      }}
                    >
                      <Circles height="80" width="80" color="#4fa94d" />
                    </div>
                  )}

                  {pdfError ? (
                    <div
                      className="alert alert-warning text-center mx-auto mt-4"
                      style={{ maxWidth: 620 }}
                    >
                      <h5 className="mb-2">No se pudo abrir el PDF</h5>
                      <p className="mb-3">{pdfError}</p>

                      <div className="d-flex justify-content-center gap-2 flex-wrap">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={retryLoadPdf}
                        >
                          Reintentar
                        </button>
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={handleClose}
                        >
                          Cerrar
                        </button>
                      </div>
                    </div>
                  ) : (
                    <TransformWrapper
                      key={`transform-${documentKey}`}
                      ref={transformRef}
                      initialScale={1}
                      minScale={0.7}
                      maxScale={4}
                      centerOnInit
                      centerZoomedOut
                      limitToBounds={false}
                      wheel={{ disabled: false, step: 0.12, smoothStep: 0.003 }}
                      pinch={{ disabled: false, step: 5 }}
                      panning={{ disabled: false, velocityDisabled: true }}
                      doubleClick={{ disabled: false, mode: "reset" }}
                    >
                      <TransformComponent
                        wrapperStyle={{
                          width: "100%",
                          height: "100%",
                          overflow: "hidden",
                          touchAction: "none",
                        }}
                        contentStyle={{
                          width: "100%",
                          minHeight: "100%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          padding: 18,
                          touchAction: "none",
                        }}
                      >
                        <Document
                          key={documentKey}
                          file={url}
                          options={PDF_DOCUMENT_OPTIONS}
                          loading={null}
                          error={null}
                          onLoadSuccess={handleDocumentLoadSuccess}
                          onLoadError={handleDocumentLoadError}
                          onSourceError={handleDocumentLoadError}
                        >
                          {numPages && (
                            <div
                              className="pdf-page-hd-wrap"
                              style={{ width: pageWidth, maxWidth: "100%" }}
                            >
                              <Page
                                key={`${documentKey}-${paginaActual}-${pdfRenderWidth}`}
                                pageNumber={paginaActual}
                                width={pdfRenderWidth}
                                devicePixelRatio={1}
                                renderAnnotationLayer={false}
                                renderTextLayer={false}
                                loading={null}
                                error={null}
                                className="pdf-page-hd"
                                onLoadSuccess={handlePageLoadSuccess}
                                onRenderSuccess={handlePageRenderSuccess}
                                onLoadError={handlePageLoadError}
                                onRenderError={handlePageLoadError}
                              />
                            </div>
                          )}
                        </Document>
                      </TransformComponent>
                    </TransformWrapper>
                  )}
                </div>
              </div>

              {!pdfError && (
                <div className="d-none d-md-block" style={{ height: "100%" }}>
                  <PDFThumbsReel
                    url={url}
                    numPages={numPages}
                    paginaActual={paginaActual}
                    documentKey={documentKey}
                    onGoToPage={irAPaginaDirecta}
                    onLoadError={handleDocumentLoadError}
                  />
                </div>
              )}
            </div>

            {!pdfError && (
              <div className="d-flex flex-row justify-content-center justify-content-sm-between align-items-center py-2 border-top flex-wrap">
                <button
                  type="button"
                  className="btn-prev btn btn-sm btn-outline-secondary me-3"
                  onClick={() =>
                    irAPaginaDirecta(Math.max(paginaActual - 1, 1))
                  }
                  disabled={paginaActual <= 1 || cargando}
                >
                  ← Anterior
                </button>

                <span className="pag-section mx-3">
                  {paginaActual} / {numPages || "..."}
                </span>

                <button
                  type="button"
                  className="btn-prev btn btn-sm btn-outline-secondary ms-3"
                  onClick={() =>
                    irAPaginaDirecta(
                      Math.min(paginaActual + 1, numPages || paginaActual),
                    )
                  }
                  disabled={!numPages || paginaActual >= numPages || cargando}
                >
                  Siguiente →
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

function usePDFSecciones() {
  return {
    secciones: {},
    buscarSecciones: () => {},
  };
}

function PDFThumbsReel({
  url,
  numPages,
  paginaActual,
  documentKey,
  onGoToPage,
  onLoadError,
}) {
  const wrapRef = useRef(null);
  const itemRefs = useRef({});
  const [thumbError, setThumbError] = useState(false);

  useEffect(() => {
    setThumbError(false);
  }, [url]);

  useEffect(() => {
    const wrap = wrapRef.current;
    const el = itemRefs.current[paginaActual];

    if (wrap && el) {
      const nextTop =
        el.offsetTop - wrap.clientHeight / 2 + el.clientHeight / 2;
      wrap.scrollTo({ top: Math.max(nextTop, 0), behavior: "smooth" });
    }
  }, [paginaActual]);

  if (!url || !numPages || thumbError) return null;

  const handleThumbError = (error) => {
    if (isPdfWorkerAbortError(error)) return;
    console.warn("No se pudo cargar una miniatura del PDF:", error);
    setThumbError(true);
    onLoadError?.(error);
  };

  return (
    <div
      ref={wrapRef}
      style={{
        width: 185,
        minWidth: 185,
        borderLeft: "1px solid rgba(0,0,0,.08)",
        height: "100%",
        overflowY: "auto",
        padding: 10,
        background: "#fff",
      }}
    >
      <Document
        key={`thumbs-${documentKey}`}
        file={url}
        options={PDF_DOCUMENT_OPTIONS}
        loading={null}
        error={null}
        onLoadError={handleThumbError}
        onSourceError={handleThumbError}
      >
        {Array.from({ length: numPages }, (_, i) => {
          const pageNum = i + 1;
          const active = pageNum === paginaActual;

          return (
            <button
              key={pageNum}
              type="button"
              ref={(node) => (itemRefs.current[pageNum] = node)}
              onClick={() => onGoToPage(pageNum)}
              style={{
                width: "100%",
                cursor: "pointer",
                marginBottom: 12,
                padding: 7,
                borderRadius: 12,
                position: "relative",
                border: active
                  ? "2px solid #0d6efd"
                  : "1px solid rgba(0,0,0,.12)",
                boxShadow: active
                  ? "0 0 0 3px rgba(13,110,253,.12)"
                  : "0 2px 8px rgba(0,0,0,.06)",
                background: active ? "rgba(13,110,253,.04)" : "#fff",
                display: "block",
                color: active ? "#0d6efd" : "#555",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 8,
                  left: 8,
                  zIndex: 2,
                  width: 28,
                  height: 28,
                  borderRadius: "50%",
                  background: active ? "#0d6efd" : "#212529",
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 12,
                  fontWeight: 700,
                  boxShadow: "0 2px 6px rgba(0,0,0,.25)",
                }}
              >
                {pageNum}
              </div>

              <div style={{ pointerEvents: "none" }}>
                <Page
                  pageNumber={pageNum}
                  width={145}
                  devicePixelRatio={1.5}
                  renderAnnotationLayer={false}
                  renderTextLayer={false}
                  loading={null}
                  error={null}
                  onLoadError={handleThumbError}
                  onRenderError={handleThumbError}
                />
              </div>

              <div
                style={{
                  marginTop: 7,
                  fontSize: 12,
                  textAlign: "center",
                  fontWeight: active ? 700 : 500,
                  color: active ? "#0d6efd" : "#555",
                }}
              >
                Página {pageNum} de {numPages}
              </div>
            </button>
          );
        })}
      </Document>
    </div>
  );
}

function GaleriaFotosSeminuevo({
  images = [],
  title = "Fotos del seminuevo",
  initialIndex = 0,
  onClose,
}) {
  const safeImages = useMemo(() => {
    const normalizeImage = (item) => {
      if (!item) return "";
      if (typeof item === "string") return item;
      return item.url || item.src || item.large || item.thumb || "";
    };

    const cleaned = images
      .map(normalizeImage)
      .map((url) => String(url || "").trim())
      .filter(Boolean);

    return cleaned.length ? cleaned : ["/assets/img/product/noimage.png"];
  }, [images]);

  const galleryTransformRef = useRef(null);
  const thumbsRef = useRef(null);

  const [activeIndex, setActiveIndex] = useState(() =>
    Math.min(Math.max(Number(initialIndex) || 0, 0), safeImages.length - 1),
  );

  useEffect(() => {
    setActiveIndex(
      Math.min(Math.max(Number(initialIndex) || 0, 0), safeImages.length - 1),
    );
  }, [initialIndex, safeImages.length]);

  useEffect(() => {
    const html = document.documentElement;
    const previousBodyOverflow = document.body.style.overflow;
    const previousHtmlOverflow = html.style.overflow;

    document.body.style.overflow = "hidden";
    html.style.overflow = "hidden";

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose?.();
      }

      if (event.key === "ArrowLeft") {
        setActiveIndex((prev) =>
          prev <= 0 ? safeImages.length - 1 : prev - 1,
        );
      }

      if (event.key === "ArrowRight") {
        setActiveIndex((prev) =>
          prev >= safeImages.length - 1 ? 0 : prev + 1,
        );
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = previousBodyOverflow;
      html.style.overflow = previousHtmlOverflow;
    };
  }, [onClose, safeImages.length]);

  const activeImage = safeImages[activeIndex] || safeImages[0];
  const hasMultipleImages = safeImages.length > 1;

  useEffect(() => {
    requestAnimationFrame(() => {
      try {
        galleryTransformRef.current?.resetTransform?.();
      } catch {}
    });
  }, [activeImage]);

  useEffect(() => {
    const strip = thumbsRef.current;
    if (!strip) return;

    const activeThumb = strip.querySelector(
      `[data-gallery-thumb="${activeIndex}"]`,
    );

    if (activeThumb?.scrollIntoView) {
      activeThumb.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [activeIndex]);

  const goPrev = () => {
    setActiveIndex((prev) => (prev <= 0 ? safeImages.length - 1 : prev - 1));
  };

  const goNext = () => {
    setActiveIndex((prev) => (prev >= safeImages.length - 1 ? 0 : prev + 1));
  };

  const zoomIn = () => {
    try {
      galleryTransformRef.current?.zoomIn?.(0.35);
    } catch {}
  };

  const zoomOut = () => {
    try {
      galleryTransformRef.current?.zoomOut?.(0.35);
    } catch {}
  };

  const resetZoom = () => {
    try {
      galleryTransformRef.current?.resetTransform?.();
    } catch {}
  };

  const galleryTitle = String(title || "").trim() || "Fotos del seminuevo";
  const galleryButtonStyle = {
    minWidth: 40,
    height: 34,
    border: "1px solid rgba(15,23,42,.25)",
    borderRadius: 9,
    background: "#ffffff",
    color: "#111827",
    fontSize: 14,
    fontWeight: 800,
    lineHeight: 1,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 1px 3px rgba(0,0,0,.12)",
  };
  const galleryCloseButtonStyle = {
    height: 34,
    border: "0",
    borderRadius: 9,
    background: "#0b3b75",
    color: "#ffffff",
    fontSize: 13,
    fontWeight: 800,
    padding: "0 12px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 7,
    boxShadow: "0 2px 6px rgba(0,0,0,.22)",
  };

  const galleryMarkup = (
    <>
      <style>{`
        .babilonia-used-gallery-backdrop {
          z-index: 1000400 !important;
        }

        .babilonia-used-gallery-modal {
          z-index: 1000500 !important;
          display: flex !important;
          visibility: visible !important;
          opacity: 1 !important;
          pointer-events: auto !important;
        }
      `}</style>

      <div
        className="babilonia-used-gallery-backdrop"
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 1000400,
          background: "rgba(0,0,0,.72)",
          backdropFilter: "none",
          WebkitBackdropFilter: "none",
        }}
      />

      <div
        className="babilonia-used-gallery-modal"
        role="dialog"
        aria-modal="true"
        tabIndex="-1"
        style={{
          zIndex: 1000500,
          position: "fixed",
          inset: 0,
          width: "100vw",
          height: "100dvh",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          background: "#111",
        }}
      >
        <div
          style={{
            flex: "0 0 auto",
            background: "#ffffff",
            borderBottom: "1px solid rgba(0,0,0,.12)",
            minHeight: 66,
            padding: "8px 14px",
            display: "grid",
            gridTemplateColumns: "minmax(0, 1fr) auto minmax(0, 1fr)",
            alignItems: "center",
            gap: 12,
            position: "relative",
            zIndex: 1000600,
          }}
        >
          <div style={{ minWidth: 0, overflow: "hidden" }}>
            <div
              style={{
                color: "#111827",
                fontSize: 17,
                fontWeight: 800,
                lineHeight: 1.15,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              title={galleryTitle}
            >
              {galleryTitle}
            </div>
            <div
              style={{
                color: "#4b5563",
                fontSize: 12,
                fontWeight: 700,
                marginTop: 3,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {safeImages.length} foto{safeImages.length === 1 ? "" : "s"}
              {" · Zoom con rueda, pellizco o doble clic"}
            </div>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 8,
              flexWrap: "nowrap",
            }}
          >
            <button
              type="button"
              onClick={zoomOut}
              title="Alejar"
              style={galleryButtonStyle}
            >
              −
            </button>
            <button
              type="button"
              onClick={resetZoom}
              title="Restablecer zoom"
              style={{ ...galleryButtonStyle, minWidth: 58 }}
            >
              100%
            </button>
            <button
              type="button"
              onClick={zoomIn}
              title="Acercar"
              style={galleryButtonStyle}
            >
              +
            </button>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              minWidth: 0,
            }}
          >
            <button
              type="button"
              aria-label="Cerrar galería y regresar a ficha técnica"
              onClick={onClose}
              style={galleryCloseButtonStyle}
            >
              <span>Cerrar</span>
              <span style={{ fontSize: 18, lineHeight: 1 }}>×</span>
            </button>
          </div>
        </div>

        <div
          className="p-2"
          style={{
            flex: "1 1 auto",
            minHeight: 0,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            background: "#2f424a",
          }}
        >
          <div
            className="position-relative d-flex align-items-center justify-content-center bg-dark rounded"
            style={{
              flex: "1 1 auto",
              minHeight: 0,
              overflow: "hidden",
              paddingLeft: hasMultipleImages ? 58 : 12,
              paddingRight: hasMultipleImages ? 58 : 12,
              paddingTop: 8,
              paddingBottom: 8,
            }}
          >
            {hasMultipleImages && (
              <button
                type="button"
                className="btn btn-light position-absolute top-50 start-0 translate-middle-y ms-3 rounded-circle"
                onClick={goPrev}
                aria-label="Foto anterior"
                style={{ zIndex: 6, width: 44, height: 44 }}
              >
                ‹
              </button>
            )}

            <TransformWrapper
              key={`gallery-${activeIndex}-${activeImage}`}
              ref={galleryTransformRef}
              initialScale={1}
              minScale={0.5}
              maxScale={5}
              centerOnInit
              centerZoomedOut
              limitToBounds={false}
              wheel={{ disabled: false, step: 0.16, smoothStep: 0.004 }}
              pinch={{ disabled: false, step: 5 }}
              panning={{ disabled: false, velocityDisabled: true }}
              doubleClick={{ disabled: false, mode: "toggle" }}
            >
              <TransformComponent
                wrapperStyle={{
                  width: "100%",
                  height: "100%",
                  overflow: "hidden",
                  touchAction: "none",
                }}
                contentStyle={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  touchAction: "none",
                }}
              >
                <img
                  src={activeImage}
                  alt={`Foto ${activeIndex + 1}`}
                  draggable={false}
                  style={{
                    width: "auto",
                    height: "auto",
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain",
                    background: "#111",
                    userSelect: "none",
                    WebkitUserSelect: "none",
                    WebkitTouchCallout: "none",
                  }}
                  onError={(event) => {
                    event.currentTarget.src = "/assets/img/product/noimage.png";
                  }}
                />
              </TransformComponent>
            </TransformWrapper>

            {hasMultipleImages && (
              <button
                type="button"
                className="btn btn-light position-absolute top-50 end-0 translate-middle-y me-3 rounded-circle"
                onClick={goNext}
                aria-label="Siguiente foto"
                style={{ zIndex: 6, width: 44, height: 44 }}
              >
                ›
              </button>
            )}

            <span
              className="badge bg-dark position-absolute bottom-0 end-0 m-3 px-3 py-2"
              style={{ background: "rgba(0,0,0,.65)", zIndex: 7 }}
            >
              {activeIndex + 1} / {safeImages.length}
            </span>
          </div>

          {safeImages.length > 1 && (
            <div
              ref={thumbsRef}
              className="d-flex gap-2 pt-2 pb-1"
              style={{
                flex: "0 0 auto",
                overflowX: "auto",
                overflowY: "hidden",
                minHeight: 82,
                maxHeight: 92,
              }}
            >
              {safeImages.map((url, index) => (
                <button
                  key={`${url}-${index}`}
                  type="button"
                  data-gallery-thumb={index}
                  className={`border rounded p-1 bg-white ${
                    index === activeIndex ? "border-primary" : "border-light"
                  }`}
                  onClick={() => setActiveIndex(index)}
                  style={{
                    minWidth: 90,
                    height: 74,
                    boxShadow:
                      index === activeIndex
                        ? "0 0 0 3px rgba(13,110,253,.18)"
                        : "none",
                  }}
                >
                  <img
                    src={url}
                    alt={`Miniatura ${index + 1}`}
                    style={{
                      width: 78,
                      height: 60,
                      objectFit: "cover",
                      borderRadius: 6,
                    }}
                    onError={(event) => {
                      event.currentTarget.src =
                        "/assets/img/product/noimage.png";
                    }}
                  />
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );

  if (typeof document === "undefined") return galleryMarkup;

  return createPortal(galleryMarkup, document.body);
}

const llantasData = [
  { year: "2022", siniestralidad: 66.2, costo: 3251.74 },
  { year: "2023", siniestralidad: 49.7, costo: 3319.51 },
  { year: "2024", siniestralidad: 57.5, costo: 3342.78 },
  { year: "2025", siniestralidad: 52.2, costo: 3170.82 },
];

const mecanicaData = [
  { year: "2020", siniestralidad: 22.8, costo: 16273.15 },
  { year: "2021", siniestralidad: 22.9, costo: 22332.09 },
  { year: "2022", siniestralidad: 33.1, costo: 27656.05 },
  { year: "2023", siniestralidad: 38.1, costo: 38517.54 },
  { year: "2024", siniestralidad: 39.5, costo: 38751.5 },
];

const reparacionesData = [
  { year: "2022", costo: 34637, color: "#20c997" },
  { year: "2023", costo: 37357, color: "#0d6efd" },
  { year: "2024", costo: 38575, color: "#002752" },
];

const siniestralidadData = [
  { name: "2022-2023", value: 42.99, color: "#007bff" },
  { name: "2023-2024", value: 48.24, color: "#dc3545" },
];

// Solución 1: Mejorar el CanvasOverlay con mejor manejo de eventos

const CanvasOverlay = forwardRef(({ containerRef }, ref) => {
  const canvasRef = useRef(null);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const ctxRef = useRef(null);
  const isDrawingRef = useRef(false);

  useImperativeHandle(ref, () => ({
    clearCanvas: () => {
      const ctx = ctxRef.current;
      if (ctx && canvasRef.current) {
        ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
      }
    },
  }));

  useEffect(() => {
    if (!containerRef?.current) return;

    const rect = containerRef.current.getBoundingClientRect();
    setDimensions({ width: rect.width, height: rect.height });

    const observer = new ResizeObserver((entries) => {
      if (!entries?.[0]?.target) return;
      const { width, height } = entries[0].contentRect;
      setDimensions({ width, height });
    });

    observer.observe(containerRef.current);

    return () => observer.disconnect();
  }, [containerRef]);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || !dimensions.width || !dimensions.height) return;

    canvas.width = dimensions.width;
    canvas.height = dimensions.height;

    const ctx = canvas.getContext("2d");
    ctx.strokeStyle = "blue";
    ctx.lineWidth = 1.5;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctxRef.current = ctx;

    const getPos = (e) => {
      const rect = canvas.getBoundingClientRect();
      if (e.touches && e.touches.length > 0) {
        return {
          x: e.touches[0].clientX - rect.left,
          y: e.touches[0].clientY - rect.top,
        };
      } else {
        return {
          x: e.offsetX,
          y: e.offsetY,
        };
      }
    };

    const startDraw = (e) => {
      // IMPORTANTE: Prevenir todos los eventos de scroll
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const { x, y } = getPos(e);
      isDrawingRef.current = true;
      ctx.beginPath();
      ctx.moveTo(x, y);

      // Deshabilitar scroll en el documento y contenedores padres
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.width = "100%";

      // Buscar y deshabilitar PerfectScrollbar
      const psContainer = canvas.closest(".ps");
      if (psContainer) {
        psContainer.style.overflow = "hidden";
        psContainer.style.touchAction = "none";
      }
    };

    const draw = (e) => {
      if (!isDrawingRef.current) return;

      // IMPORTANTE: Prevenir todos los eventos
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const { x, y } = getPos(e);
      ctx.lineTo(x, y);
      ctx.stroke();
    };

    const stopDraw = (e) => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }

      isDrawingRef.current = false;

      // Rehabilitar scroll
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.width = "";

      // Rehabilitar PerfectScrollbar
      const psContainer = canvas.closest(".ps");
      if (psContainer) {
        psContainer.style.overflow = "";
        psContainer.style.touchAction = "";
      }
    };

    // Mouse events
    canvas.addEventListener("mousedown", startDraw);
    canvas.addEventListener("mousemove", draw);
    canvas.addEventListener("mouseup", stopDraw);
    canvas.addEventListener("mouseout", stopDraw);

    // Touch events con configuración específica
    canvas.addEventListener("touchstart", startDraw, {
      passive: false,
      capture: true,
    });
    canvas.addEventListener("touchmove", draw, {
      passive: false,
      capture: true,
    });
    canvas.addEventListener("touchend", stopDraw, {
      passive: false,
      capture: true,
    });
    canvas.addEventListener("touchcancel", stopDraw, {
      passive: false,
      capture: true,
    });

    // Prevenir gestos del navegador en el canvas
    canvas.addEventListener("gesturestart", (e) => e.preventDefault());
    canvas.addEventListener("gesturechange", (e) => e.preventDefault());
    canvas.addEventListener("gestureend", (e) => e.preventDefault());

    return () => {
      // Cleanup
      canvas.removeEventListener("mousedown", startDraw);
      canvas.removeEventListener("mousemove", draw);
      canvas.removeEventListener("mouseup", stopDraw);
      canvas.removeEventListener("mouseout", stopDraw);

      canvas.removeEventListener("touchstart", startDraw);
      canvas.removeEventListener("touchmove", draw);
      canvas.removeEventListener("touchend", stopDraw);
      canvas.removeEventListener("touchcancel", stopDraw);

      canvas.removeEventListener("gesturestart", (e) => e.preventDefault());
      canvas.removeEventListener("gesturechange", (e) => e.preventDefault());
      canvas.removeEventListener("gestureend", (e) => e.preventDefault());

      // Asegurar que el scroll esté habilitado al desmontar
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.width = "";
    };
  }, [dimensions]);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: 1000,
        pointerEvents: "auto",
        touchAction: "none",
        maxWidth: "100%",
        maxHeight: "100%",
        objectFit: "contain",
        border: "2px dashed rgba(205, 205, 205, 0.56)",
        // Prevenir selección de texto y otros comportamientos
        userSelect: "none",
        WebkitUserSelect: "none",
        WebkitTouchCallout: "none",
        WebkitTapHighlightColor: "transparent",
      }}
    />
  );
});

const ZoomImage = ({
  src,
  alt = "",
  style = {},
  zoom = 2,
  maxHeight = 480,
  onError,
}) => {
  const imgRef = useRef(null);
  const [lensPos, setLensPos] = useState({ x: 0, y: 0, show: false });
  const [imgSrc, setImgSrc] = useState(src);

  const handleMouseMove = (e) => {
    const rect = imgRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    setLensPos({ x, y, show: true });
  };

  const handleMouseLeave = () => {
    setLensPos((lensPos) => ({ ...lensPos, show: false }));
  };

  const handleImgError = (e) => {
    setImgSrc("/assets/img/product/noimage.png");
    if (onError) onError(e);
  };

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        maxHeight,
        overflow: "hidden",
        borderRadius: style.borderRadius || 0,
        cursor: "zoom-in",
        display: "flex", // centrado horizontal
        justifyContent: "center", // centrado horizontal
        ...style,
      }}
    >
      <img
        src={imgSrc}
        alt={alt}
        ref={imgRef}
        onError={handleImgError}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
        style={{
          width: "70%", // imagen más pequeña
          height: "auto",
          maxHeight,
          objectFit: "contain",
          transition: "transform 0.3s ease",
          display: "block",
          borderRadius: "15px",
        }}
      />
      {lensPos.show && (
        <div
          style={{
            position: "absolute",
            top: lensPos.y - 75,
            left: lensPos.x - 75,
            width: 150,
            height: 150,
            border: "2px solidrgb(0, 42, 255)",
            backgroundImage: `url(${imgSrc})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: `${
              imgRef.current ? imgRef.current.width * zoom : 0
            }px ${imgRef.current ? imgRef.current.height * zoom : 0}px`,
            backgroundPositionX: -lensPos.x * zoom + 75,
            backgroundPositionY: -lensPos.y * zoom + 75,
            pointerEvents: "none",
            borderRadius: "50%",
            boxShadow: "0 0 8pxrgb(0, 60, 255)",
            zIndex: 9999,
          }}
        />
      )}
    </div>
  );
};

const apiUrl = "https://api.checkmark.mx/cliente/ventas/financiamiento";
const apiUpdatePlanesUrl =
  "https://api.checkmark.mx/actualizar/planes/financiamiento";
const apiPDF = "https://api.checkmark.mx/enviar/pdf"; //envio pdf
const apiUrlInventario = "https://api.checkmark.mx/financiamiento/vehiculos";
const apiProxyFichaTecnicaNuevo =
  "https://api.checkmark.mx/proxy/ficha-tecnica-nuevo";
const apiBabiloniaSeminuevosImagenes =
  "https://api.checkmark.mx/babilonia/seminuevos/imagenes";
const accessToken =
  "1MhYphhrGUbgbdRy7cyYFGQlXS7tAi6ooUoptkHQbOm9GcsKiZM7uMF1MERxwMWq30I7Y3";

// Tasa única para las estimaciones del cliente.
// Se deja fija en 21% para que el cliente vea una mensualidad conservadora
// antes de que el asesor capture la mensualidad real de NR en el modal.
const TASA_ANUAL_FINANCIAMIENTO = 0.25;

const customStyles = {
  control: (base) => ({
    ...base,
    borderColor: "transparent",
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    borderRadius: "0",
    color: "white",
    boxShadow: "none",
    "&:hover": {
      borderColor: "#fff",
    },
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  option: (base, state) => ({
    ...base,
    color: "black", // Text color for options
    backgroundColor: state.isFocused ? "transparent" : "transparent",
    "&:active": {
      backgroundColor: "transparent",
    },
  }),
  singleValue: (base) => ({
    ...base,
    color: "white", // Color of the selected value
  }),
  input: (base) => ({
    ...base,
    color: "white", // Color of the input text
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "white", // Change the color of the dropdown indicator to white
  }),
  clearIndicator: (base) => ({
    ...base,
    color: "white", // Change the color of the clear indicator to white
  }),
};

// Mapeo de agencias a marcas (para nuevos) y ag_id (para seminuevos)
const agenciaInfo = {
  "Seminuevos Gocar Azcapotzalco": {
    marca: "Renault",
    ag_id: "ag0028_5c33da0cc1c4d",
  },
  "Renault San Ángel": { marca: "Renault", ag_id: "ag0532_5598bb1c4042b" },
  "Honda Santa Fe": { marca: "Honda", ag_id: "ag0532_5598bb1c488c9" },
  "Nissan Aragón": { marca: "Nissan", ag_id: "ag0532_5598bb1c503e6" },
  "Volkswagen León Motors": {
    marca: "Volkswagen",
    ag_id: "ag0532_5598bb1c51d78",
  },
  "Seat Seminuevos Cerro Gordo": {
    marca: "Seat",
    ag_id: "ag0532_5598bb1c56605",
  },
  "Nissan Santa Clara": { marca: "Nissan", ag_id: "ag0532_5598bb1c86d5a" },
  "Renault Universidad": { marca: "Renault", ag_id: "ag0533_5598bb1d621ab" },
  "Gocar Seminuevos León Irapuato": { ag_id: "ag0931_6500d38be2bc6" },
  "Gocar Seminuevos León": { ag_id: "ag1035_6500d3cb15aed" },
  "MG Ecatepec": { marca: "MG", ag_id: "ag1150_5b44ccb6362b8" },
  "MG Toluca": { marca: "MG", ag_id: "ag2327_620bfdaf30656" },
  "Chirey Ecatepec": { marca: "Chirey", ag_id: "ag3307_631f6d5397531" },
  "MG Metepec": { marca: "MG", ag_id: "ag3636_61d5d72451639" },
  "Renault Ajusco": { marca: "Renault", ag_id: "ag3912_5980f500b41b4" },
  "Honda Los Cabos": { marca: "Honda", ag_id: "ag5423_5a8736ef2eeb7" },
  "Honda Metepec": { marca: "Honda", ag_id: "ag5457_5e20f7d1c1032" },
  "Honda Tollocan": { marca: "Honda", ag_id: "ag5650_5e20f842e21a6" },
  "Nissan Texcoco": { marca: "Nissan", ag_id: "ag5713_5c33d949e445e" },
  "Renault San Ajusco - Nuevos": {
    marca: "Renault",
    ag_id: "ag5822_5bacfe1e8a7aa",
  },
  "Nissan Tecámac": { marca: "Nissan", ag_id: "ag5912_5c33d9c0c10df" },
};

const AGENCIAS_NISSAN_PERMITIDAS = [
  "ag5713_5c33d949e445e", // Nissan Texcoco
  "ag5912_5c33d9c0c10df", // Nissan Tecámac
];

const obtenerAgenciaPorIdGlobal = (ag_id) => {
  const agenciaEncontrada = Object.entries(agenciaInfo).find(
    ([, data]) => data.ag_id === ag_id,
  );

  if (!agenciaEncontrada) return null;

  const [nombre, data] = agenciaEncontrada;

  return {
    nombre,
    ag_id: data.ag_id,
    marca: data.marca || "",
  };
};

const formatterPeso = new Intl.NumberFormat("es-MX", {
  style: "currency",
  currency: "MXN",
  minimumFractionDigits: 0,
});

// Función para formatear moneda
const formatCurrency = (value) => {
  return value != null
    ? Number(value).toLocaleString("es-MX", {
        style: "currency",
        currency: "MXN",
        minimumFractionDigits: 2,
      })
    : "";
};

const normalizarTasaFinanciamientoTexto = (
  value,
  fallback = TASA_ANUAL_FINANCIAMIENTO,
) => {
  const source =
    value !== null && value !== undefined && String(value).trim() !== ""
      ? value
      : fallback;

  if (source === null || source === undefined || String(source).trim() === "") {
    return "";
  }

  const numericValue = Number(String(source).replace(/[^0-9.-]/g, ""));

  if (!Number.isFinite(numericValue) || numericValue <= 0) {
    return "";
  }

  const porcentaje = numericValue <= 1 ? numericValue * 100 : numericValue;

  const fractionDigits = Number.isInteger(porcentaje) ? 0 : 2;

  return `${porcentaje.toLocaleString("es-MX", {
    minimumFractionDigits: 0,
    maximumFractionDigits: fractionDigits,
  })}%`;
};

const agregarTasaPiePaginaPDF = (doc, tasaTexto, options = {}) => {
  if (!doc || !tasaTexto) return;

  const {
    fontSize = 6,
    y = null,
    x = null,
    align = "right",
    prefix = "Tasa anual de referencia:",
  } = options;

  const pageCount = doc.internal.getNumberOfPages();
  const pageWidth = doc.internal.pageSize.getWidth
    ? doc.internal.pageSize.getWidth()
    : doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.getHeight
    ? doc.internal.pageSize.getHeight()
    : doc.internal.pageSize.height;
  const xPosition = x ?? pageWidth - 12;
  const yPosition = y ?? pageHeight - 12;

  for (let page = 1; page <= pageCount; page += 1) {
    doc.setPage(page);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(fontSize);
    doc.setTextColor(115, 115, 115);
    doc.text(`${prefix} ${tasaTexto}`, xPosition, yPosition, { align });
  }

  doc.setTextColor(0, 0, 0);
};

const normalizarTipoAutoCatalogo = (value = "") => {
  const raw = (value || "")
    .toString()
    .toLocaleLowerCase("es-MX")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();

  if (!raw) return "";
  if (raw.includes("seminuevo")) return "seminuevos";
  if (raw.includes("nuevo")) return "nuevos";
  if (raw === "seminuevos") return "seminuevos";
  if (raw === "nuevos") return "nuevos";

  return raw;
};

const normalizarNombrePlanFinanciamiento = (planOrTitle = "") => {
  const title =
    typeof planOrTitle === "string" ? planOrTitle : planOrTitle?.title || "";

  return String(title || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/paquete/g, "")
    .replace(/plan/g, "")
    .replace(/\s+/g, " ")
    .trim();
};

const esPlanClienteFinanciamiento = (planOrTitle = "") =>
  normalizarNombrePlanFinanciamiento(planOrTitle).includes("cliente");

const esPlanGoldFinanciamiento = (planOrTitle = "") =>
  normalizarNombrePlanFinanciamiento(planOrTitle).includes("gold");

function toTitleCase(str) {
  return str
    .toLowerCase()
    .replace(/(?:^|\s|\/|-)\S/g, (match) => match.toUpperCase());
}

const renderBarLabel = ({ x, y, width, height, value }) => {
  const cx = x + width / 2;
  const cy = y + height / 2;

  return (
    <text
      x={cx}
      y={cy}
      fill="#fff"
      fontSize={11}
      textAnchor="middle"
      dominantBaseline="middle"
    >
      {formatCurrency(value)}
    </text>
  );
};

const renderBarLabel2 = ({ x, y, width, value }) => {
  const cx = x + width / 2;
  const cy = y - 8;

  //variable modo claro/oscuro
  const labelColor =
    getComputedStyle(document.documentElement)
      .getPropertyValue("--label-color")
      .trim() || "#000";

  return (
    <text
      x={cx}
      y={cy}
      fill={labelColor}
      fontSize={11}
      textAnchor="middle"
      dominantBaseline="central"
    >
      {formatCurrency(value)}
    </text>
  );
};

const GraficasEstadisticas = () => {
  const siniestralidadData = [
    { name: "Sin siniestro", value: 27.4 },
    { name: "Con siniestro", value: 72.6 },
  ];

  const reparacionData = [
    { name: "Choque menor", costo: 7500 },
    { name: "Lesión menor", costo: 25000 },
    { name: "Lesión grave", costo: 350000 },
    { name: "Catastrofe", costo: 1500000 },
  ];

  const roboAutosData = [
    { name: "Total", vehiculos: 136993 },
    { name: "Asegurados robados", vehiculos: 61222 },
    { name: "Sin seguro", vehiculos: 75871 },
    { name: "Robo con violencia", vehiculos: 78087 },
  ];

  const distribucionSiniestrosData = [
    { name: "Robos", value: 20 },
    { name: "Responsabilidad civil", value: 30 },
    { name: "Daños materiales", value: 50 },
  ];

  return (
    <div className="container-fluid">
      <br></br>
      <h6 className="text-center text-light mb-3">
        🚘 Datos clave sobre riesgos y costos en el sector asegurador.
      </h6>
      <br></br>
      <div className="row">
        {/* Siniestralidad */}
        <div className="col-md-6 mb-4">
          <div
            className="p-3 rounded modal-grafic"
            style={{ backgroundColor: "#1f2e35" }}
          >
            <h6 className="text-warning text-center mb-2">
              📊 Siniestralidad en el sector asegurador
            </h6>
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie
                  data={siniestralidadData}
                  dataKey="value"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  outerRadius={80}
                  label={({ value }) => `${value}%`}
                >
                  <Cell fill="#66bb6a" />
                  <Cell fill="#f44336" />
                </Pie>
                <Tooltip formatter={(value) => `${value}%`} />
              </PieChart>
            </ResponsiveContainer>
            <p className="text-light text-center mt-2 text-base">
              El 72.6% de los autos asegurados presentan algún siniestro.
            </p>
          </div>
        </div>

        {/* Costos de reparación */}
        <div className="col-md-6 mb-4">
          <div
            className="p-3 rounded modal-grafic"
            style={{ backgroundColor: "#1f2e35" }}
          >
            <h6 className="text-warning text-center mb-2">
              💰 Costos de reparación por accidente
            </h6>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={reparacionData} margin={{ top: 20, left: 15 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" stroke="var(--axis-stroke)" />
                <YAxis
                  stroke="var(--axis-stroke)"
                  tickFormatter={formatCurrency}
                />
                <Tooltip formatter={(value) => value.toLocaleString()} />
                <Legend />
                <Bar dataKey="costo" fill="#f44336" label={renderBarLabel2} />
              </BarChart>
            </ResponsiveContainer>
            <p className="text-light text-center mt-2 text-base">
              Los costos de reparación pueden ser extremadamente elevados sin
              seguro.
            </p>
          </div>
        </div>

        {/* Robo de autos */}
        <div className="col-md-6 mb-4">
          <div
            className="p-3 rounded modal-grafic"
            style={{ backgroundColor: "#1f2e35" }}
          >
            <h6 className="text-warning text-center mb-2">
              🚗 Robo de autos en México
            </h6>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={roboAutosData} margin={{ top: 20, left: 10 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" stroke="var(--axis-stroke)" />
                <YAxis
                  stroke="var(--axis-stroke)"
                  tickFormatter={formatCurrency}
                />
                <Tooltip formatter={(value) => value.toLocaleString()} />
                <Legend />
                <Bar
                  dataKey="vehiculos"
                  fill="#ff9800"
                  label={renderBarLabel2}
                />
              </BarChart>
            </ResponsiveContainer>
            <p className="text-light text-center mt-2 text-base">
              Casi 137,000 autos fueron robados en 2023, más de la mitad sin
              seguro.
            </p>
          </div>
        </div>

        {/* Distribución de tipos de siniestro */}
        <div className="col-md-6 mb-4">
          <div
            className="p-3 rounded modal-grafic"
            style={{ backgroundColor: "#1f2e35" }}
          >
            <h6 className="text-warning text-center mb-2 ">
              📌 Tipos de siniestros más comunes
            </h6>
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie
                  data={distribucionSiniestrosData}
                  dataKey="value"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  outerRadius={80}
                  label={({ name, value }) => `${name}: ${value}%`}
                >
                  <Cell fill="#ffca28" />
                  <Cell fill="#ab47bc" />
                  <Cell fill="#26c6da" />
                </Pie>
                <Tooltip formatter={(value) => `${value}%`} />
              </PieChart>
            </ResponsiveContainer>
            <p className="text-light text-center mt-2 text-base">
              Los daños materiales y responsabilidad civil representan el 80% de
              los siniestros.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

function PosCustomerOrderV2({ order, getSubTotalPrice }) {
  const [vehicleData, setVehicleData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const [agencias, setAgencias] = useState([]);
  const [selectedAgencia, setSelectedAgencia] = useState(null);
  const [loading, setLoading] = useState(false);
  const [initialLoad, setInitialLoad] = useState(true);
  const [precioBaseVehiculo, setPrecioBaseVehiculo] = useState(0);
  const [garantia_extendida, setGarantiaExtendida] = useState(""); //new para modal
  const [mostrarModalInfo, setMostrarModalInfo] = useState(false); //new
  const [isSubmitting, setIsSubmitting] = useState(false); //new
  const [selectedPlan, setSelectedPlan] = useState(null); // new
  const [totalAccesorio, setTotalAccesorio] = useState(0); //total precio plan seleccionado
  const [plans, setPlans] = useState([]); // Estado para los accesorios
  const [selectedMailData, setSelectedMailData] = useState(null); //new
  const [pago_contado, setContado] = useState(false); //new
  const [accessoryModalVisible, setAccessoryModalVisible] = useState(false);
  const [accessoryModalData, setAccessoryModalData] = useState(null); //modal para los accesorios
  const [mailData, setMailData] = useState([]);
  const [isAccessoryModalOpen, setIsAccessoryModalOpen] = useState(false);
  const planesRef = useRef(); //nueva
  const [planSeleccionado, setPlanSeleccionado] = useState(null); //plan seleccionado final
  const [archivos, setArchivos] = useState([]); //aquí guardaremos los PDF
  const [readyToSend, setReadyToSend] = useState(false);
  const [tipoEnvio, setTipoEnvio] = useState("rechazo"); // tipo de envio
  const rechazoSeleccionado =
    garantia_extendida === "Si" || garantia_extendida === "No";
  const [pdfUrlsGeneradas, setPdfUrlsGeneradas] = useState([]); //urls formatos
  const [openPDFModal, setOpenPDFModal] = useState(false); //modal visualizacion
  const pdfUrlsRef = useRef([]);
  const [showOferta, setShowOferta] = useState(false);
  const [descripcionAuto, setDescripcionAuto] = useState(() => {
    return localStorage.getItem("descripcion_auto") || "";
  }); //dexcripción de auto
  const [formData, setFormData] = useState({
    nombre: "",
    apellido_paterno: "",
    apellido_materno: "",
    telefono: "",
    correo_electronico: "",
    acepta_aviso_privacidad: false,
    depende_auto: "",
    condiciones_calle: "",
    perdio_llaves: "",
    tipo_auto: "",
    preocupacion_fallas: "",
    preocupacion_robo: "",
    ingreso_mensual: "",
    //edad: "",
    enganche: "",
    historial_crediticio: "",
    tipo_trabajo: "",
    asesor: "",
    user_id: "",
    venta_id: "",
  });
  const [metodoContacto, setMetodoContacto] = useState("");
  const [origenCliente, setOrigenCliente] = useState("");

  // Evita doble apertura: solo auto-abrimos cuando el usuario “acaba de seleccionar”
  const userJustSelectedRef = useRef(false);

  // Guard para evitar abrir dos veces por carreras
  const isOpeningFichaRef = useRef(false);

  // Por si quieres tracking del último auto-open (no imprescindible, pero útil)
  const lastAutoOpenedKeyRef = useRef(null);

  // Mantiene el auto seleccionado aunque el polling todavía no haya recibido
  // selected_car desde backend. Esto evita que se cierre la ficha técnica al
  // momento de dar clic en "Me interesa".
  const selectedCarRef = useRef(null);
  const inventarioRequestIdRef = useRef(0);
  const pendingVehicleSelectionRef = useRef(false);
  const pendingVehicleSelectionTimerRef = useRef(null);

  const getSelectedCarRenderKey = (sc) =>
    sc ? `${sc.id || ""}|${sc.title || ""}|${sc.description || ""}` : "no-car";

  const markPendingVehicleSelection = useCallback((timeoutMs = 45000) => {
    pendingVehicleSelectionRef.current = true;

    if (pendingVehicleSelectionTimerRef.current) {
      clearTimeout(pendingVehicleSelectionTimerRef.current);
    }

    pendingVehicleSelectionTimerRef.current = setTimeout(() => {
      pendingVehicleSelectionRef.current = false;
      pendingVehicleSelectionTimerRef.current = null;
    }, timeoutMs);
  }, []);

  const clearPendingVehicleSelection = useCallback(() => {
    pendingVehicleSelectionRef.current = false;

    if (pendingVehicleSelectionTimerRef.current) {
      clearTimeout(pendingVehicleSelectionTimerRef.current);
      pendingVehicleSelectionTimerRef.current = null;
    }
  }, []);

  // Candado visual para el regreso al inventario solicitado por el asesor.
  // Mientras el backend termina de limpiar selected_car, ignoramos cualquier
  // selected_car viejo que llegue por polling para evitar que el detalle del
  // vehículo aparezca por unos segundos.
  const [isReturningToInventory, setIsReturningToInventory] = useState(false);
  const returningToInventoryRef = useRef(false);
  const returningToInventoryTimerRef = useRef(null);

  const releaseReturnToInventoryLock = useCallback((delayMs = 0) => {
    if (returningToInventoryTimerRef.current) {
      clearTimeout(returningToInventoryTimerRef.current);
      returningToInventoryTimerRef.current = null;
    }

    const release = () => {
      returningToInventoryRef.current = false;
      setIsReturningToInventory(false);
    };

    if (delayMs > 0) {
      returningToInventoryTimerRef.current = setTimeout(() => {
        returningToInventoryTimerRef.current = null;
        release();
      }, delayMs);
    } else {
      release();
    }
  }, []);

  const beginReturnToInventoryLock = useCallback(() => {
    clearPendingVehicleSelection();
    returningToInventoryRef.current = true;
    setIsReturningToInventory(true);

    if (returningToInventoryTimerRef.current) {
      clearTimeout(returningToInventoryTimerRef.current);
    }

    // Fallback de seguridad por si el polling no alcanza a confirmar el
    // selected_car vacío. Normalmente se libera antes desde el polling.
    returningToInventoryTimerRef.current = setTimeout(() => {
      returningToInventoryTimerRef.current = null;
      returningToInventoryRef.current = false;
      setIsReturningToInventory(false);
    }, 15000);
  }, [clearPendingVehicleSelection]);

  const [filters, setFilters] = useState({
    activo: "",
  });

  const [selectedVersion, setSelectedVersion] = useState(""); // Estado para versión seleccionada
  const [precioVehiculo, setPrecioVehiculo] = useState(0); // Estado para precio del vehículo

  // ====== Acciones solicitadas por asesor hacia cliente ======
  const clienteVolverInventarioProcesadoRef = useRef({});
  const pruebaManejoClientePromptRef = useRef({});
  const [mostrarModalPruebaManejoCliente, setMostrarModalPruebaManejoCliente] =
    useState(false);
  const [isSavingPruebaManejoCliente, setIsSavingPruebaManejoCliente] =
    useState(false);

  const preguntasPruebaManejoCliente = [
    {
      key: "imagen_marca",
      escala: 5,
      pregunta: "¿Hizo que la imagen que tengo de Nissan como marca mejorara?",
    },
    {
      key: "emocion_manejar",
      escala: 5,
      pregunta: "¿Me permitió probar la emoción de tener y manejar el auto?",
    },
    {
      key: "sencillo_solicitar",
      escala: 5,
      pregunta: "¿Fue sencillo de solicitar y utilizar?",
    },
    {
      key: "tecnologias_asistencias",
      escala: 5,
      pregunta:
        "¿Me permitió probar el funcionamiento de tecnologías y asistencias del auto?",
    },
    {
      key: "comodidad_manejo",
      escala: 5,
      pregunta: "¿Me permitió probar la comodidad del manejo?",
    },
    {
      key: "satisfaccion_prueba",
      escala: 10,
      pregunta: "¿Qué tan satisfecho está con la prueba de manejo de Nissan?",
    },
  ];

  const pruebaManejoClienteInicial = {
    realizo_prueba_manejo: "",
    licencia_manejo_frente_nombre: "",
    respuestas: {
      imagen_marca: "",
      emocion_manejar: "",
      sencillo_solicitar: "",
      tecnologias_asistencias: "",
      comodidad_manejo: "",
      satisfaccion_prueba: "",
    },
  };

  const [pruebaManejoClienteData, setPruebaManejoClienteData] = useState(
    pruebaManejoClienteInicial,
  );

  const getPruebaManejoActual = useCallback(() => {
    const raw = selectedMailData?.prueba_manejo;

    if (!raw) return {};

    if (typeof raw === "object") return raw;

    if (typeof raw === "string") {
      try {
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === "object" ? parsed : {};
      } catch (error) {
        return {};
      }
    }

    return {};
  }, [selectedMailData?.prueba_manejo]);

  const getLicenciaManejoFrenteNombreActual = useCallback(
    (fallback = "") => {
      const pruebaActual = getPruebaManejoActual();

      return (
        pruebaManejoClienteData?.licencia_manejo_frente_nombre ||
        pruebaActual?.licencia_manejo_frente_nombre ||
        selectedMailData?.licencia_manejo_frente_nombre ||
        fallback ||
        ""
      );
    },
    [
      getPruebaManejoActual,
      pruebaManejoClienteData?.licencia_manejo_frente_nombre,
      selectedMailData?.licencia_manejo_frente_nombre,
    ],
  );

  const ventaFinalizadaPorAsesor =
    Number(selectedMailData?.venta_finalizada_cliente || 0) === 1;

  const ventaFinalizadaClienteFecha =
    selectedMailData?.venta_finalizada_cliente_fecha || "";

  const ventaFinalizadaClienteNombre =
    selectedMailData?.venta_finalizada_cliente_nombre || "tu asesor";

  const normalizarValorCierre = (value = "") =>
    String(value || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, " ")
      .trim();

  const esValorCompletadoReal = (value = "") => {
    const normalized = normalizarValorCierre(value);

    return (
      normalized === "completado" ||
      normalized === "completada" ||
      normalized === "completed" ||
      normalized.startsWith("completado ") ||
      normalized.startsWith("completada ") ||
      normalized.startsWith("completed ")
    );
  };

  const ventaEstaRealmenteCompletada = [
    selectedMailData?.banorte,
    selectedMailData?.status,
    selectedMailData?.estatus,
    selectedMailData?.activo,
  ].some(esValorCompletadoReal);

  // En cliente estas acciones ya no se muestran: el cierre lo ejecuta el asesor.
  const ocultarAccionesFinalesCliente = true;
  const [isFinalizandoPorAsesor, setIsFinalizandoPorAsesor] = useState(false);
  const finalizacionAsesorProcesadaRef = useRef({});
  const finalizacionAsesorEnProcesoRef = useRef(false);

  const getFinalizacionAsesorKey = useCallback(
    (venta = selectedMailData) => {
      if (!venta?.id) return "";

      return `${venta.id}-${
        venta?.venta_finalizada_cliente_fecha || "sin-fecha"
      }`;
    },
    [selectedMailData],
  );

  // Si el asesor ya mandó la instrucción, el cliente debe ejecutar el cierre
  // completo aunque la BD ya traiga algún campo como "Completado". Ese valor
  // puede venir del asesor y antes bloqueaba el envío de correos / nuevo folio.
  const ventaFinalizacionPendientePorAsesor =
    ventaFinalizadaPorAsesor &&
    !finalizacionAsesorProcesadaRef.current[getFinalizacionAsesorKey()];

  const obtenerVentaActualizadaParaDocumentos = async () => {
    const folioActual =
      selectedMailData?.folio_venta ||
      selectedMailData?.folio ||
      resolveFolioVenta();

    if (!folioActual) return selectedMailData;

    try {
      const response = await fetch(
        "https://api.checkmark.mx/obtener/venta/financiamiento",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            access_token: accessToken,
            folio_venta: folioActual,
          }),
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const json = await response.json();
      const ventaActualizada = json?.data?.resultados?.[0] || null;

      if (!ventaActualizada) return selectedMailData;

      const folioRespuesta = String(
        ventaActualizada?.folio_venta ||
          ventaActualizada?.folio ||
          ventaActualizada?.folioVenta ||
          "",
      ).trim();

      if (folioRespuesta && folioRespuesta !== String(folioActual).trim()) {
        return selectedMailData;
      }

      setSelectedMailData(ventaActualizada);
      setMailData((prev) =>
        prev.map((item) =>
          String(item.id) === String(ventaActualizada.id)
            ? ventaActualizada
            : item,
        ),
      );

      return ventaActualizada;
    } catch (error) {
      console.warn(
        "No se pudo refrescar la venta antes de generar documentos:",
        error,
      );
      return selectedMailData;
    }
  };

  const generarDocumentosFinalizacionSilenciosa = async () => {
    const ventaParaDocumentos = await obtenerVentaActualizadaParaDocumentos();
    const documentos = [];

    const pushSystemPDF = (url, file) => {
      if (url || file) {
        documentos.push({
          url,
          file,
          esAdjunto: false,
        });
      }
    };

    if (selectedMailData?.depende_auto === "Si") {
      const { url: urlContado, file: pdfContado } = await generarPDFcontado();
      const { url: urlSeguro, file: pdfSeguro } =
        (await generarPDFseguro()) || {};

      pushSystemPDF(urlSeguro, pdfSeguro);
      pushSystemPDF(urlContado, pdfContado);
    } else {
      const pdfProcotiza = crearPdfDesdeBase64(
        ventaParaDocumentos?.procotiza_pdf_base64,
        `Cotizacion_Procotiza_${ventaParaDocumentos?.nombre || "Cliente"}.pdf`,
      );
      const pdfFinanciamiento = pdfProcotiza || (await generarPDF());
      const { url: urlSeguro, file: pdfSeguro } =
        (await generarPDFseguro()) || {};

      pushSystemPDF(urlSeguro, pdfSeguro);
      pushSystemPDF(pdfFinanciamiento?.url, pdfFinanciamiento?.file);
    }

    if (garantia_extendida === "Si") {
      const { url: urlAcept, file: pdfAcept } = await generarPDFAceptacion();
      pushSystemPDF(urlAcept, pdfAcept);
    }

    const renunciaResult = await generarPDFrenuncia();
    pushSystemPDF(renunciaResult?.url, renunciaResult?.file);

    pdfUrlsRef.current = documentos;
    setPdfUrlsGeneradas(documentos);

    return documentos;
  };

  const finalizarVentaCompletaCliente = async ({
    desdeAsesor = false,
    pedirConfirmacion = true,
  } = {}) => {
    if (isSubmittingFinalizar || isFinalizandoPorAsesor) return false;

    if (!selectedMailData?.id) {
      if (!desdeAsesor) {
        await Swal.fire({
          title: "Sin venta",
          text: "No se encontró la venta activa para finalizar.",
          icon: "warning",
          confirmButtonText: "Aceptar",
        });
      }
      return false;
    }

    if (pedirConfirmacion) {
      const confirm = await Swal.fire({
        title: "¿Finalizar venta?",
        text: "Se guardará la venta como completada.",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí, finalizar",
        cancelButtonText: "Cancelar",
        reverseButtons: true,
      });

      if (!confirm.isConfirmed) return false;
    }

    try {
      setIsSubmittingFinalizar(true);
      if (desdeAsesor) setIsFinalizandoPorAsesor(true);

      if (desdeAsesor) {
        Swal.fire({
          title: "Finalizando venta",
          text: `${ventaFinalizadaClienteNombre} finalizó esta venta. Estamos enviando documentos y preparando un nuevo folio.`,
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
            const container = document.querySelector(".swal2-container");
            if (container) container.style.zIndex = "2147482500";
          },
        });
      }

      // Si el último modal ya tenía documentos, se usan. Si todavía no existen,
      // se generan en silencio para ejecutar el mismo cierre completo.
      let documentosFinales =
        Array.isArray(pdfUrlsGeneradas) && pdfUrlsGeneradas.length > 0
          ? pdfUrlsGeneradas
          : Array.isArray(pdfUrlsRef.current) && pdfUrlsRef.current.length > 0
            ? pdfUrlsRef.current
            : [];

      if (!documentosFinales.length) {
        documentosFinales = await generarDocumentosFinalizacionSilenciosa();
      }

      const archivosAEnviar = (
        await Promise.all(
          documentosFinales.map(async (pdf, index) => {
            if (pdf?.file instanceof File) {
              return pdf.file;
            }

            if (pdf?.url) {
              return await recuperarArchivoDeUrl(
                pdf.url,
                pdf.nombre || `documento_${index}.pdf`,
              );
            }

            return null;
          }),
        )
      ).filter(Boolean);

      console.log("Enviando documentos...");
      const envioExitoso = await enviarArchivos(archivosAEnviar);

      if (envioExitoso) {
        console.log("Correo enviado con éxito");
      } else {
        console.warn(
          "El correo no se envió o no regresó confirmación, se continúa con el guardado.",
        );
      }

      const folioActual =
        selectedMailData?.folio_venta ||
        selectedMailData?.folio ||
        resolveFolioVenta();

      const checkResp = await fetch(apiPDFverificar, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          access_token: accessToken,
          folio_venta: folioActual,
        }),
      });

      const checkJson = await checkResp.json();
      const existePdfManual = checkJson?.data?.existe_pdf;

      if (!existePdfManual && archivosAEnviar.length > 0) {
        await subirPdfAdjuntoABD(archivosAEnviar[0]);
      } else {
        console.log("Ya hay un archivo en contenido. No se sobrescribe.");
      }

      const resp = await fetch(apiUrlUpdate, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          access_token: accessToken,
          venta_id: selectedMailData.id,
          banorte: "Completado",
        }),
      });

      if (!resp.ok) throw new Error(`HTTP ${resp.status}`);

      setSelectedMailData((prev) =>
        prev
          ? {
              ...prev,
              banorte: "Completado",
            }
          : prev,
      );

      setMailData((prev) =>
        prev.map((item) =>
          String(item.id) === String(selectedMailData.id)
            ? {
                ...item,
                banorte: "Completado",
              }
            : item,
        ),
      );

      setOpenPDFModal(false);
      setIsAccessoryModalOpen?.(false);
      setMostrarVideoIntro?.(false);
      setMostrarModalAccesorios?.(false);
      setOpenFicha?.(false);

      if (!desdeAsesor) {
        await Swal.fire({
          title: "¡Venta finalizada!",
          text: "La venta se guardó correctamente como completada.",
          icon: "success",
          confirmButtonText: "Aceptar",
        });
      }

      await new Promise((r) => setTimeout(r, 20));
      await forceCloseAllModals({
        dispose: true,
        timeoutMs: 250,
      });

      stopPolling?.();
      resettingSaleRef.current = true;

      const newFolio = await resetAndStartNewSale({
        setFolioVenta,
        setSelectedCar,
        setModalData,
        setOrderData,
        setGarantiaExtendida,
        setSelectedVersion,
        initialModalData: null,
      });

      if (desdeAsesor) {
        Swal.close();
      } else {
        await Swal.fire({
          title: "Nueva venta lista",
          text: `Se generó el folio ${newFolio}.`,
          icon: "info",
          confirmButtonText: "Continuar",
        });
      }

      return true;
    } catch (err) {
      console.error(err);

      await Swal.fire({
        title: "Error",
        text: desdeAsesor
          ? "El asesor finalizó la venta, pero ocurrió un problema al ejecutar el cierre completo en cliente."
          : "Ocurrió un problema al finalizar la venta.",
        icon: "error",
        confirmButtonText: "Aceptar",
      });

      return false;
    } finally {
      setIsSubmittingFinalizar(false);
      setIsFinalizandoPorAsesor(false);
    }
  };

  useEffect(() => {
    if (!selectedMailData?.id) return;

    const finalizadaPorAsesor =
      Number(selectedMailData?.venta_finalizada_cliente || 0) === 1;

    if (!finalizadaPorAsesor) return;

    // El cierre real debe ejecutarse aunque algún campo ya venga como
    // "Completado", porque el asesor puede guardar ese estado antes de que
    // el cliente envíe correos y genere el nuevo folio.
    const key = getFinalizacionAsesorKey(selectedMailData);

    if (finalizacionAsesorProcesadaRef.current[key]) return;
    if (finalizacionAsesorEnProcesoRef.current) return;

    finalizacionAsesorEnProcesoRef.current = true;

    (async () => {
      const ok = await finalizarVentaCompletaCliente({
        desdeAsesor: true,
        pedirConfirmacion: false,
      });

      // Solo marcamos como procesada cuando el cierre completo sí terminó.
      // Si algo falla o estaba ocupado, podrá reintentarse en el siguiente cambio/polling.
      if (ok) {
        finalizacionAsesorProcesadaRef.current[key] = true;
      }

      finalizacionAsesorEnProcesoRef.current = false;
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedMailData?.id,
    selectedMailData?.venta_finalizada_cliente,
    selectedMailData?.venta_finalizada_cliente_fecha,
    getFinalizacionAsesorKey,
  ]);

  // useEffect para sincronizar cuando llegan datos del asesor
  useEffect(() => {
    if (selectedMailData?.version_vehiculo) {
      setSelectedVersion(selectedMailData.version_vehiculo);
      setPrecioVehiculo(Number(selectedMailData.precio_vehiculo) || 0);
    }
  }, [selectedMailData]);

  // Efecto para actualizar selectedMailData cuando cambia mailData
  useEffect(() => {
    if (mailData.length > 0 && selectedMailData) {
      console.log("CONTENIDO DE mai:", selectedMailData);
      const updatedClient = mailData.find(
        (cliente) => cliente.id === selectedMailData.id,
      );
      setSelectedMailData(updatedClient || null);
    }
  }, [mailData]); // Este efecto sigue funcionando cuando mailData cambia

  useEffect(() => {
    const handleGlobalError = (event) => {
      if (isPdfWorkerAbortError(event?.error || event?.message)) {
        event.preventDefault?.();
        return;
      }

      console.error("Error global capturado:", event.error);
      console.error("Evento completo:", event);
    };

    const handleUnhandledRejection = (event) => {
      if (isPdfWorkerAbortError(event?.reason || event)) {
        event.preventDefault?.();
        return;
      }

      console.error("Promesa rechazada sin catch:", event.reason);
      console.error("Evento completo:", event);
    };

    window.addEventListener("error", handleGlobalError);
    window.addEventListener("unhandledrejection", handleUnhandledRejection);

    return () => {
      window.removeEventListener("error", handleGlobalError);
      window.removeEventListener(
        "unhandledrejection",
        handleUnhandledRejection,
      );
    };
  }, []);

  const handleVolverInventario = async () => {
    const folio = resolveFolioVenta();

    // UI inmediata: primero ponemos el cliente en modo inventario y activamos
    // el candado para que el polling no rehidrate un selected_car viejo.
    beginReturnToInventoryLock();
    setOpenFicha(false);
    setFichaURL("");
    setSelectedCar(null);
    selectedCarRef.current = null;
    setSelectedVersion?.(null);

    // Limpia caches y locks de auto-open
    try {
      sessionStorage.removeItem(`selected_car_${folio}`);
      sessionStorage.removeItem(`selectedCar_${folio}`);
      sessionStorage.removeItem(`version_vehiculo_${folio}`);
      localStorage.removeItem(`selected_car_${folio}`);
      localStorage.removeItem(`selectedCar_${folio}`);
    } catch {}

    userJustSelectedRef.current = false;
    lastAutoOpenedKeyRef.current = null;

    // Limpia en backend. El candado se libera cuando el polling confirma que
    // selected_car ya viene vacío; si no llega esa confirmación, se libera por
    // timeout de seguridad.
    try {
      await fetch("https://api.checkmark.mx/cliente/ventas/financiamiento", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          access_token: accessToken,
          folio_venta: folio,
          clear_selected_car: true,
        }),
      });
    } catch (error) {
      console.warn("No se pudo limpiar selected_car:", error);
    }
  };

  const limpiarFlagVolverInventarioCliente = async (ventaId) => {
    if (!ventaId) return;

    try {
      await fetch(
        "https://api.checkmark.mx/ventas/cliente/limpiar-volver-inventario",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            access_token: accessToken,
            venta_id: ventaId,
          }),
        },
      );
    } catch (error) {
      console.warn("No se pudo limpiar cliente_volver_inventario:", error);
    }
  };

  const ejecutarVolverInventarioSolicitadoPorAsesor = async () => {
    const ventaId = selectedMailData?.id;
    if (!ventaId) return;

    try {
      // Respuesta visual inmediata: el asesor es quien dispara el regreso,
      // por eso el cliente no debe ver el detalle ni el botón de regreso.
      beginReturnToInventoryLock();
      setSelectedCar(null);
      selectedCarRef.current = null;
      setSelectedVersion?.(null);

      // Cerrar primero los modales controlados por React.
      // Esto evita el error removeChild cuando React intenta desmontar un modal
      // que ya fue manipulado directamente desde el DOM.
      cerrarGaleriaFotosSeminuevo({ limpiar: true });
      setOpenFicha(false);
      setFichaURL("");
      setOpenPDFModal(false);
      setMostrarModalPruebaManejoCliente(false);
      setAccessoryModalVisible(false);
      setAccessoryModalData(null);
      setIsAccessoryModalOpen(false);
      setShowModal(false);

      // Empezamos a limpiar backend mientras se muestra el aviso.
      const limpiarSeleccionPromise = handleVolverInventario();

      // Esperamos a que React quite los modales/backdrops antes de mostrar Swal.
      // Importante: forceCloseAllModals ya no borra nodos dentro del root de React,
      // para evitar el error removeChild cuando React desmonta el visor PDF.
      await new Promise((resolve) => requestAnimationFrame(resolve));
      await new Promise((resolve) => requestAnimationFrame(resolve));
      await forceCloseAllModals({
        dispose: false,
        timeoutMs: 120,
        removeReactBackdrops: false,
      });
      await new Promise((resolve) => setTimeout(resolve, 80));

      await Swal.fire({
        icon: "info",
        title: "Regresando al inventario",
        text: "Tu asesor solicitó regresar al inventario para continuar con la selección.",
        confirmButtonText: "Aceptar",
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          const container = document.querySelector(".swal2-container");
          if (container) container.style.zIndex = "200000";
        },
      });

      await limpiarSeleccionPromise;
      await limpiarFlagVolverInventarioCliente(ventaId);

      setSelectedMailData((prev) =>
        prev
          ? {
              ...prev,
              cliente_volver_inventario: 0,
            }
          : prev,
      );

      setMailData((prev) =>
        prev.map((item) =>
          String(item.id) === String(ventaId)
            ? {
                ...item,
                cliente_volver_inventario: 0,
              }
            : item,
        ),
      );
    } catch (error) {
      console.error("Error al ejecutar volver a inventario:", error);
    }
  };

  const updatePruebaManejoClienteRespuesta = (key, value) => {
    setPruebaManejoClienteData((prev) => ({
      ...prev,
      realizo_prueba_manejo: "Si",
      // No limpiamos la licencia porque el asesor puede subirla mientras el
      // cliente sigue contestando la encuesta.
      licencia_manejo_frente_nombre:
        prev.licencia_manejo_frente_nombre ||
        getLicenciaManejoFrenteNombreActual(),
      respuestas: {
        ...(prev.respuestas || {}),
        [key]: value,
      },
    }));
  };

  const guardarRespuestaPruebaManejoCliente = async (
    respuestaCliente,
    dataOverride = null,
    opciones = {},
  ) => {
    const {
      cerrarModal = true,
      mostrarAlerta = true,
      textoExito = "",
    } = opciones || {};

    const ventaId = selectedMailData?.id;

    if (!ventaId) {
      Swal.fire("Sin venta", "No se encontró la venta activa.", "warning");
      return false;
    }

    const pruebaActual = getPruebaManejoActual();
    const licenciaActual = getLicenciaManejoFrenteNombreActual();

    const dataToSave =
      dataOverride ||
      (respuestaCliente === "No"
        ? {
            ...pruebaManejoClienteInicial,
            realizo_prueba_manejo: "No",
          }
        : {
            ...pruebaManejoClienteInicial,
            ...pruebaActual,
            ...pruebaManejoClienteData,
            realizo_prueba_manejo: "Si",
            licencia_manejo_frente_nombre: licenciaActual,
            respuestas: {
              ...(pruebaManejoClienteInicial.respuestas || {}),
              ...(pruebaActual.respuestas || {}),
              ...(pruebaManejoClienteData.respuestas || {}),
            },
          });

    try {
      setIsSavingPruebaManejoCliente(true);

      const resp = await fetch(
        "https://api.checkmark.mx/ventas/cliente/responder-prueba-manejo",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            access_token: accessToken,
            venta_id: ventaId,
            respuesta_prueba_manejo_cliente: respuestaCliente,
            encuesta_prueba_manejo_completa:
              respuestaCliente === "Si" && cerrarModal,
            solo_confirmar_prueba_manejo:
              respuestaCliente === "Si" && !cerrarModal,
            prueba_manejo: dataToSave,
          }),
        },
      );

      const json = await resp.json();

      if (!resp.ok || json.status !== "success") {
        throw new Error(json.message || "No se pudo guardar la respuesta.");
      }

      const fechaRespuesta = new Date().toISOString();

      setSelectedMailData((prev) =>
        prev
          ? {
              ...prev,
              respuesta_prueba_manejo_cliente: respuestaCliente,
              respuesta_prueba_manejo_fecha: fechaRespuesta,
              solicitar_prueba_manejo_cliente: 0,
              prueba_manejo: dataToSave,
            }
          : prev,
      );

      setMailData((prev) =>
        prev.map((item) =>
          String(item.id) === String(ventaId)
            ? {
                ...item,
                respuesta_prueba_manejo_cliente: respuestaCliente,
                respuesta_prueba_manejo_fecha: fechaRespuesta,
                solicitar_prueba_manejo_cliente: 0,
                prueba_manejo: dataToSave,
              }
            : item,
        ),
      );

      if (cerrarModal) {
        setMostrarModalPruebaManejoCliente(false);
      }

      if (mostrarAlerta) {
        await Swal.fire({
          icon: "success",
          title: "Respuesta guardada",
          text:
            textoExito ||
            (respuestaCliente === "Si"
              ? "Gracias por contestar la encuesta de prueba de manejo."
              : "Se guardó tu respuesta."),
          timer: 1800,
          showConfirmButton: false,
        });
      }

      return true;
    } catch (error) {
      Swal.fire(
        "Error",
        error.message || "No se pudo guardar la prueba de manejo.",
        "error",
      );
      return false;
    } finally {
      setIsSavingPruebaManejoCliente(false);
    }
  };

  const abrirSolicitudPruebaManejoCliente = async () => {
    cerrarGaleriaFotosSeminuevo();

    await new Promise((resolve) => requestAnimationFrame(resolve));

    const result = await Swal.fire({
      icon: "question",
      title: "Prueba de manejo",
      text: "Tu asesor te está solicitando confirmar si aceptas realizar la prueba de manejo.",
      showCancelButton: true,
      confirmButtonText: "Sí, acepto",
      cancelButtonText: "No, gracias",
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        // El PDF de ficha técnica también es fullscreen; subimos el SweetAlert
        // para que la solicitud siempre se vea encima del visor.
        const container = document.querySelector(".swal2-container");
        if (container) container.style.zIndex = "2147482500";
      },
    });

    if (result.isConfirmed) {
      const dataInicial = {
        ...pruebaManejoClienteInicial,
        realizo_prueba_manejo: "Si",
        licencia_manejo_frente_nombre: getLicenciaManejoFrenteNombreActual(),
      };

      setPruebaManejoClienteData(dataInicial);

      // Guardamos inmediatamente el "Sí acepto" para que el asesor vea la
      // aceptación y pueda cargar la licencia antes de que termine la encuesta.
      const aceptacionGuardada = await guardarRespuestaPruebaManejoCliente(
        "Si",
        dataInicial,
        {
          cerrarModal: false,
          mostrarAlerta: false,
        },
      );

      if (!aceptacionGuardada) return;

      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Aceptación registrada. El asesor ya puede cargar la licencia.",
        timer: 2200,
        showConfirmButton: false,
      });

      // NO cerramos el PDF/ficha técnica del vehículo. La encuesta se monta
      // por Portal directo en document.body y con z-index máximo para quedar
      // encima de cualquier visor, backdrop o SweetAlert activo.
      cerrarGaleriaFotosSeminuevo();
      await new Promise((resolve) => requestAnimationFrame(resolve));
      setMostrarModalPruebaManejoCliente(true);
      return;
    }

    await guardarRespuestaPruebaManejoCliente("No", {
      ...pruebaManejoClienteInicial,
      realizo_prueba_manejo: "No",
    });
  };

  const guardarEncuestaPruebaManejoCliente = async () => {
    const respuestas = pruebaManejoClienteData.respuestas || {};
    const incompletas = preguntasPruebaManejoCliente.filter(
      (item) => String(respuestas[item.key] || "").trim() === "",
    );

    if (incompletas.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "Encuesta incompleta",
        text: "Contesta todas las preguntas para continuar.",
      });
      return;
    }

    const licenciaActual = getLicenciaManejoFrenteNombreActual(
      pruebaManejoClienteData?.licencia_manejo_frente_nombre || "",
    );

    await guardarRespuestaPruebaManejoCliente(
      "Si",
      {
        ...pruebaManejoClienteData,
        realizo_prueba_manejo: "Si",
        licencia_manejo_frente_nombre: licenciaActual,
      },
      {
        cerrarModal: true,
        mostrarAlerta: true,
      },
    );
  };

  useEffect(() => {
    if (!selectedMailData?.id) return;

    const debeVolverInventario =
      Number(selectedMailData?.cliente_volver_inventario || 0) === 1;

    if (!debeVolverInventario) return;

    const key = `${selectedMailData.id}-${
      selectedMailData?.cliente_volver_inventario_fecha || "sin-fecha"
    }`;

    if (clienteVolverInventarioProcesadoRef.current[key]) return;

    // Antes se ignoraba esta instrucción si la ficha/PDF estaba abierta.
    // Eso hacía que el asesor enviara "volver a inventario", el cliente limpiara
    // el flag y nunca regresara. Ahora siempre se ejecuta la acción.
    clienteVolverInventarioProcesadoRef.current[key] = true;
    ejecutarVolverInventarioSolicitadoPorAsesor();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedMailData?.id,
    selectedMailData?.cliente_volver_inventario,
    selectedMailData?.cliente_volver_inventario_fecha,
  ]);

  useEffect(() => {
    if (!selectedMailData?.id) return;

    const solicitarPrueba =
      Number(selectedMailData?.solicitar_prueba_manejo_cliente || 0) === 1;

    const respuesta = String(
      selectedMailData?.respuesta_prueba_manejo_cliente || "",
    ).trim();

    const yaRespondio = respuesta === "Si" || respuesta === "No";

    if (!solicitarPrueba || yaRespondio || mostrarModalPruebaManejoCliente) {
      return;
    }

    const key = `${selectedMailData.id}-${
      selectedMailData?.solicitar_prueba_manejo_fecha || "sin-fecha"
    }`;

    if (pruebaManejoClientePromptRef.current[key]) return;

    pruebaManejoClientePromptRef.current[key] = true;
    abrirSolicitudPruebaManejoCliente();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedMailData?.id,
    selectedMailData?.solicitar_prueba_manejo_cliente,
    selectedMailData?.solicitar_prueba_manejo_fecha,
    selectedMailData?.respuesta_prueba_manejo_cliente,
    mostrarModalPruebaManejoCliente,
  ]);

  const apiUpdateVersionUrl =
    "https://api.checkmark.mx/actualizar/version/vehiculo/financiamiento";

  const handleVersionSelect = (version) => {
    const versionPrice = parseFloat(version.price || 0);
    setSelectedVersion(version.text);
    setPrecioVehiculo(versionPrice);

    const versionRequestData = {
      access_token: accessToken,
      venta_id: selectedMailData.id,
      version_vehiculo: version.text,
      precio_vehiculo: Math.round(versionPrice),
      precio_total: Math.round(versionPrice), // suma accesorios si aplica
    };

    fetch(apiUpdateVersionUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(versionRequestData),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});
  };

  const [tabActiva, setTabActiva] = useState("garantias");

  const GarantiasSlider = memo(function GarantiasSlider({
    garantias,
    onShowModal,
    isInCart,
    addToCartDirectly,
  }) {
    const sliderRef = useRef(null);

    const settings = {
      dots: false,
      infinite: garantias.length > 1,
      speed: 500,
      slidesToShow: Math.min(1, garantias.length),
      slidesToScroll: 1,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 3000,
      waitForAnimate: true,
      swipeToSlide: true,
      draggable: true,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: Math.min(2, garantias.length),
            slidesToScroll: 1,
            dots: garantias.length > 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: garantias.length > 1,
          },
        },
      ],
    };

    const handleFavClick = useCallback(
      (g, e) => {
        e.stopPropagation();
        if (!isInCart(g)) {
          addToCartDirectly(g);
        } else {
          Swal.fire(
            "Ya agregado",
            "Este elemento ya está en favoritos",
            "info",
          );
        }
      },
      [isInCart, addToCartDirectly],
    );

    const nextSlide = useCallback(() => sliderRef.current?.slickNext(), []);
    const prevSlide = useCallback(() => sliderRef.current?.slickPrev(), []);

    return (
      <div className="slider-container">
        <div className="sticky-search-bar mb-3 px-3">
          <input
            type="text"
            className="form-control search-input"
            placeholder="Buscar accesorio o garantía…"
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
            //autoFocus
          />
          {busqueda && (
            <button
              type="button"
              onClick={() => setBusqueda("")}
              className="btn position-absolute end-0 top-50 translate-middle-y me-4 p-0 border-0 bg-transparent text-white"
              style={{ fontSize: "1.2rem" }}
            >
              &times;
            </button>
          )}
        </div>

        {garantias.length === 0 ? (
          <div className="text-white text-center w-100 py-4">
            No se encontraron resultados
          </div>
        ) : garantias.length === 1 ? (
          (() => {
            const g = garantias[0];
            return (
              <div className="px-2">
                <Card
                  g={g}
                  onShowModal={onShowModal}
                  isInCart={isInCart}
                  handleFavClick={handleFavClick}
                  isCash={selectedMailData?.depende_auto === "Si"}
                  meses={Number(selectedMailData?.meses_financiamiento || 0)}
                />
              </div>
            );
          })()
        ) : (
          <>
            <Slider {...settings} ref={sliderRef} className="px-2">
              {garantias.map((g, idx) => (
                <div key={g.id ?? idx} className="px-2">
                  <Card
                    g={g}
                    onShowModal={onShowModal}
                    isInCart={isInCart}
                    handleFavClick={handleFavClick}
                    isCash={selectedMailData?.depende_auto === "Si"}
                    meses={Number(selectedMailData?.meses_financiamiento || 0)}
                  />
                </div>
              ))}
            </Slider>

            <div className="slider-controls mt-3 text-center">
              <button
                onClick={prevSlide}
                className="btn btn-outline-light me-2"
              >
                <i className="fas fa-chevron-left" />
              </button>
              <button onClick={nextSlide} className="btn btn-outline-light">
                <i className="fas fa-chevron-right" />
              </button>
            </div>
          </>
        )}
      </div>
    );
  });

  function Card({ g, onShowModal, isInCart, handleFavClick, isCash, meses }) {
    const price = Number(g.price || 0);
    const months = Number(meses || 0);

    const calcPMT = (principal, n) => {
      const tasa = TASA_ANUAL_FINANCIAMIENTO / 12;
      if (!n || n <= 0) return 0;
      const f = Math.pow(1 + tasa, n);
      return (principal * tasa * f) / (f - 1);
    };

    const addonMonthly = (() => {
      if (!months || months <= 0) return 0;

      // CONTADO: MSI 0% -> solo dividir entre meses
      if (isCash) return Math.round(price / months);

      // CRÉDITO: PMT con tasa
      return Math.round(calcPMT(price, months));
    })();

    return (
      <div
        className={
          "pos-product card p-2 h-100" + (!g.available ? " not-available" : "")
        }
        style={{
          cursor: "pointer",
          boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
          borderRadius: "8px",
          backgroundColor: "#1f3a47",
          transition: "transform 0.2s ease",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
        onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        onClick={() => onShowModal(g)}
      >
        {/* favorito */}
        <i
          className={isInCart(g) ? "fas fa-heart" : "far fa-heart"}
          title={isInCart(g) ? "Ya agregado" : "Agregar a favoritos"}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            fontSize: "1.2rem",
            color: "#fff",
            background: "linear-gradient(135deg, #ff6f00, #ffb74d)",
            borderRadius: "50%",
            padding: "10px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
            cursor: "pointer",
            transition: "transform 0.2s",
            zIndex: 2,
          }}
          onClick={(e) => handleFavClick(g, e)}
          onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        />

        {/* imagen */}
        <div
          className="img mb-2"
          style={{ borderRadius: "6px", overflow: "hidden" }}
        >
          <img
            src={g.image}
            onError={(e) => (e.target.src = "/assets/img/product/noimage.png")}
            alt={g.title}
            style={{
              width: "100%",
              height: "150px",
              objectFit: "cover",
              borderRadius: "8px",
            }}
          />
        </div>

        {/* texto */}
        <div className="info text-white">
          <div className="title fw-bold new-font">
            {toTitleCase(g.title.split(" - ")[0])}
          </div>
          <div
            className="desc new-font-14"
            style={{ fontSize: "0.9rem", opacity: 0.8 }}
          >
            {g.modelo
              ? (() => {
                  const normalized =
                    g.modelo.charAt(0).toUpperCase() +
                    g.modelo.slice(1).toLowerCase();
                  return normalized.length > 100
                    ? normalized.slice(0, 100) + "…"
                    : normalized;
                })()
              : ""}
          </div>

          {/* Por $X más */}
          {months > 0 && (
            <div
              className="addon-price"
              style={{ fontSize: "0.8rem", marginTop: "4px", color: "#ccc" }}
            >
              Por $
              {addonMonthly.toLocaleString("en-MX", {
                maximumFractionDigits: 0,
              })}{" "}
              más al mes
            </div>
          )}
        </div>
      </div>
    );
  }

  const agregarArchivo = (nuevo) => {
    //agregar los archivos al array

    setArchivos((prev) => {
      const nuevosArchivos =
        nuevo instanceof FileList || Array.isArray(nuevo)
          ? [...nuevo]
          : [nuevo];

      console.log("Agregando archivos:", nuevosArchivos); // <- log aquí

      return [...prev, ...nuevosArchivos];
    });
  };

  const accessToken =
    "1MhYphhrGUbgbdRy7cyYFGQlXS7tAi6ooUoptkHQbOm9GcsKiZM7uMF1MERxwMWq30I7Y3"; // El token de acceso
  const apiUrlConsulta = "https://api.checkmark.mx/ventas/telefono/consultar"; // La URL de la API
  const apiUrlUpdate =
    "https://api.checkmark.mx/actualizar/estado/financiamiento"; //actualizar los estados
  const apiPDFverificar = "https://api.checkmark.mx/verificar/pdf/adjunto"; //verificar pdf adjunto
  const apiUrlAsesores = "https://api.checkmark.mx/obtener/asesores/agencia";
  const apiUrlImagenes = "https://api.checkmark.mx/convertir/imagen";
  const apiUrlSeguro = "https://api.checkmark.mx/consultar/seguro"; //consultar seguros

  const obtenerAsesores = async (ag_id) => {
    try {
      const response = await fetch(apiUrlAsesores, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          access_token: accessToken,
          ag_id: ag_id,
        }),
      });

      const result = await response.json();

      if (result.statusCode === 200 && result.data?.asesores) {
        return result.data.asesores;
      } else {
        return [];
      }
    } catch (error) {
      return [];
    }
  };

  const generarDocumentos = async () => {
    if (!selectedMailData) return;

    try {
      const ventaParaDocumentos = await obtenerVentaActualizadaParaDocumentos();

      if (!ventaParaDocumentos) return;

      handleCloseModalFinanciamiento();
      pdfUrlsRef.current = [];

      // Función auxiliar para no repetir código
      const pushSystemPDF = (url, file) => {
        if (url) {
          pdfUrlsRef.current.push({ url, file, esAdjunto: false });
        }
      };

      if (selectedMailData?.depende_auto === "Si") {
        const { url: urlContado, file: pdfContado } = await generarPDFcontado();
        const { url: urlSeguro, file: pdfSeguro } =
          (await generarPDFseguro()) || {};

        pushSystemPDF(urlSeguro, pdfSeguro);
        pushSystemPDF(urlContado, pdfContado);
      } else {
        const pdfProcotiza = crearPdfDesdeBase64(
          ventaParaDocumentos?.procotiza_pdf_base64,
          `Cotizacion_Procotiza_${ventaParaDocumentos?.nombre || "Cliente"}.pdf`,
        );
        const pdfFinanciamiento = pdfProcotiza || (await generarPDF());
        const { url: urlSeguro, file: pdfSeguro } =
          (await generarPDFseguro()) || {};

        pushSystemPDF(urlSeguro, pdfSeguro);
        pushSystemPDF(pdfFinanciamiento?.url, pdfFinanciamiento?.file);
      }

      if (garantia_extendida === "Si") {
        const { url: urlAcept, file: pdfAcept } = await generarPDFAceptacion();
        pushSystemPDF(urlAcept, pdfAcept);
      }

      const renunciaResult = await generarPDFrenuncia();
      pushSystemPDF(renunciaResult?.url, renunciaResult?.file);

      const result = await Swal.fire({
        icon: "success",
        title: "Listo",
        text: "Documentos generados correctamente",
        confirmButtonText: "Aceptar",
      });

      if (result.isConfirmed) {
        setIsActive(false);
        await fetch(apiUrlUpdate, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            access_token: accessToken,
            venta_id: selectedMailData.id,
            financiamiento_modal: "0",
          }),
        });

        setFinanciamientoModalValue("0");
        setPdfUrlsGeneradas([...pdfUrlsRef.current]);
        cerrarGaleriaFotosSeminuevo();
        setOpenPDFModal(true);
      }
    } catch (error) {
      await Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al generar los documentos.",
        confirmButtonText: "Aceptar",
      });
    }
  };

  useEffect(() => {
    const handleStorageEvent = (event) => {
      if (event.key === "selectedMailData" && event.newValue) {
        try {
          const parsedData = JSON.parse(event.newValue);
          setSelectedMailData(parsedData); // <- Esto activa tu useEffect existente
        } catch (error) {}
      }
    };

    window.addEventListener("storage", handleStorageEvent);
    return () => window.removeEventListener("storage", handleStorageEvent);
  }, []);

  useEffect(() => {
    try {
      // 1) Parsear planes
      let planes = [];
      try {
        planes = JSON.parse(selectedMailData?.planes_financiamiento || "[]");
        if (!Array.isArray(planes)) planes = [];
      } catch {
        planes = [];
      }

      // 2) Recuperar selección previa (opcional). Si QUIERES que solo se vea cuando ya hubo selección antes,
      // entonces NO auto-selecciones aquí. Solo intenta recuperar una previa de storage:
      const folioVenta = resolveFolioVenta?.();
      const storageKey = folioVenta ? `selectedPlanTitle:${folioVenta}` : null;
      const rememberedTitle = storageKey
        ? localStorage.getItem(storageKey)
        : null;

      // Si ninguno viene seleccionado PERO hay uno recordado, márcalo:
      if (!planes.some((p) => p.isSelected) && rememberedTitle) {
        planes = planes.map((p) => ({
          ...p,
          isSelected: p.title === rememberedTitle,
        }));
      }

      // 3) Encontrar el plan seleccionado (si existe)
      const planSeleccionado =
        planes.find((p) => p.isSelected && !esPlanClienteFinanciamiento(p)) ||
        null;

      // 4) Accesorios
      let accesoriosRaw = planSeleccionado?.accessories || [];
      if (typeof accesoriosRaw === "string") {
        try {
          accesoriosRaw = JSON.parse(accesoriosRaw);
          if (typeof accesoriosRaw === "string") {
            accesoriosRaw = JSON.parse(accesoriosRaw);
          }
        } catch {
          accesoriosRaw = [];
        }
      }

      const accesoriosConvertidos = (
        Array.isArray(accesoriosRaw) ? accesoriosRaw : []
      ).map((acc) => ({
        ...acc,
        price: Number(
          acc.price?.toString().replace(/\$/g, "").replace(/,/g, "").trim(),
        ),
      }));

      // 5) Setear estados
      if (planSeleccionado) {
        setSelectedPlan(planSeleccionado);
        setTotalAccesorio(getPlanTotalCotizacion(planSeleccionado));
      } else {
        setSelectedPlan(null);
        setTotalAccesorio(0);
      }

      setPlans(accesoriosConvertidos);

      // 6) (Opcional) Reflejar en vehicleData para que tu JSX use esa fuente
      setVehicleData((prev) => ({
        ...(prev || {}),
        planesFinanciamiento: planes,
      }));
    } catch (error) {
      setSelectedPlan(null);
      setTotalAccesorio(0);
      setPlans([]);
    }
  }, [selectedMailData]);

  //******************************** GENERA PDF COTIZACIÓN FINANCIAMIENTO ***********************************************************/
  const generarPDF = async () => {
    setTipoEnvio("cotizacion");
    const dataToSend = {
      ...formData,
      nombre: selectedMailData?.nombre || "",
      apellido_paterno: selectedMailData?.apellido_paterno || "",
      apellido_materno: selectedMailData?.apellido_materno || "",
      telefono: selectedMailData?.telefono || "",
      correo_electronico: selectedMailData?.correo_electronico || "",
      ingreso_mensual: selectedMailData?.ingreso_mensual || "",
      marca_vehiculo: selectedMailData?.marca_vehiculo || "",
      modelo_vehiculo: selectedMailData?.modelo_vehiculo || "",
      version_vehiculo: selectedMailData?.version_vehiculo || "",
      meses_financiamiento: selectedMailData?.meses_financiamiento || "",
      porcentaje_enganche: selectedMailData?.porcentaje_enganche || "",
      mensualidad_estimacion: selectedMailData?.mensualidad_estimacion || "",
      agencia: selectedMailData?.agencia || "",
      ag_id: selectedMailData?.ag_id || "",
      precio_total: selectedMailData?.precio_vehiculo || "",
      monto_total: selectedMailData?.precio_total || "",
      enganche: selectedMailData?.enganche || "",
      monto_placas: selectedMailData?.monto_placas || "",
      perdio_llaves:
        selectedMailData?.perdio_llaves || formData?.perdio_llaves || "",
      agencyName: selectedMailData?.agencia || "",
      total_accesorios: totalAccesorio,
      carImageURL: selectedMailData.url_img,
    };

    const doc = new jsPDF();
    const fecha_creacion = new Date().toLocaleDateString();
    let band = 0; //bandera de control de paginas

    const parseMoneyNumber = (value) => {
      if (value === null || value === undefined || value === "") return 0;

      if (typeof value === "number") {
        return Number.isFinite(value) ? value : 0;
      }

      const normalizedValue = String(value)
        .replace(/[^0-9.-]/g, "")
        .trim();

      const parsedValue = Number(normalizedValue);

      return Number.isFinite(parsedValue) ? parsedValue : 0;
    };

    const formatMoney = (value) => {
      return parseMoneyNumber(value).toLocaleString("es-MX", {
        style: "currency",
        currency: "MXN",
      });
    };

    const tasaFinanciamientoTexto = normalizarTasaFinanciamientoTexto(
      dataToSend?.perdio_llaves || selectedMailData?.perdio_llaves,
    );

    const precioVehiculo = parseMoneyNumber(selectedMailData?.precio_vehiculo);

    const accesoriosFinanciados = parseMoneyNumber(totalAccesorio);

    const montoEnganche = parseMoneyNumber(selectedMailData?.enganche);

    const normalizarMetodoPago = (value = "") =>
      String(value || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim();

    const esMetodoFinanciado = (value = "") =>
      normalizarMetodoPago(value).includes("financiad");

    const esMetodoContado = (value = "") =>
      normalizarMetodoPago(value).includes("contado");

    const tipoSeguroActual = selectedMailData?.tipo_compra_seguro || "";
    const tipoComisionActual =
      selectedMailData?.tipo_comision ||
      selectedMailData?.tipo_comision_apertura ||
      "";

    const montoSeguroBase = parseMoneyNumber(selectedMailData?.monto_seguro);
    const montoComisionBase = parseMoneyNumber(
      selectedMailData?.monto_comision_apertura ??
        selectedMailData?.comision_apertura ??
        selectedMailData?.monto_comision,
    );

    // Cuando seguro o comisión van financiados, forman parte del monto a financiar.
    // Cuando van de contado, sólo se suman al pago inicial.
    const montoSeguroFinanciado = esMetodoFinanciado(tipoSeguroActual)
      ? montoSeguroBase
      : 0;
    const montoSeguroContado = esMetodoContado(tipoSeguroActual)
      ? montoSeguroBase
      : 0;

    const montoComisionFinanciada = esMetodoFinanciado(tipoComisionActual)
      ? montoComisionBase
      : 0;
    const montoComisionContado = esMetodoContado(tipoComisionActual)
      ? montoComisionBase
      : 0;

    const precioTotal =
      precioVehiculo +
      accesoriosFinanciados +
      montoSeguroFinanciado +
      montoComisionFinanciada;

    const montoFinanciar = Math.max(precioTotal - montoEnganche, 0);

    /* ADICIONALES CONTADO */
    const adicionalesData =
      typeof selectedMailData?.adicionales_contado === "string"
        ? JSON.parse(selectedMailData.adicionales_contado)
        : selectedMailData?.adicionales_contado || {};

    const montoAdicionales = Number(adicionalesData?.total) || 0;

    const adicionalesItems = adicionalesData?.items || [];

    /* PLACAS */
    const montoPlacas = parseMoneyNumber(selectedMailData?.monto_placas);

    /* TOTALES */
    const pagoInicial =
      montoEnganche + montoSeguroContado + montoComisionContado;

    // El pago total de contado debe incluir únicamente lo que el cliente paga
    // al inicio: enganche + seguro/comisión de contado + adicionales + placas.
    // Si seguro o comisión son financiados, ya están dentro del monto a financiar.
    const pagoTotal = pagoInicial + montoAdicionales + montoPlacas;

    /* ACCESORIOS UNIFICADOS */
    const accesoriosUnificados = [
      // Financiados
      ...(plans || []).map((acc) => ({
        titulo: toTitleCase(acc.title?.split(" - ")[0] || "Sin título"),
        metodo: "Financiado",
        precio: acc.price || 0,
      })),

      // Contado
      ...adicionalesItems.map((acc) => ({
        titulo: acc.titulo,
        metodo: "Contado",
        precio: acc.precio || 0,
      })),
    ];

    doc.setFontSize(8);
    doc.text(`${folioVenta}`, 10, 10);
    doc.text(`${fecha_creacion}`, 35, 10);

    // Agregar logo y título
    doc.setFontSize(18);
    doc.text("Cotización de Financiamiento", 105, 20, { align: "center" });

    const logoURL = "/assets/img/product/gocar_negro.png";
    //doc.addImage(dataToSend.carImageURL, "PNG", 17, 40, 75, 50); // Imagen del auto en el lado izquierdo
    try {
      // Verificar que tenemos URL
      if (!dataToSend.carImageURL) {
        throw new Error("No hay URL de imagen disponible");
      }
      const imageResponse = await fetch(apiUrlImagenes, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          url: dataToSend.carImageURL,
        }),
      });

      if (!imageResponse.ok) {
        throw new Error(
          `HTTP ${imageResponse.status}: ${imageResponse.statusText}`,
        );
      }

      const imageData = await imageResponse.json();
      let base64String = null;

      if (imageData.base64) {
        base64String = imageData.base64;
      } else if (
        imageData.statusCode === 200 &&
        imageData.data &&
        imageData.data.base64
      ) {
        base64String = imageData.data.base64;
      } else if (imageData.data && imageData.data.base64) {
        base64String = imageData.data.base64;
      } else {
        throw new Error("Respuesta del servidor no contiene imagen válida");
      }

      if (base64String) {
        let base64Data;

        if (base64String.startsWith("data:image/")) {
          base64Data = base64String.split(",")[1];
        } else {
          base64Data = base64String;
        }

        if (!base64Data || base64Data.length === 0) {
          throw new Error("Base64 data está vacío después del procesamiento");
        }

        const img = new Image(); //imagen temporal
        img.src = base64String;

        await new Promise((resolve) => {
          img.onload = () => {
            const maxWidth = 75; //medidas maximas
            const maxHeight = 50;
            const ratio = img.width / img.height;

            let finalWidth = maxWidth;
            let finalHeight = maxWidth / ratio;

            if (finalHeight > maxHeight) {
              //si es mayor, invertimos medidas
              finalHeight = maxHeight;
              finalWidth = maxHeight * ratio;
            }

            const xPos = 17;
            const yPos = 40;

            doc.addImage(
              base64Data,
              "JPEG",
              xPos,
              yPos,
              finalWidth,
              finalHeight,
            );
            resolve();
          };
        });
      } else {
        throw new Error("No se pudo extraer base64 de la respuesta");
      }
    } catch (error) {
      // Agregar información de debug al PDF
      doc.setFontSize(8);
      doc.setTextColor(255, 0, 0); // Rojo para error
      doc.text("Error cargando imagen:", 17, 70);
      doc.text(error.message.substring(0, 40), 17, 75);
      doc.text(
        `URL: ${dataToSend.carImageURL?.substring(0, 30) || "N/A"}`,
        17,
        80,
      );
      doc.setTextColor(0, 0, 0); // Resetear color
    }

    doc.addImage(logoURL, "PNG", 159, 10, 40, 10.6);
    doc.setFont("helvetica", "bold"); // Cambiar a negritas
    doc.setFontSize(12);
    doc.text(selectedMailData.marca_vehiculo, 45, 85); // Marca
    doc.setFont("helvetica", "normal"); // Modelo
    doc.setFontSize(10);
    doc.text(selectedMailData.modelo_vehiculo, 47, 89);
    doc.setFontSize(12);
    // Mensualidad estimada:
    doc.setTextColor(255, 0, 0); // Color rojo
    doc.setFont("helvetica", "bold");
    doc.text("Mensualidad:", 126, 55);
    doc.text("Plazo:", 126, 64);
    doc.setTextColor(0, 0, 0); // Color negro
    doc.setFont("helvetica", "normal"); // Texto normal
    doc.text(
      Number(dataToSend.mensualidad_estimacion).toLocaleString("es-MX", {
        style: "currency",
        currency: "MXN",
      }),
      155,
      55,
    );
    doc.text(" " + dataToSend.meses_financiamiento + " meses", 140, 64); // Escribir el resto del texto
    doc.setLineWidth(2);
    doc.setDrawColor(255, 0, 0);
    doc.line(10, 25, 200, 25);
    doc.setLineWidth(1.5);
    doc.setDrawColor(0, 0, 0);
    doc.line(10, 26, 200, 26);

    // Datos del Vehículo
    doc.setFontSize(12);
    doc.setTextColor(255, 255, 255); // Texto en blanco
    doc.setFillColor(255, 0, 0); // Fondo rojo
    doc.rect(10, 100, 91, 7, "F"); // Rectángulo para encabezado
    doc.text("Datos del Vehículo", 55, 105, { align: "center" });
    //doc.setFontSize(11);
    const datosVehiculo = [
      ["Marca:", dataToSend.marca_vehiculo],
      ["Modelo:", dataToSend.modelo_vehiculo],
      ["Versión:", dataToSend.version_vehiculo],
      [
        "Precio Vehículo:",
        Number(dataToSend.precio_total).toLocaleString("es-MX", {
          style: "currency",
          currency: "MXN",
        }),
      ],
      ["Agencia:", dataToSend.agencia],
    ];
    autoTable(doc, {
      startY: 106,
      margin: { left: 10, right: 10 },
      head: [["Dato", "Descripción"]],
      body: datosVehiculo,
      theme: "plain",
      styles: { fontSize: 8.5 },
      headStyles: { fillColor: [255, 0, 0], textColor: [255, 255, 255] },
      columnStyles: {
        0: { cellWidth: 35 }, // Ancho de la columna "Campo"
        1: { cellWidth: 56 }, // Ancho de la columna "Valor"
      },
    });

    // Datos del Cliente
    doc.setFontSize(12);
    doc.setTextColor(255, 255, 255); // Texto en blanco
    doc.setFillColor(255, 0, 0); // Fondo rojo
    doc.rect(110, 100, 91, 7, "F"); // Rectángulo para encabezado
    doc.text("Datos del Cliente", 153, 105, { align: "center" });
    // doc.setFontSize(8);
    const datosCliente = [
      ["Nombre:", dataToSend.nombre],
      ["Apellido paterno:", dataToSend.apellido_paterno || ""],
      ["Apellido materno:", dataToSend.apellido_materno || ""],
      ["Teléfono:", dataToSend.telefono],
      ["Correo:", dataToSend.correo_electronico],
      ["", ""],
      ["", ""],
      /*[
          "Ingreso mensual:",
          Number(dataToSend.ingreso_mensual).toLocaleString("es-MX", {
            style: "currency",
            currency: "MXN",
          }),
        ],*/
    ];
    autoTable(doc, {
      startY: 106,
      margin: { left: 110 },
      head: [["Dato", "Descripción"]],
      body: datosCliente,
      theme: "plain",
      styles: { fontSize: 8.5 },
      headStyles: { fillColor: [255, 0, 0], textColor: [255, 255, 255] },
      columnStyles: {
        0: { cellWidth: 35 }, // Ancho de la columna "Campo"
        1: { cellWidth: 56 }, // Ancho de la columna "Valor"
      },
    });

    // Condiciones de Financiamiento
    doc.setFontSize(12);
    doc.setTextColor(255, 255, 255); // Texto en blanco
    doc.setFillColor(255, 0, 0); // Fondo rojo
    doc.rect(10, 153, 91, 7, "F"); // Rectángulo para encabezado
    doc.text("Condiciones de Financiamiento", 57, 158, { align: "center" });
    //doc.setFontSize(11);
    const datosFinanciamiento = [
      ["Precio Vehículo:", formatMoney(precioVehiculo)],
    ];

    if (accesoriosFinanciados > 0) {
      datosFinanciamiento.push([
        "Accesorios Financiados:",
        formatMoney(accesoriosFinanciados),
      ]);
    }

    if (montoSeguroFinanciado > 0) {
      datosFinanciamiento.push([
        "Seguro Financiado:",
        formatMoney(montoSeguroFinanciado),
      ]);
    }

    if (montoComisionFinanciada > 0) {
      datosFinanciamiento.push([
        "Comisión Financiada:",
        formatMoney(montoComisionFinanciada),
      ]);
    }

    datosFinanciamiento.push(["Precio Total:", formatMoney(precioTotal)]);
    datosFinanciamiento.push([
      "Monto a Financiar:",
      formatMoney(montoFinanciar),
    ]);
    datosFinanciamiento.push([
      "Meses de financiamiento:",
      `${selectedMailData?.meses_financiamiento || 0} meses`,
    ]);

    datosFinanciamiento.push(["Enganche:", formatMoney(montoEnganche)]);

    if (montoSeguroContado > 0) {
      datosFinanciamiento.push([
        "Seguro Contado:",
        formatMoney(montoSeguroContado),
      ]);
    }

    if (montoComisionContado > 0) {
      datosFinanciamiento.push([
        "Comisión Contado:",
        formatMoney(montoComisionContado),
      ]);
    }

    datosFinanciamiento.push(["Pago Inicial:", formatMoney(pagoInicial)]);
    if (montoAdicionales > 0) {
      datosFinanciamiento.push(["Adicionales:", formatMoney(montoAdicionales)]);
    }
    if (montoPlacas > 0) {
      datosFinanciamiento.push(["Placas:", formatMoney(montoPlacas)]);
    }
    datosFinanciamiento.push(["Pago Total:", formatMoney(pagoTotal)]);
    autoTable(doc, {
      startY: 160,
      margin: { left: 10 },
      head: [["Dato", "Descripción"]],
      body: datosFinanciamiento,
      theme: "plain",
      styles: { fontSize: 8.5 },
      headStyles: { fillColor: [255, 0, 0], textColor: [255, 255, 255] },
      columnStyles: {
        0: { cellWidth: 40 }, // Ancho de la columna "Campo"
        1: { cellWidth: 51 }, // Ancho de la columna "Valor"
      },
    });

    const yPlan = doc.lastAutoTable.finalY + 10;
    const accesorios = plans || [];
    const numAccesorios = accesorios.length;
    let accesoriosSeleccionadosY;

    if (numAccesorios >= 17) {
      let col1 = accesorios.slice(0, 16); //17 accesorios
      let col2 = accesorios.slice(17); // El resto de los accesorios

      // Procesamos las columnas
      const datosCol1 = col1.map((acc) => [
        toTitleCase(acc.title?.split(" - ")[0] || "Sin título"),
        "Disponible",
        acc.price.toLocaleString("es-MX", {
          style: "currency",
          currency: "MXN",
        }),
      ]);

      const datosCol2 = col2.map((acc) => [
        toTitleCase(acc.title?.split(" - ")[0] || "Sin título"),
        "Disponible",
        acc.price.toLocaleString("es-MX", {
          style: "currency",
          currency: "MXN",
        }),
      ]);

      // Encabezados manuales
      doc.setFontSize(12);
      doc.setTextColor(255, 255, 255);
      doc.setFillColor(255, 0, 0);
      doc.rect(10, 203, 91, 7, "F");
      doc.text("Accesorios Seleccionados", 58, 208, { align: "center" });

      doc.setTextColor(255, 255, 255);
      doc.setFillColor(255, 0, 0);
      doc.rect(110, 153, 91, 7, "F");
      doc.text("Accesorios Seleccionados", 155, 158, { align: "center" });

      // Tabla 1 columna derecha
      autoTable(doc, {
        startY: 160,
        margin: { left: 110 },
        head: [["Accesorio", "Método", "Precio"]],
        body: datosCol1,
        theme: "plain",
        styles: { fontSize: 8.5 },
        headStyles: { fillColor: [255, 0, 0], textColor: [255, 255, 255] },
        columnStyles: {
          0: { cellWidth: 48 },
          1: { cellWidth: 20 },
          2: { cellWidth: 23 },
        },
      });

      // Si hay segunda columna, la agregamos
      if (col2.length > 0) {
        // Tabla 2 columna izquierda
        autoTable(doc, {
          startY: 209,
          margin: { left: 10 },
          head: [["Accesorio", "Método", "Precio"]],
          body: datosCol2,
          theme: "plain",
          styles: { fontSize: 8.5 },
          headStyles: { fillColor: [255, 0, 0], textColor: [255, 255, 255] },
          columnStyles: {
            0: { cellWidth: 48 },
            1: { cellWidth: 20 },
            2: { cellWidth: 23 },
          },
        });
      }
    } else {
      // Datos ACCESORIOS
      doc.setFontSize(12);
      doc.setTextColor(255, 255, 255); // Texto en blanco
      doc.setFillColor(255, 0, 0);
      doc.rect(110, 153, 91, 7, "F"); // Rectángulo para encabezado de accesorios
      doc.text("Accesorios Seleccionados", 150, 158, { align: "center" });

      const accesorios = plans || [];
      const datosAccesorios = accesoriosUnificados.map((acc) => [
        acc.titulo,
        acc.metodo,
        acc.precio.toLocaleString("es-MX", {
          style: "currency",
          currency: "MXN",
        }),
      ]);

      autoTable(doc, {
        startY: 160, // Justo debajo del encabezado
        margin: { left: 110 },
        head: [["Accesorio", "Método", "Precio"]],
        body: datosAccesorios,
        theme: "plain", // Para un diseño visualmente claro
        styles: { fontSize: 8.5 },
        headStyles: { fillColor: [255, 0, 0], textColor: [255, 255, 255] },
        columnStyles: {
          0: { cellWidth: 48 },
          1: { cellWidth: 20 },
          2: { cellWidth: 23 },
        },
      });

      accesoriosSeleccionadosY = doc.lastAutoTable
        ? doc.lastAutoTable.finalY
        : 160;
      //PLAN SELECCIONADO
      doc.setFontSize(12);
      doc.setTextColor(255, 255, 255);
      doc.setFillColor(255, 0, 0);
      doc.rect(10, yPlan, 91, 7, "F"); // Rectángulo para encabezado del plan seleccionado
      doc.text("Plan Seleccionado", 58, yPlan + 5, { align: "center" });

      // Verifica si hay un plan seleccionado antes de generar la tabla
      if (selectedPlan) {
        const planDetails = [
          ["Tipo:", selectedPlan.title],
          [
            "Precio Paquete:",
            `$${selectedPlan.totalPrice.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`,
          ],
        ];

        autoTable(doc, {
          startY: yPlan + 7,
          margin: { left: 10 },
          head: [["Dato", "Descripción"]],
          body: planDetails,
          theme: "plain",
          styles: { fontSize: 8.5 },
          headStyles: { fillColor: [255, 0, 0], textColor: [255, 255, 255] },
          columnStyles: {
            0: { cellWidth: 40 },
            1: { cellWidth: 51 },
          },
        });
      } else {
        // Mensaje en caso de que no haya un plan seleccionado
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(
          "No se ha seleccionado ningún plan.",
          14,
          doc.lastAutoTable.finalY + 25,
        );
      }
    }

    // Calculamos la posición
    let posicionDatosSeguro = accesoriosSeleccionadosY + 10; // Si hay muchos accesorios
    let posicionPago = posicionDatosSeguro;

    if (posicionDatosSeguro > 250) {
      //para evitar que exceda el espacio de la página
      doc.addPage();
      doc.setFontSize(8);
      doc.setTextColor(0, 0, 0);
      doc.text(`${folioVenta}3`, 10, 10);
      doc.text(`${fecha_creacion}3`, 35, 10);
      band = 1;
      posicionDatosSeguro = 20; // Reiniciamos la posición al inicio de la nueva página
      posicionPago = posicionDatosSeguro + 60;
    } else {
      if (numAccesorios > 25 || (numAccesorios >= 17 && numAccesorios <= 24)) {
        band = 1;
        posicionDatosSeguro = 14; // Reiniciamos la posición al inicio de la nueva página
        const yFinal = doc.lastAutoTable.finalY + 10;

        // Encabezado del plan
        doc.setFontSize(12);
        doc.setTextColor(255, 255, 255);
        doc.setFillColor(255, 0, 0);
        doc.rect(10, yFinal, 91, 7, "F"); // Rectángulo para encabezado del plan seleccionado
        doc.text("Plan Seleccionado", 58, yFinal + 5, { align: "center" });

        // Verifica si hay un plan seleccionado antes de generar la tabla
        if (selectedPlan) {
          const planDetails = [
            ["Tipo:", selectedPlan.title],
            [
              "Precio Paquete:",
              `$${selectedPlan.totalPrice.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}`,
            ],
            [
              "Accesorios incluidos:",
              selectedPlan.accessories.join(", ") || "Ninguno",
            ],
          ];

          autoTable(doc, {
            startY: yFinal + 7,
            margin: { left: 10 },
            head: [["Dato2", "Descripción"]],
            body: planDetails,
            theme: "plain",
            styles: { fontSize: 8.5 },
            headStyles: { fillColor: [255, 0, 0], textColor: [255, 255, 255] },
            columnStyles: {
              0: { cellWidth: 40 },
              1: { cellWidth: 51 },
            },
          });
          posicionPago = doc.lastAutoTable.finalY + 55;
        } else {
          // Mensaje en caso de que no haya un plan seleccionado
          doc.setFontSize(12);
          doc.setTextColor(0, 0, 0);
          doc.text("No se ha seleccionado ningún plan.", 14, yFinal + 20);
        }
      }
    }

    // DATOS DEL SEGURO (Posición ajustada)
    /*doc.setFontSize(12);
      doc.setTextColor(255, 255, 255);
      doc.setFillColor(255, 0, 0); // Fondo rojo para encabezado de seguro
      doc.rect(110, posicionDatosSeguro, 91, 7, "F"); // Encabezado de seguro
      doc.text("Datos Seguro", 155, posicionDatosSeguro + 5, { align: "center" });
  
      autoTable(doc, {
        startY: posicionDatosSeguro + 7, // Ajustamos justo debajo del encabezado
        margin: { left: 110 },
        head: [["Dato", "Descripción"]],
        body: [
          ["Seguro Gratis:", "PENDIENTE"],
          ["Tipo de paquete:", "PENDIENTE"],
          ["Estado:", "PENDIENTE"],
          ["Plazo:", "PENDIENTE"],
          ["Aseguradora:", "PENDIENTE"],
          ["Monto:", "PENDIENTE"],
        ],
        theme: "plain",
        styles: { fontSize: 8.5 },
        headStyles: { fillColor: [255, 0, 0], textColor: [255, 255, 255] },
        columnStyles: {
          0: { cellWidth: 42 }, // Columna "Campo"
          1: { cellWidth: 49 }, // Columna "Valor"
        },
      });*/

    // si no se ha agregado una pagina, se agrega una nueva
    if (band == 0) {
      doc.addPage();
      doc.setFontSize(8);
      doc.setTextColor(0, 0, 0);
      doc.text(`${folioVenta}`, 10, 10);
      doc.text(`${fecha_creacion}`, 35, 10);
      posicionPago = 20;
    }

    //DESGLOSE DE PAGO
    doc.setFontSize(16);
    doc.setTextColor(255, 255, 255);
    doc.setFillColor(255, 0, 0);
    doc.rect(10, posicionPago + 2, 191, 10, "F");
    doc.text("Desglose de Pagos Mensuales", 105, posicionPago + 8, {
      align: "center",
    });

    // Calcular tabla de pagos mes a mes
    let saldo = montoFinanciar;
    const mensualidad = parseMoneyNumber(dataToSend.mensualidad_estimacion);
    const meses = Number(dataToSend.meses_financiamiento) || 0;
    const fechaBase = new Date(); // Fecha actual

    // Calcular la mensualidad estimada de los adicionales financiados
    const totalAdicionalesFinanciados =
      accesoriosFinanciados + montoSeguroFinanciado + montoComisionFinanciada;
    const mensualidadAccesorios =
      meses > 0 ? totalAdicionalesFinanciados / meses : 0;
    const mensualidadVehiculo = Math.max(
      mensualidad - mensualidadAccesorios,
      0,
    );

    const tablaPagos = [];
    for (let i = 1; i <= meses; i++) {
      saldo -= mensualidad;
      const fechaPago = new Date(fechaBase); // Crear una copia
      fechaPago.setMonth(fechaPago.getMonth() + i - 1);
      const fechaFormateada = `${fechaPago
        .getDate()
        .toString()
        .padStart(2, "0")}/${(fechaPago.getMonth() + 1)
        .toString()
        .padStart(2, "0")}/${fechaPago.getFullYear()}`;

      tablaPagos.push([
        `${i}`, // Periodo
        fechaFormateada, // Fecha de Pago
        `$${mensualidadVehiculo.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`, // Renta del Auto
        `$${(mensualidadVehiculo * 0.1).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`, // Seguro de Auto (Ejemplo: 10% de la renta)
        `$${mensualidadAccesorios.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`, // Accesorios (Ejemplo: 5% de la renta)
        `$${(mensualidadVehiculo * 0.02).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`, // Garantía Extendida (Ejemplo: 2% de la renta)
        `$${(mensualidadVehiculo * 0.03).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`, // Producto Adicional (Ejemplo: 3% de la renta)
        `${Number(mensualidad).toLocaleString("es-MX", {
          style: "currency",
          currency: "MXN",
        })}`, // Renta Mensual
        //`$${saldo > 0 ? saldo.toFixed(2) : "0.00"}`,
      ]);
    }

    autoTable(doc, {
      startY: posicionPago + 10,
      margin: { left: 10 },
      head: [
        [
          "Periodo",
          "Fecha de Pago",
          "Renta del Auto",
          "Seguro de Auto",
          "Accesorios",
          "Garantía Extendida",
          "Producto Adicional",
          "Renta Mensual",
        ],
      ],
      body: tablaPagos,
      theme: "plain",
      styles: { fontSize: 8.5 },
      headStyles: {
        fillColor: [255, 0, 0],
        halign: "center",
        textColor: [255, 255, 255],
      },
      columnStyles: {
        0: { cellWidth: 23, halign: "center" }, // Periodo
        1: { cellWidth: 27, halign: "center" }, // Fecha de Pago
        2: { cellWidth: 23, halign: "center" }, // Renta del Auto
        3: { cellWidth: 24, halign: "center" }, // Seguro de Auto
        4: { cellWidth: 23, halign: "center" }, // Accesorios
        5: { cellWidth: 23, halign: "center" }, // Garantía Extendida
        6: { cellWidth: 24, halign: "center" }, // Producto Adicional
        7: { cellWidth: 24, halign: "center" }, // Renta Mensual
      },
    });

    const pagoY = doc.lastAutoTable ? doc.lastAutoTable.finalY : 160;
    let Desglose = pagoY + 10;
    if (Desglose > 250) {
      doc.setFontSize(8);
      doc.setTextColor(0, 0, 0);
      doc.text(`${folioVenta}`, 10, 10);
      doc.text(`${fecha_creacion}`, 35, 10);
    }

    // COMPARACION DE MENSUALIDAADES
    doc.setFontSize(16);
    doc.setTextColor(255, 255, 255);
    doc.setFillColor(255, 0, 0);
    doc.rect(10, doc.lastAutoTable.finalY + 10, 190, 10, "F");
    doc.text(
      "Comparación de Mensualidades",
      105,
      doc.lastAutoTable.finalY + 15,
      { align: "center" },
    );

    const plazos = [12, 24, 36, 48, 60];
    const tasaAnual = TASA_ANUAL_FINANCIAMIENTO;
    const tasaMensual = tasaAnual / 12;
    const enganche = montoEnganche;
    const montoTotal = precioTotal;
    const saldoFinanciar = Math.max(montoTotal - enganche, 0); // saldo a financiar

    function calcularMensualidad(pv, tasa, meses) {
      if (tasa === 0) return pv / meses;
      return (
        (pv * tasa * Math.pow(1 + tasa, meses)) /
        (Math.pow(1 + tasa, meses) - 1)
      );
    }

    const tablaComparacion = plazos.map((meses) => {
      const mensualidad = calcularMensualidad(
        saldoFinanciar,
        tasaMensual,
        meses,
      );
      return [
        `${meses} meses`,
        `$${mensualidad.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
      ];
    });

    autoTable(doc, {
      startY: doc.lastAutoTable.finalY + 20,
      margin: { left: 10 },
      head: [["Plazo", "Pago Mensual"]],
      body: tablaComparacion,
      theme: "plain",
      styles: { fontSize: 8.5 },
      headStyles: {
        fillColor: [255, 0, 0],
        halign: "center",
        textColor: [255, 255, 255],
      },
      columnStyles: {
        0: { cellWidth: 95, halign: "center" },
        1: { cellWidth: 95, halign: "center" },
      },
    });

    // Fecha de emisión
    const fecha = new Date().toLocaleDateString();
    doc.setFontSize(9);
    doc.setTextColor(0, 0, 0);
    doc.text(`Fecha de emisión: ${fecha}`, 14, 285);
    doc.text("Gracias por su preferencia.", 105, 290, { align: "center" });

    agregarTasaPiePaginaPDF(doc, tasaFinanciamientoTexto, {
      y: 280,
      fontSize: 6,
    });

    //doc.save(`Cotizacion_${dataToSend.nombre || "Cliente"}.pdf`);
    const blob = doc.output("blob");
    const fileName = `Cotizacion_Financiamiento_${
      dataToSend.nombre || "Cliente"
    }.pdf`;
    const pdfFile = new File([blob], fileName, {
      type: "application/pdf",
    });

    //Agrega al arreglo
    agregarArchivo(pdfFile);

    //si no se rechaza la garantia, está listo para enviar
    /*if (garantia_extendida === "No") {
        console.log("setReadyToSend(true2)");
        setReadyToSend(true);
      }*/

    // crear url y devolverla
    const url = URL.createObjectURL(blob);
    return { file: pdfFile, url };
  };

  //******************************** GENERA PDF ASEGURADORA ***********************************************************/
  const generarPDFseguro = async () => {
    /* CAMBIOS 17 DE OCTUBRE  */
    try {
      const seguroSeleccionado = await fetch(apiUrlSeguro, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          marca: selectedMailData?.marca_vehiculo?.trim() || "",
          modelo: selectedMailData?.modelo_vehiculo?.trim() || "",
          version: selectedMailData?.version_vehiculo?.trim() || "",
          access_token: accessToken,
        }),
      }).then((res) => res.json());

      if (!seguroSeleccionado) {
        console.error("No se encontró seguro para este vehículo");
        return null;
      }

      const extras = seguroSeleccionado?.extras
        ? JSON.parse(seguroSeleccionado.extras)
        : null;

      const tipoFormato = seguroSeleccionado?.tipo_formato || "formato1";
      const dataToSend = {
        ...formData,
        marca_vehiculo: selectedMailData?.marca_vehiculo || "",
        modelo_vehiculo: selectedMailData?.modelo_vehiculo || "",
        version_vehiculo: selectedMailData?.version_vehiculo || "",
        agencyName: selectedMailData?.agencia || "",
      };

      const doc = new jsPDF();
      const fecha_creacion = new Date().toLocaleDateString();

      // Agregar logo y título
      doc.setFontSize(16);
      doc.text("Cotización de Póliza de Seguro Automotriz", 105, 15, {
        align: "center",
      });

      //const logoURL = "/assets/img/product/gocar_negro.png";
      //doc.addImage(logoURL, "PNG", 159, 10, 40, 10.6);

      doc.setLineWidth(2);
      doc.setDrawColor(255, 0, 0);
      doc.line(10, 20, 200, 20);
      doc.setLineWidth(1.5);
      doc.setDrawColor(0, 0, 0);
      doc.line(10, 21, 200, 21);

      // Luego del título, dejamos espacio y cambiamos tamaño
      doc.setFontSize(10);
      const yDatos = 30; //mayor control

      // Texto normal para las etiquetas
      doc.setFont("helvetica", "normal");
      doc.text("Fecha:", 14, yDatos);
      doc.text("Agencia:", 14, yDatos + 6);

      // Texto en negritas para los valores
      doc.setFont("helvetica", "bold");
      doc.text(`${fecha_creacion}`, 35, yDatos);
      doc.text(`${dataToSend.agencyName}`, 35, yDatos + 6);

      const mensaje = `Estimado Cliente: De acuerdo a su solicitud, tenemos el gusto de someter a su consideración, la presente cotización de la póliza de seguro automotriz, del siguiente vehículo:`;

      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0); // negro
      const textoDividido = doc.splitTextToSize(mensaje, 180);
      doc.text(textoDividido, 14, yDatos + 13);

      // Datos del Vehículo
      doc.setFontSize(9);
      // Texto normal para las etiquetas
      doc.setFont("helvetica", "normal");
      doc.text("Marca:", 40, yDatos + 25);
      doc.text("Modelo:", 40, yDatos + 29);
      doc.text("Versión:", 40, yDatos + 33);
      doc.text("Clase:", 40, yDatos + 37);

      // Texto en negritas para los valores
      doc.setFont("helvetica", "bold");
      doc.text(`${dataToSend.marca_vehiculo}`, 55, yDatos + 25);
      doc.text(`${dataToSend.modelo_vehiculo}`, 55, yDatos + 29);
      doc.text(`${dataToSend.version_vehiculo}`, 55, yDatos + 33);
      doc.text("Automóvil", 55, yDatos + 37);

      // Datos generales
      // Texto normal para las etiquetas
      doc.setFont("helvetica", "normal");
      doc.text("CP:", 105, yDatos + 25);
      //doc.text("Edad:", 105, yDatos + 31);
      doc.text("Tipo Persona:", 105, yDatos + 29);
      doc.text("Uso:", 105, yDatos + 33);

      // Texto en negritas para los valores
      doc.setFont("helvetica", "bold");
      doc.text("03104", 127, yDatos + 25);
      //doc.text(`${dataToSend.edad}`, 125, yDatos + 31);
      doc.text("Física", 127, yDatos + 29);
      doc.text("Uso Partiucular", 127, yDatos + 33);

      /************ info seguro ***************/

      // Título "Aseguradora"
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.text(
        `Aseguradora: ${seguroSeleccionado?.aseguradora}`,
        14,
        yDatos + 45,
      );

      // Información general
      autoTable(doc, {
        startY: yDatos + 50,
        theme: "grid",
        head: [
          ["Folio", `${folioVenta}`],
          ["Programa Comercial", "RENAULT NUEVOS"],
        ],
        styles: { halign: "left" },
        headStyles: { fillColor: [230, 230, 230], textColor: 20 },
        columnStyles: { 0: { fontStyle: "bold" } },
        margin: { left: 14, right: 14 },
      });

      if (tipoFormato === "formato2") {
        autoTable(doc, {
          startY: doc.lastAutoTable.finalY + 5,
          head: [
            [
              "Indemnización",
              {
                content: "Auto Nuevo\n5 - 5",
                colSpan: 2,
                styles: {
                  halign: "center",
                  fillColor: [255, 0, 0],
                  textColor: 255,
                  fontStyle: "bold",
                },
              },
            ],
          ],
          body: [
            ["Coberturas", "Suma Asegurada", "Deducible"],
            ["Daños Materiales", "Valor Comercial", "5%"],
            ["Robo Total", "Valor Comercial", "5%"],
            ["R.C. a terceros", "$ 3,000,000", ""],
            ["Gastos Médicos", extras?.gastoMed, ""],
            [extras?.gastoLeg, extras?.gastoLegal, ""],
            [extras?.asistVial, extras?.asistenciaVial, ""],
            [extras?.extencion, extras?.ext, ""],
            [extras?.add, extras?.adicional, ""],
          ],
          theme: "grid",
          headStyles: { fillColor: [230, 230, 230], textColor: 20 },
          styles: { fontSize: 9 },
          margin: { left: 14, right: 14 },
          columnStyles: {
            0: { cellWidth: 100 },
            1: { cellWidth: 60 },
          },
        });

        // Vigencia
        autoTable(doc, {
          startY: doc.lastAutoTable.finalY + 5,
          head: [["VIGENCIA", "12 MESES"]],
          theme: "grid",
          styles: { fontStyle: "bold" },
          headStyles: { fillColor: [230, 230, 230], textColor: 20 },
          margin: { left: 14, right: 14 },
          columnStyles: {
            0: { cellWidth: 100 },
            1: { cellWidth: 60 },
          },
        });

        // Total
        autoTable(doc, {
          startY: doc.lastAutoTable?.finalY + 5 || 20,
          body: [
            [
              {
                content: "Prima Total",
                styles: {
                  fontStyle: "bold",
                  textColor: 255,
                  fillColor: [255, 0, 0],
                },
              },
              {
                content: formatCurrency(seguroSeleccionado?.prima_total),
                styles: {
                  fontStyle: "bold",
                  textColor: 255,
                  fillColor: [255, 0, 0],
                },
              },
            ],
          ],
          theme: "grid",
          styles: { fontSize: 10 },
          margin: { left: 14, right: 14 },
        });
      } else {
        // Tabla de coberturas
        autoTable(doc, {
          startY: doc.lastAutoTable.finalY + 5,
          head: [
            [
              "Indemnización",
              {
                content: "Auto Nuevo\n5 - 5",
                colSpan: 2,
                styles: {
                  halign: "center",
                  fillColor: [255, 0, 0],
                  textColor: 255,
                  fontStyle: "bold",
                },
              },
            ],
          ],
          body: [
            ["Coberturas", "Límite Máximo de Responsabilidad", "Deducible"],
            ["Daños Materiales", "AUTO NUEVO", "5%"],
            ["Robo Total", "AUTO NUEVO", "5%"],
            ["Responsabilidad Civil Bienes y Personas", "$ 1,000,000", ""],
            ["Responsabilidad Civil por Muerte de Terceros", "$ 3,000,000", ""],
            ["Gastos Médicos Ocupantes", "$ 500,000", ""],
            ["Zurich Asistencia", "Amparado", ""],
            ["Asistencia Legal", "Amparado", ""],
            ["Multas y Corralones", "$ 5,091", ""],
            ["Responsabilidad Civil Extranjero", "Amparado", ""],
            ["Zero", "Amparado", ""],
          ],
          theme: "grid",
          headStyles: { fillColor: [230, 230, 230], textColor: 20 },
          styles: { fontSize: 9 },
          margin: { left: 14, right: 14 },
          columnStyles: {
            0: { cellWidth: 100 },
            1: { cellWidth: 60 },
          },
        });

        // Vigencia
        autoTable(doc, {
          startY: doc.lastAutoTable.finalY + 5,
          head: [["VIGENCIA", "12 MESES"]],
          theme: "grid",
          styles: { fontStyle: "bold" },
          headStyles: { fillColor: [230, 230, 230], textColor: 20 },
          margin: { left: 14, right: 14 },
          columnStyles: {
            0: { cellWidth: 100 },
            1: { cellWidth: 60 },
          },
        });
        console.log("seguroSeleccionado:", seguroSeleccionado);

        // Totales
        autoTable(doc, {
          startY: doc.lastAutoTable?.finalY + 5 || 20,
          body: [
            ["Prima Neta", formatCurrency(seguroSeleccionado?.prima)],
            ["Derechos", formatCurrency(seguroSeleccionado?.derechos)],
            ["IVA", formatCurrency(seguroSeleccionado?.iva)],
            [
              {
                content: "Prima Total",
                styles: {
                  fontStyle: "bold",
                  textColor: 255,
                  fillColor: [255, 0, 0],
                },
              },
              {
                content: formatCurrency(seguroSeleccionado?.prima_total),
                styles: {
                  fontStyle: "bold",
                  textColor: 255,
                  fillColor: [255, 0, 0],
                },
              },
            ],
          ],
          theme: "grid",
          styles: { fontSize: 10 },
          margin: { left: 14, right: 14 },
        });
      }

      // Texto final de advertencia
      doc.setFont("helvetica", "bold");
      doc.setFontSize(9);
      doc.text(
        "ESTE DOCUMENTO SÓLO CONSTITUYE LA COTIZACIÓN, POR TANTO, QUEDA SUJETA A LA ACEPTACIÓN DEL RIESGO POR PARTE DE LA COMPAÑÍA",
        14,
        doc.internal.pageSize.height - 10,
        { maxWidth: doc.internal.pageSize.width - 28 },
      );

      //doc.save(`Cotizacion_Contado_${dataToSend.nombreCliente || "Cliente"}.pdf`);

      const blob = doc.output("blob");
      const fileName = `Cotizacion_Seguro_${dataToSend.nombre || "Cliente"}.pdf`;
      const pdfFile = new File([blob], fileName, {
        type: "application/pdf",
      });

      //Agrega al arreglo
      agregarArchivo(pdfFile);

      // crear url y devolverla
      const url = URL.createObjectURL(blob);
      return { file: pdfFile, url };
    } catch (error) {
      //si algo falla lo registramos y devolvemos null
      console.error("Ocurrio un error generado el seguro:", error);
      return null;
    }
  };

  // Normaliza texto (sin acentos, minúsculas y espacios dobles)
  const normalizarTexto = (texto = "") =>
    String(texto || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[-_/]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();

  // Se conserva el nombre anterior para no romper usos existentes.
  const normalizar = normalizarTexto;

  // Limpia años que a veces vienen dentro de títulos antiguos:
  // "VERSA 2026 SENSE BASE TM" => "versa sense base tm"
  const limpiarModeloVersion = (texto = "") =>
    normalizarTexto(texto)
      .replace(/\b(2025|2026|2027|2028|2029|25|26|27|28|29)\b/g, "")
      .replace(/\s+/g, " ")
      .trim();

  const escapeRegExp = (texto = "") =>
    String(texto).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  const incluyePalabra = (texto = "", palabra = "") => {
    const textoLimpio = normalizarTexto(texto);
    const palabraLimpia = normalizarTexto(palabra);

    if (!textoLimpio || !palabraLimpia) return false;

    return new RegExp(`\\b${escapeRegExp(palabraLimpia)}\\b`, "i").test(
      textoLimpio,
    );
  };

  const estaDisponible = (item) =>
    item?.available === true ||
    item?.available === "true" ||
    item?.available === 1 ||
    item?.available === "1";

  const coincideAgenciaItem = (item, agIdActivo = "") => {
    const itemAgId = String(item?.ag_id || "")
      .trim()
      .toLowerCase();
    const agId = String(agIdActivo || "")
      .trim()
      .toLowerCase();

    // Productos globales.
    if (!itemAgId || itemAgId === "all") return true;

    // Si no hay agencia activa, no permitimos productos de una agencia específica.
    if (!agId) return false;

    return itemAgId === agId;
  };

  const coincideMarcaItem = (item, marcaActiva = "") => {
    const itemBrand = normalizarTexto(item?.brand || "");
    const marca = normalizarTexto(marcaActiva || "");

    if (!itemBrand || itemBrand === "all") return true;
    if (!marca) return false;

    return itemBrand === marca;
  };

  const [busqueda, setBusqueda] = useState(""); //buscador de accesorios
  const palabrasClaveExcluir = [
    "Cobertura de Llaves",
    "Canastilla de techo",
    "Rejilla Separadora",
    "Tapete uso rudo area de carga",
    "Organizador de Cajuela",
    "Seguro LLantas",
    "Garantía Extendida",
  ];
  const [selectedCar, setSelectedCar] = useState(() => {
    try {
      const saved = localStorage.getItem(getSelectedCarStorageKey());
      return saved ? JSON.parse(saved) : null;
    } catch {
      return null;
    }
  });

  useEffect(() => {
    selectedCarRef.current = selectedCar;
  }, [selectedCar]);

  useEffect(() => {
    return () => {
      if (pendingVehicleSelectionTimerRef.current) {
        clearTimeout(pendingVehicleSelectionTimerRef.current);
      }
      if (returningToInventoryTimerRef.current) {
        clearTimeout(returningToInventoryTimerRef.current);
      }
    };
  }, []);

  const [accesoriosGarantias, setAccesoriosGarantias] = React.useState({
    accesorios: [],
    garantias: [],
  });

  const agIdActivo = useMemo(() => {
    return selectedMailData?.ag_id || selectedCar?.ag_id || "";
  }, [selectedMailData?.ag_id, selectedCar?.ag_id]);

  const marcaActiva = useMemo(() => {
    return (
      selectedMailData?.marca_vehiculo ||
      selectedCar?.brand ||
      selectedCar?.title ||
      ""
    );
  }, [
    selectedMailData?.marca_vehiculo,
    selectedCar?.brand,
    selectedCar?.title,
  ]);

  // 🔧 ACCESORIOS
  const accesoriosFiltrados = React.useMemo(() => {
    return accesoriosGarantias.accesorios.filter((item) => {
      if (!estaDisponible(item)) return false;
      if (!coincideMarcaItem(item, marcaActiva)) return false;
      if (!coincideAgenciaItem(item, agIdActivo)) return false;

      const titulo = normalizarTexto(item.title || "");
      const busquedaTexto = normalizarTexto(busqueda || "");
      const modelo = normalizarTexto(selectedMailData?.modelo_vehiculo || "");
      const tipo = normalizarTexto(selectedMailData?.tipo_auto || "");

      const esSeminuevo = tipo.includes("seminuevo");
      const esNuevo = tipo.includes("nuevo") && !tipo.includes("seminuevo");
      const coincideBusqueda = !busquedaTexto || titulo.includes(busquedaTexto);

      // SOLO SEMINUEVOS: ocultar en nuevos si incluye "kit de seguridad"
      const esSoloSeminuevos = titulo.includes("kit de seguridad");
      if (esNuevo && esSoloSeminuevos) return false;

      const mencionaMiModelo = modelo ? incluyePalabra(titulo, modelo) : false;
      const esUniversal = titulo.includes("todos");

      // --- LÓGICA DE VERSIONES ESPECIALES ---
      let versionProhibida = false;
      const versionesEspeciales = ["e-power", "epower", "v6", "pro-4x", "play"];
      const versionEnAuto = versionesEspeciales.find((v) => modelo.includes(v));

      versionesEspeciales.forEach((vEspecial) => {
        if (titulo.includes(vEspecial)) {
          const regexVersionEspecial = new RegExp(
            `\\b${escapeRegExp(modelo)}\\s+${escapeRegExp(vEspecial)}\\b`,
            "i",
          );

          if (
            modelo &&
            regexVersionEspecial.test(titulo) &&
            versionEnAuto !== vEspecial
          ) {
            versionProhibida = true;
          }

          // Caso EXCEPTO
          if (
            modelo &&
            titulo.includes("excepto") &&
            regexVersionEspecial.test(titulo) &&
            versionEnAuto === vEspecial
          ) {
            versionProhibida = true;
          }
        }
      });

      // --- FILTROS FINALES ---
      const coincideExclusion = palabrasClaveExcluir.some((p) =>
        titulo.includes(normalizarTexto(p)),
      );

      if (versionProhibida) return false;
      if (esSeminuevo && coincideExclusion) return false;

      return (esUniversal || mencionaMiModelo) && coincideBusqueda;
    });
  }, [
    accesoriosGarantias.accesorios,
    busqueda,
    selectedMailData?.modelo_vehiculo,
    selectedMailData?.tipo_auto,
    agIdActivo,
    marcaActiva,
  ]);

  // 🔧 GARANTÍAS
  const garantiasFiltradas = React.useMemo(() => {
    return accesoriosGarantias.garantias.filter((item) => {
      if (!estaDisponible(item)) return false;
      if (!coincideMarcaItem(item, marcaActiva)) return false;
      if (!coincideAgenciaItem(item, agIdActivo)) return false;

      const esGarantia = item.type?.toLowerCase() === "garantias";

      const titulo = normalizarTexto(item.title || "");
      const busquedaTexto = normalizarTexto(busqueda || "");
      const modelo = normalizarTexto(selectedMailData?.modelo_vehiculo || "");
      const tipoAuto = normalizarTexto(selectedMailData?.tipo_auto || "");
      const version = normalizarTexto(selectedMailData?.version_vehiculo || "");

      const coincideBusqueda = !busquedaTexto || titulo.includes(busquedaTexto);

      // OJO:
      // normalizarTexto convierte "llanta-rin" en "llanta rin".
      // Por eso no conviene comparar con igualdad exacta ni buscar sólo con guion.
      const esSeminuevo = tipoAuto.includes("seminuevo");
      const esNuevo =
        tipoAuto.includes("nuevo") && !tipoAuto.includes("seminuevo");

      const esSoloParaNuevos = palabrasClaveExcluir.some((palabra) =>
        titulo.includes(normalizarTexto(palabra)),
      );

      // SOLO SEMINUEVOS: Kit de seguridad + Localizador Gocar (se ocultan en nuevos)
      const soloParaSeminuevos = ["kit de seguridad", "localizador gocar"];
      const esSoloSeminuevos = soloParaSeminuevos.some((p) =>
        titulo.includes(normalizarTexto(p)),
      );

      if (esNuevo && esSoloSeminuevos) return false;
      if (esSeminuevo && esSoloParaNuevos) return false;

      const esProteccionLlantaRin =
        titulo.includes("proteccion de llanta rin") ||
        titulo.includes("proteccion de llanta-rin") ||
        titulo.includes("proteccion de llantas") ||
        (titulo.includes("proteccion") &&
          titulo.includes("llanta") &&
          titulo.includes("rin"));

      const esMonto4000 =
        titulo.includes("4,000") ||
        titulo.includes("4000") ||
        titulo.includes("$4");

      const esMonto5000 =
        titulo.includes("5,000") ||
        titulo.includes("5000") ||
        titulo.includes("$5");

      const esMonto12000 =
        titulo.includes("12,000") ||
        titulo.includes("12000") ||
        titulo.includes("$12");

      const esProteccion4000 = esProteccionLlantaRin && esMonto4000;
      const esProteccion5000 = esProteccionLlantaRin && esMonto5000;
      const esProteccion12000 = esProteccionLlantaRin && esMonto12000;

      // En seminuevos sólo debe quedar la protección de $4,000.
      // Se ocultan las coberturas de $5,000 y $12,000.
      if (esSeminuevo && (esProteccion5000 || esProteccion12000)) {
        return false;
      }

      // Ocultar garantías mecánicas cuando es nuevo
      const esGarantiaMecanica =
        titulo.includes("garantia mecanica") ||
        titulo.includes("garantía mecánica");

      if (esNuevo && esGarantiaMecanica) return false;

      const mencionaMiModelo = modelo ? incluyePalabra(titulo, modelo) : false;
      const esUniversal = titulo.includes("todos");

      let versionProhibida = false;
      const versionesEspeciales = ["e-power", "epower", "v6", "pro-4x", "play"];
      const versionEnAuto = versionesEspeciales.find((v) => modelo.includes(v));

      versionesEspeciales.forEach((vEspecial) => {
        if (titulo.includes(vEspecial)) {
          const regexVersionEspecial = new RegExp(
            `\\b${escapeRegExp(modelo)}\\s+${escapeRegExp(vEspecial)}\\b`,
            "i",
          );

          if (
            modelo &&
            regexVersionEspecial.test(titulo) &&
            versionEnAuto !== vEspecial
          ) {
            versionProhibida = true;
          }

          if (
            modelo &&
            titulo.includes("excepto") &&
            regexVersionEspecial.test(titulo) &&
            versionEnAuto === vEspecial
          ) {
            versionProhibida = true;
          }
        }
      });

      const coincideExclusion = palabrasClaveExcluir.some((palabra) =>
        titulo.includes(normalizarTexto(palabra)),
      );

      if (versionProhibida) return false;
      if (esSeminuevo && coincideExclusion) return false;

      // Filtro por modelo + versión.
      // Ejemplo esperado en BD: "Versa Sense Base TM" o "Kait Exclusive CVT".
      if (esGarantia && item.title?.includes(" - ")) {
        const [, rawVersiones = ""] = item.title.split(" - ");

        const versionesLista = rawVersiones
          .split(",")
          .map((v) => limpiarModeloVersion(v))
          .filter(Boolean);

        const modeloLimpio = limpiarModeloVersion(modelo);
        const versionLimpia = limpiarModeloVersion(version);
        const modeloVersion = limpiarModeloVersion(
          `${modeloLimpio} ${versionLimpia}`,
        );

        const incluyeTodos = versionesLista.includes("todos");

        // Aplica a todo el modelo: "Kait", "Versa", etc.
        const coincideSoloModelo =
          !!modeloLimpio && versionesLista.includes(modeloLimpio);

        // Aplica sólo a una versión de un modelo: "Kait Exclusive CVT".
        const coincideModeloVersion =
          !!modeloVersion && versionesLista.includes(modeloVersion);

        const coincide =
          incluyeTodos || coincideSoloModelo || coincideModeloVersion;

        if (!coincide) {
          return false;
        }
      }

      return (
        (esUniversal ||
          mencionaMiModelo ||
          normalizarTexto(item.brand) === "all") &&
        coincideBusqueda
      );
    });
  }, [
    accesoriosGarantias.garantias,
    busqueda,
    selectedMailData?.modelo_vehiculo,
    selectedMailData?.tipo_auto,
    selectedMailData?.version_vehiculo,
    agIdActivo,
    marcaActiva,
  ]);

  console.log("Contenido de plans:", plans);

  const obtenerPlansConImagen = (plans, accesoriosGarantias) => {
    const todosAccesorios = [
      ...accesoriosGarantias.accesorios,
      ...accesoriosGarantias.garantias,
    ];

    const resultados = plans.map((planAccesorio) => {
      const tituloPlan = planAccesorio.title.toLowerCase().trim();

      const encontrado = todosAccesorios.find((a) => {
        const tituloDB = a.title.toLowerCase().trim();
        const match = tituloDB === tituloPlan;

        return match;
      });

      return {
        ...planAccesorio,
        image: encontrado?.image || null,
      };
    });

    console.groupEnd();
    return resultados;
  };

  const convertirImagenABase64 = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous"; // evitar problemas CORS
      img.onload = function () {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL("image/png");
        resolve(dataURL);
      };
      img.onerror = function (error) {
        reject(error);
      };
      img.src = url;
    });
  };

  //******************************** GENERA PDF COTIZACIÓN CONTADO PENDIENTE AUN ***********************************************************/
  const generarPDFcontado = async () => {
    const plansConImagen = obtenerPlansConImagen(plans, accesoriosGarantias);

    setTipoEnvio("contado");
    const dataToSend = {
      ...formData,
      nombreCliente: selectedMailData?.nombre || "",
      marca_vehiculo: selectedMailData?.marca_vehiculo || "",
      modelo_vehiculo: selectedMailData?.modelo_vehiculo || "",
      meses_financiamiento: selectedMailData?.meses_financiamiento || "",
      porcentaje_enganche: selectedMailData?.porcentaje_enganche || "",
      mensualidad_estimacion: selectedMailData?.mensualidad_estimacion || "",
      agencia: selectedMailData?.agencia || "",
      ag_id: selectedMailData?.ag_id || "",
      precio_total: selectedMailData?.precio_vehiculo || "",
      enganche: selectedMailData?.enganche || "",
      auto: selectedMailData?.url_img || "",
      version: selectedMailData?.version_vehiculo || "",
      perdio_llaves:
        selectedMailData?.perdio_llaves || formData?.perdio_llaves || "",
    };

    const doc = new jsPDF();

    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();
    const margin = { left: 14, right: 14, top: 20, bottom: 20 };
    const maxWidth = (left, right) => pageW - left - right;

    const drawJustifiedBlock = (
      text,
      startY,
      {
        left = margin.left,
        right = margin.right,
        lineHeight = 5,
        justifyLastLine = false,
      } = {},
    ) => {
      const paragraphs = String(text).split(/\n+/);
      let y = startY;

      const breakLongWord = (word, widthAllowed) => {
        const parts = [];
        let cur = "";
        for (const ch of word) {
          const test = cur + ch;
          if (doc.getTextWidth(test) <= widthAllowed || cur === "") {
            cur = test;
          } else {
            parts.push(cur);
            cur = ch;
          }
        }
        if (cur) parts.push(cur);
        return parts;
      };

      const makeLines = (para, maxW) => {
        const words = para.split(/\s+/).filter(Boolean);
        const lines = [];
        let current = [];
        let currentWidth = 0;
        const spaceW = doc.getTextWidth(" ");

        for (let w of words) {
          let wW = doc.getTextWidth(w);
          if (wW > maxW) {
            const chunks = breakLongWord(w, maxW);
            for (const c of chunks) {
              const cW = doc.getTextWidth(c);
              if (current.length === 0 && cW >= maxW) {
                lines.push([c]);
                current = [];
                currentWidth = 0;
              } else if (
                currentWidth + (current.length ? spaceW : 0) + cW <=
                maxW
              ) {
                if (current.length) currentWidth += spaceW;
                current.push(c);
                currentWidth += cW;
              } else {
                lines.push(current);
                current = [c];
                currentWidth = cW;
              }
            }
          } else {
            if (currentWidth + (current.length ? spaceW : 0) + wW <= maxW) {
              if (current.length) currentWidth += spaceW;
              current.push(w);
              currentWidth += wW;
            } else {
              lines.push(current);
              current = [w];
              currentWidth = wW;
            }
          }
        }
        if (current.length) lines.push(current);
        return lines;
      };

      for (let p = 0; p < paragraphs.length; p++) {
        const para = paragraphs[p].trim();
        if (!para) {
          y += lineHeight;
          continue;
        }
        const lines = makeLines(para, maxWidth(left, right));
        for (let li = 0; li < lines.length; li++) {
          const words = lines[li];
          const isLastLineOfPara = li === lines.length - 1;
          const isSingleWord = words.length === 1;

          if (y > pageH - margin.bottom) {
            doc.addPage();
            y = margin.top;
          }

          if (!isLastLineOfPara || (isLastLineOfPara && justifyLastLine)) {
            if (!isSingleWord) {
              const totalWordsWidth = words.reduce(
                (sum, w) => sum + doc.getTextWidth(w),
                0,
              );
              const baseSpaces = words.length - 1;
              const spaceW = doc.getTextWidth(" ");
              const totalBaseSpace = baseSpaces * spaceW;
              const extra =
                maxWidth(left, right) - totalWordsWidth - totalBaseSpace;
              const addPerSpace = extra / baseSpaces;

              let x = left;
              for (let wi = 0; wi < words.length; wi++) {
                const w = words[wi];
                doc.text(w, x, y);
                x += doc.getTextWidth(w);
                if (wi !== words.length - 1) x += spaceW + addPerSpace;
              }
            } else {
              doc.text(words[0], left, y);
            }
          } else {
            doc.text(words.join(" "), left, y);
          }

          y += lineHeight;
        }
        y += 0; // separación entre párrafos (0 para compactar)
      }
      return y;
    };

    for (let i = 0; i < plansConImagen.length; i++) {
      const acc = plansConImagen[i];
      if (acc.image && !String(acc.image).startsWith("data:image")) {
        try {
          const esNissan = String(acc.image).includes("nissan.com.mx");

          if (esNissan) {
            const response = await fetch(apiUrlImagenes, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ url: acc.image }),
            });
            const resJson = await response.json();
            if (resJson.base64) {
              acc.image = resJson.base64;
            }
          } else {
            acc.image = await convertirImagenABase64(acc.image);
          }
        } catch (err) {
          acc.image = null;
        }
      }
    }

    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text("CARTA COTIZACION", pageW / 2, margin.top, { align: "center" });

    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    const textoIntro = `AT'N: ${dataToSend.nombreCliente}

    A quien corresponda:

    Reciba un cordial saludo, así como adjunto a la presente carta cotización solicitada:`;
    let cursorY = drawJustifiedBlock(textoIntro, margin.top + 10);

    try {
      if (!selectedMailData?.url_img)
        throw new Error("No hay URL de imagen disponible");

      const imageResponse = await fetch(apiUrlImagenes, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ url: selectedMailData.url_img }),
      });

      if (!imageResponse.ok) throw new Error(`HTTP ${imageResponse.status}`);

      const imageData = await imageResponse.json();
      const base64String = imageData.base64 || imageData.data?.base64;

      if (!base64String) throw new Error("Respuesta sin base64");

      const base64Data = base64String.startsWith("data:image/")
        ? base64String.split(",")[1]
        : base64String;
      const fullBase64 = base64String.startsWith("data:image/")
        ? base64String
        : `data:image/jpeg;base64,${base64String}`;

      await new Promise((resolve) => {
        const img = new Image();
        img.src = fullBase64;
        img.onload = () => {
          const maxWidth = 75;
          const maxHeight = 50;
          const ratio = img.width / img.height;

          let finalWidth = maxWidth;
          let finalHeight = maxWidth / ratio;

          if (finalHeight > maxHeight) {
            finalHeight = maxHeight;
            finalWidth = maxHeight * ratio;
          }

          const xPos = 17;
          const yPos = cursorY + 5;

          doc.addImage(
            base64Data,
            "JPEG",
            xPos,
            yPos,
            finalWidth,
            finalHeight,
            "auto_main",
            "FAST",
          );
          resolve();
        };
        img.onerror = () => {
          console.error("Error al cargar objeto Image");
          resolve();
        };
      });
    } catch (error) {
      doc.setFontSize(8);
      doc.setTextColor(255, 0, 0);
      doc.text(
        `Error imagen: ${error.message.substring(0, 50)}`,
        17,
        cursorY + 10,
      );
      doc.setTextColor(0, 0, 0);
    }

    const infoVehiculo = [
      ["Unidad:", dataToSend.modelo_vehiculo],
      ["Marca:", dataToSend.marca_vehiculo],
      ["Modelo:", selectedMailData.ano_vehiculo],
      ["Versión:", dataToSend.version],
    ];
    doc.autoTable({
      startY: cursorY + 8,
      margin: { left: 109 },
      body: infoVehiculo,
      theme: "plain",
      styles: { fontSize: 10 },
      columnStyles: {
        0: { cellWidth: 30, fontStyle: "bold" },
        1: { cellWidth: 60 },
      },
    });
    const infoFinalY = doc.lastAutoTable.finalY;

    doc.setFont("helvetica", "bold");
    doc.text("Descripción del vehículo:", 111, infoFinalY + 6);
    doc.setFont("helvetica", "normal");

    const descVeh = descripcionAuto ?? ""; //aqui hoy
    const descStartY = infoFinalY + 11;
    let contenidoFinalY = drawJustifiedBlock(descVeh, descStartY, {
      left: 111,
      right: margin.right,
      lineHeight: 5,
    });

    let yBase = contenidoFinalY + 5;
    doc.setFont("helvetica", "bold");
    const precio = Number(dataToSend.precio_total);
    const precioFormateado = precio.toLocaleString("es-MX", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    doc.text(`Precio Contado: $${precioFormateado}`, margin.left, yBase + 5);

    let precioFinalY = yBase + 5;
    const tasaFinanciamientoTexto = normalizarTasaFinanciamientoTexto(
      dataToSend?.perdio_llaves || selectedMailData?.perdio_llaves,
    );

    if (selectedPlan && plansConImagen?.length > 0) {
      const accesoriosNombres =
        (selectedPlan.accessories ?? [])
          .map((acc) => {
            const title = acc.title ?? "";
            return toTitleCase(title.split(" - ")[0]);
          })
          .filter(Boolean)
          .join(", ") || "Ninguno";

      const textoPlan =
        `Protección ${selectedPlan.title}: ${accesoriosNombres}. ` +
        `Al precio de: $${selectedPlan.totalPrice.toLocaleString("es-MX", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`;

      contenidoFinalY = drawJustifiedBlock(textoPlan, precioFinalY + 5, {
        left: margin.left,
        right: margin.right,
        lineHeight: 5,
      });

      let y = contenidoFinalY + 5;
      for (const acc of plansConImagen) {
        const imgW = 40;
        const imgH = 40;
        const imgX = margin.left;
        const textX = imgX + imgW + 8;

        if (y > pageH - margin.bottom - imgH - 20) {
          doc.addPage();
          y = margin.top;
        }

        if (acc.image) {
          try {
            console.error(" insertar medium en el PDF:");
            doc.addImage(
              acc.image,
              "JPEG",
              imgX,
              y,
              imgW,
              imgH,
              undefined,
              "MEDIUM",
            );
          } catch (error) {
            console.error("Error al insertar imagen en el PDF:", error);
          }
        }

        doc.setFont("helvetica", "bold");
        doc.text(toTitleCase((acc.title || "").split(" - ")[0]), textX, y + 6);

        doc.setFont("helvetica", "normal");
        const afterDescY = drawJustifiedBlock(acc.description || "", y + 10, {
          left: textX,
          right: margin.right,
          lineHeight: 5,
        });

        doc.setFont("helvetica", "bold");
        const precioAcc = Number(acc.price) || 0;
        const precioAccFmt = precioAcc.toLocaleString("es-MX", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
        doc.text(`Precio: $${precioAccFmt}`, textX, afterDescY + 5);

        y = Math.max(y + imgH, afterDescY + 10) + 10;
        contenidoFinalY = y;
      }
    } else {
      doc.setFont("helvetica", "normal");
      contenidoFinalY = drawJustifiedBlock(
        "No se ha seleccionado ningún plan.",
        precioFinalY,
        {
          left: margin.left,
          right: margin.right,
          lineHeight: 5,
        },
      );
    }

    if (contenidoFinalY > pageH - margin.bottom - 50) {
      doc.addPage();
      contenidoFinalY = margin.top;
    }

    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");

    // calcular la fecha de vigencia (7 días)
    const diasVigencia = 7;
    const fechaActual = new Date();
    const fechaVigencia = new Date(fechaActual);
    fechaVigencia.setDate(fechaActual.getDate() + diasVigencia);

    // dar formato
    const fechaFormateada = fechaVigencia.toLocaleDateString("es-MX", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    const leyenda = `Esta cotización tiene una nueva vigencia hasta ${fechaFormateada}, cambios y variaciones de precios sin previo aviso`;

    const leyendaY = drawJustifiedBlock(leyenda, contenidoFinalY + 15, {
      left: margin.left,
      right: margin.right,
      lineHeight: 5,
    });

    doc.setFontSize(10);
    doc.text("Atentamente:", pageW / 2, leyendaY + 10, { align: "center" });
    doc.text(selectedMailData.asesor, pageW / 2, leyendaY + 15, {
      align: "center",
    });
    /*doc.text("Móvil: 2228299725", pageW / 2, leyendaY + 20, {
      align: "center",
    });*/
    doc.text(`Email: ${userEmail}`, pageW / 2, leyendaY + 20, {
      align: "center",
    });

    const logoGocar = "/assets/img/product/gocar_negro.png";
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      try {
        doc.addImage(
          logoGocar,
          "JPEG",
          2,
          287.5,
          11.5,
          3.5,
          undefined,
          "MEDIUM",
        );
      } catch {}
      doc.setFontSize(7);
      doc.setFont("helvetica", "normal");
      doc.text(
        "   León Motors S.A. de C.V. RFC: LMO860212R76. C. Gabriel Mancera 1629, Col del Valle Sur, Benito Juárez, 03104 Ciudad de México, CDMX. Tel: 55 4747 5260",
        pageW / 2,
        290,
        { align: "center" },
      );
    }

    agregarTasaPiePaginaPDF(doc, tasaFinanciamientoTexto, {
      y: 284.5,
      fontSize: 6,
    });

    const blob = doc.output("blob");
    const fileName = `Cotizacion_Contado_${dataToSend.nombre || "Cliente"}.pdf`;
    const pdfFile = new File([blob], fileName, { type: "application/pdf" });

    agregarArchivo(pdfFile);
    /*if (garantia_extendida === "No") {
      console.log("setReadyToSend(true1)");
      setReadyToSend(true);
     }*/

    const url = URL.createObjectURL(blob);
    return { file: pdfFile, url };
  };

  //******************************** GENERA PDF RENUNCIA ***********************************************************/
  const generarPDFrenuncia = async () => {
    if (selectedMailData.depende_auto === "Si") {
      setTipoEnvio("rechazoContado");
    }

    setTipoEnvio("rechazoCotizacion");

    function abrirVentanaParaFirmar(
      pdfDoc,
      nombreArchivo,
      nombreCliente,
      agregarArchivo,
      existingWin = null,
    ) {
      return new Promise(async (resolve) => {
        const win = existingWin || window.open("", "_blank");
        if (!win) {
          alert(
            "El navegador bloqueó la ventana emergente. Permite pop-ups para continuar.",
          );
          return;
        }

        // Blob inicial editable (antes de firmar)
        const pdfEditableBytes = await pdfDoc.save();
        const pdfEditableBlob = new Blob([pdfEditableBytes], {
          type: "application/pdf",
        });
        const pdfEditableUrl = URL.createObjectURL(pdfEditableBlob);

        // Estructura UI (visor arriba, firmas abajo)
        win.document.open();
        win.document.write(`<!DOCTYPE html>
        <html lang="es">
        <head>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <title>Firmas</title>
        <style>
          html,body{height:100%;margin:0}
          .wrap{display:flex;flex-direction:column;height:100vh;width:100vw;overflow:hidden;background:#f5f6f8}
          .viewer{flex:1 1 auto;min-height:0;overflow:auto;background:#e9ebef}
          #pdfRoot{max-width:1200px;margin:0 auto;padding:12px;box-sizing:border-box}
          .pageCanvas{display:block;width:100%;height:auto;background:#fff;box-shadow:0 6px 20px rgba(0,0,0,.12);border-radius:6px;margin:0 auto 12px}
          .bar{flex:0 0 auto;background:#fff;border-top:1px solid #e3e6ef;padding:10px 12px}
          .bar .top{display:flex;justify-content:space-between;align-items:center;margin-bottom:8px}
          .row{display:grid;grid-template-columns:1fr 1fr;gap:12px;align-items:start}
          .btn{background:#B5BDD0;color:#2A2A2A;border:0;border-radius:8px;padding:10px 14px;font:500 13px system-ui,-apple-system,Segoe UI,Roboto,sans-serif;cursor:pointer;transition:background .2s}
          .btn:hover{background:#A0A9BF}
          .btn[disabled]{opacity:.6;cursor:not-allowed}
          .title{margin:0 0 6px;font:600 14px system-ui,-apple-system,Segoe UI,Roboto,sans-serif;color:#2a2f3a}
          .pad-wrap{display:flex;flex-direction:column;gap:8px}
          canvas.signature{width:100%;height:160px;background:#EDF0F5;border:1px solid #A3ADC2;border-radius:8px;touch-action:none}
          .ctrls{display:flex;gap:8px;justify-content:flex-end;margin-top:8px}
          @media (max-width: 720px){ .row{grid-template-columns:1fr} }
        </style>
        </head>
        <body>
          <div class="wrap">
            <div class="viewer"><div id="pdfRoot"></div></div>
            <div class="bar">
              <div class="top">
                <div style="display:flex;gap:8px;align-items:center"><strong>Firmar documento</strong></div>
                <div style="display:flex;gap:8px">
                  <button id="fit" class="btn">Ajustar</button>
                  <button id="width" class="btn">Ancho</button>
                  <button id="real" class="btn">100%</button>
                </div>
              </div>
              <div class="row">
                <div class="pad-wrap">
                  <div class="title">Firma del Cliente</div>
                  <canvas id="padCliente" class="signature"></canvas>
                  <div class="ctrls" style="padding:0"><button id="clearCliente" class="btn">Limpiar</button></div>
                </div>
                <div class="pad-wrap">
                  <div class="title">Firma del Asesor</div>
                  <canvas id="padAsesor" class="signature"></canvas>
                  <div class="ctrls" style="padding:0"><button id="clearAsesor" class="btn">Limpiar</button></div>
                </div>
              </div>
              <div class="ctrls"><button id="guardar" class="btn">Guardar</button></div>
            </div>
          </div>
          <!-- pdf.js -->
          <script src="https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js"></script>
          <script>
            (function(){
              const pdfUrl = ${JSON.stringify(pdfEditableUrl)};
              const pdfjsLib = window['pdfjs-dist/build/pdf'];
              pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';

              const pdfRoot = document.getElementById('pdfRoot');

              let pdf, numPages = 0, pages = [];
              let baseViewport; // viewport de referencia (scale 1) de la 1ra página
              let mode = 'fit'; // fit | width | real
              let baseScale = 1; // escala calculada para 'fit'

              const ratio = window.devicePixelRatio || 1;

              function makeCanvas() {
                const c = document.createElement('canvas');
                c.className = 'pageCanvas';
                return c;
              }

              function setCanvasSize(canvas, cssW, cssH, retina = true) {
                const ctx = canvas.getContext('2d');
                if (retina) {
                  canvas.width = Math.floor(cssW * ratio);
                  canvas.height = Math.floor(cssH * ratio);
                  canvas.style.width = cssW + 'px';
                  canvas.style.height = cssH + 'px';
                  ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
                } else {
                  canvas.width = Math.floor(cssW);
                  canvas.height = Math.floor(cssH);
                  canvas.style.width = cssW + 'px';
                  canvas.style.height = cssH + 'px';
                  ctx.setTransform(1, 0, 0, 1, 0, 0);
                }
                return ctx;
              }

              function computeFitScale() {
                if (!baseViewport) return 1;
                const viewer = document.querySelector('.viewer');
                const bar = document.querySelector('.bar');
                const availableW = pdfRoot.clientWidth; // interno con padding
                const availableH = viewer.clientHeight; // alto del viewer scrolleable

                // Para 'fit' queremos que UNA página quepan entera en el viewport (sin distorsión)
                const pageW = baseViewport.width;
                const pageH = baseViewport.height;

                const scaleW = availableW / pageW;
                const scaleH = availableH / pageH;

                // Elegimos el menor para que la página completa sea visible
                return Math.max(0.1, Math.min(scaleW, scaleH));
              }

              async function renderAll() {
                if (!pdf) return;

                // Limpiar contenedor
                pdfRoot.innerHTML = '';

                // Según el modo, elegimos escala base
                let scale;
                if (mode === 'fit') {
                  baseScale = computeFitScale();
                  scale = baseScale;
                } else if (mode === 'width') {
                  // ajustar al ancho del contenedor
                  const pageW = baseViewport.width;
                  scale = pdfRoot.clientWidth / pageW;
                } else {
                  // 100% (escala 1)
                  scale = 1;
                }

                for (let i = 1; i <= numPages; i++) {
                  const page = await pdf.getPage(i);
                  const vp = page.getViewport({ scale });

                  const canvas = makeCanvas();
                  pdfRoot.appendChild(canvas);

                  const ctx = setCanvasSize(canvas, vp.width, vp.height, true);
                  await page.render({ canvasContext: ctx, viewport: vp }).promise;
                }
              }

              function onResize() {
                if (mode === 'fit' || mode === 'width') {
                  // recomputar y re-render
                  renderAll();
                }
              }

              window.addEventListener('resize', onResize);
              window.addEventListener('orientationchange', () => setTimeout(onResize, 200));

              // Controles
              document.getElementById('fit').addEventListener('click', () => { mode = 'fit'; renderAll(); });
              document.getElementById('width').addEventListener('click', () => { mode = 'width'; renderAll(); });
              document.getElementById('real').addEventListener('click', () => { mode = 'real'; renderAll(); });

              // Cargar PDF
              pdfjsLib.getDocument(pdfUrl).promise.then(async (_pdf) => {
                pdf = _pdf;
                numPages = pdf.numPages;
                const p1 = await pdf.getPage(1);
                baseViewport = p1.getViewport({ scale: 1 });
                renderAll();
              });
            })();
          </script>
        </body>
        </html>`);
        win.document.close();

        // ===== Firma: lógica en la ventana =====
        const onReady = () => {
          const $ = (s) => win.document.querySelector(s);
          const padCliente = $("#padCliente");
          const padAsesor = $("#padAsesor");
          const btnClearCliente = $("#clearCliente");
          const btnClearAsesor = $("#clearAsesor");
          const btnGuardar = $("#guardar");

          let signaturePadCliente = null;
          let signaturePadAsesor = null;
          let resizeFrame = null;

          // Canvases nítidos
          const fitCanvas = (canvas) => {
            const ratio = Math.max(win.devicePixelRatio || 1, 1);
            const rect = canvas.getBoundingClientRect();

            const newWidth = Math.max(1, Math.floor(rect.width * ratio));
            const newHeight = Math.max(1, Math.floor(rect.height * ratio));

            if (canvas.width === newWidth && canvas.height === newHeight)
              return;

            canvas.width = newWidth;
            canvas.height = newHeight;

            const ctx = canvas.getContext("2d");
            ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
          };

          const drawHint = (canvas, text) => {
            const ctx = canvas.getContext("2d");
            ctx.save();
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.fillStyle = "#4A4A4A";
            ctx.font = "14px Arial";
            ctx.fillText(text, 16, 28);
            ctx.restore();
          };

          const refreshGuardar = () => {
            btnGuardar.disabled = false;
          };

          const restorePadAfterResize = (pad, canvas, hintText) => {
            if (!pad) return;

            const data = pad.toData();
            fitCanvas(canvas);
            pad.clear();

            if (data && data.length) {
              pad.fromData(data);
            } else {
              drawHint(canvas, hintText);
            }
          };

          const safeRefresh = () => {
            win.setTimeout(refreshGuardar, 0);
          };

          const bindPadRefresh = (pad, canvas) => {
            if (typeof pad.addEventListener === "function") {
              try {
                pad.addEventListener("endStroke", safeRefresh);
              } catch (e) {}
            }

            pad.onEnd = safeRefresh;

            canvas.addEventListener("mouseup", safeRefresh);
            canvas.addEventListener("touchend", safeRefresh, { passive: true });
            canvas.addEventListener("pointerup", safeRefresh);

            win.addEventListener("mouseup", safeRefresh);
            win.addEventListener("touchend", safeRefresh, { passive: true });
            win.addEventListener("pointerup", safeRefresh);
          };

          const setupCanvasBase = (canvas) => {
            canvas.style.pointerEvents = "auto";
            canvas.style.touchAction = "none";
            canvas.style.webkitUserSelect = "none";
            canvas.style.userSelect = "none";
            canvas.style.webkitTouchCallout = "none";
          };

          const initPads = () => {
            setupCanvasBase(padCliente);
            setupCanvasBase(padAsesor);

            fitCanvas(padCliente);
            fitCanvas(padAsesor);

            signaturePadCliente = new SignaturePad(padCliente, {
              minWidth: 0.5,
              maxWidth: 1.3,
            });

            signaturePadAsesor = new SignaturePad(padAsesor, {
              minWidth: 0.5,
              maxWidth: 1.3,
            });

            if (signaturePadCliente.isEmpty())
              drawHint(padCliente, "Firme aquí");
            if (signaturePadAsesor.isEmpty()) drawHint(padAsesor, "Firme aquí");

            bindPadRefresh(signaturePadCliente, padCliente);
            bindPadRefresh(signaturePadAsesor, padAsesor);

            btnClearCliente.onclick = () => {
              signaturePadCliente.clear();
              fitCanvas(padCliente);
              drawHint(padCliente, "Firme aquí");
              refreshGuardar();
            };

            btnClearAsesor.onclick = () => {
              signaturePadAsesor.clear();
              fitCanvas(padAsesor);
              drawHint(padAsesor, "Firme aquí");
              refreshGuardar();
            };

            refreshGuardar();
          };

          const ro = new win.ResizeObserver(() => {
            if (!signaturePadCliente || !signaturePadAsesor) return;

            if (resizeFrame) {
              win.cancelAnimationFrame(resizeFrame);
            }

            resizeFrame = win.requestAnimationFrame(() => {
              restorePadAfterResize(
                signaturePadCliente,
                padCliente,
                "Firme aquí",
              );
              restorePadAfterResize(
                signaturePadAsesor,
                padAsesor,
                "Firme aquí",
              );
              refreshGuardar();
            });
          });

          ro.observe(win.document.body);

          win.requestAnimationFrame(() => {
            win.requestAnimationFrame(() => {
              initPads();
            });
          });

          const cleanupPads = () => {
            try {
              ro.disconnect();
            } catch {}

            try {
              if (resizeFrame) {
                win.cancelAnimationFrame(resizeFrame);
              }
            } catch {}
          };

          btnGuardar.onclick = async () => {
            const keepInk = async (pad) => {
              if (!pad) return;
              const d = pad.toData();
              pad.clear();
              if (d && d.length) {
                pad.fromData(d);
              }
            };

            await keepInk(signaturePadCliente);
            await keepInk(signaturePadAsesor);

            const firmaClienteUrl =
              signaturePadCliente && !signaturePadCliente.isEmpty()
                ? signaturePadCliente.toDataURL()
                : null;

            const firmaAsesorUrl =
              signaturePadAsesor && !signaturePadAsesor.isEmpty()
                ? signaturePadAsesor.toDataURL()
                : null;

            let firmaClienteImg = null;
            let firmaAsesorImg = null;

            if (firmaClienteUrl) {
              const firmaClienteBytes = await fetch(firmaClienteUrl).then((r) =>
                r.arrayBuffer(),
              );
              firmaClienteImg = await pdfDoc.embedPng(firmaClienteBytes);
            }

            if (firmaAsesorUrl) {
              const firmaAsesorBytes = await fetch(firmaAsesorUrl).then((r) =>
                r.arrayBuffer(),
              );
              firmaAsesorImg = await pdfDoc.embedPng(firmaAsesorBytes);
            }

            pdfDoc
              .getPages()
              .slice(0, 4)
              .forEach((page) => {
                const pageHeight = page.getHeight();
                const margenInferior = 555;

                if (firmaAsesorImg) {
                  page.drawImage(firmaAsesorImg, {
                    x: 90,
                    y: pageHeight - margenInferior - 65,
                    width: 160,
                    height: 80,
                  });
                }

                if (firmaClienteImg) {
                  page.drawImage(firmaClienteImg, {
                    x: 350,
                    y: pageHeight - margenInferior - 65,
                    width: 160,
                    height: 80,
                  });
                }
              });

            const pdfFirmadoBytes = await pdfDoc.save();
            const pdfFirmadoBlob = new Blob([pdfFirmadoBytes], {
              type: "application/pdf",
            });

            const nombreCompleto = `${nombreArchivo}_${nombreCliente || "Cliente"}.pdf`;
            const pdfFile = new File([pdfFirmadoBlob], nombreCompleto, {
              type: "application/pdf",
            });

            const urlFirmado = URL.createObjectURL(pdfFirmadoBlob);

            agregarArchivo(pdfFile);

            cleanupPads();

            // en iPad/Safari es mejor no cerrar aquí la ventana;
            // devolvemos la misma referencia para reutilizarla en el siguiente paso
            win.setTimeout(() => {
              resolve({ file: pdfFile, url: urlFirmado, win });
            }, 120);
          };
        };

        if (
          win.document.readyState === "complete" ||
          win.document.readyState === "interactive"
        ) {
          setTimeout(onReady, 0);
        } else {
          win.addEventListener("DOMContentLoaded", onReady);
        }
      });
    }

    const dataToSend = {
      ...formData,
      mensualidad_estimacion: selectedMailData?.mensualidad_estimacion || "",
      nombreCliente: selectedMailData?.nombre || "",
      nombreAsesor: selectedMailData?.asesor || "",
      agencyName: selectedMailData?.agencia || "",
    };

    const logoURL = "/assets/img/product/gocar_negro.png";
    const encabezado1 = "/assets/img/product/encabezado1.png";
    const encabezado2 = "/assets/img/product/encabezado2.png";

    const fechaActual = new Date().toLocaleDateString("es-MX", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });

    function agregarEncabezado(doc) {
      doc.addImage(encabezado2, "PNG", 108, 0, 108, 20);
      doc.addImage(encabezado1, "PNG", 0, 0, 125, 20);
      doc.addImage(logoURL, "PNG", 108, 7, 55, 16);
      doc.setFontSize(13);
      doc.text("CARTA RENUNCIA", 105, 29, { align: "center" });
    }

    function agregarLugarYFecha(doc, agencyName, fechaActual) {
      doc.setFontSize(10);
      doc.text(`Lugar y Fecha: ${agencyName}, ${fechaActual}`, 98, 37);
      doc.line(122, 38, 195, 38);
    }

    function agregarPiePagina(doc) {
      doc.setFillColor(231, 230, 230);
      doc.rect(0, 280, 210, 20, "F");
      doc.setFontSize(10);
      doc.text(
        "C. Gabriel Mancera 1629, Col del Valle Sur, Benito Juárez, 03104 Ciudad de México, CDMX. Tel. 55 5681 8736",
        105,
        290,
        { align: "center" },
      );
    }

    function agregarFirmas(doc, nombreAsesor, nombreCliente, yBase) {
      // Firma asesor
      doc.text(nombreAsesor, 30, yBase + 49);
      doc.text("Nombre y firma del asesor y/o F&I.", 25, yBase + 56);
      doc.line(20, yBase + 50, 85, yBase + 50);

      // Firma cliente
      doc.text(nombreCliente, 120, yBase + 49);
      doc.text("Nombre y firma del cliente.", 120, yBase + 56);
      doc.line(110, yBase + 50, 175, yBase + 50);
    }

    function normalizarTexto(texto) {
      return String(texto || "")
        .toLowerCase()
        .normalize("NFD") // separa acentos
        .replace(/[\u0300-\u036f]/g, "") // elimina acentos
        .replace(/[-_/]+/g, " ") // llanta-rin → llanta rin
        .replace(/\s+/g, " ") // espacios dobles → uno
        .trim(); // sin espacios al inicio/fin
    }

    //***************************** PDF COBERTURA AMPLIA *************************/
    const generarPDFcoberturaAmplia = async () => {
      const doc = new jsPDF();

      agregarEncabezado(doc);

      //lugar y fecha
      agregarLugarYFecha(doc, dataToSend.agencyName, fechaActual);

      //Agregar primer texto
      doc.setFontSize(10);
      const texto = `Por medio del presente, yo: ${dataToSend.nombreCliente} hago constar que fue ofrecida una Cobertura Mecánica con el vehículo que estoy adquiriendo y que me fueron explicados los siguientes beneficios:`;
      const splitTexto = doc.splitTextToSize(texto, 180);
      doc.text(splitTexto, 14, 46);

      // Primer recuadro
      doc.setFillColor(214, 220, 229); // Color gris claro
      doc.roundedRect(14, 55, 180, 15, 5, 5, "F"); // (x, y, width, height, radioX, radioY)

      const texto10 = `Cobertura Amplia (para vehículos menores a 4 años de antigüedad o con hasta 80,00kms.)\nCubre costos de materiales y mano de obra necesarios para reparar o remplazar las partes o componentes mencionados a continuación.`;
      const splitTexto10 = doc.splitTextToSize(texto10, 165);
      doc.text(splitTexto10, 20, 60);

      doc.setFillColor(214, 220, 229); // Color gris claro
      doc.roundedRect(14, 75, 180, 50, 5, 5, "F");

      //Lista de beneficios en recuadro 2
      const lista = [
        "Motor",
        "Cambio manual o automático",
        "Sistema eléctrico",
        "Inyección y alimentación",
        "Dirección",
        "Suspensión",
        "Sistema de enfriamiento",
        "Sistema de frenos",
        "Cobertura de hasta $90,000.00 M.N. en repuestos y reparaciones.",
      ];

      let yLista5 = 80;
      lista.forEach((item) => {
        doc.text(`• ${item}`, 20, yLista5);
        yLista5 += 5;
      });

      //Segundo recuadro
      doc.setFillColor(214, 220, 229); // Color gris claro
      doc.roundedRect(14, yLista5 + 5, 180, 35, 5, 5, "F");
      const texto7 = `Cobertura de Tren Motriz (para vehículos menores a 10 años de antigüedad o con hasta 150,000 kms.)\nCubre costos de materiales y mano de obra necesarios para reparar o remplazar las partes o componentes mencionados a continuación.`;
      const splitTexto7 = doc.splitTextToSize(texto7, 165);
      doc.text(splitTexto7, 20, yLista5 + 10);

      // Lista de beneficios en recuadro 2
      const lista8 = [
        "Motor",
        "Cambio manual o automático",
        "Cobertura de hasta $90,000.00 en repuestos y reparaciones.",
      ];

      yLista5 += 26;
      lista8.forEach((item) => {
        doc.text(`• ${item}`, 20, yLista5);
        yLista5 += 5;
      });

      //Agregar primer texto
      const texto9 = `Dicha cobertura no tiene pago de deducible ni trámites engorrosos, es transferible si decido vender mi vehículo, tiene cobertura en toda la República Mexicana, es aplicable desde el primer día y está incluida en mi financiamiento con un costo de ${Number(
        dataToSend.mensualidad_estimacion,
      ).toLocaleString("es-MX", {
        style: "currency",
        currency: "MXN",
      })} al mes.\nConociendo los beneficios anteriores, RENUNCIO a la Cobertura Mecánica ofrecida y confirmo que no tengo interés en que sea agregarla a mi financiamiento.`;
      const splitTexto9 = doc.splitTextToSize(texto9, 180);
      doc.text(splitTexto9, 14, yLista5 + 10);

      // Espacio para firma del asesor
      agregarFirmas(
        doc,
        dataToSend.nombreAsesor,
        dataToSend.nombreCliente,
        180,
      );

      agregarPiePagina(doc);

      //doc.save(`Renuncia_Cobertura_Amplia_${dataToSend.nombreCliente}.pdf`);

      const pdfBytes = doc.output("arraybuffer");
      //const pdfDoc = await PDFDocument.load(pdfBytes);
      return await PDFDocument.load(pdfBytes);
      /*return abrirVentanaParaFirmar(
        pdfDoc,
        `Renuncia_Firmada_C.Amplia_${dataToSend.nombreCliente}`,
        dataToSend.nombreCliente,
        agregarArchivo
      );*/
    };

    //***************************** PDF COBERTURA MOVILIDAD *************************/
    const generarPDFcoberturaMovilidad = async () => {
      const doc = new jsPDF();

      agregarEncabezado(doc);

      //lugar y fecha
      agregarLugarYFecha(doc, dataToSend.agencyName, fechaActual);

      //Agregar primer texto
      doc.setFontSize(10);
      const texto = `Por medio del presente, yo: ${dataToSend.nombreCliente} hago constar que fue ofrecida una Cobertura Mecánica con el vehículo que estoy adquiriendo y que me fueron explicados los siguientes beneficios:`;
      const splitTexto = doc.splitTextToSize(texto, 180);
      doc.text(splitTexto, 14, 46);

      let yLista10 = 60;

      //Segundo recuadro
      doc.setFillColor(214, 220, 229); // Color gris claro
      doc.roundedRect(14, yLista10, 180, 50, 5, 5, "F");
      const texto18 = `o   Garantía de Movilidad (para vehículos nuevos y seminuevos.)`;
      const splitTexto18 = doc.splitTextToSize(texto18, 165);
      doc.text(splitTexto18, 27, 70);

      const texto19 = `Garantizamos tu movilidad vehicular en caso de accidente o pérdida total por daños o robo.\nDos opciones de movilidad: Vehículos de transporte con conductor (UBER) con un monto máximo de $300.00 M.N. por día o Auto Sustituto.`;
      const splitTexto19 = doc.splitTextToSize(texto19, 165);
      doc.text(splitTexto19, 20, 75);

      // Lista de beneficios en recuadro 2
      const lista12 = [
        "Accidente Vehicular",
        "Movilidad hasta por 10 días",
        "Pérdida Total",
        "Movilidad hasta por 30 días",
      ];

      yLista10 += 30;
      const yInicial = yLista10;
      lista12.forEach((item) => {
        doc.text(`• ${item}`, 27, yLista10);
        yLista10 += 5;
      });

      const texto22 = `Dichas coberturas no tiene pago de deducible ni trámites engorrosos, es transferible si decido vender mi vehículo, tiene cobertura en toda la República Mexicana, es aplicable desde el primer día y está incluida en mi financiamiento con un costo de ${Number(
        dataToSend.mensualidad_estimacion,
      ).toLocaleString("es-MX", {
        style: "currency",
        currency: "MXN",
      })} al mes.\nConociendo los beneficios anteriores, RENUNCIO a la Cobertura Mecánica ofrecida y confirmo que no tengo interés en que sea agregarla a mi financiamiento.`;
      const splitTexto22 = doc.splitTextToSize(texto22, 180);
      doc.text(splitTexto22, 14, yLista10 + 10);

      // Espacio para firma del asesor
      agregarFirmas(
        doc,
        dataToSend.nombreAsesor,
        dataToSend.nombreCliente,
        178,
      );

      agregarPiePagina(doc);

      //Obtener bytes del PDF y cargar con pdf-lib para edición
      const pdfBytes = doc.output("arraybuffer");
      //const pdfDoc = await PDFDocument.load(pdfBytes);
      return await PDFDocument.load(pdfBytes);
    };

    //***************************** PDF COBERTURA LLAVES *************************/
    const generarPDFcoberturaLlaves = async () => {
      const doc = new jsPDF();

      agregarEncabezado(doc);

      //lugar y fecha
      agregarLugarYFecha(doc, dataToSend.agencyName, fechaActual);

      //lugar y fecha
      doc.setFontSize(10);
      doc.text(
        `Lugar y Fecha: ${dataToSend.agencyName}, ${fechaActual}`,
        98,
        37,
      );
      doc.line(122, 38, 195, 38);

      //Agregar primer texto
      doc.setFontSize(10);
      const texto = `Por medio del presente, yo: ${dataToSend.nombreCliente} hago constar que fue ofrecida una Cobertura Mecánica con el vehículo que estoy adquiriendo y que me fueron explicados los siguientes beneficios:`;
      const splitTexto = doc.splitTextToSize(texto, 180);
      doc.text(splitTexto, 14, 46);

      let yLista10 = 60;

      //tercer recuadro
      doc.setFillColor(214, 220, 229); // Color gris claro
      doc.roundedRect(14, yLista10, 180, 35, 5, 5, "F");

      const texto20 = `o   Cobertura de Llaves (para vehículos nuevos.)`;
      const splitTexto20 = doc.splitTextToSize(texto20, 180);
      doc.text(splitTexto20, 27, 70);

      const texto21 = `Cubre el reemplazo de tu llave o sensor en caso de pérdida o daño irreparable.\nCobertura de hasta $6,000.00 M.N.\nAtención y reemplazo original de agencia.`;
      const splitTexto21 = doc.splitTextToSize(texto21, 180);
      doc.text(splitTexto21, 20, yLista10 + 19);

      const texto22 = `Dichas coberturas no tienen pago de deducible ni trámites engorrosos, son transferibles si decido vender mi vehículo, tiene cobertura en toda la República Mexicana, es aplicable desde el primer día y está incluida en mi financiamiento con un costo de ${Number(
        dataToSend.mensualidad_estimacion,
      ).toLocaleString("es-MX", {
        style: "currency",
        currency: "MXN",
      })} al mes.\nConociendo los beneficios anteriores, RENUNCIO a la Cobertura Mecánica ofrecida y confirmo que no tengo interés en que sea agregarla a mi financiamiento.`;
      const splitTexto22 = doc.splitTextToSize(texto22, 180);
      doc.text(splitTexto22, 14, yLista10 + 48);

      // Espacio para firma del asesor
      agregarFirmas(
        doc,
        dataToSend.nombreAsesor,
        dataToSend.nombreCliente,
        170,
      );
      agregarPiePagina(doc);

      //doc.save(`Renuncia_Cobertura_Amplia_${dataToSend.nombreCliente}.pdf`);

      //Obtener bytes del PDF y cargar con pdf-lib para edición
      const pdfBytes = doc.output("arraybuffer");
      //const pdfDoc = await PDFDocument.load(pdfBytes);
      return await PDFDocument.load(pdfBytes);
    };

    //***************************** PDF COBERTURA LLANTAS *************************/
    const generarPDFcoberturaLlantas = async () => {
      const doc = new jsPDF();

      agregarEncabezado(doc);

      //lugar y fecha
      agregarLugarYFecha(doc, dataToSend.agencyName, fechaActual);

      //lugar y fecha
      doc.setFontSize(10);
      doc.text(
        `Lugar y Fecha: ${dataToSend.agencyName}, ${fechaActual}`,
        98,
        37,
      );
      doc.line(122, 38, 195, 38);

      //Agregar primer texto
      doc.setFontSize(10);
      const texto = `Por medio del presente, yo: ${dataToSend.nombreCliente} hago constar que fueron ofrecidas las siguientes Coberturas Adicionales con el vehículo que estoy adquiriendo y que me fueron explicados los siguientes beneficios:`;
      const splitTexto = doc.splitTextToSize(texto, 180);
      doc.text(splitTexto, 14, 46);

      // Primer recuadro
      doc.setFillColor(214, 220, 229); // Color gris claro
      doc.roundedRect(14, 64, 180, 65, 5, 5, "F");
      const texto25 = `o   Cobertura de Llantas (para vehículos nuevos.)`;
      const splitTexto25 = doc.splitTextToSize(texto25, 165);
      doc.text(splitTexto25, 27, 72);
      const texto17 = `Cubre el reemplazo de neumáticos en caso de daño accidental en el camino por bache, banquetazo o corte.\nHasta 2 eventos por año.\nInstalación del neumático sin costo y en menos de 48hrs.\nReposición del neumático de las mismas características.\nCobertura transferible si el vehículo cambia de propietario.`;
      const splitTexto17 = doc.splitTextToSize(texto17, 165);
      doc.text(splitTexto17, 20, 78);

      //Lista de beneficios en recuadro 2
      const lista10 = [
        "Plan 4OOO: Hasta 4 neumáticos por evento y hasta $4,000.00 M.N por neumático",
        "Plan 5OOO: Hasta 2 neumáticos y/o rines por evento y hasta $5,000.00 M.N por neumático y/o rin.",
        "Plan 12OOO: Hasta 2 neumáticos y/o rines por evento y hasta $12,000.00 M.N por neumático y/o rin",
      ];
      let yLista10 = 109;
      lista10.forEach((item) => {
        doc.text(`• ${item}`, 20, yLista10);
        yLista10 += 5;
      });

      const texto22 = `Dichas coberturas no tiene pago de deducible ni trámites engorrosos, son transferibles si decido vender mi vehículo, tiene cobertura en toda la República Mexicana, es aplicable desde el primer día y está incluida en mi financiamiento con un costo de ${Number(
        dataToSend.mensualidad_estimacion,
      ).toLocaleString("es-MX", {
        style: "currency",
        currency: "MXN",
      })} al mes.\nConociendo los beneficios anteriores, RENUNCIO a la Cobertura Mecánica ofrecida y confirmo que no tengo interés en que sea agregarla a mi financiamiento.`;
      const splitTexto22 = doc.splitTextToSize(texto22, 180);
      doc.text(splitTexto22, 14, yLista10 + 20);

      // Espacio para firma del asesor
      agregarFirmas(
        doc,
        dataToSend.nombreAsesor,
        dataToSend.nombreCliente,
        178,
      );
      agregarPiePagina(doc);

      //doc.save(`Renuncia_Cobertura_Amplia_${dataToSend.nombreCliente}.pdf`);
      //Obtener bytes del PDF y cargar con pdf-lib para edición
      const pdfBytes = doc.output("arraybuffer");
      return await PDFDocument.load(pdfBytes);
    };

    const garantiasNuevos = [
      {
        nombres: ["Garantía De Movilidad"].map(normalizarTexto),
        generar: generarPDFcoberturaMovilidad,
      },
      {
        nombres: ["Cobertura De Llaves"].map(normalizarTexto),
        generar: generarPDFcoberturaLlaves,
      },
      {
        nombres: [
          "Protección De Llantas Por $4,000.00 1 Año",
          "Protección De Llanta-Rin Por $5,000.00 1 Año",
          "Protección De Llanta-Rin Por $12,000.00 1 Año",
        ].map(normalizarTexto),
        generar: generarPDFcoberturaLlantas,
      },
    ];

    const garantiasSeminuevos = [
      {
        nombres: [
          "Garantía Mecánica Básica 1 Año",
          "Garantía Mecánica Básica 2 Años",
          "Garantía Mecánica Básica 3 Años",
        ].map(normalizarTexto),
        generar: generarPDFcoberturaAmplia,
      },
      {
        nombres: ["Garantía De Movilidad"].map(normalizarTexto),
        generar: generarPDFcoberturaMovilidad,
      },
      {
        // En seminuevos sólo aplica la protección de $4,000.
        // Las de $5,000 y $12,000 son sólo para nuevos.
        nombres: ["Protección De Llantas Por $4,000.00 1 Año"].map(
          normalizarTexto,
        ),
        generar: generarPDFcoberturaLlantas,
      },
    ];

    const garantias =
      selectedMailData?.tipo_auto === "nuevos"
        ? garantiasNuevos
        : garantiasSeminuevos;

    const garantiasIncluidasRaw =
      planSeleccionado?.accessories?.map((acc) => acc.title || acc) || [];

    // Normalizamos
    const garantiasIncluidas = garantiasIncluidasRaw.map(normalizarTexto);

    console.log("****Garantías incluidas normalizadas:", garantiasIncluidas);

    //ejecuta solo las que no vienen incluidas
    const promesas = garantias
      .filter((g) => !g.nombres.some((n) => garantiasIncluidas.includes(n)))
      .map((g) => g.generar());

    // si todas están incluidas no abrimos nada
    if (promesas.length === 0) {
      return null;
    }

    //Espera a que todas terminen
    const resultados = await Promise.all(promesas);
    // Unir en un solo PDF
    const mergedPdf = await PDFDocument.create();

    for (const pdfDoc of resultados) {
      if (!pdfDoc) continue;
      const copiedPages = await mergedPdf.copyPages(
        pdfDoc,
        pdfDoc.getPageIndices(),
      );
      copiedPages.forEach((page) => mergedPdf.addPage(page));
    }

    const resFirma = await abrirVentanaParaFirmar(
      mergedPdf,
      `Renuncias_Unificadas_${dataToSend.nombreCliente}`,
      dataToSend.nombreCliente,
      agregarArchivo,
    );

    if (resFirma?.win && !resFirma.win.closed) {
      try {
        resFirma.win.close();
      } catch {}
    }

    const mergedBytes = await mergedPdf.save();
    const mergedBlob = new Blob([mergedBytes], { type: "application/pdf" });
    const mergedFile = new File(
      [mergedBlob],
      `Renuncias_Unificadas_${dataToSend.nombreCliente}.pdf`,
      { type: "application/pdf" },
    );
    const mergedUrl = URL.createObjectURL(mergedBlob);

    console.log("Archivos actuales:", archivos);

    return { url: mergedUrl, file: mergedFile };

    //Extraer las urls y archivos
    /*resultados.forEach(({ url, file }) => {
      if (url) pdfUrlsRef.current.push(url);
    });*/
  };

  useEffect(() => {
    console.log("Archivos actualizados:", archivos);
  }, [archivos]);

  //Envía todo al backend cuando actualice
  useEffect(() => {
    if (readyToSend && archivos.length) {
      console.log("Enviando archivos:", archivos);
      enviarArchivos();
      setReadyToSend(false); // resetea
    }
  }, [readyToSend, archivos]);

  const userEmail = localStorage.getItem("userEmail") ?? "USERNAME@GMAIL.COM"; // obtener correo de asesor

  async function enviarArchivos(listaArchivos = archivos) {
    if (!listaArchivos || !listaArchivos.length) {
      return;
    }

    const formData = new FormData();

    formData.append("access_token", accessToken);
    formData.append("cliente", selectedMailData?.nombre || "");
    formData.append(
      "correoCliente",
      selectedMailData?.correo_electronico?.trim() || "",
    );
    formData.append("correoAsesor", userEmail?.trim() || "");
    formData.append("tipo_envio", tipoEnvio);

    listaArchivos.forEach((file) => {
      formData.append("archivo[]", file);
    });

    try {
      const response = await fetch(apiPDF, {
        method: "POST",
        body: formData,
      });

      const json = await response.json();

      if (response.ok && json.statusCode === 200 && json.data?.type === "OK") {
        setArchivos([]);
      } else {
        // manejar error si quieres
        // console.error(json);
      }
    } catch (err) {
      // console.error(err);
    }
  }

  //****************************** GENERAR PDF ACEPTACIÓN *********************************************************
  const generarPDFAceptacion = () => {
    return new Promise(async (resolve, reject) => {
      try {
        const dataToSend = {
          ...formData,
          mensualidad_estimacion:
            selectedMailData?.mensualidad_estimacion || "",
          nombreCliente: selectedMailData?.nombre || "",
          asesor: selectedMailData?.asesor || "",
        };

        const doc = new jsPDF();

        const logoURL = "/assets/img/product/gocar_negro.png";
        doc.addImage(logoURL, "PNG", 14, 10, 40, 10.6);
        doc.setFontSize(20);
        doc.text("Rechazo de Garantía Extendida", 105, 30, { align: "center" });
        doc.setLineWidth(0.5);
        doc.line(14, 35, 196, 35);
        doc.setFontSize(12);

        const textoIntro = `Por medio del presente, yo: ${dataToSend.nombreCliente} hago constar que me fue ofrecida una Garantía Extendida con el vehiculo que estoy adquiriendo y que me fueron explicados los siguientes beneficios; cubre costos de materiales y mano de obra necesarios para reparar o reemplazar las partes o componentes mencionados a continuación: `;
        const splitIntro = doc.splitTextToSize(textoIntro, 180);
        doc.text(splitIntro, 14, 45);

        const beneficios = [
          "Motor – 3 años más o hasta 125,000km",
          "Transmisión – 3 años más o hasta 125,000km",
          "Dirección – 3 años más o hasta 125,000km",
          "Frenos – 3 años más o hasta 125,000km",
          "Suspensión – 3 años más o hasta 125,000km",
          "Sistema eléctrico – 3 años más o hasta 125,000km",
          "Sistema de enfriamiento – 3 años más o hasta 125,000km",
          "Sistema de combustible – 3 años más o hasta 125,000km",
          "Aire acondicionado – 3 años más o hasta 125,000km",
          "Sistema Multimedia",
          "Asistencia Vial",
        ];

        let y = 45 + splitIntro.length * 5 + 5;
        doc.setFont("helvetica", "normal");
        doc.setFontSize(11);
        beneficios.forEach((item) => {
          const splitItem = doc.splitTextToSize(`• ${item}`, 180);
          doc.text(splitItem, 18, y);
          y += splitItem.length * 5 + 2;
        });

        const textoRenuncia = `Dicha cobertura no tiene pago de deducible ni trámites engorrosos, es transferible si decido vender mi vehículo, tiene cobertura en toda la República Mexicana, es aplicable desde el primer día y está incluida en mi financiamiento un costo de ${Number(
          dataToSend.mensualidad_estimacion,
        ).toLocaleString("es-MX", {
          style: "currency",
          currency: "MXN",
        })} al mes.\n\nConociendo los beneficios anteriores, RENUNCIO a la Cobertura Mecánica ofrecida y confirmo que no tengo interés en que sea agregarla a mi financiamiento.`;
        const splitRenuncia = doc.splitTextToSize(textoRenuncia, 180);
        doc.text(splitRenuncia, 14, y + 5);

        const firmaY = 200;
        doc.text(
          `Nombre y firma del asesor y/o F&I:\n\n\n${dataToSend.asesor}`,
          14,
          firmaY,
        );
        doc.line(14, firmaY + 15, 100, firmaY + 15);
        doc.text(
          `Nombre y firma del cliente:\n\n\n${dataToSend.nombreCliente}`,
          14,
          firmaY + 30,
        );
        doc.line(14, firmaY + 45, 100, firmaY + 45);
        const fecha = new Date().toLocaleDateString();
        doc.setFontSize(10);
        doc.text(`Fecha: ${fecha}`, 14, firmaY + 65);

        const pdfBytes = doc.output("arraybuffer");
        const pdfDoc = await PDFDocument.load(pdfBytes);

        function abrirVentanaParaFirmar(
          pdfDoc,
          nombreArchivo,
          nombreCliente,
          agregarArchivo,
          existingWin = null,
        ) {
          return new Promise(async (resolve) => {
            const win = existingWin || window.open("", "_blank");
            if (!win) {
              alert(
                "El navegador bloqueó la ventana emergente. Permite pop-ups para continuar.",
              );
              return;
            }

            // Blob inicial editable (antes de firmar)
            const pdfEditableBytes = await pdfDoc.save();
            const pdfEditableBlob = new Blob([pdfEditableBytes], {
              type: "application/pdf",
            });
            const pdfEditableUrl = URL.createObjectURL(pdfEditableBlob);

            // Estructura UI (visor arriba, firmas abajo)
            win.document.open();
            win.document.write(`<!DOCTYPE html>
            <html lang="es">
            <head>
            <meta charset="utf-8" />
            <meta name="viewport" content="width=device-width,initial-scale=1" />
            <title>Firmas</title>
            <style>
              html,body{height:100%;margin:0}
              .wrap{display:flex;flex-direction:column;height:100vh;width:100vw;overflow:hidden;background:#f5f6f8}
              .viewer{flex:1 1 auto;min-height:0;overflow:auto;background:#e9ebef}
              #pdfRoot{max-width:1200px;margin:0 auto;padding:12px;box-sizing:border-box}
              .pageCanvas{display:block;width:100%;height:auto;background:#fff;box-shadow:0 6px 20px rgba(0,0,0,.12);border-radius:6px;margin:0 auto 12px}
              .bar{flex:0 0 auto;background:#fff;border-top:1px solid #e3e6ef;padding:10px 12px}
              .bar .top{display:flex;justify-content:space-between;align-items:center;margin-bottom:8px}
              .row{display:grid;grid-template-columns:1fr 1fr;gap:12px;align-items:start}
              .btn{background:#B5BDD0;color:#2A2A2A;border:0;border-radius:8px;padding:10px 14px;font:500 13px system-ui,-apple-system,Segoe UI,Roboto,sans-serif;cursor:pointer;transition:background .2s}
              .btn:hover{background:#A0A9BF}
              .btn[disabled]{opacity:.6;cursor:not-allowed}
              .title{margin:0 0 6px;font:600 14px system-ui,-apple-system,Segoe UI,Roboto,sans-serif;color:#2a2f3a}
              .pad-wrap{display:flex;flex-direction:column;gap:8px}
              canvas.signature{width:100%;height:160px;background:#EDF0F5;border:1px solid #A3ADC2;border-radius:8px;touch-action:none}
              .ctrls{display:flex;gap:8px;justify-content:flex-end;margin-top:8px}
              @media (max-width: 720px){ .row{grid-template-columns:1fr} }
            </style>
            </head>
            <body>
              <div class="wrap">
                <div class="viewer"><div id="pdfRoot"></div></div>
                <div class="bar">
                  <div class="top">
                    <div style="display:flex;gap:8px;align-items:center"><strong>Firmar documento</strong></div>
                    <div style="display:flex;gap:8px">
                      <button id="fit" class="btn">Ajustar</button>
                      <button id="width" class="btn">Ancho</button>
                      <button id="real" class="btn">100%</button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="pad-wrap">
                      <div class="title">Firma del Cliente</div>
                      <canvas id="padCliente" class="signature"></canvas>
                      <div class="ctrls" style="padding:0"><button id="clearCliente" class="btn">Limpiar</button></div>
                    </div>
                    <div class="pad-wrap">
                      <div class="title">Firma del Asesor</div>
                      <canvas id="padAsesor" class="signature"></canvas>
                      <div class="ctrls" style="padding:0"><button id="clearAsesor" class="btn">Limpiar</button></div>
                    </div>
                  </div>
                  <div class="ctrls"><button id="guardar" class="btn">Guardar</button></div>
                </div>
              </div>
              <!-- pdf.js -->
              <script src="https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js"></script>
              <script>
                (function(){
                  const pdfUrl = ${JSON.stringify(pdfEditableUrl)};
                  const pdfjsLib = window['pdfjs-dist/build/pdf'];
                  pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';

                  const pdfRoot = document.getElementById('pdfRoot');

                  let pdf, numPages = 0, pages = [];
                  let baseViewport; // viewport de referencia (scale 1) de la 1ra página
                  let mode = 'fit'; // fit | width | real
                  let baseScale = 1; // escala calculada para 'fit'

                  const ratio = window.devicePixelRatio || 1;

                  function makeCanvas() {
                    const c = document.createElement('canvas');
                    c.className = 'pageCanvas';
                    return c;
                  }

                  function setCanvasSize(canvas, cssW, cssH, retina = true) {
                    const ctx = canvas.getContext('2d');
                    if (retina) {
                      canvas.width = Math.floor(cssW * ratio);
                      canvas.height = Math.floor(cssH * ratio);
                      canvas.style.width = cssW + 'px';
                      canvas.style.height = cssH + 'px';
                      ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
                    } else {
                      canvas.width = Math.floor(cssW);
                      canvas.height = Math.floor(cssH);
                      canvas.style.width = cssW + 'px';
                      canvas.style.height = cssH + 'px';
                      ctx.setTransform(1, 0, 0, 1, 0, 0);
                    }
                    return ctx;
                  }

                  function computeFitScale() {
                    if (!baseViewport) return 1;
                    const viewer = document.querySelector('.viewer');
                    const bar = document.querySelector('.bar');
                    const availableW = pdfRoot.clientWidth; // interno con padding
                    const availableH = viewer.clientHeight; // alto del viewer scrolleable

                    // Para 'fit' queremos que UNA página quepan entera en el viewport (sin distorsión)
                    const pageW = baseViewport.width;
                    const pageH = baseViewport.height;

                    const scaleW = availableW / pageW;
                    const scaleH = availableH / pageH;

                    // Elegimos el menor para que la página completa sea visible
                    return Math.max(0.1, Math.min(scaleW, scaleH));
                  }

                  async function renderAll() {
                    if (!pdf) return;

                    // Limpiar contenedor
                    pdfRoot.innerHTML = '';

                    // Según el modo, elegimos escala base
                    let scale;
                    if (mode === 'fit') {
                      baseScale = computeFitScale();
                      scale = baseScale;
                    } else if (mode === 'width') {
                      // ajustar al ancho del contenedor
                      const pageW = baseViewport.width;
                      scale = pdfRoot.clientWidth / pageW;
                    } else {
                      // 100% (escala 1)
                      scale = 1;
                    }

                    for (let i = 1; i <= numPages; i++) {
                      const page = await pdf.getPage(i);
                      const vp = page.getViewport({ scale });

                      const canvas = makeCanvas();
                      pdfRoot.appendChild(canvas);

                      const ctx = setCanvasSize(canvas, vp.width, vp.height, true);
                      await page.render({ canvasContext: ctx, viewport: vp }).promise;
                    }
                  }

                  function onResize() {
                    if (mode === 'fit' || mode === 'width') {
                      // recomputar y re-render
                      renderAll();
                    }
                  }

                  window.addEventListener('resize', onResize);
                  window.addEventListener('orientationchange', () => setTimeout(onResize, 200));

                  // Controles
                  document.getElementById('fit').addEventListener('click', () => { mode = 'fit'; renderAll(); });
                  document.getElementById('width').addEventListener('click', () => { mode = 'width'; renderAll(); });
                  document.getElementById('real').addEventListener('click', () => { mode = 'real'; renderAll(); });

                  // Cargar PDF
                  pdfjsLib.getDocument(pdfUrl).promise.then(async (_pdf) => {
                    pdf = _pdf;
                    numPages = pdf.numPages;
                    const p1 = await pdf.getPage(1);
                    baseViewport = p1.getViewport({ scale: 1 });
                    renderAll();
                  });
                })();
              </script>
            </body>
            </html>`);
            win.document.close();

            // ===== Firma: lógica en la ventana =====
            const onReady = () => {
              const $ = (s) => win.document.querySelector(s);
              const padCliente = $("#padCliente");
              const padAsesor = $("#padAsesor");
              const btnClearCliente = $("#clearCliente");
              const btnClearAsesor = $("#clearAsesor");
              const btnGuardar = $("#guardar");

              let signaturePadCliente = null;
              let signaturePadAsesor = null;
              let resizeFrame = null;

              const fitCanvas = (canvas) => {
                const ratio = Math.max(win.devicePixelRatio || 1, 1);
                const rect = canvas.getBoundingClientRect();

                const newWidth = Math.max(1, Math.floor(rect.width * ratio));
                const newHeight = Math.max(1, Math.floor(rect.height * ratio));

                if (canvas.width === newWidth && canvas.height === newHeight)
                  return;

                canvas.width = newWidth;
                canvas.height = newHeight;

                const ctx = canvas.getContext("2d");
                ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
              };

              const drawHint = (canvas, text) => {
                const ctx = canvas.getContext("2d");
                ctx.save();
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                ctx.fillStyle = "#4A4A4A";
                ctx.font = "14px Arial";
                ctx.fillText(text, 16, 28);
                ctx.restore();
              };

              const refreshGuardar = () => {
                btnGuardar.disabled = false;
              };

              const restorePadAfterResize = (pad, canvas, hintText) => {
                if (!pad) return;

                const data = pad.toData();
                fitCanvas(canvas);
                pad.clear();

                if (data && data.length) {
                  pad.fromData(data);
                } else {
                  drawHint(canvas, hintText);
                }
              };

              const safeRefresh = () => {
                win.setTimeout(refreshGuardar, 0);
              };

              const bindPadRefresh = (pad, canvas) => {
                if (typeof pad.addEventListener === "function") {
                  try {
                    pad.addEventListener("endStroke", safeRefresh);
                  } catch (e) {}
                }

                pad.onEnd = safeRefresh;

                canvas.addEventListener("mouseup", safeRefresh);
                canvas.addEventListener("touchend", safeRefresh, {
                  passive: true,
                });
                canvas.addEventListener("pointerup", safeRefresh);

                win.addEventListener("mouseup", safeRefresh);
                win.addEventListener("touchend", safeRefresh, {
                  passive: true,
                });
                win.addEventListener("pointerup", safeRefresh);
              };

              const setupCanvasBase = (canvas) => {
                canvas.style.pointerEvents = "auto";
                canvas.style.touchAction = "none";
                canvas.style.webkitUserSelect = "none";
                canvas.style.userSelect = "none";
                canvas.style.webkitTouchCallout = "none";
              };

              const initPads = () => {
                setupCanvasBase(padCliente);
                setupCanvasBase(padAsesor);

                fitCanvas(padCliente);
                fitCanvas(padAsesor);

                signaturePadCliente = new SignaturePad(padCliente, {
                  minWidth: 0.5,
                  maxWidth: 1.3,
                });

                signaturePadAsesor = new SignaturePad(padAsesor, {
                  minWidth: 0.5,
                  maxWidth: 1.3,
                });

                if (signaturePadCliente.isEmpty())
                  drawHint(padCliente, "Firme aquí");
                if (signaturePadAsesor.isEmpty())
                  drawHint(padAsesor, "Firme aquí");

                bindPadRefresh(signaturePadCliente, padCliente);
                bindPadRefresh(signaturePadAsesor, padAsesor);

                btnClearCliente.onclick = () => {
                  signaturePadCliente.clear();
                  fitCanvas(padCliente);
                  drawHint(padCliente, "Firme aquí");
                  refreshGuardar();
                };

                btnClearAsesor.onclick = () => {
                  signaturePadAsesor.clear();
                  fitCanvas(padAsesor);
                  drawHint(padAsesor, "Firme aquí");
                  refreshGuardar();
                };

                refreshGuardar();
              };

              const ro = new win.ResizeObserver(() => {
                if (!signaturePadCliente || !signaturePadAsesor) return;

                if (resizeFrame) {
                  win.cancelAnimationFrame(resizeFrame);
                }

                resizeFrame = win.requestAnimationFrame(() => {
                  restorePadAfterResize(
                    signaturePadCliente,
                    padCliente,
                    "Firme aquí",
                  );
                  restorePadAfterResize(
                    signaturePadAsesor,
                    padAsesor,
                    "Firme aquí",
                  );
                  refreshGuardar();
                });
              });

              ro.observe(win.document.body);

              win.requestAnimationFrame(() => {
                win.requestAnimationFrame(() => {
                  initPads();
                });
              });

              const cleanupPads = () => {
                try {
                  ro.disconnect();
                } catch {}

                try {
                  if (resizeFrame) {
                    win.cancelAnimationFrame(resizeFrame);
                  }
                } catch {}
              };

              btnGuardar.onclick = async () => {
                const keepInk = async (pad) => {
                  if (!pad) return;
                  const d = pad.toData();
                  pad.clear();
                  if (d && d.length) {
                    pad.fromData(d);
                  }
                };

                await keepInk(signaturePadCliente);
                await keepInk(signaturePadAsesor);

                const firmaClienteUrl =
                  signaturePadCliente && !signaturePadCliente.isEmpty()
                    ? signaturePadCliente.toDataURL()
                    : null;

                const firmaAsesorUrl =
                  signaturePadAsesor && !signaturePadAsesor.isEmpty()
                    ? signaturePadAsesor.toDataURL()
                    : null;

                let firmaClienteImg = null;
                let firmaAsesorImg = null;

                if (firmaClienteUrl) {
                  const firmaClienteBytes = await fetch(firmaClienteUrl).then(
                    (r) => r.arrayBuffer(),
                  );
                  firmaClienteImg = await pdfDoc.embedPng(firmaClienteBytes);
                }

                if (firmaAsesorUrl) {
                  const firmaAsesorBytes = await fetch(firmaAsesorUrl).then(
                    (r) => r.arrayBuffer(),
                  );
                  firmaAsesorImg = await pdfDoc.embedPng(firmaAsesorBytes);
                }

                pdfDoc
                  .getPages()
                  .slice(0, 4)
                  .forEach((page) => {
                    if (firmaAsesorImg) {
                      page.drawImage(firmaAsesorImg, {
                        x: 110,
                        y: 210,
                        width: 155,
                        height: 78,
                      });
                    }

                    if (firmaClienteImg) {
                      page.drawImage(firmaClienteImg, {
                        x: 110,
                        y: 140,
                        width: 155,
                        height: 78,
                      });
                    }
                  });

                const pdfFirmadoBytes = await pdfDoc.save();
                const pdfFirmadoBlob = new Blob([pdfFirmadoBytes], {
                  type: "application/pdf",
                });

                const nombreCompleto = `${nombreArchivo}_${nombreCliente || "Cliente"}.pdf`;
                const pdfFile = new File([pdfFirmadoBlob], nombreCompleto, {
                  type: "application/pdf",
                });

                const urlFirmado = URL.createObjectURL(pdfFirmadoBlob);

                agregarArchivo(pdfFile);

                cleanupPads();

                // en iPad/Safari es mejor no cerrar aquí la ventana;
                // devolvemos la misma referencia para reutilizarla en el siguiente paso
                win.setTimeout(() => {
                  resolve({ file: pdfFile, url: urlFirmado, win });
                }, 120);
              };
            };

            if (
              win.document.readyState === "complete" ||
              win.document.readyState === "interactive"
            ) {
              setTimeout(onReady, 0);
            } else {
              win.addEventListener("DOMContentLoaded", onReady);
            }
          });
        }

        const res = await abrirVentanaParaFirmar(
          pdfDoc,
          "Carta_Aceptacion",
          dataToSend.nombreCliente,
          agregarArchivo,
        );

        if (res?.win && !res.win.closed) {
          try {
            res.win.close();
          } catch {}
        }

        resolve(res);
      } catch (e) {
        reject(e);
      }
    });
  };

  const [accesoriosModalValue, setAccesoriosModalValue] = useState("0");
  const [financiamientoModalValue, setFinanciamientoModalValue] = useState("0");
  const [mostrarVideoIntro, setMostrarVideoIntro] = useState(false);
  const lastAccModalRef = useRef(null); // último valor visto de accesorios_modal
  const isVideoOpenRef = useRef(false); // saber si el video está abierto ahora mismo

  const getCartStorageKey = () => {
    const folio = resolveFolioVenta();
    return folio ? `orderCart_${folio}` : "orderCart";
  };

  const getSelectedCarStorageKey = () => {
    const folio = resolveFolioVenta();
    return folio ? `selectedCar_${folio}` : "selectedCar";
  };

  // Clave única para sessionStorage
  const FOLIO_KEY = "folio_venta";

  // Devuelve el folio resolviendo prioridad: URL > sessionStorage
  const resolveFolioVenta = () => {
    const params = new URLSearchParams(window.location.search);
    const fromURL =
      params.get("folio_venta") ||
      params.get("folio") || // por si usas alias
      null;

    const fromStorage = sessionStorage.getItem(FOLIO_KEY);

    // Prioridad al de la URL si existe
    const folio =
      (fromURL && fromURL.trim()) ||
      (fromStorage && fromStorage.trim()) ||
      null;

    // Si viene por URL y es distinto al almacenado, actualiza sessionStorage
    if (fromURL && fromURL !== fromStorage) {
      sessionStorage.setItem(FOLIO_KEY, fromURL);
    }

    return folio;
  };

  // Activa esto solo en la vista de "listado", NO en la pantalla POS del folio.
  const enableInboxPolling = false; // o prop/estado según tu UI
  // estado "fuente de verdad" del folio actual
  const [folioVenta, setFolioVenta] = useState(() => resolveFolioVenta() || "");

  // refs para coordinar polling / reset
  const pollIdRef = useRef(null);
  const resettingSaleRef = useRef(false);

  // Cuando se finaliza una venta y se genera un folio nuevo, el formulario
  // queda pendiente. Mientras esta bandera esté activa NO se debe rehidratar
  // agencia, asesores ni vehículo desde la venta anterior.
  const nuevaVentaFormularioPendienteRef = useRef(false);
  const agenciaSeleccionadaManualNuevaVentaRef = useRef(false);

  const stopPolling = () => {
    if (pollIdRef.current) {
      clearInterval(pollIdRef.current);
      pollIdRef.current = null;
    }
  };

  const deepEqual = (a, b) => JSON.stringify(a) === JSON.stringify(b);

  useEffect(() => {
    if (!enableInboxPolling) return;

    const apiUrlVehicle =
      "https://api.checkmark.mx/obtener/venta/financiamiento";

    let cancelled = false;
    const tick = async () => {
      try {
        const response = await fetch(apiUrlVehicle, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ access_token: accessToken, ...filters }),
        });
        const data = await response.json();
        const list = Array.isArray(data.data?.resultados)
          ? data.data.resultados
          : [];

        if (cancelled) return;
        setMailData((prev) => (deepEqual(prev, list) ? prev : list));
        // ⛔️ NO tocar selectedMailData, selectedCar, orderData, modales, etc.
      } catch {}
    };

    tick();
    const intervalId = setInterval(tick, 10000); // menos agresivo
    return () => {
      cancelled = true;
      clearInterval(intervalId);
    };
  }, [accessToken, filters, enableInboxPolling]);

  useEffect(() => {
    const actualizarFirmaModal = async () => {
      if (mostrarModalInfo && selectedMailData?.id) {
        try {
          await fetch(apiUrlUpdate, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              access_token: accessToken,
              venta_id: selectedMailData.id,
              firma_modal: "1",
            }),
          });
        } catch (error) {}
      }
    };

    actualizarFirmaModal();
  }, [mostrarModalInfo]);

  const cerrarModalAccesorios = async () => {
    //Manejo de modal accesorios
    try {
      setMostrarModalAccesorios(false); // Oculta el modal

      // Envía actualización a la API
      const response = await fetch(apiUrlUpdate, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          access_token: accessToken,
          venta_id: selectedMailData?.id,
          accesorios_modal: "0",
        }),
      });

      const result = await response.json();

      // Asegúrate de actualizar el valor local también
      if (result.statusCode === 200) {
        setAccesoriosModalValue("0");
      }
    } catch (error) {}
  };

  const limpiarFinanciamientoModalCliente = async (ventaIdParam = "") => {
    const ventaId =
      ventaIdParam ||
      selectedMailData?.id ||
      vehicleData?.id ||
      formData?.venta_id ||
      "";

    if (!ventaId) return;

    // Limpieza local inmediata: así el siguiente 0 -> 1 sí vuelve a disparar.
    setFinanciamientoModalValue("0");
    lastFinModalRef.current = "0";

    setSelectedMailData((prev) =>
      prev && String(prev.id) === String(ventaId)
        ? { ...prev, financiamiento_modal: "0" }
        : prev,
    );

    setMailData((prev) =>
      Array.isArray(prev)
        ? prev.map((item) =>
            String(item.id) === String(ventaId)
              ? { ...item, financiamiento_modal: "0" }
              : item,
          )
        : prev,
    );

    try {
      await fetch(apiUrlUpdate, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          access_token: accessToken,
          venta_id: ventaId,
          financiamiento_modal: "0",
        }),
      });
    } catch (error) {
      console.warn("No se pudo limpiar financiamiento_modal:", error);
    }
  };

  const [nombreCliente, setNombreCliente] = useState("");

  // Usa siempre el folio “vivo” (URL > sessionStorage)
  const getCurrentFolio = () => resolveFolioVenta();

  const fetchVentaIdByFolio = async ({ accessToken, folio }) => {
    try {
      const resp = await fetch(
        "https://api.checkmark.mx/obtener/venta/financiamiento",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            access_token: accessToken,
            folio_venta: folio,
          }),
        },
      );
      const json = await resp.json();
      const row = json?.data?.resultados?.[0];
      return row?.id || null;
    } catch {
      return null;
    }
  };

  // Obtén un venta_id “confiable”: primero del estado actual; si no, lo busca por folio
  const safeGetVentaId = async ({ accessToken, selectedMailData }) => {
    const folio = getCurrentFolio();
    if (!folio) return null;
    // Si ya tienes la fila actual en memoria, úsala
    if (selectedMailData?.folio_venta === folio && selectedMailData?.id) {
      return selectedMailData.id;
    }
    // Si no, búscalo en backend
    return await fetchVentaIdByFolio({ accessToken, folio });
  };

  // Helper: consulta si el folio ya tiene nombre/asesor en backend
  const checkFolioTieneNombre = async (folio) => {
    try {
      const resp = await fetch(
        "https://api.checkmark.mx/obtener/venta/financiamiento",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            access_token: accessToken,
            folio_venta: folio,
          }),
        },
      );
      const data = await resp.json();
      const row = data?.data?.resultados?.[0];

      if (row && (row.nombre || row.asesor || row.id_usuario)) {
        return { ok: true, nombre: row.nombre || "" };
      }
    } catch {}
    return { ok: false, nombre: "" };
  };

  // Primer useEffect - Manejo del flujo principal de modales (AJUSTADO)
  useEffect(() => {
    (async () => {
      if (resettingSaleRef.current) return;

      const folio = resolveFolioVenta();
      if (!folio) return;

      const formCompletado =
        localStorage.getItem(`formCompletado_${folio}`) === "1";
      const yaAceptoPrivacidad =
        localStorage.getItem(`avisoPrivacidadAceptado_${folio}`) === "true";
      const nombreLocal = localStorage.getItem(`nombreCliente_${folio}`) || "";
      const bienvenidaMostrada =
        localStorage.getItem(`bienvenidaMostrada_${folio}`) === "1";

      // Si ya aceptó privacidad y tenemos nombre, muestra la bienvenida UNA sola vez.
      if (
        (yaAceptoPrivacidad || nombreLocal) &&
        !bienvenidaMostrada &&
        nombreLocal
      ) {
        setNombreCliente?.(nombreLocal);
        // pequeña espera para asegurar que no haya otros modales en transición
        setTimeout(() => openWelcome(nombreLocal, folio), 100);
        return;
      }

      // Si ya completó form, o ya aceptó privacidad, o ya tenemos nombre -> nada más
      if (formCompletado || yaAceptoPrivacidad || nombreLocal) {
        if (nombreLocal) setNombreCliente?.(nombreLocal);
        return;
      }

      // ¿El backend ya tiene nombre para este folio?
      const { ok, nombre } = await checkFolioTieneNombre(folio);
      if (ok) {
        if (nombre) {
          setNombreCliente?.(nombre);
          localStorage.setItem(`nombreCliente_${folio}`, nombre);
        }
        localStorage.setItem(`avisoPrivacidadAceptado_${folio}`, "true");

        // Ya que aceptó privacidad vía backend y tenemos nombre, muestra bienvenida si no la vimos
        if (nombre && !bienvenidaMostrada)
          setTimeout(() => openWelcome(nombre, folio), 100);
        return;
      }

      // Si NO está identificado, mostramos el formulario
      showModalSafe("formularioModal", {
        backdrop: "static",
        keyboard: false,
        focus: true,
      });

      // Asegura la venta inicial del folio (idempotente)
      //await generarVentaInicialConFolio?.(folio);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [folioVenta, accessToken]);

  // Segundo useEffect - Validación del formulario
  const [formularioEnviado, setFormularioEnviado] = useState(false);
  const [tipoAuto, setTipoAuto] = useState(() => {
    try {
      const folio = resolveFolioVenta?.();
      return folio ? localStorage.getItem(`tipoAuto_${folio}`) || "" : "";
    } catch {
      return "";
    }
  }); // tipo de auto elegido en formulario
  const [agenciaActual, setAgenciaActual] = useState({
    ag_id: null,
    nombre: "",
  });
  const [agenciasDisponibles, setAgenciasDisponibles] = useState([]);
  const [mostrarSelectAgencia, setMostrarSelectAgencia] = useState(false);
  const [ventaResetKey, setVentaResetKey] = useState(0);

  useEffect(() => {
    const nombre = document.getElementById("nombre");
    const telefono = document.getElementById("telefono");
    const correo = document.getElementById("correo");
    const asesor = document.getElementById("asesor");
    const agencia = document.getElementById("agenciaVenta");
    const metodo = document.getElementById("metodoContacto");
    const origen = document.getElementById("origenCliente");
    const btnEnviar = document.getElementById("btnEnviarFormulario");

    if (
      !nombre ||
      !telefono ||
      !correo ||
      !asesor ||
      !metodo ||
      !origen ||
      !btnEnviar
    )
      return;

    const validarFormulario = () => {
      const nombreValido = nombre.value.trim() !== "";
      const telefonoValido = telefono.value.trim().length >= 8;
      const correoValido =
        correo.value.trim() === "" || correo.value.includes("@");
      const asesorValido = asesor.value.trim() !== "";
      const agenciaValida = !!agenciaActual.ag_id;
      const tipoAutoValido = tipoAuto !== "" && tipoAuto !== null;
      const metodoValido = metodo.value !== "";
      const origenValido = origen.value !== "";

      btnEnviar.disabled = !(
        nombreValido &&
        telefonoValido &&
        correoValido &&
        asesorValido &&
        agenciaValida &&
        tipoAutoValido &&
        origenValido &&
        metodoValido
      );
    };

    // Escuchadores de eventos
    nombre.addEventListener("input", validarFormulario);
    telefono.addEventListener("input", validarFormulario);
    correo.addEventListener("input", validarFormulario);
    asesor.addEventListener("change", validarFormulario);
    agencia?.addEventListener("change", validarFormulario);
    metodo.addEventListener("change", validarFormulario);
    origen.addEventListener("change", validarFormulario);

    validarFormulario();

    return () => {
      nombre.removeEventListener("input", validarFormulario);
      telefono.removeEventListener("input", validarFormulario);
      correo.removeEventListener("input", validarFormulario);
      asesor.removeEventListener("change", validarFormulario);
      agencia?.removeEventListener("change", validarFormulario);
      metodo?.removeEventListener("change", validarFormulario);
      origen?.removeEventListener("change", validarFormulario);
    };
  }, [tipoAuto, agenciaActual.ag_id]);

  // Tercer useEffect - Manejo del envío del formulario
  useEffect(() => {
    const btnEnviar = document.getElementById("btnEnviarFormulario");
    if (!btnEnviar) return;

    const handleEnviar = async () => {
      const folio = resolveFolioVenta();
      if (!folio) {
        alert("No hay folio activo.");
        return;
      }

      const ventaGenerada = await generarVentaInicialConFolio(folio);

      if (!ventaGenerada) {
        alert("Error al inicializar la venta en el servidor.");
        return;
      }

      const nombre = document.getElementById("nombre").value.trim();
      const apellido_paterno =
        document.getElementById("apellidoPaterno")?.value.trim() || "";
      const apellido_materno =
        document.getElementById("apellidoMaterno")?.value.trim() || "";
      const telefono = document.getElementById("telefono").value.trim();
      const correo_electronico = document.getElementById("correo").value.trim();
      const asesorSelect = document.getElementById("asesor");
      const id_usuario = asesorSelect.value.trim();
      const asesorNombre =
        asesorSelect.options[asesorSelect.selectedIndex]?.text?.trim() || "";
      const metodoContactoVal = document.getElementById("metodoContacto").value;
      const origenClienteVal = document.getElementById("origenCliente").value;

      if (
        !nombre ||
        telefono.length < 8 ||
        !id_usuario ||
        !agenciaActual.ag_id ||
        !metodoContactoVal ||
        !origenClienteVal
      ) {
        alert("Por favor completa correctamente todos los campos.");
        return;
      }

      const venta_id = await safeGetVentaId({ accessToken, selectedMailData });
      if (!venta_id) {
        alert("No se pudo localizar la venta actual. Intenta de nuevo.");
        return;
      }

      const dataToSend = {
        access_token: accessToken,
        venta_id,
        nombre,
        apellido_paterno,
        apellido_materno,
        telefono,
        correo_electronico,
        id_usuario,
        asesor: asesorNombre,
        ag_id: agenciaActual.ag_id,
        agencia: agenciaActual.nombre,
        tipo_auto: tipoAuto,
        fuente_origen: metodoContactoVal,
        fuente: origenClienteVal,
      };

      try {
        const response = await fetch(
          "https://api.checkmark.mx/actualizar/estado/financiamiento",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(dataToSend),
          },
        );
        const result = await response.json();

        if (result.statusCode === 200) {
          // Persistencias locales
          setNombreCliente(nombre);
          localStorage.setItem(`nombreCliente_${folio}`, nombre);
          localStorage.setItem(`formCompletado_${folio}`, "1");
          localStorage.setItem(`tipoAuto_${folio}`, tipoAuto);
          const tipoNormalizado = normalizarTipoAutoCatalogo(tipoAuto);

          nuevaVentaFormularioPendienteRef.current = false;
          agenciaSeleccionadaManualNuevaVentaRef.current = false;
          setFormularioEnviado(true);
          setCategoryType(tipoNormalizado || "all");
          if (tipoNormalizado !== "nuevos") {
            setSubTipoNuevo("all");
          }
          // Cierra formulario
          hideModalSafe("formularioModal");

          // Abre AVISO DE PRIVACIDAD con blur
          setTimeout(() => {
            showModalSafe("avisoPrivacidadModal", {
              backdrop: "static",
              keyboard: false,
              focus: true,
            });

            const checkbox = document.getElementById("aceptoPrivacidad");
            const btnContinuar = document.getElementById(
              "btnContinuarPrivacidad",
            );

            if (checkbox && btnContinuar) {
              checkbox.checked = false;
              btnContinuar.disabled = true;

              const toggle = () => {
                btnContinuar.disabled = !checkbox.checked;
              };
              const onContinuar = () => {
                // Marca privacidad como aceptada
                localStorage.setItem(
                  `avisoPrivacidadAceptado_${folio}`,
                  "true",
                );
                hideModalSafe("avisoPrivacidadModal");

                // Ahora sí, abrir BIENVENIDA (una sola vez por folio)
                if (
                  localStorage.getItem(`bienvenidaMostrada_${folio}`) !== "1"
                ) {
                  setTimeout(() => openWelcome(nombre, folio), 150);
                }

                checkbox.removeEventListener("change", toggle);
                btnContinuar.removeEventListener("click", onContinuar);
              };

              checkbox.addEventListener("change", toggle);
              btnContinuar.addEventListener("click", onContinuar);
            }
          }, 150);

          // Limpia inputs
          document.getElementById("nombre").value = "";
          document.getElementById("apellidoPaterno").value = "";
          document.getElementById("apellidoMaterno").value = "";
          document.getElementById("telefono").value = "";
          document.getElementById("correo").value = "";
          document.getElementById("asesor").value = "";
          document.getElementById("metodoContacto").value = "";
          document.getElementById("origenCliente").value = "";
        } else {
          alert("Ocurrió un error al guardar la información.");
        }
      } catch (error) {
        alert("Error de conexión al guardar los datos.");
      }
    };

    btnEnviar.addEventListener("click", handleEnviar);
    return () => btnEnviar.removeEventListener("click", handleEnviar);
  }, [folioVenta, accessToken, selectedMailData, agenciaActual]);

  // === Helper: abrir bienvenida con blur, setear mensaje y flag ===
  function openWelcome(nombre, folio) {
    // Mensaje (si tu modal tiene #bienvenidaMensaje)
    const elMsg = document.getElementById("bienvenidaMensaje");
    if (elMsg)
      elMsg.textContent = `¡Bienvenido, ${nombre}! Gracias por confiar en nosotros.`;

    // Evita mostrarla varias veces por el mismo folio en esta pestaña
    localStorage.setItem(`bienvenidaMostrada_${folio}`, "1");

    // Abre con backdrop para blur y deshabilitar teclado
    showModalSafe("bienvenidaModal", {
      backdrop: "static",
      keyboard: false,
      focus: true,
    });
  }

  // Función para generar venta inicial (sin cambios)
  const generarVentaInicial = async () => {
    // Usa el helper en lugar de leer directo sessionStorage
    const folioVenta = resolveFolioVenta();
    if (!folioVenta) return false;

    const ventaInicial = {
      folio_venta: folioVenta,
      ag_id: agenciaActual.ag_id,
      agencia: agenciaActual.nombre,
      access_token: accessToken,
      acepta_aviso_privacidad: "1",
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(ventaInicial),
      });

      const result = await response.json();
      // Si tu API ya regresa qr_venta, déjalo disponible
      return response.ok ? result : false;
    } catch (error) {
      return false;
    }
  };

  // Función para obtener vehículos con filtros
  const fetchVehicles = async (agencyName = "") => {
    if (initialLoad && !agencyName) {
      setLoading(false);
      return;
    }

    setLoading(true);
    const currentCart = [...orderData];

    // Si no hay una agencia seleccionada, no hacemos la solicitud
    if (!agencyName) {
      setLoading(false);
      return;
    }

    const agencia = agenciaInfo[agencyName] || {};
    const marca = agencia.marca || "";
    const ag_id = agencia.ag_id || "";

    // Verificar que tenemos filtros válidos
    if (!marca || !ag_id) {
      setLoading(false);
      return;
    }

    const requestData = {
      access_token: accessToken,
      marca,
      ag_id,
    };

    try {
      const response = await fetch(apiUrlInventario, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();

      if (data?.vehicles) {
        setTableData(data.vehicles); // Asegúrate de que los datos sean del tipo esperado
      }

      // Si no hay carrito previo, actualizarlo con los datos de la respuesta
      if (
        currentCart.length === 0 &&
        Array.isArray(data.order) &&
        data.order.length > 0
      ) {
        setOrderData(data.order);
        sessionStorage.setItem("orderCart", JSON.stringify(data.order));
      } else {
        setOrderData(currentCart);
      }

      setOrderHistoryData(data.orderHistory || []);
      setInitialLoad(false); // Ya no estamos en carga inicial
      setCategoryType("all");
      setSubTipoNuevo("all");
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const obtenerAgenciaPorId = useCallback((ag_id) => {
    return obtenerAgenciaPorIdGlobal(ag_id);
  }, []);

  const handleSeleccionAgencia = useCallback(
    (e) => {
      const ag_id = e.target.value;

      if (!ag_id) {
        agenciaSeleccionadaManualNuevaVentaRef.current = false;
        setAgenciaActual({ ag_id: null, nombre: "" });
        sessionStorage.removeItem("agenciaSeleccionadaVenta");
        setTableData([]);
        setAsesores([]);

        try {
          const asesorSelect = document.getElementById("asesor");
          if (asesorSelect) asesorSelect.value = "";
        } catch {}

        return;
      }

      const agencia = obtenerAgenciaPorId(ag_id);
      if (!agencia) return;

      const nuevaAgencia = {
        ag_id: agencia.ag_id,
        nombre: agencia.nombre,
      };

      agenciaSeleccionadaManualNuevaVentaRef.current = true;
      setAgenciaActual(nuevaAgencia);
      sessionStorage.setItem(
        "agenciaSeleccionadaVenta",
        JSON.stringify(nuevaAgencia),
      );
      setTableData([]);
      setAsesores([]);

      try {
        const asesorSelect = document.getElementById("asesor");
        if (asesorSelect) asesorSelect.value = "";
      } catch {}
    },
    [obtenerAgenciaPorId],
  );

  useEffect(() => {
    const agenciasNissanUsuario = getAgenciasNissanUsuarioDisponibles();
    const folioActual = resolveFolioVenta?.() || folioVenta || "";

    const ventaPerteneceAFolioActual =
      !!selectedMailData &&
      String(
        selectedMailData?.folio_venta ||
          selectedMailData?.folio ||
          selectedMailData?.folioVenta ||
          "",
      ).trim() === String(folioActual || "").trim();

    const getAgenciaGuardadaValida = () => {
      const agenciaGuardadaRaw = sessionStorage.getItem(
        "agenciaSeleccionadaVenta",
      );

      if (!agenciaGuardadaRaw) return null;

      try {
        const agenciaGuardada = JSON.parse(agenciaGuardadaRaw);
        const existeAgencia = agenciasNissanUsuario.some(
          (agencia) => agencia.ag_id === agenciaGuardada?.ag_id,
        );

        return existeAgencia ? agenciaGuardada : null;
      } catch {
        return null;
      }
    };

    if (nuevaVentaFormularioPendienteRef.current) {
      const agenciaGuardadaValida = getAgenciaGuardadaValida();

      if (
        agenciaSeleccionadaManualNuevaVentaRef.current &&
        agenciaGuardadaValida
      ) {
        // El usuario ya eligió agencia en ESTA nueva venta. Se conserva para
        // que carguen asesores/inventario de esa agencia, pero sin tomar nada
        // de la venta anterior.
        setAgenciaActual({
          ag_id: agenciaGuardadaValida.ag_id,
          nombre: agenciaGuardadaValida.nombre,
        });
        setAgenciasDisponibles(agenciasNissanUsuario);
        setMostrarSelectAgencia(agenciasNissanUsuario.length > 1);
        return;
      }

      if (agenciasNissanUsuario.length > 1) {
        // Nueva venta + varias agencias: siempre placeholder.
        setAgenciaActual({ ag_id: null, nombre: "" });
        setAgenciasDisponibles(agenciasNissanUsuario);
        setMostrarSelectAgencia(true);
        setAsesores([]);
        setTableData([]);
        return;
      }

      if (agenciasNissanUsuario.length === 1) {
        const agencia = agenciasNissanUsuario[0];

        setAgenciaActual({
          ag_id: agencia.ag_id,
          nombre: agencia.nombre,
        });
        setAgenciasDisponibles(agenciasNissanUsuario);
        setMostrarSelectAgencia(false);
        return;
      }

      setAgenciaActual({ ag_id: null, nombre: "" });
      setAgenciasDisponibles([]);
      setMostrarSelectAgencia(false);
      setAsesores([]);
      setTableData([]);
      return;
    }

    let agIdVenta = "";

    // Sólo tomamos agencia desde BD si la venta pertenece al folio activo.
    // Esto evita que un tick viejo del polling vuelva a poner la agencia,
    // asesores y vehículo de la venta anterior.
    if (ventaPerteneceAFolioActual && selectedMailData?.ag_id) {
      agIdVenta = selectedMailData.ag_id;
    } else if (selectedCar?.ag_id) {
      agIdVenta = selectedCar.ag_id;
    }

    const agenciaDesdeVenta = agIdVenta ? obtenerAgenciaPorId(agIdVenta) : null;

    if (agenciaDesdeVenta) {
      setAgenciaActual({
        ag_id: agenciaDesdeVenta.ag_id,
        nombre: agenciaDesdeVenta.nombre,
      });

      setAgenciasDisponibles(agenciasNissanUsuario);
      setMostrarSelectAgencia(false);
      return;
    }

    const agenciaGuardadaValida = getAgenciaGuardadaValida();

    if (agenciaGuardadaValida) {
      setAgenciaActual({
        ag_id: agenciaGuardadaValida.ag_id,
        nombre: agenciaGuardadaValida.nombre,
      });

      setAgenciasDisponibles(agenciasNissanUsuario);
      setMostrarSelectAgencia(agenciasNissanUsuario.length > 1);
      return;
    }

    if (agenciasNissanUsuario.length === 1) {
      const agencia = agenciasNissanUsuario[0];

      setAgenciaActual({
        ag_id: agencia.ag_id,
        nombre: agencia.nombre,
      });

      setAgenciasDisponibles(agenciasNissanUsuario);
      setMostrarSelectAgencia(false);
      return;
    }

    if (agenciasNissanUsuario.length > 1) {
      setAgenciaActual({ ag_id: null, nombre: "" });
      setAgenciasDisponibles(agenciasNissanUsuario);
      setMostrarSelectAgencia(true);
      setAsesores([]);
      setTableData([]);
      return;
    }

    const agenciaFallback = obtenerAgenciaPorId("ag5713_5c33d949e445e");

    if (agenciaFallback) {
      setAgenciaActual({
        ag_id: agenciaFallback.ag_id,
        nombre: agenciaFallback.nombre,
      });

      setAgenciasDisponibles([agenciaFallback]);
      setMostrarSelectAgencia(false);
      return;
    }

    setAgenciaActual({ ag_id: null, nombre: "" });
    setAgenciasDisponibles([]);
    setMostrarSelectAgencia(false);
  }, [
    folioVenta,
    ventaResetKey,
    selectedMailData?.folio_venta,
    selectedMailData?.folio,
    selectedMailData?.folioVenta,
    selectedMailData?.ag_id,
    selectedCar?.ag_id,
  ]);

  // === Locks para no duplicar venta inicial por folio ===
  function markVentaInicial(folio) {
    sessionStorage.setItem(`venta_inicial_creada_for_${folio}`, "1");
  }
  function isVentaInicialCreada(folio) {
    return sessionStorage.getItem(`venta_inicial_creada_for_${folio}`) === "1";
  }

  // Tu POST inicial, recibiendo folio explícito (o resolviéndolo si no viene)

  function clearKeys(storage, keys = []) {
    keys.forEach((k) => {
      try {
        storage.removeItem(k);
      } catch {}
    });
  }

  function forceCloseModalById(id = "modalPosItem") {
    try {
      document.getElementById(id)?.classList.remove("show");
      document.body.classList.remove("modal-open");
      document.querySelector(".modal-backdrop")?.remove();
    } catch {}
  }

  function hideModalById(id) {
    try {
      const el = document.getElementById(id);
      if (!el) return;
      const modal =
        window.bootstrap?.Modal.getInstance(el) ||
        new window.bootstrap.Modal(el);
      modal.hide();
    } catch {}
  }

  function closeAllModals() {
    try {
      document.querySelectorAll(".modal.show").forEach((m) => {
        const inst = window.bootstrap?.Modal.getInstance(m);
        inst?.hide();
        m.classList.remove("show");
      });
      document.body.classList.remove("modal-open");
      document.querySelectorAll(".modal-backdrop").forEach((b) => b.remove());
    } catch {}
  }

  const INITIAL_SELECTED_VERSION = null;

  async function generarVentaInicialConFolio(folio) {
    const ventaInicial = {
      folio_venta: folio,
      ag_id: agenciaActual.ag_id,
      agencia: agenciaActual.nombre,
      access_token: accessToken,
      acepta_aviso_privacidad: "1",
      accesorios_modal: "0",
      financiamiento_modal: "0",
    };

    try {
      const r = await fetch(
        "https://api.checkmark.mx/cliente/ventas/financiamiento",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(ventaInicial),
        },
      );

      if (r.ok) {
        ventaCreadaRef.current = true;
        return true;
      }

      return false;
    } catch {
      return false;
    }
  }

  async function guardarOrderCartEnBackend() {
    const folio = resolveFolioVenta();
    if (!folio) return;
    if (!ventaCreadaRef.current) return;

    try {
      await fetch("https://api.checkmark.mx/cliente/ventas/financiamiento", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          access_token: accessToken,
          folio_venta: folio,
          order_cart: orderData || [],
          precio_total: getTotalPrice?.() ?? 0,
        }),
      });
    } catch {}
  }

  //Helpers video
  // === Helpers de flags por folio para el video de accesorios ===
  const accIntroKeys = (folio) => ({
    dismissed: `accIntroDismissed_${folio}`, // usuario lo omitió manualmente
    watched: `accIntroWatched_${folio}`, // el video terminó una vez
  });

  const markAccIntroDismissed = (folio) => {
    try {
      localStorage.setItem(accIntroKeys(folio).dismissed, "1");
    } catch {}
  };

  const clearAccIntroDismissed = (folio) => {
    try {
      localStorage.removeItem(accIntroKeys(folio).dismissed);
    } catch {}
  };

  const markAccIntroWatched = (folio) => {
    try {
      localStorage.setItem(accIntroKeys(folio).watched, "1");
    } catch {}
  };

  const wasAccIntroDismissed = (folio) => {
    try {
      return localStorage.getItem(accIntroKeys(folio).dismissed) === "1";
    } catch {
      return false;
    }
  };

  const wasAccIntroWatched = (folio) => {
    try {
      return localStorage.getItem(accIntroKeys(folio).watched) === "1";
    } catch {
      return false;
    }
  };

  // === Helpers para mostrar modales de forma segura (con fallback) ===
  function ensureBackdrop() {
    if (document.querySelector(".modal-backdrop.show")) return;
    const b = document.createElement("div");
    b.className = "modal-backdrop fade show";
    document.body.appendChild(b);
    document.body.classList.add("modal-open");
    document.body.style.removeProperty("overflow");
  }

  /**
   * Muestra un modal por id de forma segura:
   * - Usa Bootstrap si está disponible (getOrCreateInstance).
   * - Si Bootstrap no está, aplica fallback manual + backdrop.
   */
  function showModalSafe(
    id,
    bsOptions = { backdrop: "static", keyboard: false, focus: true },
  ) {
    const el = document.getElementById(id);
    if (!el) return;
    try {
      const Modal = window.bootstrap?.Modal;
      if (Modal) {
        const inst = Modal.getOrCreateInstance
          ? Modal.getOrCreateInstance(el, bsOptions)
          : Modal.getInstance?.(el) || new Modal(el, bsOptions);
        inst?.show?.();
        ensureBackdrop();
      } else {
        el.style.display = "block";
        el.classList.add("show");
        el.removeAttribute("aria-hidden");
        el.setAttribute("aria-modal", "true");
        ensureBackdrop();
      }
    } catch {
      el.style.display = "block";
      el.classList.add("show");
      ensureBackdrop();
    }
  }

  function hideModalSafe(id) {
    const el = document.getElementById(id);
    if (!el) return;
    try {
      const Modal = window.bootstrap?.Modal;
      if (Modal) {
        const inst = Modal.getInstance?.(el) || Modal.getOrCreateInstance?.(el);
        inst?.hide?.();
      } else {
        el.classList.remove("show");
        el.style.display = "none";
        el.setAttribute("aria-hidden", "true");
        el.removeAttribute("aria-modal");
      }
    } catch {
      el.classList.remove("show");
      el.style.display = "none";
    }
    // Limpieza general
    document.querySelectorAll(".modal-backdrop").forEach((b) => b.remove());
    document.body.classList.remove("modal-open");
    document.body.style.removeProperty("padding-right");
    document.body.style.removeProperty("overflow");
  }

  const getAgenciasNissanUsuarioDisponibles = () => {
    try {
      const agenciasStorage = JSON.parse(
        localStorage.getItem("agencias") || "[]",
      );

      return agenciasStorage
        .filter((ag_id) => AGENCIAS_NISSAN_PERMITIDAS.includes(ag_id))
        .map((ag_id) => obtenerAgenciaPorIdGlobal(ag_id))
        .filter(Boolean);
    } catch {
      return [];
    }
  };

  const limpiarCacheVehiculoVenta = (folio = "") => {
    const keysPorFolio = folio
      ? [
          `selected_car_${folio}`,
          `selectedCar_${folio}`,
          `version_vehiculo_${folio}`,
          `orderCart_${folio}`,
          `tipoAuto_${folio}`,
          `selectedPlanTitle:${folio}`,
        ]
      : [];

    const keysGlobales = [
      "selected_car",
      "selectedCar",
      "orderCart",
      "version_vehiculo",
      "descripcion_auto",
      "agenciaSeleccionadaVenta",
    ];

    try {
      [...keysPorFolio, ...keysGlobales].forEach((key) => {
        localStorage.removeItem(key);
        sessionStorage.removeItem(key);
      });
    } catch {}
  };

  const resetAgenciaFormularioNuevaVenta = () => {
    const agenciasUsuario = getAgenciasNissanUsuarioDisponibles();

    if (agenciasUsuario.length > 1) {
      // Nueva venta con varias agencias: no se debe seleccionar ninguna por defecto.
      // El usuario debe elegir una agencia para que se cargue la lista correcta de asesores.
      setAgenciaActual({ ag_id: null, nombre: "" });
      setAgenciasDisponibles(agenciasUsuario);
      setMostrarSelectAgencia(true);
      setAsesores?.([]);
      setTableData?.([]);

      try {
        sessionStorage.removeItem("agenciaSeleccionadaVenta");
      } catch {}

      return;
    }

    if (agenciasUsuario.length === 1) {
      const agenciaDefault = agenciasUsuario[0];

      setAgenciaActual({
        ag_id: agenciaDefault.ag_id,
        nombre: agenciaDefault.nombre,
      });

      setAgenciasDisponibles(agenciasUsuario);
      setMostrarSelectAgencia(false);

      try {
        sessionStorage.setItem(
          "agenciaSeleccionadaVenta",
          JSON.stringify({
            ag_id: agenciaDefault.ag_id,
            nombre: agenciaDefault.nombre,
          }),
        );
      } catch {}

      return;
    }

    const agenciaFallback = obtenerAgenciaPorIdGlobal("ag5713_5c33d949e445e");

    if (agenciaFallback) {
      setAgenciaActual({
        ag_id: agenciaFallback.ag_id,
        nombre: agenciaFallback.nombre,
      });
      setAgenciasDisponibles([agenciaFallback]);
      setMostrarSelectAgencia(false);
    } else {
      setAgenciaActual({ ag_id: null, nombre: "" });
      setAgenciasDisponibles([]);
      setMostrarSelectAgencia(false);
    }
  };

  // === Tu flujo: reset + nueva venta + abrir formulario ===
  const resetAndStartNewSale = async ({
    setFolioVenta,
    setSelectedCar,
    setModalData,
    setOrderData,
    setGarantiaExtendida,
    setSelectedVersion,
    initialModalData = null,
  }) => {
    const oldFolio =
      resolveFolioVenta?.() || sessionStorage.getItem("folio_venta");

    // 0) Bloquea rehidratación y pausa polling antes de tocar cualquier estado.
    // Esto evita que el polling vuelva a pintar el selected_car del folio anterior.
    resettingSaleRef.current = true;
    nuevaVentaFormularioPendienteRef.current = true;
    agenciaSeleccionadaManualNuevaVentaRef.current = false;
    stopPolling?.();

    // 1) Cancela selecciones pendientes y refs que no dependen del render.
    clearPendingVehicleSelection?.();
    releaseReturnToInventoryLock?.();

    selectedCarRef.current = null;
    userJustSelectedRef.current = false;
    lastAutoOpenedKeyRef.current = null;
    isOpeningFichaRef.current = false;
    openFichaRef.current = false;
    fichaURLRef.current = "";
    lastAccModalRef.current = null;
    lastFinModalRef.current = "0";
    isVideoOpenRef.current = false;

    if (pendingVehicleSelectionTimerRef.current) {
      clearTimeout(pendingVehicleSelectionTimerRef.current);
      pendingVehicleSelectionTimerRef.current = null;
    }

    // 2) Invalida respuestas viejas de inventario y limpia toda la UI de la venta anterior.
    inventarioRequestIdRef.current += 1;

    setOpenFicha?.(false);
    setFichaURL?.("");
    setOpenFotosSeminuevo?.(false);
    setFotosSeminuevo?.([]);
    setTituloFotosSeminuevo?.("Fotos del seminuevo");
    setLoadingFotosSeminuevo?.(false);
    setMostrarVideoIntro?.(false);
    setMostrarModalAccesorios?.(false);
    setAccessoryModalVisible?.(false);
    setAccessoryModalData?.(null);
    setIsAccessoryModalOpen?.(false);
    setOpenPDFModal?.(false);
    setShowModal?.(false);

    setOrderData?.([]);
    orderDataRef.current = [];
    setOrderHistoryData?.([]);
    setSelectedCar?.(null);
    setGarantiaExtendida?.("");
    setSelectedVersion?.(null);
    setPrecioVehiculo?.(0);
    setPrecioBaseVehiculo?.(0);
    setSelectedPlan?.(null);
    setPlanSeleccionado?.(null);
    setModalData?.(initialModalData);
    setVehicleData?.(null);
    setSelectedMailData?.(null);
    setPdfUrlsGeneradas?.([]);
    pdfUrlsRef.current = [];
    setArchivos?.([]);
    setReadyToSend?.(false);
    setAccesoriosModalValue?.("0");
    setFinanciamientoModalValue?.("0");
    setTableData?.([]);
    setAccesoriosGarantias?.({ accesorios: [], garantias: [] });
    setInitialLoad?.(false);
    setLoading?.(false);
    setCategoryType?.("all");
    setSubTipoNuevo?.("all");
    setTipoAuto?.("");
    setFormularioEnviado?.(false);
    setMetodoContacto?.("");
    setOrigenCliente?.("");
    setPhoneNumber?.("");
    setIsPhoneValid?.(false);
    setAsesores?.([]);
    setAgenciaActual?.({ ag_id: null, nombre: "" });

    try {
      const agenciaSelect = document.getElementById("agenciaVenta");
      const asesorSelect = document.getElementById("asesor");
      if (agenciaSelect) agenciaSelect.value = "";
      if (asesorSelect) asesorSelect.value = "";
    } catch {}

    // Importante: como es una nueva venta, resetea banderas de sincronización.
    ventaCreadaRef.current = false;
    firstCartSyncRef.current = true;

    // 3) Limpia storages/cachés del folio anterior y también claves globales.
    limpiarCacheVehiculoVenta(oldFolio);

    try {
      if (oldFolio) {
        localStorage.removeItem(`nombreCliente_${oldFolio}`);
        localStorage.removeItem(`avisoPrivacidadAceptado_${oldFolio}`);
        localStorage.removeItem(`formCompletado_${oldFolio}`);
        localStorage.removeItem(`bienvenidaMostrada_${oldFolio}`);
      }
    } catch {}

    // 4) Recalcula las agencias permitidas del usuario para que el select vuelva a mostrarse
    // cuando el usuario tiene más de una agencia Nissan.
    resetAgenciaFormularioNuevaVenta();

    // 5) Genera nuevo folio + súbelo a URL.
    const newFolio = Math.random().toString(36).substring(2, 15).toUpperCase();
    sessionStorage.setItem("folio_venta", newFolio);
    setFolioVenta?.(newFolio);

    try {
      const url = new URL(window.location.href);
      url.searchParams.set("folio_venta", newFolio);
      window.history.replaceState({}, "", url);
    } catch {}

    // 6) Limpia banderas locales del nuevo folio y fuerza recarga de inventario/agencias.
    limpiarCacheVehiculoVenta(newFolio);

    try {
      localStorage.removeItem(`nombreCliente_${newFolio}`);
      localStorage.removeItem(`avisoPrivacidadAceptado_${newFolio}`);
      localStorage.removeItem(`formCompletado_${newFolio}`);
      localStorage.removeItem(`bienvenidaMostrada_${newFolio}`);
    } catch {}

    setVentaResetKey((prev) => prev + 1);

    // Esperamos un microtick para que React procese el null de selectedCar y los refs
    // ya estén limpios antes de reactivar polling.
    await new Promise((resolve) => setTimeout(resolve, 0));

    setTimeout(() => {
      showModalSafe("formularioModal", {
        backdrop: "static",
        keyboard: false,
        focus: true,
      });
    }, 250);

    // 7) Reanuda polling ya con folio nuevo y sin cachés del vehículo anterior.
    resettingSaleRef.current = false;
    startPolling?.();

    return newFolio;
  };

  const LegendVersion = ({ text }) => (
    <span
      className="text-warning"
      title={text}
      style={{
        display: "inline-block",
        maxWidth: "clamp(16ch, 24vw, 28ch)", // limita ancho sin cambiar tu layout
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        fontWeight: 600,
        fontSize: "0.95rem",
        verticalAlign: "bottom",
      }}
    >
      {text}
    </span>
  );

  // helpers reutilizables

  const toMoney = (v) =>
    new Intl.NumberFormat("es-MX", {
      style: "currency",
      currency: "MXN",
      maximumFractionDigits: 0,
    }).format(Number(v || 0));

  const calcPMT = ({
    price,
    meses,
    enganchePct,
    engancheMonto = null,
    tasaAnual,
    isMSI = false,
  }) => {
    const total = toNumberCotizacion(price);
    const n = Number(meses || 0);
    if (!n || n <= 0) return 0;

    if (isMSI) {
      return Math.round(total / n);
    }

    const enganche =
      engancheMonto !== null && engancheMonto !== undefined
        ? toNumberCotizacion(engancheMonto)
        : (Number(enganchePct || 0) / 100) * total;

    const base = Math.max(total - enganche, 0);
    const tasa =
      (Number(tasaAnual) > 1 ? Number(tasaAnual) / 100 : Number(tasaAnual)) /
      12;

    if (tasa <= 0) return Math.round(base / n);

    const factor = Math.pow(1 + tasa, n);
    return Math.round((base * (tasa * factor)) / (factor - 1));
  };

  const parseMaybeJSON = (v) => {
    try {
      return typeof v === "string" ? JSON.parse(v) : v;
    } catch {
      return null;
    }
  };

  const toNumberCotizacion = (value = 0) => {
    if (value === null || value === undefined || value === "") return 0;

    if (typeof value === "number") {
      return Number.isFinite(value) ? value : 0;
    }

    const clean = String(value)
      .replace(/\$/g, "")
      .replace(/,/g, "")
      .replace(/\s/g, "")
      .trim();

    const parsed = Number(clean);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const getPlanAccessoriesArray = (plan = {}) => {
    let accessories = plan?.accessories || plan?.accesorios || [];

    if (typeof accessories === "string") {
      try {
        accessories = JSON.parse(accessories);

        if (typeof accessories === "string") {
          accessories = JSON.parse(accessories);
        }
      } catch {
        accessories = [];
      }
    }

    return Array.isArray(accessories) ? accessories : [];
  };

  const getPlanTotalCotizacion = (plan = {}) => {
    if (!plan) return 0;

    const totalFromAccessories = getPlanAccessoriesArray(plan).reduce(
      (sum, acc) =>
        sum +
        toNumberCotizacion(
          acc?.price ??
            acc?.precio ??
            acc?.amount ??
            acc?.monto ??
            acc?.valor ??
            0,
        ),
      0,
    );

    if (totalFromAccessories > 0) {
      return totalFromAccessories;
    }

    return toNumberCotizacion(
      plan?.totalPrice ??
        plan?.total_price ??
        plan?.precio_total ??
        plan?.total ??
        0,
    );
  };

  const isPlanSelectedCotizacion = (plan = {}) =>
    plan?.isSelected === true ||
    plan?.isSelected === "true" ||
    plan?.isSelected === 1 ||
    plan?.isSelected === "1";

  const getPlanesFinanciamientoCotizacion = (data = selectedMailData) => {
    const planes = parseMaybeJSON(data?.planes_financiamiento) || [];

    return Array.isArray(planes)
      ? planes.filter((plan) => !esPlanClienteFinanciamiento(plan))
      : [];
  };

  const getPlanSeleccionadoCotizacion = (data = selectedMailData) => {
    const planes = getPlanesFinanciamientoCotizacion(data);
    return planes.find(isPlanSelectedCotizacion) || null;
  };

  const getPrecioVehiculoCotizacion = (data = selectedMailData) => {
    const precioVehiculo = toNumberCotizacion(data?.precio_vehiculo);
    if (precioVehiculo > 0) return precioVehiculo;

    return toNumberCotizacion(getPrecioDesde(data));
  };

  const getEngancheMontoCreditoCotizacion = (
    data = selectedMailData,
    precioVehiculoOverride = null,
  ) => {
    const precioVehiculoBase =
      precioVehiculoOverride !== null && precioVehiculoOverride !== undefined
        ? toNumberCotizacion(precioVehiculoOverride)
        : getPrecioVehiculoCotizacion(data);

    const engancheDirecto = toNumberCotizacion(
      data?.enganche ??
        data?.engancheEditable ??
        data?.enganche_c ??
        data?.engancheC ??
        0,
    );

    if (engancheDirecto > 0) {
      return Math.round(engancheDirecto);
    }

    const porcentaje = toNumberCotizacion(data?.porcentaje_enganche || 15);
    const porcentajeSeguro = porcentaje > 0 ? porcentaje : 15;

    return Math.round((precioVehiculoBase * porcentajeSeguro) / 100);
  };

  const calcularMensualidadFinanciamientoCotizacion = ({
    total = 0,
    meses = 60,
    engancheMonto = 0,
    tasaAnual = TASA_ANUAL_FINANCIAMIENTO,
    isMSI = false,
  }) => {
    const totalFinanciarBase = toNumberCotizacion(total);
    const n = Number(meses || 0);

    if (!n || n <= 0) return 0;

    if (isMSI) {
      return Math.round(totalFinanciarBase / n);
    }

    const enganche = Math.max(toNumberCotizacion(engancheMonto), 0);
    const principal = Math.max(totalFinanciarBase - enganche, 0);
    const tasaMensual =
      (Number(tasaAnual) > 1 ? Number(tasaAnual) / 100 : Number(tasaAnual)) /
      12;

    if (tasaMensual <= 0) {
      return Math.round(principal / n);
    }

    const factor = Math.pow(1 + tasaMensual, n);

    return Math.round((principal * tasaMensual * factor) / (factor - 1));
  };

  // precio “Desde”: si hay versión seleccionada úsala; si no, toma precio_vehiculo
  const getPrecioDesde = (smd) => {
    const vSel = smd?.version_vehiculo?.toString().trim();
    const versiones = parseMaybeJSON(smd?.versiones)?.size || [];
    const match = versiones.find((v) => v?.text?.toString().trim() === vSel);
    const precioVersion = match ? Number(match.price || 0) : null;
    return precioVersion ?? Number(smd?.precio_vehiculo || 0);
  };

  const setIfChanged = (setter) => (prev, next) =>
    JSON.stringify(prev) === JSON.stringify(next) ? prev : next;

  const lastFinModalRef = useRef("0"); // inicia en "0"

  // === ÚNICO efecto de sincronización por folio ===
  const startPolling = () => {
    stopPolling();

    const tick = async () => {
      // ⛔️ no hidratar mientras haces reset de venta
      if (resettingSaleRef.current) return;

      const folio = resolveFolioVenta();
      if (!folio) return;

      try {
        const resp = await fetch(
          "https://api.checkmark.mx/obtener/venta/financiamiento",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              access_token: accessToken,
              folio_venta: folio,
            }),
          },
        );
        const json = await resp.json();

        // Si esta respuesta pertenece a un folio viejo, se ignora.
        // Esto evita que una petición que quedó viva antes del reset vuelva a
        // pintar la agencia, asesores o vehículo de la venta anterior.
        if (String(folio || "") !== String(resolveFolioVenta?.() || "")) {
          return;
        }

        const row = json?.data?.resultados?.[0];

        // Si no hay fila: limpia durante reset o cuando el formulario de la
        // nueva venta todavía no se guarda.
        if (!row) {
          if (
            resettingSaleRef.current ||
            nuevaVentaFormularioPendienteRef.current
          ) {
            clearPendingVehicleSelection();
            selectedCarRef.current = null;
            setSelectedCar((p) => (p ? null : p));
            setOrderData((p) => (p?.length ? [] : p));
            setSelectedMailData((p) => (p ? null : p));
            setVehicleData((p) => (p ? null : p));
            setOpenFicha?.(false);
            setFichaURL?.("");
          }
          return;
        }

        const rowFolio = String(
          row?.folio_venta || row?.folio || row?.folioVenta || "",
        ).trim();

        if (rowFolio && rowFolio !== String(folio || "").trim()) {
          return;
        }

        // 1) Detalle completo de la venta
        setSelectedMailData((prev) =>
          JSON.stringify(prev) === JSON.stringify(row) ? prev : row,
        );

        // 2) selected_car → hidrata si viene; si NO viene, límpialo (para no arrastrar del folio previo)
        const sc = parseMaybeJSON(row.selected_car);
        const canUseSelectedCarFromServer =
          !!sc &&
          !returningToInventoryRef.current &&
          !nuevaVentaFormularioPendienteRef.current;

        if (nuevaVentaFormularioPendienteRef.current) {
          // Folio nuevo con formulario pendiente: nunca pintamos el auto de la
          // venta anterior, aunque llegue un selected_car viejo por carrera.
          clearPendingVehicleSelection();
          selectedCarRef.current = null;
          setOpenFicha?.(false);
          setFichaURL?.("");
          setSelectedCar((prev) => (prev ? null : prev));

          try {
            localStorage.removeItem(`selected_car_${folio}`);
            localStorage.removeItem(`selectedCar_${folio}`);
          } catch {}
        } else if (returningToInventoryRef.current) {
          // Si estamos regresando al inventario por solicitud del asesor,
          // ignoramos cualquier selected_car viejo que llegue en este tick.
          clearPendingVehicleSelection();
          setOpenFicha?.(false);
          setFichaURL?.("");
          setSelectedCar((prev) => (prev ? null : prev));

          try {
            localStorage.removeItem(`selected_car_${folio}`);
            localStorage.removeItem(`selectedCar_${folio}`);
          } catch {}

          // Cuando el backend ya confirma selected_car vacío, liberamos el candado.
          if (!sc) {
            releaseReturnToInventoryLock();
          }
        } else if (canUseSelectedCarFromServer) {
          clearPendingVehicleSelection();

          const hydratedSelectedCar = mergeFichaTecnicaVentaEnSelectedCar(
            sc,
            row,
          );

          setSelectedCar((prev) =>
            JSON.stringify(prev) === JSON.stringify(hydratedSelectedCar)
              ? prev
              : hydratedSelectedCar,
          );

          try {
            localStorage.setItem(
              `selected_car_${folio}`,
              JSON.stringify(hydratedSelectedCar),
            );
            localStorage.setItem(
              `selectedCar_${folio}`,
              JSON.stringify(hydratedSelectedCar),
            );
          } catch {}
        } else if (!pendingVehicleSelectionRef.current) {
          // OJO: un tick del polling puede venir sin selected_car justo después de
          // seleccionar un auto nuevo, aunque la ficha técnica ya esté abierta.
          // No debemos cerrar el PDF por ese vacío temporal; sólo limpiamos cuando
          // realmente no hay ficha abierta ni vehículo local en memoria.
          if (openFichaRef.current || selectedCarRef.current) {
            setSelectedCar((prev) => prev || selectedCarRef.current || prev);
          } else {
            setSelectedCar((prev) => (prev ? null : prev));
            try {
              localStorage.removeItem(`selected_car_${folio}`);
              localStorage.removeItem(`selectedCar_${folio}`);
            } catch {}
          }
        }

        // 3) order_cart → nunca lo borres por “no llegó”; sólo en reset explícito
        const cart = parseMaybeJSON(row.order_cart);
        if (Array.isArray(cart)) {
          const changed =
            JSON.stringify(orderDataRef.current) !== JSON.stringify(cart);
          if (changed) {
            setOrderData(cart);
            try {
              sessionStorage.setItem("orderCart", JSON.stringify(cart));
            } catch {}
          }
        } else if (resettingSaleRef.current) {
          if (orderDataRef.current?.length) {
            setOrderData([]);
            try {
              sessionStorage.removeItem("orderCart");
            } catch {}
          }
        }

        // 4) Campos mínimos para cálculos
        const vdPatch = {
          precio_vehiculo: Number(row.precio_vehiculo ?? 0),
          precio_total: Number(row.precio_total ?? 0),
          version_vehiculo: row.version_vehiculo ?? null,
          url_img: row.url_img ?? null,
          meses_financiamiento: Number(row.meses_financiamiento ?? 0),
          porcentaje_enganche: Number(row.porcentaje_enganche ?? 0),
        };
        setVehicleData((prev) => {
          const next = { ...(prev || {}), ...vdPatch };
          return JSON.stringify(prev) === JSON.stringify(next) ? prev : next;
        });

        // 5) banderas de modales sólo si hay auto
        if (row.accesorios_modal !== undefined) {
          setAccesoriosModalValue(row.accesorios_modal);

          // Normalizamos a string "0"/"1"
          const val = String(row.accesorios_modal);

          // Disparar SOLO en flanco 0 -> 1 (y si hay auto)
          if (val !== lastAccModalRef.current) {
            if (
              val === "1" &&
              canUseSelectedCarFromServer &&
              !isVideoOpenRef.current
            ) {
              setMostrarVideoIntro(true);
            }
            lastAccModalRef.current = val;
          }
        }

        if (row.financiamiento_modal !== undefined) {
          setFinanciamientoModalValue(row.financiamiento_modal);
          const val = String(row.financiamiento_modal);

          // Si cambió de 0 → 1
          if (
            val === "1" &&
            lastFinModalRef.current === "0" &&
            canUseSelectedCarFromServer
          ) {
            handleShowModalEstadisticas?.(row.id);
          }

          if (
            val === "1" &&
            canUseSelectedCarFromServer &&
            lastFinModalRef.current !== "1" &&
            financiamientoModalValue !== "1"
          ) {
            console.log("Reapertura modal tras recarga");
            handleShowModalEstadisticas?.(row.id);
          }

          lastFinModalRef.current = val;
        }

        /*if (row.financiamiento_modal !== undefined) {
          setFinanciamientoModalValue(row.financiamiento_modal);
          if (row.financiamiento_modal === "1" && sc) {
            console.log("ABRIENDO MODAL 2");
            handleShowModalEstadisticas?.(row.id);
          }
        }*/

        // persistir folio en session (por si vino en URL)
        try {
          sessionStorage.setItem("folio_venta", folio);
        } catch {}
      } catch {
        // opcional: manejo de error/log
      }
    };

    // primer tick inmediato y luego cada 5s
    tick();
    pollIdRef.current = setInterval(tick, 5000);
  };

  // Arranca/para el polling cuando cambie el token
  useEffect(() => {
    startPolling();
    return stopPolling;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken]);

  // Context and general state
  const context = useContext(AppSettings);
  const [posMobileSidebarToggled, setPosMobileSidebarToggled] = useState(false);
  const [categoryType, setCategoryType] = useState("all");
  const [subTipoNuevo, setSubTipoNuevo] = useState("all");
  const [tableData, setTableData] = useState([]);

  const handleTipoAutoChange = useCallback((value) => {
    const tipoNormalizado = normalizarTipoAutoCatalogo(value);

    setTipoAuto(value);
    setCategoryType(tipoNormalizado || "all");
    setSubTipoNuevo("all");

    try {
      const folio = resolveFolioVenta?.();
      if (folio) localStorage.setItem(`tipoAuto_${folio}`, value);
    } catch {}
  }, []);
  const [orderData, setOrderData] = useState(() => {
    try {
      const saved = localStorage.getItem(getCartStorageKey());
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });

  const [orderHistoryData, setOrderHistoryData] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(null);

  const tipoAutoSeleccionado = useMemo(() => {
    const folio = resolveFolioVenta?.();
    const tipoGuardado = folio ? localStorage.getItem(`tipoAuto_${folio}`) : "";

    return normalizarTipoAutoCatalogo(
      tipoAuto ||
        formData?.tipo_auto ||
        selectedMailData?.tipo_auto ||
        tipoGuardado ||
        "",
    );
  }, [tipoAuto, formData?.tipo_auto, selectedMailData?.tipo_auto]);

  const categoriaEfectivaCatalogo = useMemo(() => {
    return tipoAutoSeleccionado || categoryType || "all";
  }, [tipoAutoSeleccionado, categoryType]);

  useEffect(() => {
    if (!tipoAutoSeleccionado) return;

    setCategoryType(tipoAutoSeleccionado);

    if (tipoAutoSeleccionado !== "nuevos") {
      setSubTipoNuevo("all");
    }
  }, [tipoAutoSeleccionado]);

  const subTiposNuevos = useMemo(() => {
    const vehiculos = Array.isArray(tableData?.food) ? tableData.food : [];
    const mapa = new Map();

    vehiculos
      .filter((item) => item.type === "nuevos")
      .forEach((item) => {
        const subTipo = item.sub_tipo?.trim();
        if (!subTipo) return;

        const key = subTipo.toLocaleLowerCase("es-MX");

        if (!mapa.has(key)) {
          mapa.set(key, {
            label: subTipo.toUpperCase(),
            value: subTipo,
          });
        }
      });

    return [{ label: "TODOS", value: "all" }, ...Array.from(mapa.values())];
  }, [tableData]);

  const updateOrderDataAndSave = (newOrderData) => {
    setOrderData(newOrderData);
    sessionStorage.setItem("orderCart", JSON.stringify(newOrderData));
  };

  // Phone validation states
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isPhoneValid, setIsPhoneValid] = useState(false);
  const [phoneModalInstance, setPhoneModalInstance] = useState(null);

  // Product modal states
  const [productModal, setProductModal] = useState();
  const [modalData, setModalData] = useState();
  const [modalQuantity, setModalQuantity] = useState();
  const [modalSelectedSize, setModalSelectedSize] = useState();
  const [modalSelectedAddon, setModalSelectedAddon] = useState([]);
  const [isSubmittingFinalizar, setIsSubmittingFinalizar] = useState(false);

  const orderDataRef = useRef([]);
  useEffect(() => {
    orderDataRef.current = orderData || [];
  }, [orderData]);

  // Original POS functions
  var toggleMobileSidebar = (event) => {
    event.preventDefault();
    setPosMobileSidebarToggled(true);
  };

  var dismissMobileSidebar = (event) => {
    event.preventDefault();
    setPosMobileSidebarToggled(false);
  };

  var showType = (event, type) => {
    event.preventDefault();

    setCategoryType(type);

    // El sub_tipo solo aplica para autos nuevos; al salir de NUEVOS lo reiniciamos.
    if (type !== "nuevos") {
      setSubTipoNuevo("all");
    }
  };

  const pickCarFields = (c = {}) => {
    // En autos nuevos la ficha correcta viene del inventario
    // (/financiamiento/vehiculos -> url_ficha_tecnica). La guardamos dentro
    // de selected_car para poder reutilizarla después en asesor/cliente sin
    // crear otro campo en la venta.
    const fichaTecnica =
      obtenerFichaTecnicaUrl(c) ||
      normalizeFichaTecnicaUrl(
        getFichaTecnicaFromVehicle(c) ||
          getFichaTecnicaFromVenta(selectedMailData),
      );

    return {
      id: c.id ?? null,
      title: c.title ?? "",
      description: c.description ?? c.modelo ?? "",
      year: c.year ?? c.ano ?? "",
      image: c.image ?? c.url_img ?? "",
      url_img: c.url_img ?? c.image ?? "",
      price: Number(c.price ?? 0),
      type: c.type ?? "",
      sub_tipo: c.sub_tipo ?? null,
      ag_id: c.ag_id ?? agenciaActual?.ag_id ?? "",
      used_id: c.used_id ?? "",
      pdf: fichaTecnica,
      ficha_tecnica: fichaTecnica,
      ficha_tecnica_vehiculo: fichaTecnica,
      url_ficha_tecnica: fichaTecnica,
      url_cotizacion: c.url_cotizacion ?? "",
      procotiza_pdf_base64: c.procotiza_pdf_base64 ?? "",
      availableOptions: c.availableOptions ?? c.options ?? null, // opcional
    };
  };

  // Función para enviar un vehículo (nuevo o seminuevo) al servidor
  const sendVehicleToServer = async (vehicleData) => {
    // Folio: URL > sessionStorage
    const folioVenta = resolveFolioVenta();
    if (!folioVenta) return false;

    // Asegura persistencia si vino por URL
    sessionStorage.setItem("folio_venta", folioVenta);

    const allOptions = vehicleData.availableOptions;

    const orderDataItem = {
      folio_venta: folioVenta,
      marca_vehiculo: vehicleData.title,
      modelo_vehiculo: vehicleData.description,
      selected_car: pickCarFields(vehicleData),
      ano_vehiculo: vehicleData.year,
      url_img: vehicleData.image,
      access_token: accessToken,
      price: vehicleData.price,
      type: vehicleData.type,
      precio_total: getTotalPrice(),
      ag_id: agenciaActual.ag_id,
      agencia: agenciaActual.nombre,
      versiones: allOptions,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(orderDataItem),
      });

      const result = await response.json();
      return response.ok; // o "return result" si prefieres usar el cuerpo
    } catch (error) {
      return false;
    }
  };

  const updateOptionPlanDirectly = async (accessory) => {
    const ventaId = vehicleData?.id; // ID de la venta
    const planes = vehicleData?.planesFinanciamiento || []; // array de planes

    if (!Array.isArray(planes) || !ventaId) {
      return;
    }

    // 1️⃣ Buscar plan "Plan cliente"
    let optionPlan = planes.find((p) => p.title === "Plan cliente");

    if (!optionPlan) {
      // Si no existe, lo creas vacío
      optionPlan = {
        title: "Plan cliente",
        accessories: [],
        totalPrice: 0,
        isSelected: false,
      };
      planes.push(optionPlan);
    }

    // 2️⃣ Asegúrate de tener accessories como array
    if (!Array.isArray(optionPlan.accessories)) {
      optionPlan.accessories = [];
    }

    // 3️⃣ Agrega el nuevo accesorio
    optionPlan.accessories.push({
      title: accessory.title,
      description: accessory.description,
      price: Number(accessory.price),
      type: accessory.type,
    });

    // 4️⃣ Actualiza totalPrice del plan
    optionPlan.totalPrice = optionPlan.accessories.reduce(
      (sum, acc) => sum + Number(acc.price || 0),
      0,
    );

    // 5️⃣ Prepara el payload para guardar
    const payload = {
      access_token: accessToken,
      venta_id: ventaId,
      planes_financiamiento: planes,
      precio_total: Math.round(
        parseFloat(vehicleData?.precio_vehiculo || 0) +
          planes.reduce((sum, p) => sum + Number(p.totalPrice || 0), 0),
      ),
    };

    // 6️⃣ Enviar al backend
    try {
      const response = await fetch(apiUpdatePlanesUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (result.statusCode === 200) {
      } else {
        throw new Error("Error en servidor");
      }
    } catch (error) {}
  };

  // Función para enviar un accesorio o garantía al servidor
  const sendAccessoryToServer = async (accessoryData) => {
    // Folio: URL > sessionStorage
    const folioVenta = resolveFolioVenta();
    if (!folioVenta) return false;

    // Asegura persistencia si vino por URL
    sessionStorage.setItem("folio_venta", folioVenta);

    // Simplificamos el accesorio para que solo tenga title y price
    const accessoryItem = {
      title: accessoryData.title,
      price: accessoryData.price.toString(), // string para formato compatible
      description: accessoryData.description,
      type: accessoryData.type,
    };

    const orderDataItem = {
      folio_venta: folioVenta,
      access_token: accessToken,
      nuevo_accesorio: accessoryItem,
      precio_total: getTotalPrice(), // total actual
    };

    try {
      const response = await fetch(`${apiUrl}/accesorios`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(orderDataItem),
      });

      const result = await response.json();
      return response.ok; // o `return result` si quieres usar el cuerpo
    } catch (error) {
      return false;
    }
  };

  // Modificación de la función addToCartDirectly para accesorios/garantías
  const addToCartDirectly = async (food) => {
    if (food.type === "accesorios" || food.type === "garantias") {
      setSelectedBrand(food.brand);

      const newAccessoryData = {
        id: food.id,
        image: food.image,
        title: food.title,
        price: food.price,
        year: food.year,
        type: food.type,
        description: food.modelo,
        quantity: 1,
        options: [],
      };

      // 1. Guardar en tabla accesorios
      const serverResult = await sendAccessoryToServer(newAccessoryData);

      if (!serverResult) {
        Swal.fire(
          "Error",
          "No se pudo guardar el accesorio en el servidor",
          "error",
        );
      }

      // 2. Agregarlo a planes_seleccionados -> Plan cliente
      updateOptionPlanDirectly(newAccessoryData);
    }

    // 3. Agregar al carrito local
    const newOrderData = [
      ...orderData,
      {
        id: food.id,
        image: food.image,
        title: food.title,
        price: food.price,
        year: food.year,
        type: food.type,
        description: food.modelo,
        quantity: 1,
        options: [],
      },
    ];

    updateOrderDataAndSave(newOrderData);
  };

  // Verificar si ya está agregado el accesorio/garantia
  const isInCart = (producto) => {
    return orderData.some((item) => item.id === producto.id);
  };

  var showPosItemModal = (event, food) => {
    event.preventDefault();

    // Guardamos la marca del vehículo seleccionado
    setSelectedBrand(food.brand);

    // Abrimos el modal con la información del producto
    setModalData(food);
    setModalQuantity(1);
    productModal.show();
  };

  const showAccessoryModal = (food) => {
    cerrarGaleriaFotosSeminuevo();
    setAccessoryModalData(food);
    setAccessoryModalVisible(true);
  };

  var getOrderTotal = () => {
    return orderData ? orderData.length : 0;
  };

  var getTotalPrice = () => {
    var value = 0;

    if (orderData) {
      for (var i = 0; i < orderData.length; i++) {
        value +=
          parseFloat(orderData[i].price) * parseInt(orderData[i].quantity);
      }
    }
    return Math.round(value); // Redondeamos para obtener un número entero
  };

  var toggleConfirmation = (event, id, value) => {
    event.preventDefault();

    if (orderData) {
      const newData = orderData.map((obj) => {
        if (obj.id === id) {
          return { ...obj, confirmation: value };
        }
        return obj;
      });

      setOrderData(newData);
    }
  };

  var removeOrder = (event, id) => {
    event.preventDefault();

    if (orderData) {
      const newData = orderData.filter(function (order) {
        return order.id !== id;
      });

      setOrderData(newData);
    }
  };

  // Modificación de la función addToCart para vehículos.
  // Se quitó el setTimeout porque abría una ventana donde el polling podía
  // leer selected_car vacío, limpiar selectedCar y cerrar la ficha técnica.
  const addToCart = async (event, vehicleOverride = null, addOptions = {}) => {
    event?.preventDefault?.();

    const { skipProductModalHide = false } = addOptions || {};

    if (!skipProductModalHide) {
      try {
        productModal?.hide?.();
      } catch {}
    }

    const sourceData = vehicleOverride || modalData;
    if (!sourceData) return false;

    const selectedOptions = [];
    const finalPrice = sourceData.price;

    if (modalSelectedAddon) {
      for (let i = 0; i < modalSelectedAddon.length; i++) {
        selectedOptions.push({
          key: "addon",
          value: modalSelectedAddon[i],
        });
      }
    }

    let updatedOrderData = [...(orderDataRef.current || orderData || [])];

    // Preparar objeto del nuevo vehículo
    // La URL de ficha técnica debe salir del vehículo seleccionado en el inventario.
    // Para nuevos, esa URL ya viene como url_ficha_tecnica desde /financiamiento/vehiculos.
    // También la guardamos en selected_car para usarla más adelante en el asesor.
    const fichaTecnicaSource =
      obtenerFichaTecnicaUrl(sourceData) ||
      normalizeFichaTecnicaUrl(
        getFichaTecnicaFromVehicle(sourceData) ||
          getFichaTecnicaFromVenta(selectedMailData),
      );

    const newVehicleData = {
      id: sourceData.id,
      image: sourceData.image || sourceData.url_img || "",
      url_img: sourceData.url_img || sourceData.image || "",
      title: sourceData.title,
      price: finalPrice,
      year: sourceData.year,
      type: sourceData.type,
      description: sourceData.description || sourceData.modelo || "",
      quantity: modalQuantity,
      options: selectedOptions,
      ag_id: sourceData.ag_id || agenciaActual?.ag_id || "",
      used_id: sourceData.used_id || "",
      pdf: fichaTecnicaSource,
      ficha_tecnica: fichaTecnicaSource,
      ficha_tecnica_vehiculo: fichaTecnicaSource,
      url_ficha_tecnica: fichaTecnicaSource,
      url_cotizacion: sourceData.url_cotizacion || "",
      procotiza_pdf_base64: sourceData.procotiza_pdf_base64 || "",
      // Agregar las opciones completas para tenerlas disponibles
      availableOptions: sourceData.options ? sourceData.options : {},
    };

    // Reemplazar si es tipo "nuevo" o "seminuevo"
    if (sourceData.type === "nuevos" || sourceData.type === "seminuevos") {
      updatedOrderData = updatedOrderData.filter(
        (item) => item.type !== "nuevos" && item.type !== "seminuevos",
      );

      setPrecioBaseVehiculo(finalPrice);
      markPendingVehicleSelection();
      selectedCarRef.current = newVehicleData;

      const serverResult = await sendVehicleToServer(newVehicleData);

      if (!serverResult) {
        Swal.fire(
          "Error",
          "No se pudo guardar el vehículo en el servidor",
          "error",
        );
      } else {
        // No liberamos pendingVehicleSelection aquí.
        // El polling lo limpia cuando reciba selected_car desde backend.
        // Si lo liberamos por tiempo, un tick temporal sin selected_car puede
        // cerrar la ficha técnica justo después de dar "Me interesa".
      }
    }

    updatedOrderData.push(newVehicleData);
    updateOrderDataAndSave(updatedOrderData);

    return true;
  };

  useEffect(() => {
    if (vehicleData?.planesFinanciamiento) {
      const seleccionado = vehicleData.planesFinanciamiento.find(
        (p) => p.isSelected,
      );
      if (seleccionado) {
        setPlanSeleccionado(seleccionado);
      }
    }
  }, [vehicleData]);

  useEffect(() => {
    // Verifica si el valor de selectedBrand ha cambiado y aplica el filtro
  }, [selectedBrand]); // Se ejecutará cada vez que selectedBrand cambie

  useEffect(() => {
    // --- UI / contexto ---
    context.setAppHeaderNone(true);
    context.setAppSidebarNone(true);
    context.setAppContentFullHeight(true);
    context.setAppContentClass("p-0");

    // Modal
    setProductModal(new Modal(document.getElementById("modalPosItem")));

    // 1) Carrito desde sessionStorage (solo si aún no hay nada en memoria)
    try {
      const savedCart = sessionStorage.getItem("orderCart");
      const initialCart = savedCart ? JSON.parse(savedCart) : [];
      const currentOrder = orderDataRef.current || [];

      if (currentOrder.length === 0 && initialCart.length > 0) {
        setOrderData(initialCart);
      }
    } catch {}

    // --- Inventario / catálogo ---
    const folioActualInventario = resolveFolioVenta?.() || folioVenta || "";
    const ventaPerteneceAFolioActualInventario =
      !!selectedMailData &&
      String(
        selectedMailData?.folio_venta ||
          selectedMailData?.folio ||
          selectedMailData?.folioVenta ||
          "",
      ).trim() === String(folioActualInventario || "").trim();

    const usarDatosVentaParaInventario =
      ventaPerteneceAFolioActualInventario &&
      !nuevaVentaFormularioPendienteRef.current;

    const ag_id = usarDatosVentaParaInventario
      ? selectedMailData?.ag_id || agenciaActual.ag_id
      : agenciaActual.ag_id;
    const nombre = usarDatosVentaParaInventario
      ? selectedMailData?.agencia || agenciaActual.nombre
      : agenciaActual.nombre;

    const agenciaPorId = obtenerAgenciaPorIdGlobal(ag_id);
    const agenciaPorNombre = nombre ? agenciaInfo[nombre] || {} : {};

    const marca =
      (usarDatosVentaParaInventario ? selectedMailData?.marca_vehiculo : "") ||
      agenciaPorId?.marca ||
      agenciaPorNombre?.marca ||
      "";

    let controller = null;

    if (!ag_id || !marca) {
      setTableData([]);
      setAccesoriosGarantias({
        accesorios: [],
        garantias: [],
      });
      setLoading(false);
    } else {
      const requestId = ++inventarioRequestIdRef.current;
      controller = new AbortController();

      const requestData = {
        access_token: accessToken,
        marca,
        ag_id,
      };

      setLoading(true);

      // Limpieza preventiva para que no se queden accesorios de otra agencia
      // mientras llega la nueva respuesta.
      setTableData([]);
      setAccesoriosGarantias({
        accesorios: [],
        garantias: [],
      });

      fetch(apiUrlInventario, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
        signal: controller.signal,
      })
        .then((res) => res.json())
        .then((data) => {
          // Si llegó una respuesta vieja, se ignora para que no pise la agencia actual.
          if (requestId !== inventarioRequestIdRef.current) return;

          const foodOriginal = Array.isArray(data?.food) ? data.food : [];

          // Blindaje extra del cliente:
          // aunque el backend mande algo de otra agencia, aquí se descarta.
          const foodFiltrado = foodOriginal.filter((item) => {
            const tipo = item?.type;

            if (tipo === "accesorios" || tipo === "garantias") {
              return (
                !item?.hide &&
                estaDisponible(item) &&
                coincideMarcaItem(item, marca) &&
                coincideAgenciaItem(item, ag_id)
              );
            }

            return true;
          });

          const dataLimpia = {
            ...data,
            food: foodFiltrado,
          };

          console.log("Inventario agencia:", requestData);
          console.log("Respuesta inventario filtrada:", dataLimpia);

          setTableData(dataLimpia);

          const currentOrder = orderDataRef.current || [];

          if (
            Array.isArray(data?.order) &&
            data.order.length > 0 &&
            currentOrder.length === 0 &&
            !selectedCarRef.current
          ) {
            setOrderData(data.order);

            try {
              sessionStorage.setItem("orderCart", JSON.stringify(data.order));
            } catch {}
          }

          setOrderHistoryData(data?.orderHistory || []);
          setInitialLoad(false);
          setCategoryType(tipoAutoSeleccionado || "all");
          setSubTipoNuevo("all");
        })
        .catch((error) => {
          if (error?.name === "AbortError") return;

          console.error("Error cargando inventario:", error);
          setTableData([]);
          setAccesoriosGarantias({
            accesorios: [],
            garantias: [],
          });
        })
        .finally(() => {
          if (requestId === inventarioRequestIdRef.current) {
            setLoading(false);
          }
        });
    }

    return () => {
      if (controller) {
        controller.abort();
      }

      context.setAppHeaderNone(false);
      context.setAppSidebarNone(false);
      context.setAppContentFullHeight(false);
      context.setAppContentClass("");
    };
    // Este efecto sólo debe recargar inventario cuando cambia la agencia,
    // el tipo de auto o los datos de la venta necesarios para resolver agencia/marca.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    folioVenta,
    ventaResetKey,
    agenciaActual.ag_id,
    agenciaActual.nombre,
    selectedMailData?.ag_id,
    selectedMailData?.agencia,
    selectedMailData?.marca_vehiculo,
    tipoAutoSeleccionado,
  ]);

  // Configuración inicial
  useEffect(() => {
    // Configuración inicial del contexto
    context.setAppHeaderNone(true);
    context.setAppSidebarNone(true);
    context.setAppContentFullHeight(true);
    context.setAppContentClass("p-0");

    // Creación del modal del producto
    setProductModal(new Modal(document.getElementById("modalPosItem")));

    // Ya no hacemos la carga inicial automática de vehículos
    // fetchVehicles(); <-- Esta línea se elimina

    // Función de limpieza al desmontar el componente
    return () => {
      context.setAppHeaderNone(false);
      context.setAppSidebarNone(false);
      context.setAppContentFullHeight(false);
      context.setAppContentClass("");
    };
  }, []);

  const [mostrarModalAccesorios, setMostrarModalAccesorios] = useState(false);
  const [canvasActivo, setCanvasActivo] = useState(false);
  const canvasRef = useRef();
  const [searchVehicle, setsearchVehicle] = useState(""); //buscador de vehiculos
  // Nuevo estado para controlar si el botón está activo
  const [isActive, setIsActive] = useState(true);
  const [asesores, setAsesores] = useState([]); //Lista de asesores

  const actualizarFirmaModal = async (valor) => {
    if (!selectedMailData?.id) return; // Si no hay id, no hace nada

    try {
      await fetch(apiUrlUpdate, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          access_token: accessToken,
          venta_id: selectedMailData.id,
          firma_modal: valor, // valor dinámico que recibimos
        }),
      });
    } catch (error) {}
  };

  const handleShowModalEstadisticas = (ventaIdParam = "") => {
    console.log("ABRIENDO MODAL");
    cerrarGaleriaFotosSeminuevo();
    const modalElement = document.getElementById("accessoryModal");
    const modal = Modal.getOrCreateInstance(modalElement);
    modal.show();
    setIsAccessoryModalOpen(true);

    // El asesor abre con financiamiento_modal = 1.
    // El cliente lo consume y lo regresa a 0 para permitir futuras reaperturas.
    limpiarFinanciamientoModalCliente(ventaIdParam);
  };

  const handleCloseModalFinanciamiento = () => {
    const modalElement = document.getElementById("accessoryModal");

    if (!modalElement) return;

    const modal = Modal.getOrCreateInstance(modalElement);

    console.log("Modal Bootstrap instance (cerrando):", modal);

    // Cierra el modal
    modal.hide();

    // 🔒 Forzamos limpieza visual y de backdrop (por si Bootstrap se queda colgado)
    setTimeout(() => {
      modalElement.classList.remove("show");
      modalElement.style.display = "none";
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "";
      document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
    }, 300); // 300ms coincide con la duración del fade

    // Actualiza el estado de React
    setIsAccessoryModalOpen(false);
    limpiarFinanciamientoModalCliente();
  };

  const RibbonDiagonal = (
    { text, color }, //etiqueta accesorios
  ) => (
    <div
      style={{
        position: "absolute",
        top: "28px",
        left: "-40px",
        backgroundColor: color,
        color: "white",
        padding: "5px 29px",
        transform: "rotate(-45deg)",
        fontWeight: "bold",
        fontSize: "14px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",
        zIndex: 10,
        borderRadius: "5px",
      }}
    >
      {text}
    </div>
  );

  React.useEffect(() => {
    const food = Array.isArray(tableData?.food) ? tableData.food : [];

    if (!food.length) {
      setAccesoriosGarantias({
        accesorios: [],
        garantias: [],
      });
      return;
    }

    const filtrarExtraPorContexto = (item) => {
      if (!item || item.hide) return false;
      if (!estaDisponible(item)) return false;
      if (!coincideMarcaItem(item, marcaActiva)) return false;
      if (!coincideAgenciaItem(item, agIdActivo)) return false;

      return true;
    };

    setAccesoriosGarantias({
      accesorios: food.filter(
        (item) => item.type === "accesorios" && filtrarExtraPorContexto(item),
      ),
      garantias: food.filter(
        (item) => item.type === "garantias" && filtrarExtraPorContexto(item),
      ),
    });
  }, [tableData, agIdActivo, marcaActiva]);

  const renderLineLabel = ({ x, y, value }) => {
    return (
      <text
        x={x}
        y={y + 35}
        fontSize={11}
        fill="var(--label-color)"
        textAnchor="middle"
      >
        {`${value}%`}
      </text>
    );
  };

  const parsedSelectedPlans = useMemo(() => {
    //mostrar el pna seleccionado (modo espejo)
    try {
      return JSON.parse(
        JSON.parse(selectedMailData?.planes_seleccionados || "[]"),
      );
    } catch (e) {
      return [];
    }
  }, [selectedMailData]);

  const parsedAccesoriosSeleccionados = useMemo(() => {
    try {
      return JSON.parse(selectedMailData?.accesorios_seleccionados || "[]");
    } catch (e) {
      return [];
    }
  }, [selectedMailData]);

  /************* FICHAS TECNICAS *************/
  const [openFicha, setOpenFicha] = useState(false);
  const [fichaURL, setFichaURL] = useState("");
  const [openFotosSeminuevo, setOpenFotosSeminuevo] = useState(false);
  const [fotosSeminuevo, setFotosSeminuevo] = useState([]);
  const [tituloFotosSeminuevo, setTituloFotosSeminuevo] = useState(
    "Fotos del seminuevo",
  );
  const [loadingFotosSeminuevo, setLoadingFotosSeminuevo] = useState(false);

  const cerrarGaleriaFotosSeminuevo = useCallback((options = {}) => {
    const { limpiar = false } = options || {};

    setOpenFotosSeminuevo(false);
    setLoadingFotosSeminuevo(false);

    if (limpiar) {
      setFotosSeminuevo([]);
      setTituloFotosSeminuevo("Fotos del seminuevo");
    }
  }, []);

  useEffect(() => {
    const handleCerrarGaleria = () => {
      cerrarGaleriaFotosSeminuevo();
    };

    window.addEventListener(
      "babilonia:cerrar-galeria-seminuevo",
      handleCerrarGaleria,
    );

    return () => {
      window.removeEventListener(
        "babilonia:cerrar-galeria-seminuevo",
        handleCerrarGaleria,
      );
    };
  }, [cerrarGaleriaFotosSeminuevo]);

  const openFichaRef = useRef(false);
  const fichaURLRef = useRef("");

  useEffect(() => {
    if (
      mostrarModalAccesorios ||
      mostrarModalPruebaManejoCliente ||
      openPDFModal ||
      accessoryModalVisible ||
      isAccessoryModalOpen ||
      showModal
    ) {
      cerrarGaleriaFotosSeminuevo();
    }
  }, [
    mostrarModalAccesorios,
    mostrarModalPruebaManejoCliente,
    openPDFModal,
    accessoryModalVisible,
    isAccessoryModalOpen,
    showModal,
    cerrarGaleriaFotosSeminuevo,
  ]);

  useEffect(() => {
    openFichaRef.current = openFicha;
  }, [openFicha]);

  useEffect(() => {
    fichaURLRef.current = fichaURL;
  }, [fichaURL]);

  const extractUsedIdFromUrl = (value = "") => {
    const raw = String(value || "");
    const match = raw.match(/\/jpgs\/[^/]+\/([^/]+)\//i);
    return match?.[1] || "";
  };

  // selected_car es el único lugar donde se persiste la ficha técnica del vehículo.
  // Esto evita crear columnas nuevas y permite que asesor/cliente lean el mismo JSON.
  const getSelectedCarFromVenta = (venta = selectedMailData) => {
    if (!venta) return null;

    const raw = venta.selected_car || venta.selectedCar || null;
    if (!raw) return null;

    if (typeof raw === "object") return raw;

    if (typeof raw === "string") {
      try {
        return JSON.parse(raw);
      } catch {
        return null;
      }
    }

    return null;
  };

  const normalizarTipoCatalogo = (value = "") => {
    const raw = String(value || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim();

    if (raw.includes("seminuevo")) return "seminuevos";
    if (raw.includes("nuevo")) return "nuevos";
    return raw;
  };

  const getVehiculoActivoParaFicha = (vehicleOverride = null) => {
    const selectedCarVenta = getSelectedCarFromVenta();

    return (
      vehicleOverride ||
      selectedCar ||
      selectedCarRef.current ||
      selectedCarVenta ||
      (vehicleData && vehicleData.selected_car) || {
        title:
          selectedMailData?.marca_vehiculo || selectedMailData?.marca || "",
        description:
          selectedMailData?.modelo_vehiculo || selectedMailData?.modelo || "",
        type: selectedMailData?.tipo_auto || "",
        used_id: selectedMailData?.used_id || "",
      }
    );
  };

  const esVehiculoSeminuevoActivo = (vehicleOverride = null) => {
    const sc = getVehiculoActivoParaFicha(vehicleOverride) || {};

    const tipo = normalizarTipoCatalogo(
      sc.type || selectedMailData?.tipo_auto || "",
    );

    return tipo === "seminuevos";
  };

  const getUsedIdSeminuevoActivo = (vehicleOverride = null) => {
    const sc = getVehiculoActivoParaFicha(vehicleOverride) || {};

    return String(
      sc.used_id ||
        selectedMailData?.used_id ||
        extractUsedIdFromUrl(
          sc.url_img || sc.image || selectedMailData?.url_img,
        ) ||
        "",
    ).trim();
  };

  const getTituloFotosSeminuevo = (vehicleOverride = null) => {
    const sc = getVehiculoActivoParaFicha(vehicleOverride) || {};

    const marca = String(
      sc.title ||
        sc.brand ||
        selectedMailData?.marca_vehiculo ||
        selectedMailData?.marca ||
        "",
    ).trim();

    const modelo = String(
      sc.description ||
        sc.modelo_vehiculo ||
        sc.modelo ||
        sc.model ||
        selectedMailData?.modelo_vehiculo ||
        selectedMailData?.modelo ||
        "",
    ).trim();

    const titulo = `${marca} ${modelo}`.trim();

    return titulo ? `Fotos ${titulo}` : "Fotos del seminuevo";
  };

  const obtenerImagenesSeminuevoBabilonia = async (usedId = "") => {
    const usedIdLimpio = String(usedId || "").trim();

    if (!usedIdLimpio) {
      throw new Error("No se encontró el used_id del seminuevo.");
    }

    const response = await fetch(apiBabiloniaSeminuevosImagenes, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        used_id: usedIdLimpio,
      }),
    });

    const data = await response.json().catch(() => null);

    if (!response.ok || data?.status !== "success") {
      throw new Error(
        data?.message || "No se pudieron obtener las fotos del seminuevo.",
      );
    }

    const images = Array.isArray(data?.data?.images)
      ? data.data.images
      : Array.isArray(data?.data?.thumb)
        ? data.data.thumb
        : [];

    return images;
  };

  const abrirFotosSeminuevo = async (vehicleOverride = null) => {
    if (loadingFotosSeminuevo) return;

    if (!esVehiculoSeminuevoActivo(vehicleOverride)) {
      Swal.fire(
        "Fotos no disponibles",
        "La galería de fotos sólo aplica para seminuevos.",
        "info",
      );
      return;
    }

    const usedId = getUsedIdSeminuevoActivo(vehicleOverride);

    if (!usedId) {
      Swal.fire(
        "Fotos no disponibles",
        "No se encontró el used_id del seminuevo para consultar sus fotos.",
        "warning",
      );
      return;
    }

    setLoadingFotosSeminuevo(true);

    try {
      const images = await obtenerImagenesSeminuevoBabilonia(usedId);

      setFotosSeminuevo(images);
      setTituloFotosSeminuevo(getTituloFotosSeminuevo(vehicleOverride));
      setOpenFotosSeminuevo(true);
    } catch (error) {
      console.error("Error al obtener fotos del seminuevo:", error);
      Swal.fire(
        "No se pudieron cargar las fotos",
        error?.message || "Intenta abrir la galería nuevamente.",
        "error",
      );
    } finally {
      setLoadingFotosSeminuevo(false);
    }
  };

  const getFichaTecnicaFromVenta = (venta = selectedMailData) => {
    const raw = String(
      venta?.ficha_tecnica_vehiculo ||
        venta?.url_ficha_tecnica_vehiculo ||
        venta?.ficha_tecnica ||
        venta?.url_ficha_tecnica ||
        venta?.pdf ||
        venta?.fichaTecnica ||
        "",
    ).trim();

    return raw;
  };

  const getFichaTecnicaFromVehicle = (vehicle = {}) => {
    if (!vehicle || typeof vehicle !== "object") return "";

    const raw = String(
      vehicle?.ficha_tecnica_vehiculo ||
        vehicle?.url_ficha_tecnica_vehiculo ||
        vehicle?.fichaTecnicaVehiculo ||
        vehicle?.urlFichaTecnicaVehiculo ||
        vehicle?.url_ficha_tecnica ||
        vehicle?.ficha_tecnica ||
        vehicle?.ficha_tecnica_url ||
        vehicle?.urlFichaTecnica ||
        vehicle?.technical_sheet_url ||
        vehicle?.pdf ||
        vehicle?.fichaTecnica ||
        "",
    ).trim();

    return raw;
  };

  const normalizeFichaTecnicaUrl = (rawValue = "") => {
    const raw = String(rawValue || "").trim();

    if (!raw) return "";

    if (/^(blob:|data:|https?:\/\/|\/\/)/i.test(raw)) {
      return raw.startsWith("//") ? `https:${raw}` : raw;
    }

    // Si por alguna razón Nissan llega como ruta relativa, lo convertimos a URL absoluta.
    if (raw.startsWith("/content/") || raw.startsWith("/etc/")) {
      return `https://www.nissan.com.mx${raw}`;
    }

    return raw;
  };

  const esUrlNissan = (value = "") =>
    /^https?:\/\/(www\.)?nissan\.com\.mx\//i.test(String(value || "").trim());

  const buildFichaTecnicaUrlParaVisor = (rawValue = "") => {
    const urlOriginal = normalizeFichaTecnicaUrl(rawValue);

    if (!urlOriginal) return { original: "", visor: "" };

    // react-pdf/pdf.js hace fetch del PDF. Los PDFs de Nissan bloquean CORS
    // cuando se leen directo desde localhost, por eso para visor usamos proxy.
    if (esUrlNissan(urlOriginal)) {
      return {
        original: urlOriginal,
        visor: `${apiProxyFichaTecnicaNuevo}?access_token=${encodeURIComponent(
          accessToken,
        )}&url=${encodeURIComponent(urlOriginal)}`,
      };
    }

    return { original: urlOriginal, visor: urlOriginal };
  };

  const normalizeInventoryText = (value = "") =>
    String(value || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();

  const getInventoryItems = () => {
    if (Array.isArray(tableData?.food)) return tableData.food;
    if (Array.isArray(tableData)) return tableData;
    return [];
  };

  const buildVehicleSearchInfo = (vehicle = {}) => {
    const selectedCarVenta = getSelectedCarFromVenta();

    const marca = normalizeInventoryText(
      vehicle?.title ||
        vehicle?.brand ||
        selectedCarVenta?.title ||
        selectedCarVenta?.brand ||
        selectedMailData?.marca_vehiculo ||
        selectedMailData?.marca ||
        "",
    );

    const modelo = normalizeInventoryText(
      vehicle?.description ||
        vehicle?.modelo_vehiculo ||
        vehicle?.model ||
        selectedCarVenta?.description ||
        selectedCarVenta?.modelo ||
        selectedCarVenta?.modelo_vehiculo ||
        selectedMailData?.modelo_vehiculo ||
        selectedMailData?.modelo ||
        "",
    );

    const tipo = normalizarTipoCatalogo(
      vehicle?.type ||
        selectedCarVenta?.type ||
        selectedMailData?.tipo_auto ||
        "",
    );

    return {
      id: vehicle?.id != null ? String(vehicle.id) : "",
      marca,
      modelo,
      tipo,
    };
  };

  const findFichaTecnicaInInventory = (vehicle = {}) => {
    const inventario = getInventoryItems();
    if (!inventario.length) return "";

    const search = buildVehicleSearchInfo(vehicle);

    const found = inventario.find((item) => {
      const itemFicha = getFichaTecnicaFromVehicle(item);
      if (!itemFicha) return false;

      const itemId = item?.id != null ? String(item.id) : "";
      const itemTipo = normalizarTipoCatalogo(item?.type || "");
      const itemMarca = normalizeInventoryText(
        item?.title || item?.brand || "",
      );
      const itemModelo = normalizeInventoryText(
        item?.description || item?.modelo_vehiculo || item?.model || "",
      );

      // Si viene el id del mismo inventario, es el match más seguro.
      if (search.id && itemId && search.id === itemId) return true;

      // Match por marca/modelo. Este es el respaldo importante cuando selected_car
      // ya viene guardado desde la venta pero sin la URL del inventario.
      if (search.marca && search.modelo && itemMarca && itemModelo) {
        const sameTipo = !search.tipo || !itemTipo || search.tipo === itemTipo;
        const sameMarca = itemMarca === search.marca;
        const sameModelo =
          itemModelo === search.modelo ||
          itemModelo.includes(search.modelo) ||
          search.modelo.includes(itemModelo);

        if (sameTipo && sameMarca && sameModelo) return true;
      }

      return false;
    });

    return getFichaTecnicaFromVehicle(found);
  };

  const mergeFichaTecnicaVentaEnSelectedCar = (
    car = {},
    venta = selectedMailData,
  ) => {
    if (!car) return car;

    // Para nuevos, primero intentamos recuperar la URL exacta desde inventario.
    // Después usamos selected_car/venta como respaldo. No se crea ningún campo nuevo,
    // solo se guarda la URL dentro del JSON selected_car.
    const fichaFinal =
      findFichaTecnicaInInventory(car) ||
      getFichaTecnicaFromVehicle(car) ||
      getFichaTecnicaFromVehicle(getSelectedCarFromVenta(venta)) ||
      getFichaTecnicaFromVenta(venta);

    if (!fichaFinal) return car;

    return {
      ...car,
      pdf: fichaFinal,
      ficha_tecnica: fichaFinal,
      ficha_tecnica_vehiculo: fichaFinal,
      url_ficha_tecnica: fichaFinal,
    };
  };

  const obtenerFichaTecnicaUrl = (vehicle = {}) => {
    const selectedCarVenta = getSelectedCarFromVenta();

    // Prioridad final:
    // 1) inventario con el vehículo actual,
    // 2) campos del vehículo actual,
    // 3) inventario usando selected_car guardado,
    // 4) selected_car guardado,
    // 5) campos sueltos de venta como último respaldo.
    const raw =
      findFichaTecnicaInInventory(vehicle) ||
      getFichaTecnicaFromVehicle(vehicle) ||
      findFichaTecnicaInInventory(selectedCarVenta) ||
      getFichaTecnicaFromVehicle(selectedCarVenta) ||
      getFichaTecnicaFromVenta(selectedMailData);

    return normalizeFichaTecnicaUrl(raw);
  };

  const abrirPDF = (vehicleOverride = null) => {
    // evita doble disparo por carreras o múltiples renders
    if (isOpeningFichaRef.current) return;
    isOpeningFichaRef.current = true;

    try {
      const selectedCarVenta = getSelectedCarFromVenta();

      const scBase = vehicleOverride ||
        selectedCar ||
        selectedCarRef.current ||
        selectedCarVenta ||
        (vehicleData && vehicleData.selected_car) || {
          title:
            selectedMailData?.marca_vehiculo || selectedMailData?.marca || "",
          description:
            selectedMailData?.modelo_vehiculo || selectedMailData?.modelo || "",
          type: selectedMailData?.tipo_auto || "nuevos",
        };

      if (!scBase) return;

      const sc = mergeFichaTecnicaVentaEnSelectedCar(scBase, selectedMailData);

      const tipo = normalizarTipoCatalogo(
        sc.type || selectedMailData?.tipo_auto || "",
      );

      let url = "";

      if (tipo === "seminuevos") {
        const agId =
          sc.ag_id || selectedMailData?.ag_id || agenciaActual?.ag_id || "";
        const usedId =
          sc.used_id ||
          extractUsedIdFromUrl(
            sc.url_img || sc.image || selectedMailData?.url_img,
          );

        if (!agId || !usedId) {
          Swal.fire(
            "Ficha técnica no disponible",
            "No se encontró el identificador del seminuevo para abrir el PDF.",
            "warning",
          );
          return;
        }

        url = `https://api.checkmark.mx/proxy/folleto?access_token=${accessToken}&ag_id=${encodeURIComponent(
          agId,
        )}&used_id=${encodeURIComponent(clean(usedId))}`;
      } else {
        const fichaOriginal = obtenerFichaTecnicaUrl(sc);
        const fichaUrls = buildFichaTecnicaUrlParaVisor(fichaOriginal);
        url = fichaUrls.visor;

        if (!fichaUrls.original || !url) {
          console.warn("No se encontró ficha técnica para nuevo", {
            sc,
            selectedCar,
            selectedCarRef: selectedCarRef.current,
            selectedCarVenta,
            selectedMailData,
            inventario: getInventoryItems(),
          });

          Swal.fire(
            "Ficha técnica no disponible",
            "No se encontró la URL de ficha técnica del inventario para este vehículo nuevo.",
            "warning",
          );
          return;
        }

        // Guardamos en selected_car la URL REAL del inventario, no la del proxy.
        // Así el asesor puede reutilizarla después y decidir si la abre directo o por proxy.
        const carConFicha = {
          ...sc,
          pdf: fichaUrls.original,
          ficha_tecnica: fichaUrls.original,
          ficha_tecnica_vehiculo: fichaUrls.original,
          url_ficha_tecnica: fichaUrls.original,
          ficha_tecnica_proxy_url: fichaUrls.visor,
        };

        selectedCarRef.current = carConFicha;
        setSelectedCar(carConFicha);
      }

      setFichaURL(url);
      setOpenFicha(true);
    } finally {
      // libera el candado un poco después
      setTimeout(() => {
        isOpeningFichaRef.current = false;
      }, 300);
    }
  };

  // helpers que ya usabas
  const ensureObject = (v) => {
    if (!v) return null;
    if (typeof v === "string") {
      try {
        return JSON.parse(v);
      } catch {
        return null;
      }
    }
    return typeof v === "object" ? v : null;
  };
  const clean = (s) =>
    String(s || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-")
      .toLowerCase();

  useEffect(() => {
    if (!selectedCar) return;

    const currKey = getSelectedCarRenderKey(selectedCar);

    if (userJustSelectedRef.current) {
      if (lastAutoOpenedKeyRef.current !== currKey && !openFicha) {
        abrirPDF(selectedCar);
        lastAutoOpenedKeyRef.current = currKey;
      }
      userJustSelectedRef.current = false;
    }
    // si llega por hidratación, no auto-abre
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCar, openFicha]);

  // quita el efecto que depende de openFicha

  /* Formatos Generados liberar memoria */
  useEffect(() => {
    if (!openPDFModal && pdfUrlsGeneradas.length) {
      pdfUrlsGeneradas.forEach((u) => URL.revokeObjectURL(u));
      setPdfUrlsGeneradas([]);
    }

    return () => {
      pdfUrlsGeneradas.forEach((u) => URL.revokeObjectURL(u));
    };
  }, [openPDFModal]);

  useEffect(() => {
    const cargarAsesores = async () => {
      if (!agenciaActual.ag_id) {
        setAsesores([]);
        return;
      }

      const lista = await obtenerAsesores(agenciaActual.ag_id);
      setAsesores(lista);
    };

    cargarAsesores();
  }, [agenciaActual.ag_id]);

  const scrollRef = useRef(null);

  useEffect(() => {
    if (canvasActivo) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    // Limpieza por si se desmonta el componente
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [canvasActivo]);

  useEffect(() => {
    if (mostrarModalInfo) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
  }, [mostrarModalInfo]);

  useEffect(() => {
    if (openPDFModal) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => document.body.classList.remove("modal-open");
  }, [openPDFModal]);

  useEffect(() => {
    if (mostrarModalPruebaManejoCliente) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }

    return () => document.body.classList.remove("modal-open");
  }, [mostrarModalPruebaManejoCliente]);

  useEffect(() => {
    console.log("selectedMailData cambió:", selectedMailData);
  }, [selectedMailData]);

  const PROMO_THRESHOLD = 15000;
  const PROMO_DISCOUNT_RATE = 0.1;

  const toPromoNumber = (value) => {
    if (value === null || value === undefined || value === "") return 0;

    if (typeof value === "number") {
      return Number.isFinite(value) ? value : 0;
    }

    const cleaned = String(value)
      .replace(/\$/g, "")
      .replace(/,/g, "")
      .replace(/%/g, "")
      .trim();

    const parsed = Number(cleaned);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const parsePromoArray = (value) => {
    if (!value) return [];

    if (Array.isArray(value)) return value;

    if (typeof value === "string") {
      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return [];
      }
    }

    return [];
  };

  const normalizarPlanPromo = (value = "") =>
    String(value || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/paquete/g, "")
      .replace(/plan/g, "")
      .replace(/\s+/g, " ")
      .trim();

  const getValorPromoServidor = (planTitle = "", data = {}) => {
    const planNormalizado = normalizarPlanPromo(planTitle);

    // En backend histórico estos campos se usaron como indicador/faltante.
    // Los dejamos como respaldo, pero la regla principal se calcula con el
    // total real del plan para que cliente y asesor coincidan.
    if (planNormalizado.includes("platinum")) return toPromoNumber(data?.edad);
    if (planNormalizado.includes("gold")) return toPromoNumber(data?.mstar);
    if (planNormalizado.includes("cliente")) return toPromoNumber(data?.nexu);
    if (planNormalizado.includes("elite")) {
      return toPromoNumber(data?.condiciones_calle);
    }

    return 0;
  };

  const getPrecioBaseAccesorioPromo = (acc = {}) => {
    const candidatos = [
      acc.precio_original,
      acc.original_price,
      acc.originalPrice,
      acc.base_price,
      acc.basePrice,
      acc.precio_base,
      acc.priceOriginal,
      acc.precioSinDescuento,
      acc.precio_sin_descuento,
      acc.price,
      acc.precio,
    ];

    for (const value of candidatos) {
      const parsed = toPromoNumber(value);
      if (parsed > 0) return parsed;
    }

    return 0;
  };

  const getTotalBasePromocionPlan = (plan = {}, data = {}) => {
    if (!plan) return 0;

    const totalDirecto = [
      plan.totalExtrasBase,
      plan.total_base,
      plan.totalBase,
      plan.totalPriceOriginal,
      plan.totalOriginalPrice,
      plan.total_original,
      plan.precio_original,
      plan.precioSinDescuento,
      plan.precio_sin_descuento,
    ]
      .map(toPromoNumber)
      .find((value) => value > 0);

    const accesorios = parsePromoArray(plan.accessories);
    const totalAccesoriosBase = accesorios.reduce(
      (sum, acc) => sum + getPrecioBaseAccesorioPromo(acc),
      0,
    );

    const totalVisible = toPromoNumber(plan.totalPrice || plan.total_price);
    const totalBase = Math.max(
      totalDirecto || 0,
      totalAccesoriosBase,
      totalVisible,
    );

    // Fuente de verdad para la promoción: precios base del plan/accesorios.
    // No mezclamos total visible + faltante de backend, porque eso provocaba
    // que Gold mostrara descuento aplicado cuando realmente aún faltaban $904.
    return totalBase;
  };

  const obtenerPromocion = (plan, selectedMailData) => {
    if (!plan) {
      return { mensaje: "No aplica promoción", descuento: 0, faltante: 0 };
    }

    // Gold es paquete precargado; no mostramos faltantes para evitar mensajes
    // confusos en un paquete que no se modifica desde cliente.
    if (esPlanGoldFinanciamiento(plan)) {
      return { mensaje: "Paquete precargado", descuento: 0, faltante: 0 };
    }

    const totalBase = getTotalBasePromocionPlan(plan, selectedMailData);
    const valorServidor = getValorPromoServidor(plan?.title, selectedMailData);
    const tieneTotalCalculado = totalBase > 0;
    const aplicaPorTotal = totalBase >= PROMO_THRESHOLD;

    // El valor guardado en backend (mstar, edad, nexu, etc.) se usa sólo como
    // respaldo cuando el cliente no puede calcular el total base. Si sí tenemos
    // accesorios/precios base, manda el cálculo local para evitar estados viejos.
    const aplicaPorServidor = !tieneTotalCalculado && valorServidor > 0;

    if (aplicaPorTotal || aplicaPorServidor) {
      return {
        mensaje: "¡Felicidades! Tienes un descuento del 10% aplicado",
        descuento: PROMO_DISCOUNT_RATE,
        faltante: 0,
        totalBase,
      };
    }

    const faltanteCalculado = Math.max(PROMO_THRESHOLD - totalBase, 0);
    const faltanteServidor = valorServidor < 0 ? Math.abs(valorServidor) : 0;
    const faltante = tieneTotalCalculado ? faltanteCalculado : faltanteServidor;

    if (faltante > 0) {
      return {
        mensaje: `Te faltan $${Math.round(faltante).toLocaleString("es-MX")} para obtener tu descuento`,
        descuento: 0,
        faltante,
        totalBase,
      };
    }

    return { mensaje: "No aplica promoción", descuento: 0, faltante: 0 };
  };

  const [ofertaPlan, setOfertaPlan] = useState(null);

  useEffect(() => {
    if (vehicleData?.planesFinanciamiento) {
      const planSeleccionado = vehicleData.planesFinanciamiento.find(
        (plan) => plan.isSelected && !esPlanClienteFinanciamiento(plan),
      );

      if (planSeleccionado && planSeleccionado.accessories.length < 2) {
        setOfertaPlan(planSeleccionado);
        // setShowOferta(true);
      }
    }
  }, [vehicleData]);

  useEffect(() => {
    //aqui essss
    // 1) Resolver folio: URL > sessionStorage
    let folio = resolveFolioVenta();

    // 2) Si no hay, generamos uno nuevo
    if (!folio) {
      folio = Math.random().toString(36).substring(2, 15).toUpperCase();
      sessionStorage.setItem("folio_venta", folio);

      // (Opcional) reflejarlo en la URL actual
      const url = new URL(window.location.href);
      url.searchParams.set("folio_venta", folio);
      window.history.replaceState({}, "", url);
    } else {
      // Asegura persistencia si vino por URL
      sessionStorage.setItem("folio_venta", folio);
    }

    // 3) Propagar a estado
    setFolioVenta(folio);

    // 4) Crear venta inicial solo si aún no existe para este folio
    /*if (!isVentaInicialCreada(folio)) {
      generarVentaInicialConFolio(folio);
    }*/
  }, []);

  // Guarda order_cart
  useEffect(() => {
    const folio = resolveFolioVenta();
    if (!folio) return;

    // cache local
    try {
      localStorage.setItem(
        getCartStorageKey(),
        JSON.stringify(orderData || []),
      );
    } catch {}

    // evitar primer disparo al cargar
    if (firstCartSyncRef.current) {
      firstCartSyncRef.current = false;
      return;
    }

    // solo sincronizar si ya existe la venta inicial
    if (!ventaCreadaRef.current) return;

    guardarOrderCartEnBackend();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderData]);

  useEffect(() => {
    isVideoOpenRef.current = mostrarVideoIntro;
  }, [mostrarVideoIntro]);

  // Si cambias de folio, resetea el “último valor” para volver a detectar el flanco
  useEffect(() => {
    lastAccModalRef.current = null;
  }, [folioVenta]);
  const [activeIndex, setActiveIndex] = useState(0);
  const precioDesde =
    selectedCar?.price ?? Number(vehicleData?.precio_vehiculo ?? 0);

  //manejo de pdf adjunto trabajandooo
  //Efecto para monitorear y resetear el carrusel cuando cambie la lista
  useEffect(() => {
    const carouselEl = document.getElementById("pdfCarousel");
    if (carouselEl && pdfUrlsGeneradas.length > 0) {
      // Si el indice activo qued fuera lo reseteamos a 0
      if (activeIndex >= pdfUrlsGeneradas.length) {
        setActiveIndex(0);
      }
      // Forzamos reconocer que el modal sigue vivo
      const items = carouselEl.querySelectorAll(".carousel-item");
      if (items.length > 0 && !carouselEl.querySelector(".active")) {
        items[0].classList.add("active");
      }
    }
  }, [pdfUrlsGeneradas, activeIndex]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file && file.type === "application/pdf") {
      const localPdfUrl = URL.createObjectURL(file);
      const newId = Date.now();

      setPdfUrlsGeneradas((prev) => {
        const newList = [
          ...prev,
          {
            url: localPdfUrl,
            nombre: file.name,
            esAdjunto: true,
            id: newId,
          },
        ];
        return newList;
      });

      e.target.value = "";

      Swal.fire({
        title: "Adjuntado",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });
    }
  };

  const handleRemoveFile = (indexToRemove) => {
    //eliminar archivos
    const nuevasUrls = pdfUrlsGeneradas.filter(
      (_, index) => index !== indexToRemove,
    );

    // reseteamos el índice a 0 siempre que borramos
    setPdfUrlsGeneradas(nuevasUrls);
    setActiveIndex(0);

    Swal.fire({
      title: "Eliminado",
      icon: "success",
      timer: 800,
      showConfirmButton: false,
    });
  };

  const recuperarArchivoDeUrl = async (url, nombre) => {
    //funcion auxiliar para convertir de url a pdf
    const response = await fetch(url);
    const data = await response.blob();
    return new File([data], nombre, { type: "application/pdf" });
  };

  const CHASIS_IMG =
    "https://www.nissanframework.com/resourcefiles/g-vehicle-detail-versions-images/versiones-np300-chasis-tm-ac-nissan-np300-nissan-np300.jpg";

  const [tieneGarantiaExtendida, setTieneGarantiaExtendida] = useState(false);

  const getVersionImage = (selectedVersion, selectedMailData) => {
    const text = (selectedVersion || "").toString().trim().toUpperCase();

    const isChasis = text.includes("CHASIS TM AC VDC '26");

    if (isChasis) return CHASIS_IMG;

    return selectedMailData?.url_img || "/assets/img/product/noimage.png";
  };

  const formatName = (name = "") =>
    name
      .toLowerCase()
      .replace(/(^\p{L}|\s\p{L})/gu, (char) => char.toUpperCase());

  // Limpia "Ma", "MA", "Ma.", "M.A." SOLO si viene al inicio
  const cleanName = (name = "") =>
    name
      .trim()
      .replace(/^(ma|m\.a\.|ma\.)\s+/i, "")
      .trim();

  const asesoresOrdenados = [...asesores].sort((a, b) => {
    const an = cleanName(a?.nombre ?? "");
    const bn = cleanName(b?.nombre ?? "");
    return an.localeCompare(bn, "es", { sensitivity: "base" });
  });

  // borrar
  // const [puedeOmitir, setPuedeOmitir] = useState(false);

  // useEffect(() => {
  //   if (!mostrarVideoIntro) return;

  //   setPuedeOmitir(false);
  //   const t = setTimeout(() => setPuedeOmitir(true), 10000); // 10s

  //   return () => clearTimeout(t);
  // }, [mostrarVideoIntro]);
  //Hasta aqui

  useEffect(() => {
    if (selectedCar) setIsAccessoryModalOpen(false);
  }, [selectedCar]);

  const obtenerDatosCobertura = (tipo) => {
    const base = {
      // pFabrica: % que ocupa la de fábrica (verde)
      // pExtendida: % que se añade con el switch (amarillo)
      Motor: {
        pFabrica: 45,
        pExtendida: 40,
        texto: "3 AÑOS / 60,000 KM",
        extendido: "Hasta 3 AÑOS / 125,000 KM",
      },
      Transmisión: {
        pFabrica: 45,
        pExtendida: 40,
        texto: "3 AÑOS / 60,000 KM",
        extendido: "Hasta 3 AÑOS / 125,000 KM",
      },
      Dirección: {
        pFabrica: 45,
        pExtendida: 40,
        texto: "3 AÑOS / 60,000 KM",
        extendido: "Hasta 3 AÑOS / 125,000 KM",
      },
      Frenos: {
        pFabrica: 45,
        pExtendida: 40,
        texto: "3 AÑOS / 60,000 KM",
        extendido: "Hasta 3 AÑOS / 125,000 KM",
      },
      Suspensión: {
        pFabrica: 45,
        pExtendida: 40,
        texto: "3 AÑOS / 60,000 KM",
        extendido: "Hasta 3 AÑOS / 125,000 KM",
      },
      "Sistema Eléctrico": {
        pFabrica: 45,
        pExtendida: 40,
        texto: "3 AÑOS / 60,000 KM",
        extendido: "Hasta 3 AÑOS / 125,000 KM",
      },
      "Sistema de Enfriamiento": {
        pFabrica: 45,
        pExtendida: 40,
        texto: "3 AÑOS / 60,000 KM",
        extendido: "Hasta 3 AÑOS / 125,000 KM",
      },
      "Sistema de Combustible": {
        pFabrica: 45,
        pExtendida: 40,
        texto: "3 AÑOS / 60,000 KM",
        extendido: "Hasta 3 AÑOS / 125,000 KM",
      },
      "Aire Acondicionado": {
        pFabrica: 45,
        pExtendida: 30,
        texto: "3 AÑOS / 60,000 KM",
        extendido: "Según Plan",
      },
      "Sistema Multimedia": {
        pFabrica: 0,
        pExtendida: 80,
        texto: "No incluido",
        extendido: "¡Protegido!",
      },
      "Asistencia Vial": {
        pFabrica: 0,
        pExtendida: 100,
        texto: "No incluida",
        extendido: "24/7 Activado",
      },
    };
    return (
      base[tipo] || { pFabrica: 0, pExtendida: 0, texto: "", extendido: "" }
    );
  };

  const WarrantyItem = ({
    icon,
    titulo,
    descripcion,
    tieneGarantiaExtendida,
  }) => {
    const data = obtenerDatosCobertura(titulo);

    // Colores personalizados
    const verdeVivo = "#2ecc71"; // Un verde más vibrante
    const rojoSuave = "#e74c3c"; // Un rojo que indica "pendiente" o "riesgo"

    return (
      <div className="row align-items-center mb-4 gy-2">
        <div className="col-md-6 d-flex">
          <span
            className="warranty-icon me-3"
            style={{ fontSize: "1.4rem", color: "#fff" }}
          >
            <i className={icon}></i>
          </span>
          <div>
            <h5 className="fw-bold mb-0" style={{ fontSize: "1.05rem" }}>
              {titulo}
            </h5>
            <p className="mb-0 text-muted" style={{ fontSize: "0.85rem" }}>
              {descripcion}
            </p>
          </div>
        </div>

        <div className="col-md-6">
          <div
            className="progress"
            style={{
              height: "32px", // Barra más gruesa
              backgroundColor: "#f0f0f0",
              borderRadius: "8px", // Bordes un poco más redondeados para look moderno
              overflow: "hidden",
              boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
            }}
          >
            {/* SECCIÓN 1: FÁBRICA (Siempre verde vivo) */}
            {data.pFabrica > 0 && (
              <div
                className="progress-bar"
                style={{
                  color: "#FFF",
                  width: `${data.pFabrica}%`,
                  backgroundColor: verdeVivo,
                  borderRight: "2px solid rgba(255,255,255,0.3)",
                  transition: "0.5s ease",
                }}
              >
                <small className="fw-bold">Fábrica</small>
              </div>
            )}

            {/* SECCIÓN 2: EL RESTO (Cambia de Rojo a Verde según el switch) */}
            <div
              className="progress-bar"
              style={{
                // Calculamos el resto para que siempre llene la barra (100 - pFabrica)
                width: `${100 - data.pFabrica}%`,
                backgroundColor: tieneGarantiaExtendida ? verdeVivo : rojoSuave,
                color: "#fff",
                transition: "all 0.6s cubic-bezier(0.4, 0, 0.2, 1)", // Animación más fluida
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <small
                className="fw-bold text-uppercase"
                style={{ letterSpacing: "1px" }}
              >
                {tieneGarantiaExtendida ? "Protección Total" : "Sin Cobertura"}
              </small>
            </div>
          </div>

          {/* Texto informativo debajo de la barra */}
          <div
            className="d-flex justify-content-between mt-2"
            style={{ fontSize: "0.75rem" }}
          >
            <span className="fw-bold text-success">
              {data.pFabrica > 0 ? `INICIAL: ${data.texto}` : "SIN BASE"}
            </span>
            <span
              className={`fw-bold transition-all ${
                tieneGarantiaExtendida ? "text-success" : "text-danger"
              }`}
            >
              {tieneGarantiaExtendida
                ? `COMPLETA: ${data.extendido}`
                : "REQUIERE ACTIVACIÓN"}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const ventaCreadaRef = useRef(false);
  const firstCartSyncRef = useRef(true);

  const tipoAutoParaModal = selectedMailData?.tipo_auto?.toLowerCase() || "";
  const esSeminuevoParaModal = tipoAutoParaModal.includes("seminuevo");

  const videoRef = useRef(null);
  const [esIOS, setEsIOS] = useState(false);
  const [mostrarBotonPlay, setMostrarBotonPlay] = useState(false);
  const [puedeOmitir, setPuedeOmitir] = useState(false);
  const [videoIniciado, setVideoIniciado] = useState(false);
  const [videoActualIndex, setVideoActualIndex] = useState(0);

  useEffect(() => {
    const isiPadOrIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

    setEsIOS(isiPadOrIOS);
  }, []);

  const tipoAutoVideos = selectedMailData?.tipo_auto?.toLowerCase() || "";
  const esSeminuevo = tipoAutoVideos.includes("seminuevo");

  const videosIntro = esSeminuevo
    ? [
        "/assets/vid/nissanv3.mp4",
        "/assets/vid/nissanv4.mp4",
        "/assets/vid/nissanv5.mp4",
      ]
    : ["/assets/vid/nissanv3.mp4", "/assets/vid/nissanv4.mp4"];

  const videoActual = videosIntro[videoActualIndex] || null;

  useEffect(() => {
    if (mostrarVideoIntro) {
      setPuedeOmitir(false);
      setVideoIniciado(false);
      setMostrarBotonPlay(true);
      setVideoActualIndex(0);
    }
  }, [mostrarVideoIntro, tipoAuto]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video || !mostrarVideoIntro || !videoActual) return;

    video.pause();
    video.load();
    video.currentTime = 0;
    video.muted = false;
    video.playsInline = true;

    setMostrarBotonPlay(true);
    setVideoIniciado(false);
  }, [mostrarVideoIntro, videoActual]);

  useEffect(() => {
    if (!mostrarVideoIntro) return;

    setPuedeOmitir(false);

    const t = setTimeout(() => {
      setPuedeOmitir(true);
    }, 10000);

    return () => clearTimeout(t);
  }, [mostrarVideoIntro]);

  const reproducirManual = async () => {
    try {
      const video = videoRef.current;
      if (!video) return;

      video.muted = false;
      video.playsInline = true;
      video.currentTime = 0;

      await video.play();

      setMostrarBotonPlay(false);
      setVideoIniciado(true);
    } catch (error) {
      console.error("No se pudo reproducir manualmente:", error);
      setMostrarBotonPlay(true);
    }
  };

  const handleVideoEnded = () => {
    const ultimoVideo = videoActualIndex >= videosIntro.length - 1;

    if (ultimoVideo) {
      setMostrarVideoIntro(false);
      cerrarGaleriaFotosSeminuevo();
      setMostrarModalAccesorios(true);
    } else {
      setVideoIniciado(false);
      setVideoActualIndex((prev) => prev + 1);
      setMostrarBotonPlay(true);
    }
  };

  useEffect(() => {
    const folio = resolveFolioVenta();
    if (!folio) return;

    try {
      localStorage.setItem(
        `orderCart_${folio}`,
        JSON.stringify(orderData || []),
      );
    } catch {}
  }, [orderData, folioVenta]);

  useEffect(() => {
    const folio = resolveFolioVenta();
    if (!folio) return;

    try {
      const savedCart = localStorage.getItem(`orderCart_${folio}`);
      if (!savedCart) return;

      const parsed = JSON.parse(savedCart);
      if (Array.isArray(parsed)) {
        setOrderData(parsed);
      }
    } catch (error) {
      console.error("Error al recuperar carrito:", error);
    }
  }, []);

  const subirPdfAdjuntoABD = async (file) => {
    try {
      const folio =
        selectedMailData?.folio_venta ||
        selectedMailData?.folio ||
        formData?.venta_id ||
        "S/F";

      const fd = new FormData();

      fd.append("access_token", "ktreughty765tryugh");
      fd.append("folio_venta", folio);
      fd.append("pdf", file);

      const resp = await fetch(
        "https://api.checkmark.mx/ventas/guardar-pdf-adjunto",
        {
          method: "POST",
          body: fd,
        },
      );

      let result = {};
      try {
        result = await resp.json();
      } catch (e) {}

      if (result?.statusCode !== 200) {
        console.error("No se pudo guardar el PDF:", result);
        return false;
      }

      return true;
    } catch (error) {
      console.error("Error al subir PDF adjunto:", error);
      return false;
    }
  };

  return (
    <>
      {mostrarModalPruebaManejoCliente &&
        typeof document !== "undefined" &&
        createPortal(
          <div
            role="presentation"
            style={{
              position: "fixed",
              inset: 0,
              zIndex: 2147483000,
              backgroundColor: "rgba(0,0,0,.72)",
              backdropFilter: "blur(2px)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "18px",
              pointerEvents: "auto",
            }}
          >
            <div
              role="dialog"
              aria-modal="true"
              aria-labelledby="encuestaPruebaManejoTitulo"
              style={{
                width: "min(880px, calc(100vw - 28px))",
                maxHeight: "calc(100vh - 28px)",
                background: "#fff",
                borderRadius: 22,
                overflow: "hidden",
                boxShadow: "0 24px 90px rgba(0,0,0,.48)",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                className="border-0"
                style={{
                  background:
                    "linear-gradient(135deg, #003b71 0%, #0d6efd 100%)",
                  color: "#fff",
                  padding: "20px 24px",
                }}
              >
                <h5 id="encuestaPruebaManejoTitulo" className="mb-1 fw-bold">
                  Encuesta de prueba de manejo
                </h5>
                <small style={{ opacity: 0.9 }}>
                  Selecciona una calificación para cada pregunta. La aceptación
                  ya quedó registrada para que el asesor pueda cargar la
                  licencia.
                </small>
              </div>

              <div
                style={{
                  maxHeight: "68vh",
                  overflowY: "auto",
                  padding: "22px 24px",
                  background: "#f4f7fb",
                  flex: "1 1 auto",
                }}
              >
                {preguntasPruebaManejoCliente.map((item, index) => {
                  const selectedValue = String(
                    pruebaManejoClienteData?.respuestas?.[item.key] || "",
                  );

                  return (
                    <div
                      key={item.key}
                      className="mb-3"
                      style={{
                        background: "#fff",
                        border: "1px solid rgba(0,0,0,.08)",
                        borderRadius: 16,
                        padding: "18px 18px 16px",
                        boxShadow: "0 8px 20px rgba(0,0,0,.05)",
                      }}
                    >
                      <div className="d-flex align-items-start gap-3 mb-3">
                        <div
                          style={{
                            minWidth: 34,
                            height: 34,
                            borderRadius: "50%",
                            background: "#003b71",
                            color: "#fff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontWeight: 700,
                            fontSize: 14,
                          }}
                        >
                          {index + 1}
                        </div>
                        <div>
                          <div
                            className="fw-bold text-dark"
                            style={{ lineHeight: 1.35 }}
                          >
                            {item.pregunta}
                          </div>
                          <div className="small text-muted mt-1">
                            Escala del 1 al {item.escala}
                          </div>
                        </div>
                      </div>

                      <div className="d-flex flex-wrap gap-2 ps-md-5">
                        {Array.from({ length: item.escala }, (_, i) => {
                          const value = String(i + 1);
                          const isActive = selectedValue === value;

                          return (
                            <button
                              key={value}
                              type="button"
                              onClick={() =>
                                updatePruebaManejoClienteRespuesta(
                                  item.key,
                                  value,
                                )
                              }
                              disabled={isSavingPruebaManejoCliente}
                              aria-pressed={isActive}
                              style={{
                                width: item.escala === 10 ? 42 : 48,
                                height: 42,
                                borderRadius: 12,
                                border: isActive
                                  ? "1px solid #003b71"
                                  : "1px solid #cbd5e1",
                                background: isActive ? "#003b71" : "#fff",
                                color: isActive ? "#fff" : "#334155",
                                fontWeight: 700,
                                boxShadow: isActive
                                  ? "0 8px 18px rgba(0,59,113,.28)"
                                  : "none",
                                cursor: isSavingPruebaManejoCliente
                                  ? "not-allowed"
                                  : "pointer",
                                transition: "all .15s ease",
                              }}
                            >
                              {value}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </div>

              <div
                className="d-flex justify-content-between flex-wrap gap-2"
                style={{ background: "#fff", padding: "16px 24px" }}
              >
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() =>
                    guardarRespuestaPruebaManejoCliente("No", {
                      ...pruebaManejoClienteInicial,
                      realizo_prueba_manejo: "No",
                    })
                  }
                  disabled={isSavingPruebaManejoCliente}
                >
                  No realizar prueba
                </button>

                <button
                  type="button"
                  className="btn btn-primary px-4"
                  onClick={guardarEncuestaPruebaManejoCliente}
                  disabled={isSavingPruebaManejoCliente}
                  style={{ backgroundColor: "#003b71", borderColor: "#003b71" }}
                >
                  {isSavingPruebaManejoCliente
                    ? "Guardando..."
                    : "Guardar encuesta"}
                </button>
              </div>
            </div>
          </div>,
          document.body,
        )}

      {/* Modal de Bienvenida */}
      <div
        id="bienvenidaModal"
        className="modal fade"
        tabIndex="-1"
        aria-labelledby="bienvenidaTitulo"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content text-center">
            <div className="modal-body">
              <div className="mb-3">
                <i className="bi bi-emoji-smile"></i>
              </div>
              <h5 className="modal-title" id="bienvenidaTitulo">
                ¡Estamos encantados de tenerte con nosotros!
              </h5>
              <p id="bienvenidaMensaje">
                Estamos encantados de tenerte con nosotros.
              </p>
              <button
                type="button"
                className="btn btn-success"
                onClick={() => hideModalSafe("bienvenidaModal")} //  cierre explícito
              >
                Comenzar
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal de Aviso de Privacidad */}
      <div
        className="modal fade"
        id="avisoPrivacidadModal"
        tabIndex="-1"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Aviso de Privacidad</h5>
            </div>
            <div className="modal-body text-white">
              <p>
                Este sistema utiliza información personal para brindar un mejor
                servicio. Al continuar, acepta nuestro aviso de privacidad.
              </p>

              {/* Enlace para ver el PDF */}
              <p>
                <a
                  href="/simulacion_aviso.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-link text-info p-0"
                >
                  Ver aviso de privacidad completo
                </a>
              </p>

              <div className="form-check mt-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="aceptoPrivacidad"
                />
                <label className="form-check-label" htmlFor="aceptoPrivacidad">
                  He leído y acepto el aviso de privacidad.
                </label>
              </div>
            </div>
            <div className="modal-footer">
              <button
                id="btnContinuarPrivacidad"
                className="btn btn-primary"
                disabled
              >
                Continuar
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal - Formulario, aqui ess*/}
      <div
        className="modal fade"
        id="formularioModal"
        tabIndex="-1"
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title new-font">Información personal</h5>
            </div>
            <div className="modal-body">
              {mostrarSelectAgencia && agenciasDisponibles.length > 1 && (
                <div className="mb-3">
                  <label htmlFor="agenciaVenta" className="new-font form-label">
                    Agencia
                  </label>
                  <select
                    id="agenciaVenta"
                    className="new-font form-select"
                    value={agenciaActual.ag_id || ""}
                    onChange={handleSeleccionAgencia}
                  >
                    <option value="">Selecciona una agencia</option>
                    {agenciasDisponibles.map((agencia) => (
                      <option key={agencia.ag_id} value={agencia.ag_id}>
                        {agencia.nombre}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              <div className="mb-3">
                <label htmlFor="nombre" className="new-font form-label">
                  Nombre
                </label>
                <input
                  type="text"
                  id="nombre"
                  className="new-font form-control"
                  placeholder="Ej. Juan Pérez"
                />
              </div>
              <div className="row g-3 mb-3">
                <div className="col-md-6">
                  <label htmlFor="apellidoPaterno" className="new-font form-label">
                    Apellido paterno (opcional)
                  </label>
                  <input
                    type="text"
                    id="apellidoPaterno"
                    className="new-font form-control"
                    placeholder="Ej. Pérez"
                  />
                </div>
                <div className="col-md-6">
                  <label htmlFor="apellidoMaterno" className="new-font form-label">
                    Apellido materno (opcional)
                  </label>
                  <input
                    type="text"
                    id="apellidoMaterno"
                    className="new-font form-control"
                    placeholder="Ej. López"
                  />
                </div>
              </div>
              <div className="mb-3">
                <label htmlFor="telefono" className="new-font form-label">
                  Número de teléfono
                </label>
                <input
                  type="tel"
                  id="telefono"
                  className="new-font form-control"
                  placeholder="Ej. 5551234567"
                />
              </div>
              <div className="mb-3">
                <label htmlFor="correo" className="form-label new-font">
                  Correo electrónico
                </label>
                <input
                  type="email"
                  id="correo"
                  className="new-font form-control"
                  placeholder="Ej. juan@example.com"
                />
              </div>

              <div className="mb-3">
                <label htmlFor="asesor" className="new-font form-label">
                  Asesores
                </label>
                <select
                  id="asesor"
                  className="new-font form-select"
                  disabled={!agenciaActual.ag_id}
                >
                  <option value="">
                    {agenciaActual.ag_id
                      ? "Selecciona a tu asesor"
                      : "Primero selecciona una agencia"}
                  </option>

                  {asesoresOrdenados.map((asesor) => (
                    <option key={asesor.id} value={asesor.id}>
                      {formatName(cleanName(asesor.nombre))}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mb-3">
                <label className="new-font form-label d-block">
                  ¿Qué tipo de auto buscas?
                </label>

                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="tipoAuto"
                    id="autoNuevo"
                    value="nuevos"
                    checked={tipoAuto === "nuevos"}
                    onChange={(e) => handleTipoAutoChange(e.target.value)}
                  />
                  <label
                    className="form-check-label new-font"
                    htmlFor="autoNuevo"
                  >
                    Nuevo
                  </label>
                </div>

                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="tipoAuto"
                    id="autoSeminuevo"
                    value="seminuevos"
                    checked={tipoAuto === "seminuevos"}
                    onChange={(e) => handleTipoAutoChange(e.target.value)}
                  />
                  <label
                    className="form-check-label new-font"
                    htmlFor="autoSeminuevo"
                  >
                    Seminuevo
                  </label>
                </div>
              </div>
              <div className="mb-3">
                <label htmlFor="metodoContacto" className="new-font form-label">
                  ¿Cómo te enteraste de nosotros?
                </label>
                <select id="metodoContacto" className="new-font form-select">
                  <option value="">Selecciona una opción</option>
                  <option value="Redes sociales">Redes sociales</option>
                  <option value="Punto de venta">Punto de venta</option>
                  <option value="Carabana">Carabana</option>
                  <option value="Volanteo">Volanteo</option>
                  <option value="Recomendación">Recomendación</option>
                  <option value="Publicidad en la calle">
                    Publicidad en la calle
                  </option>
                </select>
              </div>
              <div className="mb-3">
                <label htmlFor="origenCliente" className="new-font form-label">
                  Origen del Cliente
                </label>
                <select id="origenCliente" className="new-font form-select">
                  <option value="">Selecciona el origen</option>
                  <option value="Cartera">Cartera</option>
                  <option value="Piso">Piso</option>
                  <option value="Digital">Digital</option>
                  <option value="Calle">Calle</option>
                </select>
              </div>
            </div>
            <div className="modal-footer">
              <button
                id="btnEnviarFormulario"
                className="new-font btn btn-lg btn-success"
                disabled
              >
                Enviar
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        className={
          "pos pos-with-menu pos-with-sidebar" +
          (posMobileSidebarToggled ? "pos-mobile-sidebar-toggled" : "")
        }
        id="pos"
      >
        <div className="pos-container">
          <div className="pos-menu">
            <div className="logo">
              <Link
                to="/analytics"
                // to={selectedCar ? "#" : "/analytics"}
                // onClick={(e) => selectedCar && e.preventDefault()}
                // className={selectedCar ? "pointer-events-none opacity-50" : ""}
              >
                <div className="logo-img">
                  <Icon
                    icon="material-symbols-light:home"
                    className="fs-50px text-white"
                  />
                </div>
                <div className="logo-text new-font-14">INICIO</div>
              </Link>
            </div>

            <div className="nav-container">
              <PerfectScrollbar className="h-100">
                <ul className="nav nav-tabs">
                  {Array.isArray(tableData?.category)
                    ? tableData.category
                        .filter((category) => {
                          if (
                            category.type === "garantias" ||
                            category.type === "accesorios"
                          ) {
                            return false;
                          }

                          // Ya contestado el formulario: el tipo de auto elegido manda.
                          if (formularioEnviado && tipoAutoSeleccionado) {
                            return category.type === tipoAutoSeleccionado;
                          }

                          return true;
                        })
                        .map((category, index) => (
                          <li className="nav-item" key={index}>
                            <a
                              className={
                                "nav-link new-font-12" +
                                (category.type === categoriaEfectivaCatalogo
                                  ? " active"
                                  : "") +
                                (formularioEnviado
                                  ? " opacity-50 pointer-events-none"
                                  : "") // Visualmente bloqueado
                              }
                              onClick={(event) => {
                                event.preventDefault(); // para evitar el salto al href
                                if (formularioEnviado) return; // Bloqueo de función
                                if (category.type === "accesorios") {
                                  cerrarGaleriaFotosSeminuevo();
                                  setMostrarModalAccesorios(true); //aqui abre el modal
                                } else {
                                  showType(event, category.type); // comportamiento normal
                                }
                              }}
                              href="#/"
                            >
                              <Icon icon={category.icon} className="nav-icon" />{" "}
                              {category.text}
                            </a>
                          </li>
                        ))
                    : null}
                </ul>
              </PerfectScrollbar>

              {categoriaEfectivaCatalogo === "nuevos" &&
                subTiposNuevos.length > 1 && (
                  <div className="px-2 py-2 border-top">
                    <div className="text-white-50 new-font-12 mb-2">
                      Tipo de auto
                    </div>

                    <div className="d-flex flex-column gap-2">
                      {subTiposNuevos.map((tab) => (
                        <button
                          key={tab.value}
                          type="button"
                          className={
                            "btn btn-sm text-start new-font-12 " +
                            (subTipoNuevo === tab.value
                              ? "btn-primary"
                              : "btn-outline-light")
                          }
                          onClick={() => setSubTipoNuevo(tab.value)}
                        >
                          {tab.label}
                        </button>
                      ))}
                    </div>
                  </div>
                )}
            </div>
          </div>

          <div className="pos-content">
            <PerfectScrollbar className="pos-content-container h-100">
              <div ref={planesRef} className="position-relative">
                {" "}
                {/* CANVAS */}
                {canvasActivo && (
                  <CanvasOverlay ref={canvasRef} containerRef={planesRef} />
                )}
                {/* Contenido con estado de carga */}
                {loading ? (
                  <div className="loader-data">
                    <Circles height="80" width="80" color="#4fa94d" />
                  </div>
                ) : initialLoad ? (
                  /* Mensaje inicial cuando no se ha seleccionado ninguna agencia */
                  <div className="text-center p-5">
                    <h4>Selecciona una agencia para ver su inventario</h4>
                    <p className="text-muted">
                      El inventario se cargará después de seleccionar una
                      agencia
                    </p>
                  </div>
                ) : selectedCar && !isReturningToInventory ? (
                  <div className="d-flex justify-content-center align-items-center p-4">
                    <div
                      className="card shadow-lg border-0"
                      style={{
                        maxWidth: "900px",
                        width: "100%",
                        borderRadius: "16px",
                        overflow: "visible",
                      }}
                    >
                      {/* Imagen principal con precio */}
                      <div className="position-relative">
                        <ZoomImage
                          key={`${selectedMailData?.id || ""}-${getVersionImage(selectedVersion, selectedMailData)}-${getSelectedCarRenderKey(selectedCar)}`}
                          src={getVersionImage(
                            selectedVersion,
                            selectedMailData,
                          )}
                          alt={selectedMailData?.modelo_vehiculo || "Vehículo"}
                          style={{ maxHeight: "480px", borderRadius: "8px" }}
                          zoom={2.5}
                        />

                        <span className="position-absolute text-price btn-zoom">
                          Desde: {toMoney(getPrecioDesde(selectedMailData))}
                        </span>

                        <button
                          className="position-absolute btn btn-success btn-sm btn-fichas"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            abrirPDF(); // ← manual: el usuario puede abrir cuando quiera
                          }}
                        >
                          Ficha Técnica
                        </button>
                      </div>

                      {/* Contenido principal */}
                      <div className="p-4">
                        <h3 className="fw-bold mb-1">
                          {selectedMailData?.marca_vehiculo || "N/A"}
                        </h3>
                        <p className="text-muted">
                          {selectedMailData?.modelo_vehiculo || "N/A"}
                        </p>

                        {/* El regreso al inventario ahora lo dispara el asesor.
                            Se oculta el botón al cliente para evitar acciones duplicadas. */}
                      </div>

                      {/* NUEVA SECCIÓN: Resumen y planes debajo */}
                      <div className="mt-2 p-4">
                        <div className="row">
                          <h5 className="fw-bold mb-3">RESUMEN</h5>
                          <div className="row">
                            <div className="col-md-6">
                              <ul className="list-group list-group-flush fs-6">
                                <li className="list-group-item">
                                  <i
                                    className="fas fa-car me-2"
                                    style={{ color: "#00e58e" }}
                                  />
                                  Marca:{" "}
                                  {selectedMailData?.marca_vehiculo || "N/A"}
                                </li>
                                <li className="list-group-item">
                                  <i
                                    className="fas fa-cube me-2"
                                    style={{ color: "#00e58e" }}
                                  />
                                  Modelo:{" "}
                                  {selectedMailData?.modelo_vehiculo || "N/A"}
                                </li>
                                <li className="list-group-item">
                                  <i
                                    className="fas fa-calendar me-2"
                                    style={{ color: "#00e58e" }}
                                  />
                                  Año: {selectedMailData?.ano_vehiculo || "N/A"}
                                </li>
                                <li className="list-group-item">
                                  <i
                                    className="fas fa-cogs me-2"
                                    style={{ color: "#00e58e" }}
                                  />
                                  Versión:{" "}
                                  {selectedMailData?.version_vehiculo || "N/A"}
                                </li>

                                {/* Mostrar agencia solo si tu lógica de "contado" lo pide */}
                                {String(
                                  selectedMailData?.depende_auto,
                                ).toLowerCase() === "no" && (
                                  <li className="list-group-item">
                                    <i
                                      className="fas fa-building me-2"
                                      style={{ color: "#00e58e" }}
                                    />
                                    Agencia:{" "}
                                    {selectedMailData?.agencia || "N/A"}
                                  </li>
                                )}

                                <li className="list-group-item">
                                  <i
                                    className="fas fa-info-circle me-2"
                                    style={{ color: "#00e58e" }}
                                  />
                                  *El precio total mostrado no incluye
                                  accesorios ni garantías adicionales.
                                </li>
                              </ul>
                            </div>

                            <div className="col-md-6">
                              <ul className="list-group list-group-flush fs-6">
                                {/* Rama CONTADO / CRÉDITO tomada del backend */}
                                {String(
                                  selectedMailData?.depende_auto,
                                ).toLowerCase() === "si" ? (
                                  <>
                                    <li className="list-group-item">
                                      <i
                                        className="fas fa-calendar-alt me-2"
                                        style={{ color: "#00e58e" }}
                                      />
                                      Meses:{" "}
                                      {selectedMailData?.meses_financiamiento >
                                      0
                                        ? `${selectedMailData.meses_financiamiento} meses`
                                        : "N/A"}
                                    </li>

                                    <li className="list-group-item">
                                      <i
                                        className="fas fa-dollar-sign me-2"
                                        style={{ color: "#00e58e" }}
                                      />
                                      Mensualidad:{" "}
                                      {selectedMailData?.mensualidad_estimacion
                                        ? toMoney(
                                            selectedMailData.mensualidad_estimacion,
                                          )
                                        : "N/A"}
                                    </li>

                                    <li className="list-group-item">
                                      <i
                                        className="fas fa-money-bill-wave me-2"
                                        style={{ color: "#00e58e" }}
                                      />
                                      Precio Total*:{" "}
                                      {toMoney(
                                        getPrecioDesde(selectedMailData),
                                      )}
                                    </li>

                                    <li className="list-group-item">
                                      <i
                                        className="fas fa-building me-2"
                                        style={{ color: "#00e58e" }}
                                      />
                                      Agencia:{" "}
                                      {selectedMailData?.agencia || "N/A"}
                                    </li>
                                  </>
                                ) : (
                                  <>
                                    <li className="list-group-item">
                                      <i
                                        className="fas fa-calendar-alt me-2"
                                        style={{ color: "#00e58e" }}
                                      />
                                      Meses:{" "}
                                      {selectedMailData?.meses_financiamiento >
                                      0
                                        ? `${selectedMailData.meses_financiamiento} meses`
                                        : "N/A"}
                                    </li>

                                    <li className="list-group-item">
                                      <i
                                        className="fas fa-dollar-sign me-2"
                                        style={{ color: "#00e58e" }}
                                      />
                                      Mensualidad:{" "}
                                      {selectedMailData?.mensualidad_estimacion
                                        ? toMoney(
                                            selectedMailData.mensualidad_estimacion,
                                          )
                                        : "N/A"}
                                    </li>

                                    <li className="list-group-item">
                                      <i
                                        className="fas fa-money-bill-wave me-2"
                                        style={{ color: "#00e58e" }}
                                      />
                                      Precio Total*:{" "}
                                      {toMoney(
                                        getPrecioDesde(selectedMailData),
                                      )}
                                    </li>

                                    <li className="list-group-item">
                                      <i
                                        className="fas fa-coins me-2"
                                        style={{ color: "#00e58e" }}
                                      />
                                      Enganche:{" "}
                                      {selectedMailData?.enganche
                                        ? toMoney(selectedMailData.enganche)
                                        : "N/A"}
                                    </li>

                                    <li className="list-group-item">
                                      <div className="col-md-6 mb-3 text-center">
                                        <label className="fw-bold">
                                          <i
                                            className="fas fa-percentage me-2"
                                            style={{ color: "#00e58e" }}
                                          />
                                          Porcentaje de Enganche:
                                        </label>
                                        <input
                                          type="range"
                                          className="form-range"
                                          min="0"
                                          max="100"
                                          value={Number(
                                            selectedMailData?.porcentaje_enganche ||
                                              0,
                                          )}
                                          readOnly
                                        />
                                        <span
                                          className="badge"
                                          style={{
                                            backgroundColor: "#00e58e",
                                            color: "#fff",
                                            fontSize: "0.65rem",
                                            padding: "0.35em 0.75em",
                                            borderRadius: "0.4rem",
                                          }}
                                        >
                                          {Number(
                                            selectedMailData?.porcentaje_enganche ||
                                              0,
                                          )}
                                          %
                                        </span>
                                      </div>
                                    </li>
                                  </>
                                )}
                              </ul>
                            </div>
                          </div>

                          {(() => {
                            const planesRaw =
                              parseMaybeJSON(
                                selectedMailData?.planes_financiamiento,
                              ) || [];
                            const planes = Array.isArray(planesRaw)
                              ? planesRaw.filter(
                                  (plan) => !esPlanClienteFinanciamiento(plan),
                                )
                              : [];
                            if (!planes.length) return null;

                            // ¿Hay al menos un plan marcado como seleccionado?
                            const isPlanSelected = (p) =>
                              p?.isSelected === true ||
                              p?.isSelected === "true" ||
                              p?.isSelected === 1 ||
                              p?.isSelected === "1";
                            const anySelected = planes.some(isPlanSelected);
                            if (!anySelected) return null;

                            // ===== Datos base =====
                            const isContado =
                              String(
                                selectedMailData?.depende_auto || "",
                              ).toLowerCase() === "si";

                            const precioVehiculo = Number(
                              selectedMailData?.precio_vehiculo ?? 0,
                            );

                            // Enganche “general” (para crédito)…
                            const enganchePctCredito = Number(
                              selectedMailData?.porcentaje_enganche ?? 0,
                            );
                            const engancheMontoCredito =
                              getEngancheMontoCreditoCotizacion(
                                selectedMailData,
                                precioVehiculo,
                              );
                            // …y enganche para adicionales (contado); si no viene, 0.
                            const enganchePctAdic = Number(
                              selectedMailData?.porcentaje_enganche_adicionales ??
                                0,
                            );

                            // Tasa anual -> mensual
                            const tasaAnual = TASA_ANUAL_FINANCIAMIENTO;
                            const i =
                              (tasaAnual > 1 ? tasaAnual / 100 : tasaAnual) /
                              12;

                            const mesesDefault = Number(
                              selectedMailData?.meses_financiamiento || 36,
                            );
                            const cashMonths = [3, 6, 9];
                            const safeMesesDefault = isContado
                              ? cashMonths.includes(mesesDefault)
                                ? mesesDefault
                                : 3
                              : mesesDefault;

                            const toMoney = (n) =>
                              new Intl.NumberFormat("es-MX", {
                                style: "currency",
                                currency: "MXN",
                                maximumFractionDigits: 0,
                              }).format(Number(n || 0));

                            // PMT estándar con enganche fijo de la venta.
                            // Esto evita que al seleccionar un plan cambie la mensualidad
                            // porque el backend haya recalculado el porcentaje sobre el total.
                            const calcMensualidad = (
                              total,
                              meses,
                              engancheMonto,
                              isMSI,
                            ) =>
                              calcularMensualidadFinanciamientoCotizacion({
                                total,
                                meses,
                                engancheMonto,
                                tasaAnual,
                                isMSI,
                              });

                            return (
                              <div className="col-12 mt-5">
                                <h5 className="fw-bold mb-3">PLANES</h5>
                                <div className="row">
                                  {planes.map((plan, index) => {
                                    const totalAccesorios =
                                      getPlanTotalCotizacion(plan);

                                    // === BASE a financiar según modalidad ===
                                    // - CRÉDITO: vehículo + accesorios, enganche de crédito
                                    // - CONTADO: sólo accesorios, vehículo es 100% contado; usar enganche de adicionales (o 0%)
                                    const baseCredito = Math.max(
                                      precioVehiculo + totalAccesorios,
                                      0,
                                    );
                                    const baseContado = Math.max(
                                      totalAccesorios,
                                      0,
                                    );

                                    const base = isContado
                                      ? baseContado
                                      : baseCredito;
                                    const engancheMontoPlan = isContado
                                      ? 0
                                      : engancheMontoCredito;

                                    // Mensualidades
                                    const mensualidadSel = calcMensualidad(
                                      base,
                                      safeMesesDefault,
                                      engancheMontoPlan,
                                      isContado,
                                    );

                                    // En contado NO tiene sentido 36/48 (porque MSI solo 3/6/9)
                                    // entonces puedes ponerlos en 0 o calcular simple si quisieras.
                                    // Yo recomiendo ocultarlos, así:
                                    const mensualidad36 = isContado
                                      ? 0
                                      : calcMensualidad(
                                          base,
                                          36,
                                          engancheMontoPlan,
                                          false,
                                        );
                                    const mensualidad48 = isContado
                                      ? 0
                                      : calcMensualidad(
                                          base,
                                          48,
                                          engancheMontoPlan,
                                          false,
                                        );

                                    return (
                                      <div
                                        className="col-md-6 mb-4"
                                        key={index}
                                      >
                                        <div
                                          className={`card card-plans shadow-sm text-white ${
                                            isPlanSelected(plan)
                                              ? "border border-3 border-success bg-dark bg-opacity-75"
                                              : "bg-dark bg-opacity-50"
                                          }`}
                                        >
                                          <div
                                            className="card-body text-center"
                                            style={{
                                              overflow: "visible",
                                              position: "relative",
                                            }}
                                          >
                                            <h5 className="card-title text-uppercase mb-3">
                                              {plan?.title || "Plan"}
                                            </h5>
                                            <h6 className="card-subtitle mb-2 text-muted">
                                              Accesorios incluidos:
                                            </h6>

                                            {Array.isArray(plan?.accessories) &&
                                            plan.accessories.length > 0 ? (
                                              <div className="accessories-wrapper position-relative d-flex flex-wrap justify-content-center mt-2">
                                                {plan.accessories.map(
                                                  (acc, iAcc) => (
                                                    <span
                                                      key={iAcc}
                                                      className="badge text-dark m-1 custom-tooltip"
                                                      style={{
                                                        backgroundColor:
                                                          "rgba(5, 236, 248, 0.79)",
                                                        color: "white",
                                                        borderRadius: "8px",
                                                        padding: "5px 10px",
                                                        margin: "5px",
                                                        boxShadow:
                                                          "rgba(0, 0, 0, 0.1) 0px 2px 6px",
                                                        cursor: "pointer",
                                                        position: "relative",
                                                        display: "inline-block",
                                                      }}
                                                    >
                                                      {toTitleCase(
                                                        (
                                                          acc?.title || ""
                                                        ).split(" - ")[0],
                                                      )}
                                                      {acc?.description && (
                                                        <span className="tooltip-centered">
                                                          {acc.description}
                                                        </span>
                                                      )}
                                                    </span>
                                                  ),
                                                )}
                                              </div>
                                            ) : (
                                              <p className="text-muted">
                                                No se han seleccionado
                                                accesorios.
                                              </p>
                                            )}

                                            {/* Totales y mensualidades */}
                                            <div
                                              className="mt-3"
                                              style={{ fontSize: "0.9rem" }}
                                            >
                                              {safeMesesDefault ? (
                                                <div className="mt-1">
                                                  {safeMesesDefault} meses /{" "}
                                                  <strong>
                                                    {toMoney(mensualidadSel)}
                                                  </strong>{" "}
                                                  Mensual
                                                </div>
                                              ) : (
                                                <div className="mt-1 text-muted">
                                                  Sin plazo configurado en la
                                                  venta
                                                </div>
                                              )}

                                              {!isContado && (
                                                <div
                                                  className="mt-2"
                                                  style={{ fontSize: "0.8rem" }}
                                                >
                                                  <div>
                                                    36 meses /{" "}
                                                    {toMoney(mensualidad36)}{" "}
                                                    Mensual
                                                  </div>
                                                  <div>
                                                    48 meses /{" "}
                                                    {toMoney(mensualidad48)}{" "}
                                                    Mensual
                                                  </div>
                                                </div>
                                              )}
                                            </div>

                                            {/* Promo (si aplica) */}
                                            {typeof obtenerPromocion ===
                                              "function" && (
                                              <div
                                                className="mt-3 promotion-box"
                                                style={{ fontSize: "0.9rem" }}
                                              >
                                                {obtenerPromocion(
                                                  plan,
                                                  selectedMailData,
                                                )?.mensaje || ""}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            );
                          })()}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    {/*buscador */}
                    <div className="sticky-search row mb-3">
                      <div className="col-12">
                        <div className="search-box position-relative">
                          <input
                            type="text"
                            className="form-control border-0 fs-5 pe-5"
                            placeholder="Buscar vehículo…"
                            value={searchVehicle}
                            onChange={(e) => setsearchVehicle(e.target.value)}
                          />

                          {/*botn ✕ para limpiar */}
                          {searchVehicle && (
                            <button
                              type="button"
                              className="btn search-clear-btn"
                              onClick={() => setsearchVehicle("")}
                              aria-label="Limpiar búsqueda"
                            >
                              &times;
                            </button>
                          )}
                        </div>
                      </div>
                    </div>

                    {categoriaEfectivaCatalogo === "nuevos" &&
                      subTiposNuevos.length > 1 && (
                        <div className="mb-3">
                          <div className="d-flex align-items-center gap-2 flex-wrap">
                            <span className="text-muted new-font-12 me-1">
                              Tipo de auto:
                            </span>

                            {subTiposNuevos.map((tab) => (
                              <button
                                key={tab.value}
                                type="button"
                                className={
                                  "btn btn-sm rounded-pill px-3 " +
                                  (subTipoNuevo === tab.value
                                    ? "btn-primary"
                                    : "btn-outline-primary")
                                }
                                onClick={() => setSubTipoNuevo(tab.value)}
                              >
                                {tab.label}
                              </button>
                            ))}
                          </div>
                        </div>
                      )}

                    <div className="row g-3">
                      {tableData && tableData.food ? (
                        (() => {
                          const normalize = (str = "") =>
                            str
                              .toLocaleLowerCase("es-MX")
                              .normalize("NFD")
                              .replace(/[\u0300-\u036f]/g, "");

                          const query = normalize(searchVehicle);

                          const filtered = tableData.food.filter((food) => {
                            const categoriaEfectiva = categoriaEfectivaCatalogo;

                            // El tipo elegido en el formulario manda sobre el menú lateral.
                            if (
                              categoriaEfectiva !== "all" &&
                              food.type !== categoriaEfectiva
                            ) {
                              return false;
                            }

                            // Filtro por sub_tipo únicamente para autos nuevos
                            if (
                              food.type === "nuevos" &&
                              subTipoNuevo !== "all" &&
                              food.sub_tipo !== subTipoNuevo
                            ) {
                              return false;
                            }

                            if (
                              query &&
                              !(
                                normalize(food.title).includes(query) ||
                                normalize(food.modelo ?? "").includes(query) ||
                                normalize(food.description ?? "").includes(
                                  query,
                                ) ||
                                normalize(food.sub_tipo ?? "").includes(query)
                              )
                            ) {
                              return false;
                            }

                            if (
                              food.type === "accesorios" ||
                              food.type === "garantias"
                            ) {
                              return selectedBrand
                                ? food.brand === selectedBrand ||
                                    food.brand === "all"
                                : food.brand === "all";
                            }

                            return true;
                          });

                          if (filtered.length === 0) {
                            return (
                              <div className="col-12 text-center py-5">
                                <h5>No se encontraron resultados</h5>
                              </div>
                            );
                          }

                          return filtered.map((food, index) => (
                            <div
                              className="col-xl-3 col-md-4 col-6"
                              key={index}
                            >
                              <a
                                href="#/"
                                className={
                                  "pos-product" +
                                  (!food.available ? " not-available" : "")
                                }
                                onClick={(event) => {
                                  event.preventDefault();
                                  if (
                                    food.type === "accesorios" ||
                                    food.type === "garantias"
                                  ) {
                                    addToCartDirectly(food); // Agregar directamente al carrito
                                  }
                                  showPosItemModal(event, food); // Abrir el modal SIEMPRE
                                }}
                              >
                                <div className="img">
                                  <img
                                    src={food.image}
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src =
                                        "/assets/img/product/noimage.png";
                                    }}
                                    alt={food.title}
                                    style={{
                                      width: "100%",
                                      height: "180px",
                                      objectFit: "cover",
                                      backgroundColor: "white",
                                    }}
                                  />
                                </div>

                                <div className="info">
                                  <div className="title new-font">
                                    {toTitleCase(food.title.split(" - ")[0])}{" "}
                                    {(food.type === "nuevos" ||
                                      food.type === "seminuevos") &&
                                      food.description}
                                  </div>
                                  <div className="desc new-font-14">
                                    {food.modelo.length > 100
                                      ? `${food.modelo.slice(0, 100)}...`
                                      : food.modelo}
                                  </div>
                                  {food.type !== "garantias" &&
                                    food.type !== "accesorios" && (
                                      <div className="price new-font-14">
                                        $
                                        {new Intl.NumberFormat("es-MX", {
                                          style: "decimal",
                                          minimumFractionDigits: 0,
                                          maximumFractionDigits: 0,
                                        }).format(food.price)}
                                      </div>
                                    )}
                                </div>

                                {!food.available && (
                                  <div className="not-available-text">
                                    <div>No disponible</div>
                                  </div>
                                )}
                              </a>
                            </div>
                          ));
                        })()
                      ) : (
                        <div className="col-12">Cargando...</div>
                      )}
                    </div>
                  </>
                )}
              </div>
            </PerfectScrollbar>
          </div>

          <div className="pos-sidebar" id="pos-sidebar">
            <div className="h-100 d-flex flex-column p-0">
              <div className="pos-sidebar-header mb-2px d-flex align-items-center justify-content-between">
                <div className="back-btn">
                  <button
                    type="button"
                    onClick={dismissMobileSidebar}
                    className="btn"
                  >
                    <i className="fa fa-chevron-left"></i>
                  </button>
                </div>
                <div className="order d-flex align-items-center black-text new-font-14">
                  Folio:{" "}
                  <span className="fw-semibold text-white mx-2 black-text">
                    {folioVenta}
                  </span>
                  <img
                    src={
                      selectedMailData?.qr_venta ||
                      `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(
                        `https://babiloniafi.mx/pos/customer-order-v2?folio_venta=${
                          resolveFolioVenta() || ""
                        }`,
                      )}`
                    }
                    alt="QR Code"
                    className="qr-code"
                  />
                </div>
              </div>

              <div className="pos-sidebar-nav fs-10px">
                <ul className="nav nav-tabs nav-fill">
                  <li className="nav-item">
                    <a
                      className="nav-link fw-semibold active black-text new-font-14"
                      href="#/"
                      data-bs-toggle="tab"
                      data-bs-target="#newOrderTab"
                    >
                      ORDEN
                    </a>
                  </li>
                </ul>
              </div>

              <PerfectScrollbar className="pos-sidebar-body tab-content h-100">
                <div
                  className="tab-pane fade h-100 show active"
                  id="newOrderTab"
                >
                  {selectedMailData ? (
                    <div className="pos-order">
                      <div className="pos-order-product">
                        <div
                          className="img"
                          style={{
                            backgroundImage: `url(${getVersionImage(selectedVersion, selectedMailData)})`,
                          }}
                        />
                        <div className="flex-1">
                          <div className="fw-semibold text-white black-text new-font">
                            {/* Marca / Modelo / Versión REVISAR*/}
                            {[
                              selectedMailData?.marca_vehiculo,
                              //selectedMailData?.modelo_vehiculo,
                              selectedMailData?.version_vehiculo,
                            ]
                              .filter(Boolean)
                              .join(" ")}
                          </div>

                          {/* Precio del vehículo */}
                          <div className="mb-1 black-text new-font-14">
                            $
                            {new Intl.NumberFormat("es-MX", {
                              style: "decimal",
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            }).format(
                              Number(selectedMailData?.precio_vehiculo || 0),
                            )}
                          </div>

                          {/* Agencia (opcional) */}
                          {selectedMailData?.agencia ? (
                            <div className="text-muted new-font-12">
                              {selectedMailData.agencia}
                            </div>
                          ) : null}
                        </div>
                      </div>

                      {/* Total (mismo precio; sin cantidades/confirmación) */}
                      <div className="pos-order-price d-flex flex-column">
                        <div className="flex-1 h6 mb-0 black-text new-font-14">
                          $
                          {new Intl.NumberFormat("es-MX", {
                            style: "decimal",
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                          }).format(
                            Number(selectedMailData?.precio_vehiculo || 0),
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="h-100 d-flex align-items-center justify-content-center text-center">
                      <div>
                        <div className="mb-3 mt-n5">
                          <svg
                            width="6em"
                            height="6em"
                            viewBox="0 0 16 16"
                            className="text-gray-300"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              d="M14 5H2v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5zM1 4v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4H1z"
                            />
                            <path d="M8 1.5A2.5 2.5 0 0 0 5.5 4h-1a3.5 3.5 0 1 1 7 0h-1A2.5 2.5 0 0 0 8 1.5z" />
                          </svg>
                        </div>
                        <h5>Selecciona un vehículo del inventario</h5>
                      </div>
                    </div>
                  )}

                  <div className="mt-4 p-3 border-tp shadow-sm">
                    <ul className="nav nav-tabs nav-fill">
                      <li className="nav-item">
                        <a
                          className="nav-link fw-semibold active black-text new-font-14"
                          href="#/"
                          data-bs-toggle="tab"
                          data-bs-target="#newOrderTab"
                        >
                          Versiones Disponibles
                        </a>
                      </li>
                    </ul>
                    <div className="option-versions">
                      <div className="option-versions">
                        {selectedMailData?.versiones
                          ? JSON.parse(selectedMailData.versiones).size.map(
                              (version, index) => (
                                <div className="option" key={index}>
                                  <input
                                    type="radio"
                                    id={"version" + index}
                                    name="versionVehiculo"
                                    className="option-input"
                                    value={version.text}
                                    onChange={() =>
                                      handleVersionSelect(version)
                                    }
                                    checked={selectedVersion === version.text}
                                  />
                                  <label
                                    className="option-label"
                                    htmlFor={"version" + index}
                                  >
                                    <span className="option-text new-font-14">
                                      {version.text}
                                    </span>
                                    <span className="option-price new-font-14">
                                      $
                                      {Number(version.price).toLocaleString(
                                        "en-MX",
                                        {
                                          maximumFractionDigits: 0,
                                        },
                                      )}
                                      <br />
                                      <small
                                        className="new-font-14"
                                        style={{
                                          fontSize: "12px",
                                          color: "#666",
                                        }}
                                      >
                                        Desde $
                                        {(() => {
                                          const precio =
                                            Number(version.price) || 0;
                                          const meses = 60; // plazo por defecto
                                          const tasaAnual =
                                            TASA_ANUAL_FINANCIAMIENTO; // 21% anual
                                          const i = tasaAnual / 12; // tasa mensual
                                          const enganchePct = 0.15; // 🔹 15% de enganche
                                          const pv = precio * (1 - enganchePct);

                                          // PMT
                                          const pmt =
                                            i > 0
                                              ? (pv *
                                                  i *
                                                  Math.pow(1 + i, meses)) /
                                                (Math.pow(1 + i, meses) - 1)
                                              : pv / meses;

                                          return pmt.toLocaleString("es-MX", {
                                            maximumFractionDigits: 0,
                                          });
                                        })()}
                                        /mes
                                      </small>
                                    </span>
                                  </label>
                                </div>
                              ),
                            )
                          : null}
                      </div>
                    </div>
                  </div>
                  <div className="p-3 shadow-sm">
                    <a className="nav-link fw-semibold active black-text text-center mb-4 new-font-14">
                      Garantías & Accesorios Disponibles
                    </a>
                    <ul className="nav nav-tabs nav-fill custom-tabs">
                      <li className="nav-item">
                        <button
                          className={`nav-link fw-semibold ${
                            tabActiva === "garantias" ? "active" : ""
                          }`}
                          onClick={() => setTabActiva("garantias")}
                        >
                          Garantías
                        </button>
                      </li>
                      <li className="nav-item">
                        <button
                          className={`nav-link fw-semibold ${
                            tabActiva === "accesorios" ? "active" : ""
                          }`}
                          onClick={() => setTabActiva("accesorios")}
                        >
                          Accesorios
                        </button>
                      </li>
                    </ul>
                    <div className="text-center mt-2">
                      <button
                        className="btn btn-vertd btn-link p-0 fw-semibold"
                        onClick={() => setMostrarVideoIntro(true)}
                      >
                        Ver todo
                      </button>
                    </div>

                    <div className="tab-content mt-3">
                      {tabActiva === "garantias" && (
                        <GarantiasSlider
                          garantias={garantiasFiltradas}
                          onShowModal={showAccessoryModal}
                          isInCart={isInCart}
                          addToCartDirectly={addToCartDirectly}
                        />
                      )}

                      {tabActiva === "accesorios" && (
                        <GarantiasSlider
                          garantias={accesoriosFiltrados}
                          onShowModal={showAccessoryModal}
                          isInCart={isInCart}
                          addToCartDirectly={addToCartDirectly}
                        />
                      )}
                    </div>
                  </div>
                </div>

                <div className="tab-pane fade h-100" id="plansTab">
                  <div className="h-100 align-items-center justify-content-center text-center">
                    <div className="row">
                      {/* Iteramos sobre los 3 planes de financiamiento */}
                      {vehicleData?.planesFinanciamiento
                        ?.filter((plan) => !esPlanClienteFinanciamiento(plan))
                        ?.map((plan, index) => (
                          <div className="col-md-12 mb-4" key={index}>
                            <div className="card">
                              <div className="card-body text-center">
                                <h5 className="card-title">{plan.title}</h5>

                                {/* Mostrar los accesorios de cada plan */}
                                <h6 className="card-price">
                                  Accesorios incluidos:
                                </h6>
                                {plan.accessories &&
                                plan.accessories.length > 0 ? (
                                  plan.accessories.map(
                                    (accesorio, accIndex) => (
                                      <span
                                        key={accIndex}
                                        className="badge bg-info text-dark me-2"
                                      >
                                        {accesorio.title}
                                      </span>
                                    ),
                                  )
                                ) : (
                                  <p>No se han seleccionado accesorios.</p>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </PerfectScrollbar>
            </div>
          </div>
        </div>
      </div>

      <a
        href="#/"
        className="pos-mobile-sidebar-toggler carrito-toggle"
        data-bs-toggle="modal"
        data-bs-target="#orderModal"
      >
        <i className="bi bi-bag"></i>
        <span className="badge">{getOrderTotal()}</span>
      </a>
      {/* <a
        href="#/"
        className="pos-mobile-sidebar-toggler pincel-toggle"
        onClick={() => setCanvasActivo((prev) => !prev)}
      >
        <i className={`bi ${canvasActivo ? "bi-brush-fill" : "bi-brush"}`}></i>
        <span className="badge">{canvasActivo ? "ON" : "OFF"}</span>
      </a>

      <a
        href="#/"
        className="pos-mobile-sidebar-toggler borrar-toggle"
        onClick={() => canvasRef.current?.clearCanvas()}
      >
        <i className="bi bi-trash"></i>
      </a> */}

      <div
        className="modal fade"
        id="orderModal"
        tabIndex="-1"
        aria-labelledby="orderModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="orderModalLabel">
                Detalles de la Orden
              </h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={handleCloseModalFinanciamiento}
              ></button>
            </div>

            <div className="modal-body p-0">
              <div className="pos-sidebar">
                <div className="h-100 d-flex flex-column">
                  {/* Header folio */}
                  <div className="pos-sidebar-header mb-2px d-flex align-items-center justify-content-between">
                    <div className="order d-flex align-items-center">
                      Folio:{" "}
                      <span className="fw-semibold text-white mx-2">
                        {folioVenta}
                      </span>
                      <img
                        src={
                          selectedMailData?.qr_venta ||
                          `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(
                            `https://babiloniafi.mx/pos/customer-order-v2?folio_venta=${
                              resolveFolioVenta() || ""
                            }`,
                          )}`
                        }
                        alt="QR Code"
                        className="qr-code"
                      />
                    </div>
                  </div>

                  {/* Tabs (solo accesorios/vehículo) */}
                  <div className="pos-sidebar-nav fs-10px">
                    <ul className="nav nav-tabs nav-fill">
                      <li className="nav-item">
                        <a
                          className="nav-link fw-semibold active"
                          href="#/"
                          data-bs-toggle="tab"
                          data-bs-target="#newOrderTabMobile"
                        >
                          Accesorios ({getOrderTotal()})
                        </a>
                      </li>
                    </ul>
                  </div>

                  {/* Body */}
                  <PerfectScrollbar className="pos-sidebar-body tab-content h-100">
                    {orderData && orderData.length > 0 ? (
                      <div className="row">
                        {orderData
                          .filter(
                            (order) =>
                              order.type !== "accesorios" &&
                              order.type !== "garantias",
                          )
                          .map((order, index) => (
                            <div className="col-12 mb-3" key={index}>
                              <div className="card">
                                <div className="card-body">
                                  <div className="d-flex align-items-center">
                                    <img
                                      src={order.image}
                                      alt={order.title}
                                      className="rounded me-3"
                                      style={{ width: "100px", height: "auto" }}
                                    />
                                    <div className="flex-grow-1">
                                      <h5 className="mb-2">
                                        {order.title} {order.description}
                                      </h5>
                                      <div className="d-flex align-items-center">
                                        <span className="me-3">
                                          <div className="mb-1">
                                            {toMoney(
                                              selectedMailData?.precio_vehiculo,
                                            )}
                                          </div>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                      </div>
                    ) : (
                      <div className="row h-100">
                        <div className="col-12 d-flex flex-column align-items-center justify-content-center py-5 pt-4 pb-4">
                          <svg
                            width="6em"
                            height="6em"
                            viewBox="0 0 16 16"
                            className="text-gray-300 mb-3"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              d="M14 5H2v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5zM1 4v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4H1z"
                            />
                            <path d="M8 1.5A2.5 2.5 0 0 0 5.5 4h-1a3.5 3.5 0 1 1 7 0h-1A2.5 2.5 0 0 0 8 1.5z" />
                          </svg>
                          <h5>No se encontró ningún vehículo o accesorio</h5>
                        </div>
                      </div>
                    )}

                    <div
                      className="tab-pane fade h-100"
                      id="orderHistoryTabMobile"
                    ></div>
                  </PerfectScrollbar>

                  {/* ===== Footer con cálculos a partir de selectedMailData ===== */}
                  <div className="pos-sidebar-footer">
                    {(() => {
                      // Helpers locales
                      const toMoney = (n) =>
                        new Intl.NumberFormat("es-MX", {
                          style: "currency",
                          currency: "MXN",
                          maximumFractionDigits: 0,
                        }).format(Number(n || 0));
                      const calcPMT = ({
                        price = 0,
                        meses = 60,
                        enganchePct = 0,
                        engancheMonto = null,
                        tasaAnual = TASA_ANUAL_FINANCIAMIENTO,
                        isMSI = false,
                      }) => {
                        const total = Number(price || 0);
                        const enganche =
                          engancheMonto !== null && engancheMonto !== undefined
                            ? Number(engancheMonto || 0)
                            : (Number(enganchePct || 0) / 100) * total;

                        return calcularMensualidadFinanciamientoCotizacion({
                          total,
                          meses,
                          engancheMonto: enganche,
                          tasaAnual,
                          isMSI:
                            isMSI || selectedMailData?.depende_auto === "Si",
                        });
                      };

                      // ===== Datos base =====
                      const hasVersion = !!selectedMailData?.version_vehiculo;

                      const precioVeh =
                        getPrecioVehiculoCotizacion(selectedMailData);
                      const planSeleccionadoFooter =
                        getPlanSeleccionadoCotizacion(selectedMailData);
                      const adicionales = getPlanTotalCotizacion(
                        planSeleccionadoFooter,
                      );
                      const precioTot = Math.max(precioVeh + adicionales, 0);

                      const meses = Number(
                        selectedMailData?.meses_financiamiento ?? 60,
                      );
                      const enganchePctCredito = Number(
                        selectedMailData?.porcentaje_enganche ?? 15,
                      );
                      const engancheMontoCredito =
                        getEngancheMontoCreditoCotizacion(
                          selectedMailData,
                          precioVeh,
                        );
                      const tasaAnual = TASA_ANUAL_FINANCIAMIENTO;

                      const isContado =
                        String(
                          selectedMailData?.depende_auto || "",
                        ).toLowerCase() === "si";

                      if (isContado) {
                        // ====== CONTADO ======
                        // Vehículo se paga al contado (enganche efectivo 100%),
                        // y SOLO se financian los ADICIONALES con 0% de enganche.
                        const pmtAdicionales = hasVersion
                          ? calcPMT({
                              price: adicionales,
                              meses,
                              enganchePct: 0, // 0% de enganche para adicionales en contado
                              tasaAnual,
                            })
                          : 0;

                        return (
                          <>
                            <div className="d-flex align-items-center mb-3">
                              <div className="fw-bold fs-5 text-muted">
                                Precio Total
                              </div>
                              <div className="flex-1 text-end h4 mb-0 text-primary fw-semibold">
                                {hasVersion
                                  ? toMoney(precioVeh)
                                  : "Selecciona una versión"}
                              </div>
                            </div>

                            <hr className="my-3 opacity-50" />

                            <div className="d-flex align-items-center mb-3">
                              <div className="fw-bold fs-5 text-muted">
                                Mensualidad de adicionales
                              </div>
                              <div className="flex-1 text-end h4 mb-0 text-success fw-semibold">
                                {hasVersion
                                  ? toMoney(pmtAdicionales)
                                  : "Selecciona una versión"}
                              </div>
                            </div>

                            <div className="text-muted small fst-italic text-center">
                              *El precio total mostrado no incluye accesorios ni
                              garantías adicionales.
                            </div>
                          </>
                        );
                      }

                      // ====== CRÉDITO ======
                      const pmtSinAdic = hasVersion
                        ? calcPMT({
                            price: precioVeh,
                            meses,
                            enganchePct: enganchePctCredito,
                            engancheMonto: engancheMontoCredito,
                            tasaAnual,
                          })
                        : 0;

                      const pmtConAdic = hasVersion
                        ? calcPMT({
                            price: precioVeh + adicionales, // o precioTot, equivalen
                            meses,
                            enganchePct: enganchePctCredito,
                            engancheMonto: engancheMontoCredito,
                            tasaAnual,
                          })
                        : 0;

                      return (
                        <>
                          <div className="d-flex align-items-center mb-3">
                            <div className="fw-bold fs-5 text-muted">
                              Mensualidad sin adicionales
                            </div>
                            <div className="flex-1 text-end h4 mb-0 text-primary fw-semibold">
                              {hasVersion
                                ? toMoney(pmtSinAdic)
                                : "Selecciona una versión"}
                            </div>
                          </div>

                          <hr className="my-3 opacity-50" />

                          <div className="d-flex align-items-center mb-3">
                            <div className="fw-bold fs-5 text-muted">
                              Mensualidad con adicionales
                            </div>
                            <div className="flex-1 text-end h4 mb-0 text-success fw-semibold">
                              {hasVersion
                                ? toMoney(pmtConAdic)
                                : "Selecciona una versión"}
                            </div>
                          </div>

                          <div className="text-muted small fst-italic text-center">
                            *El precio total mostrado no incluye accesorios ni
                            garantías adicionales.
                          </div>
                        </>
                      );
                    })()}
                  </div>
                </div>
              </div>
            </div>

            {/* Footer modal */}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline-primary mb-2"
                data-bs-dismiss="modal"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Product Modal */}
      <div className="modal modal-pos fade" id="modalPosItem">
        <div className="modal-dialog modal-lg">
          <div className="modal-content border-0">
            {modalData && (
              <>
                <div className="modal-pos-product">
                  <div className="modal-pos-product-img d-flex flex-column">
                    {/* Mostrar la imagen solo si no hay video */}
                    {!modalData.video && (
                      <div
                        className="d-flex justify-content-center align-items-center"
                        style={{ height: "250px", backgroundColor: "white" }}
                      >
                        <img
                          src={modalData.image}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/assets/img/product/noimage.png";
                          }}
                          alt="Producto"
                          style={{
                            maxHeight: "100%",
                            maxWidth: "100%",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                    )}

                    {/* Mostrar video solo si existe */}
                    {modalData.video && (
                      <div className="modal-pos-product-video mt-3">
                        <video width="100%" controls>
                          <source src={modalData.video} type="video/mp4" />
                          Tu navegador no soporta el tag de video.
                        </video>
                      </div>
                    )}
                  </div>

                  <div className="modal-pos-product-info">
                    <div className="fs-4 fw-semibold black-text new-font">
                      {modalData.title}{" "}
                      {(modalData.type === "nuevos" ||
                        modalData.type === "seminuevos") &&
                        modalData.description}
                    </div>
                    <div className="fs-4 fw-semibold black-text new-font">
                      {modalData.year}
                    </div>
                    <div className="fs-4 fw-semibold d-none new-font-14">
                      {modalData.type}
                    </div>
                    <div className="text-body text-opacity-50 mb-2 new-font-14">
                      {modalData.modelo.length > 200
                        ? `${modalData.modelo.slice(0, 200)}...`
                        : modalData.modelo}
                    </div>

                    {modalData.type !== "accesorios" &&
                      modalData.type !== "garantias" && (
                        <div className="fs-3 fw-bold mb-3 black-text">
                          Desde: $
                          {new Intl.NumberFormat("es-MX", {
                            style: "decimal",
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                          }).format(modalData.price)}
                        </div>
                      )}

                    <hr className="opacity-1" />
                    <div className="row">
                      <div className="col-4">
                        <button
                          className="btn btn-default fw-semibold mb-0 d-block py-3 w-100 new-font-14"
                          data-bs-dismiss="modal"
                        >
                          Cerrar
                        </button>
                      </div>
                      {modalData.type !== "accesorios" &&
                        modalData.type !== "garantias" && (
                          <div className="col-8">
                            <button
                              className="btn btn-theme fw-semibold d-flex justify-content-center align-items-center py-3 m-0 w-100 new-font-14"
                              onClick={async (event) => {
                                event.preventDefault();
                                event.stopPropagation();

                                // Al dar “Me interesa”, la ficha se toma del inventario
                                // y se guarda en selected_car para reutilizarla después.
                                const fichaTecnicaModal =
                                  obtenerFichaTecnicaUrl(modalData) ||
                                  normalizeFichaTecnicaUrl(
                                    getFichaTecnicaFromVehicle(modalData) ||
                                      getFichaTecnicaFromVenta(
                                        selectedMailData,
                                      ),
                                  );

                                const vehicleToSelect = {
                                  ...modalData,
                                  description:
                                    modalData.description ||
                                    modalData.modelo ||
                                    "",
                                  url_img:
                                    modalData.url_img || modalData.image || "",
                                  ag_id:
                                    modalData.ag_id ||
                                    agenciaActual?.ag_id ||
                                    selectedMailData?.ag_id ||
                                    "",
                                  pdf: fichaTecnicaModal,
                                  ficha_tecnica: fichaTecnicaModal,
                                  ficha_tecnica_vehiculo: fichaTecnicaModal,
                                  url_ficha_tecnica: fichaTecnicaModal,
                                  url_cotizacion:
                                    modalData.url_cotizacion || "",
                                  procotiza_pdf_base64:
                                    modalData.procotiza_pdf_base64 || "",
                                };

                                markPendingVehicleSelection();

                                // Guarda la descripción ORIGINAL
                                const desc =
                                  vehicleToSelect.modelo ||
                                  vehicleToSelect.description ||
                                  "";

                                setDescripcionAuto(desc);
                                localStorage.setItem("descripcion_auto", desc);

                                // Abrimos la ficha con el vehículo explícito para no depender
                                // de que React termine de actualizar selectedCar.
                                userJustSelectedRef.current = false;
                                lastAutoOpenedKeyRef.current =
                                  getSelectedCarRenderKey(vehicleToSelect);

                                // Cerramos primero el modal de producto y esperamos a que Bootstrap
                                // termine su limpieza antes de montar la ficha técnica.
                                try {
                                  productModal?.hide?.();
                                } catch {}

                                await new Promise((resolve) =>
                                  setTimeout(resolve, 320),
                                );

                                selectedCarRef.current = vehicleToSelect;
                                setSelectedCar(vehicleToSelect);

                                // Primero guardamos selected_car en backend. Si abrimos el PDF antes,
                                // un tick del polling puede llegar con selected_car vacío y desmontar
                                // visualmente la ficha técnica en vehículos nuevos.
                                await addToCart(event, vehicleToSelect, {
                                  skipProductModalHide: true,
                                });

                                abrirPDF(vehicleToSelect);
                              }}
                            >
                              Me interesa{" "}
                              <i className="bi bi-plus fa-2x ms-2 my-n3"></i>
                            </button>
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="accessoryModal"
        tabIndex="-1"
        aria-labelledby="accessoryModalLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog modal-lg modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="accessoryModalLabel">
                Comparación de Accesorios
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <DragDropContext
              // onDragEnd={handleDragEndModal}
              onDragStart={() => {
                document.body.style.cursor = "grabbing";
              }}
              onDragUpdate={() => {
                document.body.style.cursor = "grabbing";
              }}
            >
              <div className="modal-body">
                {!esSeminuevoParaModal && (
                  <>
                    <div className="row mt-4">
                      <div className="col-12">
                        <h6 className="mb-3">Garantía Extendida</h6>

                        <div
                          className={`custom-switch ${tieneGarantiaExtendida ? "active" : ""}`}
                          onClick={() =>
                            setTieneGarantiaExtendida(!tieneGarantiaExtendida)
                          }
                        >
                          <div className="switch-circle"></div>
                        </div>

                        <br />

                        <WarrantyItem
                          icon="fa-solid fa-screwdriver-wrench"
                          titulo="Motor"
                          descripcion="Cubre componentes internos del bloque, culata, sistema de lubricación y sincronización."
                          tieneGarantiaExtendida={tieneGarantiaExtendida}
                        />

                        <WarrantyItem
                          icon="fa-solid fa-gears"
                          titulo="Transmisión"
                          descripcion="Protege la caja de cambios, convertidor de par y componentes internos de tracción."
                          tieneGarantiaExtendida={tieneGarantiaExtendida}
                        />

                        <WarrantyItem
                          icon="fa-solid fa-circle-dot"
                          titulo="Dirección"
                          descripcion="Cubre la caja de dirección, bomba de asistencia y terminales de dirección."
                          tieneGarantiaExtendida={tieneGarantiaExtendida}
                        />

                        <WarrantyItem
                          icon="fa-solid fa-life-ring"
                          titulo="Frenos"
                          descripcion="Protege el servofreno, cilindro maestro, bomba de vacío y módulos de ABS."
                          tieneGarantiaExtendida={tieneGarantiaExtendida}
                        />

                        <WarrantyItem
                          icon="fa-solid fa-truck-monster"
                          titulo="Suspensión"
                          descripcion="Cubre amortiguadores, brazos de control, rótulas y resortes de suspensión."
                          tieneGarantiaExtendida={tieneGarantiaExtendida}
                        />

                        <WarrantyItem
                          icon="fa-solid fa-bolt"
                          titulo="Sistema Eléctrico"
                          descripcion="Cubre alternador, motor de arranque y el cableado principal del vehículo."
                          tieneGarantiaExtendida={tieneGarantiaExtendida}
                        />

                        <WarrantyItem
                          icon="fa-solid fa-temperature-half"
                          titulo="Sistema de Enfriamiento"
                          descripcion="Cubre radiador, bomba de agua, termostato y ventiladores del motor."
                          tieneGarantiaExtendida={tieneGarantiaExtendida}
                        />

                        <WarrantyItem
                          icon="fa-solid fa-gas-pump"
                          titulo="Sistema de Combustible"
                          descripcion="Cubre la bomba de combustible, inyectores y líneas de presión rígidas."
                          tieneGarantiaExtendida={tieneGarantiaExtendida}
                        />

                        <WarrantyItem
                          icon="fa-solid fa-snowflake"
                          titulo="Aire Acondicionado"
                          descripcion="Cubre compresor, evaporador y condensador del sistema de climatización."
                          tieneGarantiaExtendida={tieneGarantiaExtendida}
                        />

                        <WarrantyItem
                          icon="fa-solid fa-display"
                          titulo="Sistema Multimedia"
                          descripcion="Pantalla, módulo de audio y componentes electrónicos del sistema de entretenimiento."
                          tieneGarantiaExtendida={tieneGarantiaExtendida}
                        />

                        <WarrantyItem
                          icon="fa-solid fa-truck-pickup"
                          titulo="Asistencia Vial"
                          descripcion="Servicio de grúa, paso de corriente, asistencia en ruta y soporte 24/7."
                          tieneGarantiaExtendida={tieneGarantiaExtendida}
                        />

                        <p className="small fw-bold text-center warranty-disclaimer mt-4">
                          LA GARANTÍA DE MARCA NO APLICA PARA VEHÍCULOS DE USO
                          ESPECIAL, MODIFICADOS, AUTOS DE RENTA Y USO COMERCIAL
                        </p>
                      </div>
                    </div>

                    <div className="row mt-4">
                      <div className="col-md-6 mb-3">
                        <div className="form-group">
                          <label>¿Rechazar garantía extendida?</label>
                          <div>
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                className="form-check-input"
                                name="garantia"
                                id="garantiaSi"
                                value="Si"
                                checked={garantia_extendida === "Si"}
                                onChange={() => {
                                  setMostrarModalInfo(true);
                                  setGarantiaExtendida("");
                                }}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="garantiaSi"
                              >
                                Sí
                              </label>
                            </div>

                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                className="form-check-input"
                                name="garantia"
                                id="garantiaNo"
                                value="No"
                                checked={garantia_extendida === "No"}
                                onChange={() => setGarantiaExtendida("No")}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="garantiaNo"
                              >
                                No
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </DragDropContext>

            <div className="modal-footer">
              <button
                className="btn btn-primary"
                onClick={generarDocumentos}
                disabled={
                  isSubmitting ||
                  (!esSeminuevoParaModal && !rechazoSeleccionado)
                }
              >
                {isSubmitting ? "Enviando..." : "Firmar"}
              </button>
            </div>
          </div>

          {!esSeminuevoParaModal && mostrarModalInfo && (
            <div
              className="modal fade show d-block modal-fullscreen-custom"
              tabIndex="-1"
              role="dialog"
              style={{
                backgroundColor: "rgba(0,0,0,0.1)",
                backdropFilter: "blur(4px)",
                inset: 0,
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div
                className="modal-dialog modal-fullscreen modal-dialog-scrollable"
                role="document"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="modal-content">
                  <div className="modal-header" style={{ color: "white" }}>
                    <h5 className="modal-title">
                      Antes de rechazar la garantía...
                    </h5>
                  </div>

                  <div className="modal-body" style={{ color: "white" }}>
                    <div
                      className="p-3 rounded mt-4 modal-info"
                      style={{ backgroundColor: "#1f2e35" }}
                    >
                      <h5 className="text-warning text-center mb-3">
                        ¡Garantiza hoy, maneja tranquilo mañana!
                      </h5>
                      <br />
                      <div className="row">
                        <div className="col-md-6">
                          <ul className="text-light text-base list-unstyled">
                            <li className="card-hover d-flex align-items-start">
                              <i className="fa-solid fa-circle-dot text-success me-2 mt-1 icon-sm"></i>
                              <span>
                                <strong>Rines:</strong> La reparación puede
                                costarte al menos $3,500.00, pero reemplazar un
                                rin nuevo de 16” puede ir de $4,800 hasta
                                $5,000*. ¿Vas a correr ese riesgo? ¡Protégete
                                ahora con los planes 5000 y 12000!
                                <sup>¹</sup>
                              </span>
                            </li>
                            <li className="card-hover d-flex align-items-start mb-3">
                              <i className="fa-solid fa-car-side text-success me-2 mt-1 icon-sm"></i>
                              <span>
                                <strong>Movilidad:</strong> Rentar un auto
                                subcompacto por 30 días cuesta desde $27,000. La
                                cobertura garantiza movilidad continua.
                                <sup>²</sup>
                              </span>
                            </li>
                            <li className="card-hover d-flex align-items-start mb-3">
                              <i className="fa-solid fa-screwdriver-wrench text-success me-2 mt-1 icon-sm"></i>
                              <span>
                                <strong>Reparaciones mayores:</strong> Reparar
                                un motor puede costar entre $68,000 y $119,000.
                                <sup>³</sup>
                              </span>
                            </li>
                          </ul>
                        </div>

                        <div className="col-md-6">
                          <ul className="text-light text-base list-unstyled">
                            <li className="card-hover d-flex align-items-start mb-3">
                              <i className="fa-solid fa-circle-exclamation text-success me-2 mt-1 icon-sm"></i>
                              <span>
                                <strong>Neumáticos:</strong> Reventar 2 puede
                                costarte al menos $6,800.00. Con cobertura, no
                                pagas nada.
                              </span>
                            </li>
                            <li className="card-hover d-flex align-items-start mb-3">
                              <i className="fa-solid fa-triangle-exclamation text-success me-2 mt-1 icon-sm"></i>
                              <span>
                                <strong>Averías mecánicas:</strong> En promedio
                                se pagan más de $38,000 por siniestro. Con
                                garantía, ese monto no saldrá de tu bolsillo.
                              </span>
                            </li>
                            <li className="card-hover d-flex align-items-start mb-3">
                              <i className="fa-solid fa-key text-success me-2 mt-1 icon-sm"></i>
                              <span>
                                <strong>Llaves perdidas:</strong> Reponerlas
                                puede costarte hasta $6,000.00. Con cobertura,
                                no pagas nada.
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <p>
                        <sup>¹</sup> Precio promedio para sedanes como Versa,
                        MG5, Virtus, Aveo, etc.
                        <br />
                        <sup>²</sup> Precio promedio por día de $900.00 para
                        renta de un subcompacto de 4 puertas.
                        <br />
                        <sup>³</sup> Por reparación de vehículos de uso común,
                        el precio de reemplazo de motor puede ser
                        significativamente mayor.
                      </p>
                    </div>

                    <div>
                      <div className="row mt-4">
                        <h5 className="text-warning text-center mb-5">
                          ¿Cuánto podrías perder sin una garantía?
                        </h5>

                        <div className="col-md-6">
                          <h6>(%) Siniestralidad de Llantas por Año</h6>
                          <ResponsiveContainer width="100%" height={300}>
                            <LineChart
                              data={llantasData}
                              margin={{
                                top: 10,
                                right: 20,
                                left: 20,
                                bottom: 10,
                              }}
                            >
                              <CartesianGrid strokeDasharray="3 3" />
                              <XAxis
                                dataKey="year"
                                stroke="var(--axis-stroke)"
                              />
                              <YAxis unit="%" stroke="var(--axis-stroke)" />
                              <Tooltip formatter={(value) => `${value}%`} />
                              <Legend />
                              <Line
                                type="monotone"
                                dataKey="siniestralidad"
                                stroke="#dc3545"
                                name="Siniestralidad"
                                label={renderLineLabel}
                              />
                            </LineChart>
                          </ResponsiveContainer>
                          <p className="text-light text-center mt-2 text-base">
                            En promedio, más del 57% de los autos con cobertura
                            de llantas presentan un siniestro cada año.
                          </p>
                        </div>

                        <div className="col-md-6">
                          <h6>Costo Promedio por Siniestro (Llantas)</h6>
                          <ResponsiveContainer width="100%" height={300}>
                            <BarChart data={llantasData}>
                              <CartesianGrid strokeDasharray="3 3" />
                              <XAxis
                                dataKey="year"
                                stroke="var(--axis-stroke)"
                              />
                              <YAxis
                                stroke="var(--axis-stroke)"
                                tickFormatter={formatCurrency}
                              />
                              <Tooltip
                                formatter={(value) => formatCurrency(value)}
                              />
                              <Legend />
                              <Bar
                                dataKey="costo"
                                fill="#28a745"
                                name="Costo Promedio"
                                label={renderBarLabel}
                              >
                                {llantasData.map((entry, index) => (
                                  <Cell key={`bar-${index}`} />
                                ))}
                              </Bar>
                            </BarChart>
                          </ResponsiveContainer>
                          <p className="text-light text-center mt-2 text-base">
                            Reparar dos llantas puede costarte más de $3,000.
                            Con garantía, tú pagas $0.
                          </p>
                        </div>

                        <div className="col-md-6 mt-4">
                          <h6>(%) Siniestralidad Cobertura Mecánica</h6>
                          <ResponsiveContainer width="100%" height={300}>
                            <LineChart
                              data={mecanicaData}
                              margin={{
                                top: 10,
                                right: 20,
                                left: 20,
                                bottom: 10,
                              }}
                            >
                              <CartesianGrid strokeDasharray="3 3" />
                              <XAxis
                                dataKey="year"
                                stroke="var(--axis-stroke)"
                              />
                              <YAxis unit="%" stroke="var(--axis-stroke)" />
                              <Tooltip formatter={(value) => `${value}%`} />
                              <Legend />
                              <Line
                                type="monotone"
                                dataKey="siniestralidad"
                                stroke="#007bff"
                                name="Siniestralidad"
                                label={renderLineLabel}
                              />
                            </LineChart>
                          </ResponsiveContainer>
                          <p className="text-light text-center mt-2 text-base">
                            La siniestralidad mecánica alcanzó el 79% en 2024.
                            Eso significa que 8 de cada 10 autos necesitaron
                            reparación.
                          </p>
                        </div>

                        <div className="col-md-6 mt-4">
                          <h6>Costo Promedio por Siniestro (Mecánica)</h6>
                          <ResponsiveContainer width="100%" height={300}>
                            <BarChart data={mecanicaData}>
                              <CartesianGrid strokeDasharray="3 3" />
                              <XAxis
                                dataKey="year"
                                stroke="var(--axis-stroke)"
                              />
                              <YAxis
                                stroke="var(--axis-stroke)"
                                tickFormatter={formatCurrency}
                              />
                              <Tooltip
                                formatter={(value) => formatCurrency(value)}
                              />
                              <Legend />
                              <Bar
                                dataKey="costo"
                                fill="#ffc107"
                                name="Costo Promedio"
                                label={renderBarLabel}
                              >
                                {mecanicaData.map((entry, index) => (
                                  <Cell key={`bar2-${index}`} />
                                ))}
                              </Bar>
                            </BarChart>
                          </ResponsiveContainer>
                          <p className="text-light text-center mt-2 text-base">
                            El costo promedio de una reparación mecánica en 2024
                            fue de $38,575. Con garantía, tú no pagas nada.
                          </p>
                        </div>

                        <div className="col-md-6 mt-4">
                          <h6>Evolución del costo de reparaciones</h6>
                          <ResponsiveContainer width="100%" height={350}>
                            <BarChart
                              data={reparacionesData}
                              margin={{
                                top: 20,
                                right: 30,
                                left: 20,
                                bottom: 10,
                              }}
                            >
                              <CartesianGrid
                                strokeDasharray="3 3"
                                stroke="#444"
                              />
                              <XAxis
                                dataKey="year"
                                stroke="var(--axis-stroke)"
                              />
                              <YAxis
                                stroke="var(--axis-stroke)"
                                tickFormatter={formatCurrency}
                              />
                              <Tooltip
                                formatter={(value) => formatCurrency(value)}
                              />
                              <Legend />
                              <Bar
                                dataKey="costo"
                                name="Costo de Reparaciones"
                                label={renderBarLabel}
                              >
                                {reparacionesData.map((entry, index) => (
                                  <Cell
                                    key={`bar-${index}`}
                                    fill={entry.color}
                                  />
                                ))}
                              </Bar>
                            </BarChart>
                          </ResponsiveContainer>
                          <p className="text-light text-center mt-2 text-base">
                            En los últimos 3 años, el costo de reparación ha
                            aumentado hasta 2.4 veces. La cobertura evita que
                            estos aumentos afecten tu bolsillo.
                          </p>
                        </div>

                        <div className="col-md-6 mt-4">
                          <h6>Evolución de Siniestralidad</h6>
                          <ResponsiveContainer width="100%" height={350}>
                            <PieChart>
                              <Tooltip formatter={(value) => `${value}%`} />
                              <Legend />
                              <Pie
                                data={siniestralidadData}
                                dataKey="value"
                                nameKey="name"
                                cx="50%"
                                cy="50%"
                                outerRadius={120}
                                label={({ value }) => `${value}%`}
                              >
                                {siniestralidadData.map((entry, index) => (
                                  <Cell
                                    key={`cell-${index}`}
                                    fill={entry.color}
                                  />
                                ))}
                              </Pie>
                            </PieChart>
                          </ResponsiveContainer>
                          <p className="text-light text-center mt-2 text-base">
                            La siniestralidad global ha ido en aumento. No es
                            una posibilidad remota: es una realidad cada vez más
                            común.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="alert alert-warning text-center mt-4">
                      <strong>
                        ¿Estás completamente seguro de rechazar la garantía?
                      </strong>
                    </div>
                  </div>

                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      onClick={async () => {
                        await actualizarFirmaModal("10");
                        setGarantiaExtendida("No");
                        setMostrarModalInfo(false);
                      }}
                    >
                      No, conservar garantía
                    </button>
                    <button
                      className="btn btn-danger"
                      onClick={async () => {
                        await actualizarFirmaModal("00");
                        setGarantiaExtendida("Si");
                        setMostrarModalInfo(false);
                      }}
                    >
                      Sí, rechazar garantía
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {mostrarModalAccesorios && ( //MODAL ACCESORIOS Y GaRANTIAS
        <div
          className="modal fade show d-block modal-fullscreen"
          tabIndex="-1"
          role="dialog"
          style={{
            backgroundColor: "rgba(0,0,0,0.3)",
            backdropFilter: "blur(8px)", // Más desenfoque para profundidad
          }}
          onClick={cerrarModalAccesorios}
        >
          <div
            className="modal-dialog modal-fullscreen modal-dialog-centered modal-dialog-scrollable"
            role="document"
            onClick={(e) => e.stopPropagation()}
            style={{
              animation: "fadeIn 0.3s ease-in-out",
            }}
          >
            <div
              className="modal-content border-0"
              style={{
                backgroundColor: "#223840",
                borderRadius: "12px",
                padding: "20px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
              }}
            >
              <div className="modal-header">
                <h5 className="modal-title text-white">
                  ¡Personaliza tu auto!
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={cerrarModalAccesorios}
                  style={{
                    filter: "brightness(1.2)",
                    transition: "transform 0.2s ease",
                  }}
                  onMouseEnter={(e) =>
                    (e.target.style.transform = "scale(1.1)")
                  }
                  onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
                ></button>
              </div>

              <div
                className="modal-body"
                style={{ maxHeight: "100vh", overflowY: "auto" }}
              >
                <div className="sticky-search-bar">
                  {" "}
                  {/* BUSCADOR */}
                  <input
                    type="text"
                    className="form-control search-input"
                    placeholder="Buscar accesorio o garantía..."
                    value={busqueda}
                    onChange={(e) => setBusqueda(e.target.value)}
                  />
                </div>
                {/* Garantías */}
                <div style={{ position: "relative", marginBottom: "35px" }}>
                  {/*<RibbonDiagonal text="Garantias" color="#ffb74d" />*/}
                  <div className="row g-3 mb-4"></div>
                </div>
                <div className="row g-3">
                  {garantiasFiltradas.length === 0 ? (
                    <div className="text-white text-center w-100">
                      No se encontraron garantías
                    </div>
                  ) : (
                    garantiasFiltradas.map((food, index) => (
                      <div
                        className="col-xl-3 col-md-4 col-6"
                        key={"garantia-" + index}
                      >
                        <div
                          className={
                            "pos-product card p-2" +
                            (!food.available ? " not-available" : "")
                          }
                          style={{
                            cursor: "pointer",
                            textDecoration: "none",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                            borderRadius: "8px",
                            backgroundColor: "#1f3a47",
                            transition: "transform 0.2s ease",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.transform = "scale(1.05)")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.transform = "scale(1)")
                          }
                          onClick={(e) => {
                            e.preventDefault();
                            showAccessoryModal(food);
                          }}
                        >
                          {/* Ícono de interés */}
                          <i
                            className={`${
                              isInCart(food) ? "fas fa-heart" : "far fa-heart"
                            } icono-heart`}
                            title={
                              isInCart(food)
                                ? "Ya agregado"
                                : "Agregar a favoritos"
                            }
                            style={{
                              position: "absolute",
                              top: "10px",
                              right: "10px",
                              fontSize: "1.2rem",
                              color: "#fff",
                              background:
                                "linear-gradient(135deg, #ff6f00, #ffb74d)",
                              borderRadius: "50%",
                              padding: "10px",
                              boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                              cursor: "pointer",
                              transition: "transform 0.2s",
                              zIndex: 2,
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (!isInCart(food)) {
                                addToCartDirectly(food); //agregamos al carrito
                              } else {
                                Swal.fire(
                                  "Ya agregado",
                                  "Este accesorio ya está en favoritos",
                                  "info",
                                );
                              }
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.transform = "scale(1.2)")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.transform = "scale(1)")
                            }
                          ></i>
                          <div
                            className="img mb-2"
                            style={{ borderRadius: "6px", overflow: "hidden" }}
                          >
                            <img
                              src={food.image}
                              onError={(e) =>
                                (e.target.src =
                                  "/assets/img/product/noimage.png")
                              }
                              alt={food.title}
                              style={{
                                width: "100%",
                                height: "180px",
                                objectFit: "cover",
                                backgroundColor: "transparent",
                                borderRadius: "8px",
                              }}
                            />
                          </div>
                          <div className="info text-white">
                            <div className="title fw-bold">
                              {toTitleCase(food.title.split(" - ")[0])}
                            </div>
                            <div
                              className="desc"
                              style={{ fontSize: "0.9rem", opacity: 0.8 }}
                            >
                              {food.modelo
                                ? food.modelo.length > 100
                                  ? `${food.modelo
                                      .slice(0, 100)
                                      .charAt(0)
                                      .toUpperCase()}${food.modelo
                                      .slice(1, 100)
                                      .toLowerCase()}...`
                                  : food.modelo.charAt(0).toUpperCase() +
                                    food.modelo.slice(1).toLowerCase()
                                : ""}
                            </div>
                          </div>
                          {!food.available && (
                            <div className="not-available-text mt-2 text-danger fw-bold">
                              No disponible
                            </div>
                          )}
                        </div>
                      </div>
                    ))
                  )}
                </div>
                <div className="divider-bar"></div>

                {/* Accesorios */}
                <div style={{ position: "relative", marginBottom: "35px" }}>
                  {/*<RibbonDiagonal text="Accesorios" color="#ffb74d" />*/}
                  <div className="row g-3 mb-4">{/* accesorios */}</div>
                </div>
                {/* Recorre Accesorios */}
                <div className="row g-3 mb-4">
                  {accesoriosFiltrados.length === 0 ? (
                    <div className="text-white text-center w-100">
                      No se encontraron accesorios
                    </div>
                  ) : (
                    accesoriosFiltrados.map((food, index) => (
                      <div
                        className="col-xl-3 col-md-4 col-6"
                        key={"accesorio-" + index}
                      >
                        <div
                          className={
                            "pos-product card p-2" +
                            (!food.available ? " not-available" : "")
                          }
                          style={{
                            cursor: "pointer",
                            textDecoration: "none",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                            borderRadius: "8px",
                            backgroundColor: "#1f3a47",
                            transition: "transform 0.2s ease",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.transform = "scale(1.05)")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.transform = "scale(1)")
                          }
                          onClick={(e) => {
                            e.preventDefault();
                            showAccessoryModal(food); //solo mostramos la info
                          }}
                        >
                          {/* Ícono de interés */}
                          <i
                            className={`${
                              isInCart(food) ? "fas fa-heart" : "far fa-heart"
                            } icono-heart`}
                            title={
                              isInCart(food)
                                ? "Ya agregado"
                                : "Agregar a favoritos"
                            }
                            style={{
                              position: "absolute",
                              top: "10px",
                              right: "10px",
                              fontSize: "1.2rem",
                              color: "#fff",
                              background:
                                "linear-gradient(135deg, #ff6f00, #ffb74d)",
                              borderRadius: "50%",
                              padding: "10px",
                              boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                              cursor: "pointer",
                              transition: "transform 0.2s",
                              zIndex: 2,
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (!isInCart(food)) {
                                addToCartDirectly(food); //agregamos al carrito
                              } else {
                                Swal.fire(
                                  "Ya agregado",
                                  "Este accesorio ya está en favoritos",
                                  "info",
                                );
                              }
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.transform = "scale(1.2)")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.transform = "scale(1)")
                            }
                          ></i>
                          <div
                            className="img mb-2"
                            style={{ borderRadius: "6px", overflow: "hidden" }}
                          >
                            <img
                              src={food.image}
                              onError={(e) =>
                                (e.target.src =
                                  "/assets/img/product/noimage.png")
                              }
                              alt={food.title}
                              style={{
                                width: "100%",
                                height: "180px",
                                objectFit: "cover",
                                backgroundColor: "transparent", // Fondo transparente
                                borderRadius: "8px",
                              }}
                            />
                          </div>
                          <div className="info text-white">
                            <div className="title fw-bold new-font">
                              {toTitleCase(food.title.split(" - ")[0])}
                            </div>
                            <div
                              className="desc"
                              style={{ fontSize: "0.9rem", opacity: 0.8 }}
                            >
                              {food.modelo
                                ? food.modelo.length > 100
                                  ? `${food.modelo
                                      .slice(0, 100)
                                      .charAt(0)
                                      .toUpperCase()}${food.modelo
                                      .slice(1, 100)
                                      .toLowerCase()}...`
                                  : food.modelo.charAt(0).toUpperCase() +
                                    food.modelo.slice(1).toLowerCase()
                                : ""}
                            </div>
                          </div>
                          {!food.available && (
                            <div className="not-available-text mt-2 text-danger fw-bold">
                              No disponible
                            </div>
                          )}
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary new-font"
                  onClick={cerrarModalAccesorios}
                  style={{
                    padding: "10px 15px",
                    borderRadius: "6px",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) =>
                    (e.target.style.backgroundColor = "#334d5e")
                  }
                  onMouseLeave={(e) => (e.target.style.backgroundColor = "")}
                >
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {accessoryModalVisible &&
        accessoryModalData && ( //Modal información accesorios y garantias
          <div
            className="modal modal-pos fade show"
            id="modalPosAccessory"
            style={{
              display: "block",
              backgroundColor: "rgba(0, 0, 0, 0.46)",
              backdropFilter: "blur(3px)",
              zIndex: 1065, // Encima del modal de accesorios
            }}
            tabIndex="-1"
          >
            <div
              className={`modal-dialog ${accessoryModalData.pdf ? "modal-fullscreen" : "modal-lg modal-dialog-centered"}`}
            >
              <div className="modal-content border-0">
                <div
                  className="modal-pos-product"
                  style={
                    accessoryModalData.pdf
                      ? {
                          display: "flex",
                          flexWrap: "wrap",
                          flexDirection: "row",
                          padding: 0,
                        }
                      : {}
                  }
                >
                  <div
                    className={`modal-pos-product-img d-flex flex-column ${accessoryModalData.pdf ? "col-12 col-lg-8" : ""}`}
                    /* Forzamos 70% en lg y 100% en móvil para ganar al CSS externo */
                    style={
                      accessoryModalData.pdf
                        ? {
                            flex:
                              window.innerWidth >= 992 ? "0 0 70%" : "0 0 100%",
                            maxWidth: window.innerWidth >= 992 ? "70%" : "100%",
                            width: window.innerWidth >= 992 ? "70%" : "100%",
                          }
                        : {}
                    }
                  >
                    {!accessoryModalData.video && !accessoryModalData.pdf && (
                      <div
                        className="d-flex justify-content-center align-items-center"
                        style={{
                          height: "250px",
                          backgroundColor: "white",
                          borderRadius: "10px",
                        }}
                      >
                        <img
                          src={accessoryModalData.image}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/assets/img/product/noimage.png";
                          }}
                          alt="Producto"
                          style={{
                            maxHeight: "100%",
                            maxWidth: "100%",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                    )}
                    {/*{accessoryModalData.video && (
                      <div className="modal-pos-product-video mt-3">
                        <video width="100%" controls>
                          <source
                            src={accessoryModalData.video}
                            type="video/mp4"
                          />
                          Tu navegador no soporta el tag de video.
                        </video>
                      </div>
                    )}*/}

                    {accessoryModalData.pdf && (
                      <div
                        className="modal-pos-product-video"
                        style={{
                          height: "100%",
                          display: "flex !important",
                          flexDirection: "column",
                        }}
                      >
                        <iframe
                          src={`${accessoryModalData.pdf}#view=FitH`}
                          width="100%"
                          height="100%"
                          style={{
                            border: "none",
                            flexGrow: 1,
                            minHeight:
                              window.innerWidth > 992 ? "80vh" : "60vh",
                          }}
                          title="Documento de Garantía"
                        />
                        <a
                          href={accessoryModalData.pdf}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-link mt-2"
                          style={{
                            position: "relative",
                            zIndex: 1050,
                            display: "inline-block",
                          }}
                        >
                          Ver tríptico en pantalla completa
                        </a>
                      </div>
                    )}
                  </div>

                  <div
                    className={`modal-pos-product-info ${accessoryModalData.pdf ? "col-12 col-lg-4" : ""}`}
                    style={{
                      /* Forzamos 30% en lg y 100% en móvil para ganar al CSS externo */
                      flex: accessoryModalData.pdf
                        ? window.innerWidth >= 992
                          ? "0 0 30%"
                          : "0 0 100%"
                        : "1",
                      maxWidth: accessoryModalData.pdf
                        ? window.innerWidth >= 992
                          ? "30%"
                          : "100%"
                        : "100%",
                      width: accessoryModalData.pdf
                        ? window.innerWidth >= 992
                          ? "30%"
                          : "100%"
                        : "auto",
                      padding: "2rem",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                  >
                    <div className="mb-auto mt-auto">
                      <div className="fs-4 fw-semibold text-white black-text new-font">
                        {toTitleCase(accessoryModalData.title.split(" - ")[0])}
                      </div>
                      <div className="text-body text-white mb-2 new-font-14">
                        {accessoryModalData.modelo
                          ? accessoryModalData.modelo.charAt(0).toUpperCase() +
                            accessoryModalData.modelo.slice(1).toLowerCase()
                          : ""}
                      </div>
                    </div>

                    <hr className="opacity-1" />
                    <div className="row">
                      <div className="col-12 mt-4">
                        <button
                          className="btn btn-default fw-semibold mb-0 d-block py-3 w-100 new-font-14"
                          onClick={() => setAccessoryModalVisible(false)}
                        >
                          Cerrar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      {mostrarVideoIntro && videoActual && (
        <div className="video-overlay" style={{ zIndex: 9999 }}>
          <video
            ref={videoRef}
            key={videoActual}
            src={videoActual}
            playsInline
            preload="auto"
            onEnded={handleVideoEnded}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />

          {mostrarBotonPlay && (
            <button
              className="boton-iniciar-video"
              style={{ pointerEvents: "auto" }}
              onClick={reproducirManual}
            >
              <i className="fa-solid fa-play"></i>
              {videoActualIndex === 0
                ? "Reproducir video"
                : "Reproducir siguiente video"}
            </button>
          )}

          {puedeOmitir && (
            <button
              className="boton-omitir"
              style={{ pointerEvents: "auto" }}
              onClick={(e) => {
                e.stopPropagation();
                setMostrarVideoIntro(false);
                cerrarGaleriaFotosSeminuevo();
                setMostrarModalAccesorios(true);
              }}
            >
              Omitir ➤
            </button>
          )}
        </div>
      )}

      {openFicha && (
        <VisorFichaTecnica
          url={fichaURL}
          onClose={() => {
            cerrarGaleriaFotosSeminuevo({ limpiar: true });
            setOpenFicha(false);
          }}
          selectedMailData={selectedMailData}
          showFotosButton={esVehiculoSeminuevoActivo()}
          onOpenFotos={() => abrirFotosSeminuevo()}
          loadingFotos={loadingFotosSeminuevo}
        />
      )}

      {openFotosSeminuevo && (
        <GaleriaFotosSeminuevo
          images={fotosSeminuevo}
          title={tituloFotosSeminuevo}
          onClose={() => cerrarGaleriaFotosSeminuevo()}
        />
      )}
      {selectedCar &&
        !isReturningToInventory &&
        !openFicha &&
        !mostrarModalInfo &&
        !isAccessoryModalOpen && (
          <div className="sticky-bottom-panel no-top-line">
            <div className="container px-2 d-flex align-items-center h-100 flex-wrap w-100 gap-3">
              {(() => {
                // ===== Helpers =====
                const money = (v) =>
                  `$${new Intl.NumberFormat("es-MX", {
                    style: "decimal",
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  }).format(Math.round(Number(v || 0)))}`;
                const calcPMT = ({
                  price = 0,
                  meses = 60,
                  enganchePct = 15,
                  engancheMonto = null,
                  tasaAnual = TASA_ANUAL_FINANCIAMIENTO,
                  isMSI = false,
                }) => {
                  const total = Number(price || 0);
                  const enganche =
                    engancheMonto !== null && engancheMonto !== undefined
                      ? Number(engancheMonto || 0)
                      : (Number(enganchePct || 0) / 100) * total;

                  return calcularMensualidadFinanciamientoCotizacion({
                    total,
                    meses,
                    engancheMonto: enganche,
                    tasaAnual,
                    isMSI: isMSI || selectedMailData?.depende_auto === "Si",
                  });
                };

                // ===== Datos base =====
                const hasVersion = !!selectedMailData?.version_vehiculo;
                const precioVeh =
                  Number(selectedMailData?.precio_vehiculo) || 0;

                const meses =
                  Number(selectedMailData?.meses_financiamiento) || 60;
                const engPct =
                  Number(selectedMailData?.porcentaje_enganche) || 15; // (100% en contado)
                const engancheMontoCredito = getEngancheMontoCreditoCotizacion(
                  selectedMailData,
                  precioVeh,
                );
                const tasaAnual = TASA_ANUAL_FINANCIAMIENTO;

                const esContado =
                  String(selectedMailData?.depende_auto || "").toLowerCase() ===
                  "si";

                if (esContado) {
                  // === CONTADO ===
                  // 1) Tomar accesorios del plan seleccionado
                  const planes =
                    parseMaybeJSON(selectedMailData?.planes_financiamiento) ||
                    [];
                  const isSel = (p) =>
                    p?.isSelected === true ||
                    p?.isSelected === "true" ||
                    p?.isSelected === 1 ||
                    p?.isSelected === "1";
                  const planSel = planes.find(isSel);

                  const adicionalesMonto = getPlanTotalCotizacion(planSel);

                  // 2) Enganche para adicionales: 0% por defecto (para NO anular el financiamiento)
                  const engancheAdicPct = Number(
                    selectedMailData?.porcentaje_enganche_adicionales ?? 0,
                  );

                  const pmtAdic = hasVersion
                    ? calcPMT({
                        price: adicionalesMonto,
                        meses,
                        enganchePct: engancheAdicPct, // <- 0% normalmente
                        tasaAnual,
                      })
                    : 0;

                  return (
                    <>
                      <div className="d-flex align-items-center flex-wrap w-100 gap-3">
                        {/* Precio Total del vehículo (contado) */}
                        <div className="d-flex align-items-baseline gap-2">
                          <div className="fw-bold text-muted">Precio Total</div>
                          <div className="h4 mb-0 text-primary fw-semibold">
                            <div className="mensualidad-wrapper">
                              <div className="mensualidad-ticker">
                                {!hasVersion ? (
                                  <LegendVersion text="Selecciona una versión para ver el precio." />
                                ) : precioVeh > 0 ? (
                                  money(precioVeh)
                                ) : (
                                  "N/A"
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="vr opacity-25 d-none d-md-block" />

                        {/* Mensualidad de adicionales */}
                        <div className="d-flex align-items-baseline gap-2">
                          <div className="fw-bold text-muted">
                            Mens. de adicionales
                          </div>
                          <div className="h4 mb-0 text-success fw-semibold">
                            <div className="mensualidad-wrapper">
                              <div className="mensualidad-ticker">
                                {!hasVersion ? (
                                  <LegendVersion text="Selecciona una versión para calcular adicionales." />
                                ) : (
                                  money(pmtAdic)
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  );
                }

                // === CRÉDITO ===
                const planesCredito =
                  getPlanesFinanciamientoCotizacion(selectedMailData);
                const planSeleccionadoCredito =
                  planesCredito.find(isPlanSelectedCotizacion) || null;
                const adicionalesCredito = getPlanTotalCotizacion(
                  planSeleccionadoCredito,
                );
                const precioTot = Math.max(precioVeh + adicionalesCredito, 0);

                const pmtSinAdic = hasVersion
                  ? calcPMT({
                      price: precioVeh,
                      meses,
                      enganchePct: engPct,
                      engancheMonto: engancheMontoCredito,
                      tasaAnual,
                    })
                  : 0;

                const pmtConAdic = hasVersion
                  ? calcPMT({
                      price: precioTot,
                      meses,
                      enganchePct: engPct,
                      engancheMonto: engancheMontoCredito,
                      tasaAnual,
                    })
                  : 0;

                const diff = Math.max(0, pmtConAdic - pmtSinAdic);

                return (
                  <>
                    <div className="d-flex align-items-center flex-wrap w-100 gap-3">
                      <div className="d-flex align-items-baseline gap-2">
                        <div className="fw-bold text-muted">
                          Mens. sin adicionales
                        </div>
                        <div className="h4 mb-0 text-primary fw-semibold">
                          <div className="mensualidad-wrapper">
                            <div className="mensualidad-ticker">
                              {!hasVersion ? (
                                <LegendVersion text="Selecciona una versión para calcular mensualidad." />
                              ) : (
                                money(pmtSinAdic)
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="vr opacity-25 d-none d-md-block" />

                      <div className="d-flex align-items-baseline gap-2">
                        <div className="fw-bold text-muted">
                          Mens. con adicionales
                        </div>
                        <div className="h4 mb-0 text-success fw-semibold">
                          <div className="mensualidad-wrapper">
                            <div className="mensualidad-ticker">
                              {!hasVersion ? (
                                <LegendVersion text="Selecciona una versión para calcular adicionales." />
                              ) : (
                                money(pmtConAdic)
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="vr opacity-25 d-none d-md-block" />

                      {hasVersion && diff > 0 && (
                        <div className="flex-grow-1 black-text fw-semibold text-truncate">
                          <span className="me-1">¡Arma tu plan!</span>
                          Por{" "}
                          <span className="text-success">{money(diff)}</span> al
                          mes, incluye tus adicionales.
                        </div>
                      )}
                    </div>
                  </>
                );
              })()}

              {/* ===== Footer ===== */}
              <div className="w-100 d-flex justify-content-center align-items-center flex-wrap gap-3 text-center">
                <span className="text-muted small fst-italic m-0">
                  *El precio total no incluye accesorios ni garantías
                  adicionales.
                </span>

                <div className="btn-group">
                  <button
                    className="btn btn-outline-primary"
                    onClick={() => setCanvasActivo((prev) => !prev)}
                    disabled={!selectedMailData?.version_vehiculo}
                  >
                    {canvasActivo ? "Desactivar pincel" : "Activar pincel"}
                  </button>
                  <button
                    className="btn btn-outline-primary"
                    onClick={() => canvasRef.current?.clearCanvas()}
                    disabled={!selectedMailData?.version_vehiculo}
                  >
                    Borrar todo
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

      {openPDFModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1055, inset: 0 }}
          onClick={() => {}}
        >
          <div
            className="modal-dialog modal-fullscreen modal-dialog-scrollable"
            onClick={(e) => e.stopPropagation()} // evita cierre al hacer clic dentro
          >
            <div className="modal-content h-100 d-flex flex-column">
              {/* HEADER */}
              <div className="modal-header">
                <h5 className="modal-title mb-0">Documentos Generados</h5>
                {/* Sin botón de cerrar: el cierre de esta venta lo controla el asesor. */}
              </div>

              <div className="modal-body p-0 d-flex" style={{ minHeight: 0 }}>
                <div
                  id="pdfCarousel"
                  className="carousel slide w-100 h-100"
                  data-bs-ride="false"
                  style={{ position: "relative" }}
                >
                  <div className="carousel-inner h-100">
                    {pdfUrlsGeneradas.map((pdf, index) => {
                      return (
                        <div
                          key={pdf.id || `sys-${index}`}
                          className={`carousel-item h-100 ${index === activeIndex ? "active" : ""}`}
                        >
                          <div className="w-100 h-100 position-relative p-3">
                            {pdf.esAdjunto &&
                              !ocultarAccionesFinalesCliente && (
                                <button
                                  type="button"
                                  className="btn btn-remove-pdf d-flex align-items-center justify-content-center shadow"
                                  onClick={() => handleRemoveFile(index)}
                                  onMouseOver={(e) =>
                                    (e.currentTarget.style.transform =
                                      "scale(1.1)")
                                  }
                                  onMouseOut={(e) =>
                                    (e.currentTarget.style.transform =
                                      "scale(1.0)")
                                  }
                                  title="Eliminar archivo"
                                >
                                  <i className="bi bi-trash3-fill style-i"></i>
                                </button>
                              )}
                            <div className="bg-white h-100 w-100 overflow-auto rounded shadow-sm">
                              <PDFAllPages url={pdf.url} />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  {pdfUrlsGeneradas.length > 1 && (
                    <>
                      <button
                        className="carousel-control-prev"
                        type="button"
                        data-bs-target="#pdfCarousel"
                        data-bs-slide="prev"
                        style={{ width: "12%", alignItems: "center" }}
                      >
                        <span
                          className="carousel-control-prev-icon pdf-arrow"
                          aria-hidden="true"
                        />
                        <span className="visually-hidden">Anterior</span>
                      </button>
                      <button
                        className="carousel-control-next"
                        type="button"
                        data-bs-target="#pdfCarousel"
                        data-bs-slide="next"
                        style={{ width: "12%", alignItems: "center" }}
                      >
                        <span
                          className="carousel-control-next-icon pdf-arrow"
                          aria-hidden="true"
                        />
                        <span className="visually-hidden">Siguiente</span>
                      </button>
                    </>
                  )}
                </div>
              </div>

              {/* FOOTER */}
              <div className="modal-footer">
                {/* Input de archivo oculto: se conserva por compatibilidad interna, pero ya no se muestra acción para adjuntar desde cliente. */}
                <input
                  type="file"
                  accept=".pdf"
                  id="file-upload"
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />

                <div
                  className={`alert ${
                    isFinalizandoPorAsesor ||
                    ventaFinalizacionPendientePorAsesor ||
                    ventaFinalizadaPorAsesor
                      ? "alert-success"
                      : "alert-info"
                  } w-100 mb-0 d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-2`}
                  style={{ borderRadius: "14px" }}
                >
                  <div>
                    <strong>
                      {isFinalizandoPorAsesor ||
                      ventaFinalizacionPendientePorAsesor
                        ? "Finalizando venta..."
                        : ventaFinalizadaPorAsesor
                          ? "Venta en proceso de cierre."
                          : "Acciones deshabilitadas."}
                    </strong>
                    <div className="small mt-1">
                      {isFinalizandoPorAsesor ||
                      ventaFinalizacionPendientePorAsesor
                        ? "Estamos enviando los documentos, marcando la venta como completada y preparando un nuevo folio. No cierres esta pantalla."
                        : ventaFinalizadaPorAsesor
                          ? `${ventaFinalizadaClienteNombre} finalizó esta venta. Estamos esperando que el cierre automático termine.`
                          : "Tu asesor se encargará de finalizar la venta. Desde cliente ya no se muestran las acciones de editar, adjuntar ni finalizar."}
                      {!isFinalizandoPorAsesor &&
                      ventaFinalizadaPorAsesor &&
                      ventaFinalizadaClienteFecha ? (
                        <> Fecha: {ventaFinalizadaClienteFecha}</>
                      ) : null}
                    </div>
                  </div>

                  {(isFinalizandoPorAsesor ||
                    ventaFinalizacionPendientePorAsesor) && (
                    <span className="spinner-border spinner-border-sm text-success" />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {showOferta && (
        <div
          className="oferta-popup position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            backgroundColor: "rgba(0,0,0,0.4)",
            zIndex: 9999,
            backdropFilter: "blur(1px)", // muy sutil
            transition: "opacity 0.3s ease-in-out",
          }}
        >
          <div
            className="card p-4 text-center"
            style={{
              maxWidth: "400px",
              borderRadius: "15px",
              boxShadow: "0 8px 25px rgba(0,0,0,0.3)",
              background: "linear-gradient(135deg, #4091e2, #00366f)", // degradado azul corporativo
              color: "white",
              position: "relative",
              transform: "scale(1)",
              animation: "popUp 0.3s ease-out",
            }}
          >
            {/* Icono de promoción */}
            <div style={{ fontSize: "2rem", marginBottom: "10px" }}>🎉</div>
            <h4 className="fw-bold mb-2">¡Oferta Especial!</h4>
            <p style={{ fontSize: "0.95rem", marginBottom: "20px" }}>
              Llévate el <strong>10% de descuento</strong> en la garantía de
              llantas. ¡Aprovecha para agregarla a tu plan!
            </p>

            {/* Botones */}
            <div className="d-flex justify-content-center gap-3">
              <button
                className="btn"
                style={{
                  backgroundColor: "white",
                  color: "#00366f",
                  fontWeight: "bold",
                  borderRadius: "50px",
                  padding: "8px 20px",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                }}
                onClick={() => setShowOferta(false)}
              >
                Cerrar
              </button>

              <button
                className="btn"
                style={{
                  backgroundColor: "#00366f",
                  color: "white",
                  fontWeight: "bold",
                  borderRadius: "50px",
                  padding: "8px 20px",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                }}
                onClick={() => {
                  setShowOferta(false);
                }}
              >
                Agregar al plan
              </button>
            </div>
          </div>

          <style>{`
      @keyframes popUp {
        0% { transform: scale(0.5); opacity: 0; }
        100% { transform: scale(1); opacity: 1; }
      }
    `}</style>
        </div>
      )}
    </>
  );
}

export default PosCustomerOrderV2;
